import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  URL: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
  json: { input: any; output: any; }
};

export type AccountManager = {
  __typename?: 'AccountManager';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isBot: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
};

export type AccountManagerLegacy = {
  __typename?: 'AccountManagerLegacy';
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_image?: Maybe<Scalars['String']['output']>;
};

export type AdminCognitoUser = {
  __typename?: 'AdminCognitoUser';
  created?: Maybe<Scalars['DateTime']['output']>;
  databaseId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userOptions?: Maybe<CognitoUserOptions>;
  username: Scalars['String']['output'];
};

export type AdminCognitoUsersSearchFilters = {
  email?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminCognitoUsersSearchSortField>;
};

export type AdminCognitoUsersSearchResult = {
  __typename?: 'AdminCognitoUsersSearchResult';
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
  users: Array<AdminCognitoUser>;
};

export enum AdminCognitoUsersSearchSortField {
  Created = 'created',
  Email = 'email',
  Status = 'status',
  Username = 'username'
}

export type AdminCreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  type: AdminCreateUserType;
};

export enum AdminCreateUserType {
  Customer = 'customer',
  Supplier = 'supplier'
}

export type AdminEventsSearchFilters = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminEventsSearchSortField>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEventsSearchResult = {
  __typename?: 'AdminEventsSearchResult';
  events: Array<Events>;
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export enum AdminEventsSearchSortField {
  Customer = 'customer',
  Date = 'date',
  Type = 'type'
}

export type AdminGetPartnershipEventsResult = {
  __typename?: 'AdminGetPartnershipEventsResult';
  events: Array<Events>;
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type AdminOnboardingBoardColumn = {
  __typename?: 'AdminOnboardingBoardColumn';
  status: AdminOnboardingBoardStatus;
  suppliers: Array<AdminOnboardingSupplierCard>;
  /**
   * Total matching suppliers, which may exceed the returned page. For hidden
   * statuses this is the total within recentDays, not all time.
   */
  totalRecords: Scalars['Int']['output'];
};

/**
 * The board's own vocabulary. TO_REVIEW and PROFILE_INCOMPLETE are board buckets
 * derived from suppliers.state ('submitted' and 'pending' with no onboarding row);
 * the rest are stored onboarding statuses.
 */
export enum AdminOnboardingBoardStatus {
  ActivationCallBooked = 'ACTIVATION_CALL_BOOKED',
  ActivationCallReady = 'ACTIVATION_CALL_READY',
  ClosedLost = 'CLOSED_LOST',
  ClosedWon = 'CLOSED_WON',
  ProfileIncomplete = 'PROFILE_INCOMPLETE',
  RequestedAmendments = 'REQUESTED_AMENDMENTS',
  ToReview = 'TO_REVIEW'
}

export type AdminOnboardingCheck = {
  __typename?: 'AdminOnboardingCheck';
  key: AdminOnboardingCheckKey;
  /** Short sentence shown when the check does not pass. */
  reason?: Maybe<Scalars['String']['output']>;
  state: AdminOnboardingCheckState;
};

export enum AdminOnboardingCheckKey {
  Documents = 'DOCUMENTS',
  FoodHygieneRating = 'FOOD_HYGIENE_RATING',
  PrimaryTag = 'PRIMARY_TAG',
  PublicLiability = 'PUBLIC_LIABILITY',
  ReviewSignal = 'REVIEW_SIGNAL'
}

export enum AdminOnboardingCheckState {
  Fail = 'FAIL',
  Pass = 'PASS',
  Unknown = 'UNKNOWN'
}

export type AdminOnboardingDocumentEntry = {
  __typename?: 'AdminOnboardingDocumentEntry';
  /** Negative once lapsed; null when no expiry is recorded. */
  daysUntilExpiry?: Maybe<Scalars['Int']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this vertical is asked for the document at all. */
  isRequired: Scalars['Boolean']['output'];
  state: AdminOnboardingDocumentEntryState;
  type: DocumentFileTypeEnum;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AdminOnboardingDocumentEntryState {
  /**
   * Answered by a field on the supplier rather than an upload: the FSA rating,
   * the alcohol permit and the risk assessment score.
   */
  AnsweredOnProfile = 'ANSWERED_ON_PROFILE',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Missing = 'MISSING',
  /** A copy is on file but carries no expiry date. */
  NoExpiry = 'NO_EXPIRY',
  Rejected = 'REJECTED',
  Valid = 'VALID'
}

export enum AdminOnboardingDocumentState {
  ActionRequired = 'ACTION_REQUIRED',
  Current = 'CURRENT',
  ExpiringSoon = 'EXPIRING_SOON',
  None = 'NONE'
}

export type AdminOnboardingDocumentSummary = {
  __typename?: 'AdminOnboardingDocumentSummary';
  /**
   * Counted per document type, not per row: a renewed certificate does not leave
   * its expired predecessor on the count.
   */
  expiringSoon: Scalars['Int']['output'];
  missingOrExpired: Scalars['Int']['output'];
  /** Earliest expiry still in the future. */
  nextExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Cover on the valid public liability certificate, in pounds. Null when there
   * is no valid copy, and for every certificate uploaded before the field
   * existed — a gap in our records rather than a supplier without cover.
   */
  publicLiabilityCoverAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * A valid certificate is on file but carries no expiry date, so its cover
   * cannot be shown to be current.
   */
  publicLiabilityCoverIsUndated: Scalars['Boolean']['output'];
  state: AdminOnboardingDocumentState;
  /** Types with a valid copy on file. */
  validTypes: Array<DocumentFileTypeEnum>;
};

export type AdminOnboardingFollowUp = {
  __typename?: 'AdminOnboardingFollowUp';
  dueDate: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminOnboardingKeyDetails = {
  __typename?: 'AdminOnboardingKeyDetails';
  area?: Maybe<Scalars['String']['output']>;
  /**
   * The supplier's earliest user. A supplier can have several through
   * suppliers_users; the modal shows one set of contact details.
   */
  contactName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  /** "area · region", the row the mockup labels "City". */
  locationLabel?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /**
   * Account creation, not submission: there is no submission timestamp, so this
   * reads as "Signed up" rather than the mockup's "Applied".
   */
  signedUpAt?: Maybe<Scalars['DateTime']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  ukRegion?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type AdminOnboardingMissingSection = {
  __typename?: 'AdminOnboardingMissingSection';
  /**
   * Set only where the requirement is a count, so "Images 4 of 6" is possible;
   * null for a section that is simply unfinished.
   */
  have?: Maybe<Scalars['Int']['output']>;
  key: AdminOnboardingMissingSectionKey;
  /** Section name as the supplier sees it in their own form. */
  label: Scalars['String']['output'];
  need?: Maybe<Scalars['Int']['output']>;
};

export enum AdminOnboardingMissingSectionKey {
  Business = 'BUSINESS',
  CompanyDetails = 'COMPANY_DETAILS',
  Documents = 'DOCUMENTS',
  Images = 'IMAGES',
  Logistics = 'LOGISTICS',
  Profile = 'PROFILE'
}

export type AdminOnboardingSupplierCard = {
  __typename?: 'AdminOnboardingSupplierCard';
  adminUrl: Scalars['String']['output'];
  /** Null until submittedAt exists. */
  applicationAgeDays?: Maybe<Scalars['Int']['output']>;
  /** Area from the regions table, derived from the postcode. */
  area?: Maybe<Scalars['String']['output']>;
  /** Reasons of the failing checks, ready to render as the blocker panel. */
  blockers: Array<Scalars['String']['output']>;
  categoriesTier2: Array<Scalars['String']['output']>;
  categoryTier1?: Maybe<Scalars['String']['output']>;
  /** Display name for the vertical, e.g. Audio Visual. */
  categoryTier1Label?: Maybe<Scalars['String']['output']>;
  /** Deterministic compliance checks, evaluated server-side. */
  checks: Array<AdminOnboardingCheck>;
  closedReason?: Maybe<Scalars['String']['output']>;
  /** Drives the single documents chip on the card. */
  documents: AdminOnboardingDocumentSummary;
  followUp?: Maybe<AdminOnboardingFollowUp>;
  /** Numeric FSA score, null when never fetched or not applicable. */
  foodHygieneRating?: Maybe<Scalars['Int']['output']>;
  foodHygieneRatingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Canonical FSA listing link, null when no listing is on file. */
  foodHygieneRatingUrl?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  /**
   * Ready-to-render location line, e.g. "Homerton · Greater London", collapsed to
   * one value when the area and region name the same place.
   */
  locationLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Sections of the supplier's own onboarding form still to finish. Empty for a
   * complete profile.
   */
  missingSections: Array<AdminOnboardingMissingSection>;
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  primaryTag?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  /** When the supplier created their account. */
  signedUpAt?: Maybe<Scalars['DateTime']['output']>;
  status: AdminOnboardingBoardStatus;
  /** Whole days since the status was last set; null for the derived buckets. */
  statusAgeDays?: Maybe<Scalars['Int']['output']>;
  /**
   * Null for TO_REVIEW and PROFILE_INCOMPLETE: those are derived from the
   * supplier's own state, so nobody set them and there is no event to report.
   */
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  statusChangedBy?: Maybe<Scalars['String']['output']>;
  /** Null until suppliers.submitted_at exists. */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  ukRegion?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type AdminOnboardingSupplierDetail = {
  __typename?: 'AdminOnboardingSupplierDetail';
  /**
   * Deterministic checks only — no AI assessment and no written summary. Review
   * signal stays UNKNOWN until TT-5165 persists a chosen listing.
   */
  assessment: Array<AdminOnboardingCheck>;
  /** The supplier's own profile description, shown as the bio. */
  bio?: Maybe<Scalars['String']['output']>;
  blockers: Array<Scalars['String']['output']>;
  categoriesTier2: Array<Scalars['String']['output']>;
  categoryTier1?: Maybe<Scalars['String']['output']>;
  categoryTier1Label?: Maybe<Scalars['String']['output']>;
  /** Why the supplier was closed lost; null in every other status. */
  closedReason?: Maybe<Scalars['String']['output']>;
  /** Every document the supplier owes, plus anything they uploaded beyond it. */
  documentList: Array<AdminOnboardingDocumentEntry>;
  /** The same summary the card's documents chip uses, so both agree. */
  documents: AdminOnboardingDocumentSummary;
  expiringSoonMonths: Scalars['Int']['output'];
  followUp?: Maybe<AdminOnboardingFollowUp>;
  foodHygieneRating?: Maybe<Scalars['Int']['output']>;
  foodHygieneRatingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  foodHygieneRatingUrl?: Maybe<Scalars['String']['output']>;
  keyDetails: AdminOnboardingKeyDetails;
  name?: Maybe<Scalars['String']['output']>;
  primaryTag?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Null for a supplier in a derived bucket: TO_REVIEW and PROFILE_INCOMPLETE
   * have no onboarding row, so there is no stored status to report.
   */
  status?: Maybe<OnboardingStatus>;
  statusAgeDays?: Maybe<Scalars['Int']['output']>;
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  statusChangedBy?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type AdminPartnershipsSearchFilters = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminPartnershipsSearchSortField>;
};

export type AdminPartnershipsSearchResult = {
  __typename?: 'AdminPartnershipsSearchResult';
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  partnerships: Array<Partnership>;
  totalRecords: Scalars['Int']['output'];
};

export enum AdminPartnershipsSearchSortField {
  Created = 'created',
  Name = 'name',
  Slug = 'slug'
}

export type AdminQuotesSearchFilters = {
  hasVenuePartner?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminQuotesSearchSortField>;
  status?: InputMaybe<Enum_Quotes_State>;
  statuses?: InputMaybe<Array<Enum_Quotes_State>>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  timeframe?: InputMaybe<AdminQuotesSearchTimeframe>;
};

export type AdminQuotesSearchResult = {
  __typename?: 'AdminQuotesSearchResult';
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  quotes: Array<Quotes>;
  totalRecords: Scalars['Int']['output'];
};

export enum AdminQuotesSearchSortField {
  Created = 'created',
  Customer = 'customer',
  CustomerTotal = 'customerTotal',
  EventDate = 'eventDate',
  Supplier = 'supplier'
}

export enum AdminQuotesSearchTimeframe {
  Past = 'past',
  Upcoming = 'upcoming'
}

export type AdminRegisterSupplierEventInput = {
  body: Scalars['Json']['input'];
  eventType: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};

export type AdminRequestsSearchFilters = {
  category_tier1?: InputMaybe<Scalars['String']['input']>;
  category_tier2?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminRequestsSearchSortField>;
};

export type AdminRequestsSearchResult = {
  __typename?: 'AdminRequestsSearchResult';
  eventRequests: Array<Event_Requests>;
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export enum AdminRequestsSearchSortField {
  Budget = 'budget',
  CategoryTier2 = 'category_tier2',
  Created = 'created',
  Id = 'id'
}

export type AdminReviewCandidate = {
  __typename?: 'AdminReviewCandidate';
  /**
   * Address, website and source URL are what a person checks the candidate
   * against before choosing it.
   */
  address?: Maybe<Scalars['String']['output']>;
  /** The provider's own id for the listing, stored when one is chosen. */
  listingId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  provider: ReviewProvider;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AdminReviewSnapshot = {
  __typename?: 'AdminReviewSnapshot';
  fetchedAt: Scalars['DateTime']['output'];
  /**
   * Reviews of two stars or fewer, over the listing's whole life rather than a
   * recent window — no provider exposes enough review history for one. Null
   * where the provider publishes no breakdown at all, which is every Google
   * listing, and distinct from zero.
   */
  negativeReviewCount?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminReviewsSearchFilters = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminReviewsSearchSortField>;
  source?: InputMaybe<Enum_Reviews_Source>;
};

export type AdminReviewsSearchResult = {
  __typename?: 'AdminReviewsSearchResult';
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  reviews: Array<Reviews>;
  totalRecords: Scalars['Int']['output'];
};

export enum AdminReviewsSearchSortField {
  Created = 'created',
  Customer = 'customer',
  EventDate = 'eventDate',
  EventType = 'eventType',
  Published = 'published',
  Rating = 'rating',
  Source = 'source',
  Supplier = 'supplier'
}

export type AdminSetSupplierReviewListingInput = {
  /** Required for SELECTED, ignored for NO_MATCH. */
  listingId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Explicit rather than inferred from a missing listingId: a caller that forgot
   * the field would otherwise erase a decision without saying so.
   */
  outcome: ReviewListingOutcome;
  provider: ReviewProvider;
  supplierUuid: Scalars['String']['input'];
};

export type AdminSupplierEventsFilters = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<SortOrder>;
  supplierId: Scalars['String']['input'];
};

export type AdminSupplierOnboardingBoardFilters = {
  /** Optional vertical filter, applied to every column and hidden list. */
  category_tier1?: InputMaybe<Scalars['String']['input']>;
  /** How far ahead an expiry counts as expiring soon. Defaults to 3 months. */
  expiringSoonMonths?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Cap on each hidden status's recent list, defaulting to 1000 — a safety cap
   * rather than a page size, high enough to cover a normal window. A bucket
   * holding more than the cap is still cut off, so compare a list's length
   * against its totalRecords to tell whether you have all of it. Pass a smaller
   * value to ask for a preview. Active columns are unbounded: every supplier
   * waiting on a decision is returned.
   */
  hiddenListLimit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Recency window in days for the hidden statuses. It bounds both their counts
   * and their lists: a supplier activated two years ago is not board context.
   * Active columns are never date-bounded. Defaults to 60.
   */
  recentDays?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminSupplierOnboardingBoardResult = {
  __typename?: 'AdminSupplierOnboardingBoardResult';
  /** Active swim lanes, in board order. */
  columns: Array<AdminOnboardingBoardColumn>;
  /** The expiring-soon threshold actually applied to documents. */
  expiringSoonMonths: Scalars['Int']['output'];
  /**
   * Statuses kept off the board, as a count plus a list. Both are scoped to
   * recentDays, so the count matches what the list is drawn from.
   */
  hidden: Array<AdminOnboardingBoardColumn>;
  /** The recency window actually applied to the hidden statuses. */
  recentDays: Scalars['Int']['output'];
};

export type AdminSupplierOnboardingDetailFilters = {
  /** How far ahead an expiry counts as expiring soon. Defaults to 3 months. */
  expiringSoonMonths?: InputMaybe<Scalars['Int']['input']>;
  supplierUuid: Scalars['String']['input'];
};

export type AdminSupplierReviewCandidatesFilters = {
  provider: ReviewProvider;
  supplierUuid: Scalars['String']['input'];
};

export type AdminSupplierReviewListing = {
  __typename?: 'AdminSupplierReviewListing';
  /**
   * Shown to the reader because the decision does not expire: without it a
   * year-old "no match" is indistinguishable from yesterday's.
   */
  decidedAt: Scalars['DateTime']['output'];
  decidedBy?: Maybe<Scalars['String']['output']>;
  /** Who decided, as they were named at the time. */
  decidedByName?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  outcome: ReviewListingOutcome;
  provider: ReviewProvider;
  /** Null for NO_MATCH, and when the provider no longer has the listing. */
  reviews?: Maybe<AdminReviewSnapshot>;
};

export type AdminSupplierReviewListingFilters = {
  provider: ReviewProvider;
  supplierUuid: Scalars['String']['input'];
};

/**
 * One thing that happened to a supplier, for the activity history tab.
 *
 * Derived from stored state rather than from an event log, which is why the
 * onboarding status contributes a single event: the table keeps one row per
 * supplier and every earlier transition was overwritten.
 */
export type AdminSupplierTimelineEvent = {
  __typename?: 'AdminSupplierTimelineEvent';
  /** The person behind it, where we know one. Null for system events. */
  actor?: Maybe<Scalars['String']['output']>;
  /** The muted line under it. Null when the title says everything. */
  description?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  /** The bold line, e.g. "Document uploaded". */
  title: Scalars['String']['output'];
  /** Stable key for an icon, a filter or a grouping. Never displayed raw. */
  type: AdminTimelineEventType;
};

export type AdminSupplierTimelineFilters = {
  supplierUuid: Scalars['String']['input'];
};

export type AdminSuppliersSearchFilters = {
  category_tier1?: InputMaybe<Scalars['String']['input']>;
  category_tier2?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  min_capacity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminSuppliersSearchSortField>;
  state?: InputMaybe<Enum_Suppliers_State>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSuppliersSearchResult = {
  __typename?: 'AdminSuppliersSearchResult';
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  suppliers: Array<Suppliers>;
  totalRecords: Scalars['Int']['output'];
};

export enum AdminSuppliersSearchSortField {
  CategoryTier1 = 'category_tier1',
  LocationCity = 'location_city',
  Name = 'name',
  State = 'state',
  Updated = 'updated',
  Uuid = 'uuid'
}

export enum AdminTimelineEventType {
  Activated = 'ACTIVATED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  FoodHygieneRating = 'FOOD_HYGIENE_RATING',
  ReviewListing = 'REVIEW_LISTING',
  SignedUp = 'SIGNED_UP',
  StatusChanged = 'STATUS_CHANGED',
  UserAdded = 'USER_ADDED'
}

export type AdminUpdateSupplierInput = {
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  category_tier1?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  primary_tag?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Enum_Suppliers_State>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  vat_number?: InputMaybe<Scalars['String']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AdminUsersAccountStatus {
  Active = 'active',
  All = 'all',
  Closed = 'closed'
}

export type AdminUsersSearchFilters = {
  accountStatus?: InputMaybe<AdminUsersAccountStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminUsersSearchSortField>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  userTypes?: InputMaybe<Array<Enum_Users_Type>>;
};

export type AdminUsersSearchResult = {
  __typename?: 'AdminUsersSearchResult';
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
  users: Array<Users>;
};

export enum AdminUsersSearchSortField {
  Created = 'created',
  Email = 'email',
  Name = 'name'
}

export type Agency_UsersListRelationFilter = {
  every?: InputMaybe<Agency_UsersWhereInput>;
  none?: InputMaybe<Agency_UsersWhereInput>;
  some?: InputMaybe<Agency_UsersWhereInput>;
};

export type Anonymous_UsersListRelationFilter = {
  every?: InputMaybe<Anonymous_UsersWhereInput>;
  none?: InputMaybe<Anonymous_UsersWhereInput>;
  some?: InputMaybe<Anonymous_UsersWhereInput>;
};

export type Attachment = {
  __typename?: 'Attachment';
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum AttachmentEntityType {
  QuoteAttachment = 'QUOTE_ATTACHMENT',
  QuoteTemplateAttachment = 'QUOTE_TEMPLATE_ATTACHMENT'
}

export type AttachmentInput = {
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type AttributionData = {
  __typename?: 'AttributionData';
  browsingHistory: Array<Maybe<Scalars['Json']['output']>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  referrer: Array<Maybe<Scalars['String']['output']>>;
  sessionPreviousPages: Array<Maybe<Scalars['String']['output']>>;
  sessionStartPage?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  utmParams?: Maybe<Scalars['Json']['output']>;
};

export enum AutomationTriggerEnum {
  XDaysAfterBookingConfirmed = 'x_days_after_booking_confirmed',
  XDaysAfterQuoteSubmittedAndCustomerNotReplied = 'x_days_after_quote_submitted_and_customer_not_replied',
  XDaysBeforeEventAfterBookingConfirmed = 'x_days_before_event_after_booking_confirmed'
}

export type BookedSupplierReferralEvent = {
  __typename?: 'BookedSupplierReferralEvent';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  state: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BookingProtection = {
  __typename?: 'BookingProtection';
  protection_fee: Scalars['Float']['output'];
  protection_rounding: Scalars['Float']['output'];
  protection_type: Scalars['String']['output'];
};

export type BookingsListRelationFilter = {
  every?: InputMaybe<BookingsWhereInput>;
  none?: InputMaybe<BookingsWhereInput>;
  some?: InputMaybe<BookingsWhereInput>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export enum CallMethod {
  Admin = 'admin',
  Complete = 'complete',
  Create = 'create',
  Edit = 'edit'
}

export type Card = {
  __typename?: 'Card';
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  expiryYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type Categories_Tier2ListRelationFilter = {
  every?: InputMaybe<Categories_Tier2WhereInput>;
  none?: InputMaybe<Categories_Tier2WhereInput>;
  some?: InputMaybe<Categories_Tier2WhereInput>;
};

export type Categories_Tier2_Tag_GroupsListRelationFilter = {
  every?: InputMaybe<Categories_Tier2_Tag_GroupsWhereInput>;
  none?: InputMaybe<Categories_Tier2_Tag_GroupsWhereInput>;
  some?: InputMaybe<Categories_Tier2_Tag_GroupsWhereInput>;
};

export enum CateringEnum {
  BuffetStyle = 'buffet_style',
  FamilyStyle = 'family_style',
  SeatedDining = 'seated_dining',
  StreetFood = 'street_food'
}

export type CheckoutPaymentInput = {
  amount: Scalars['Float']['input'];
  analyticsContext: EventAnalytics;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentType: CheckoutPaymentType;
  protectionType: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
};

export type CheckoutPaymentResponse = {
  __typename?: 'CheckoutPaymentResponse';
  paymentComplete: Scalars['Boolean']['output'];
  paymentInformation?: Maybe<PaymentInformation>;
  paymentIntentClientSecret?: Maybe<Scalars['String']['output']>;
  subscriptionStatus: CheckoutSubscriptionStatus;
};

export enum CheckoutPaymentType {
  Plan = 'PLAN',
  Single = 'SINGLE'
}

export enum CheckoutSubscriptionStatus {
  Created = 'CREATED',
  NotRequired = 'NOT_REQUIRED'
}

export type CognitoUserOptions = {
  __typename?: 'CognitoUserOptions';
  canDeleteEvents?: Maybe<Scalars['Boolean']['output']>;
  canDeleteUsers?: Maybe<Scalars['Boolean']['output']>;
  sparkRole?: Maybe<Scalars['String']['output']>;
  superAdmin?: Maybe<Scalars['Boolean']['output']>;
  supplierOnboarding?: Maybe<Scalars['Boolean']['output']>;
};

export type CognitoUserOptionsInput = {
  canDeleteEvents: Scalars['Boolean']['input'];
  canDeleteUsers: Scalars['Boolean']['input'];
  sparkRole?: InputMaybe<Scalars['String']['input']>;
  superAdmin: Scalars['Boolean']['input'];
  supplierOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompletedPaymentResponse = {
  __typename?: 'CompletedPaymentResponse';
  amount?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  externalPaymentInfoId?: Maybe<Scalars['String']['output']>;
  method: Scalars['String']['output'];
  quoteId: Scalars['String']['output'];
  scheduledPaymentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type CompletedPaymentsFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CompletedPaymentsOrderByInput>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paymentYearMonth?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Enum_Supplier_Payments_Status>;
  supplierId: Scalars['String']['input'];
  type?: InputMaybe<Enum_Supplier_Payments_Type>;
};

export type CompletedPaymentsOrderByInput = {
  amount?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  eventDate?: InputMaybe<SortOrder>;
};

export type CompletedPaymentsResponse = {
  __typename?: 'CompletedPaymentsResponse';
  completedPayments: Array<CompletedPaymentResponse>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type ConnectUuid = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsListRelationFilter = {
  every?: InputMaybe<ConversationsWhereInput>;
  none?: InputMaybe<ConversationsWhereInput>;
  some?: InputMaybe<ConversationsWhereInput>;
};

export type Conversations_MessagesListRelationFilter = {
  every?: InputMaybe<Conversations_MessagesWhereInput>;
  none?: InputMaybe<Conversations_MessagesWhereInput>;
  some?: InputMaybe<Conversations_MessagesWhereInput>;
};

export type Conversations_Read_ReceiptsListRelationFilter = {
  every?: InputMaybe<Conversations_Read_ReceiptsWhereInput>;
  none?: InputMaybe<Conversations_Read_ReceiptsWhereInput>;
  some?: InputMaybe<Conversations_Read_ReceiptsWhereInput>;
};

export type Conversations_UsersListRelationFilter = {
  every?: InputMaybe<Conversations_UsersWhereInput>;
  none?: InputMaybe<Conversations_UsersWhereInput>;
  some?: InputMaybe<Conversations_UsersWhereInput>;
};

export enum CoursesEnum {
  Canapes = 'canapes',
  Desserts = 'desserts',
  EveningSnacks = 'evening_snacks',
  Mains = 'mains',
  Starters = 'starters'
}

export type CreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse';
  paymentComplete: Scalars['Boolean']['output'];
  paymentInformation?: Maybe<PaymentInformation>;
  paymentIntentClientSecret?: Maybe<Scalars['String']['output']>;
};

export type CreatePitchApplicationInput = {
  pitchApplicationDocuments: Array<Scalars['Upload']['input']>;
  pitchGroupUuid: Scalars['String']['input'];
  pitchStatus: PitchStatus;
  supplierSetupUuid?: InputMaybe<Scalars['String']['input']>;
  supplierUuid: Scalars['String']['input'];
};

export type CreateSupplierSetupDimensionsInput = {
  depth: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type CreateSupplierSetupImagesInput = {
  supplierImageUuid: Scalars['String']['input'];
};

export type CreateSupplierSetupInput = {
  availability?: InputMaybe<Scalars['String']['input']>;
  eventType: SupplierSetupEventType;
  setupType: SupplierSetupType;
  state?: InputMaybe<SupplierSetupState>;
  supplierSetupBackDimensions?: InputMaybe<CreateSupplierSetupDimensionsInput>;
  supplierSetupFrontDimensions?: InputMaybe<CreateSupplierSetupDimensionsInput>;
  supplierSetupImages?: InputMaybe<Array<CreateSupplierSetupImagesInput>>;
  supplierSetupPowerConnections?: InputMaybe<CreateSupplierSetupPowerConnectionsInput>;
  supplierSetupRequirements?: InputMaybe<CreateSupplierSetupRequirementsInput>;
  supplierUuid: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateSupplierSetupPowerConnectionsInput = {
  x13amp: Scalars['Int']['input'];
  x16ThreePhase: Scalars['Int']['input'];
  x16amp: Scalars['Int']['input'];
  x32amp: Scalars['Int']['input'];
  x33ThreePhase: Scalars['Int']['input'];
  x63ThreePhase: Scalars['Int']['input'];
};

export type CreateSupplierSetupRequirementsInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  fullyElectric: Scalars['Boolean']['input'];
  hotHoldOnly: Scalars['Boolean']['input'];
  loadRequirements?: InputMaybe<Scalars['String']['input']>;
  lowSmoke: Scalars['Boolean']['input'];
  usesGas: Scalars['Boolean']['input'];
};

export type CustomerEventFilter = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventUuid?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<EventStateFilter>;
};

export type CustomerEventRequestFilter = {
  requestId?: InputMaybe<Scalars['String']['input']>;
  requestUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerEventRequestsFilter = {
  requestUuids: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CustomerEventsFilter = {
  state?: InputMaybe<EventStateFilter>;
};

export type CustomerQuotePriceRange = {
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomerQuoteState {
  Booked = 'BOOKED',
  Shortlisted = 'SHORTLISTED'
}

export type CustomerQuotes = {
  __typename?: 'CustomerQuotes';
  preFilteredQuotesCount?: Maybe<Scalars['Int']['output']>;
  quotes?: Maybe<Array<Maybe<Quotes>>>;
};

export type CustomerQuotesFilter = {
  priceRange?: InputMaybe<CustomerQuotePriceRange>;
  quoteState?: InputMaybe<CustomerQuoteState>;
  supplierTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomerQuotesOrderByInput = {
  created?: InputMaybe<SortOrder>;
  score?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
};

export type CustomerUpdateQuoteInput = {
  isShortlisted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum DeclinedContext {
  Admin = 'ADMIN',
  Checkout = 'CHECKOUT',
  Messaging = 'MESSAGING',
  Quote = 'QUOTE'
}

export type DeclinedEventRequestsEventRequestsWhereInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DeclinedEventRequestsWhereInput = {
  event_request_id?: InputMaybe<Scalars['String']['input']>;
  event_requests?: InputMaybe<DeclinedEventRequestsEventRequestsWhereInput>;
};

export type Declined_Event_RequestsListRelationFilter = {
  every?: InputMaybe<Declined_Event_RequestsWhereInput>;
  none?: InputMaybe<Declined_Event_RequestsWhereInput>;
  some?: InputMaybe<Declined_Event_RequestsWhereInput>;
};

export type DeregisterDevicePushTokenInput = {
  deviceUuid: Scalars['String']['input'];
};

export type DeregisterDevicePushTokenResponse = {
  __typename?: 'DeregisterDevicePushTokenResponse';
  success: Scalars['Boolean']['output'];
};

export type DirectRequest = {
  __typename?: 'DirectRequest';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<Users>;
  eventRequestUuid: Scalars['String']['output'];
  supplier?: Maybe<Suppliers>;
  supplierUuid: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum DistanceSource {
  CrowFlies = 'crow_flies',
  GoogleMaps = 'google_maps',
  Valhalla = 'valhalla'
}

export type DrivingDistanceToEventRequest = {
  __typename?: 'DrivingDistanceToEventRequest';
  distance: Scalars['Float']['output'];
  distanceAndEta?: Maybe<Scalars['String']['output']>;
  eventRequestId: Scalars['String']['output'];
  source?: Maybe<DistanceSource>;
};

export type EditTagInput = {
  data: TagsUpdateInput;
  where: TagsWhereUniqueInput;
};

export type EditUserInput = {
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  type: Enum_Users_Type;
};

export type Enumenum_Bookings_StateNullableFilter = {
  equals?: InputMaybe<Enum_Bookings_State>;
  in?: InputMaybe<Array<Enum_Bookings_State>>;
  not?: InputMaybe<NestedEnumenum_Bookings_StateNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Bookings_State>>;
};

export type Enumenum_Calls_Call_ToNullableFilter = {
  equals?: InputMaybe<Enum_Calls_Call_To>;
  in?: InputMaybe<Array<Enum_Calls_Call_To>>;
  not?: InputMaybe<NestedEnumenum_Calls_Call_ToNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Calls_Call_To>>;
};

export type Enumenum_Conversations_Messages_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Conversations_Messages_Type>;
};

export type Enumenum_Conversations_Messages_TypeFilter = {
  equals?: InputMaybe<Enum_Conversations_Messages_Type>;
  in?: InputMaybe<Array<Enum_Conversations_Messages_Type>>;
  not?: InputMaybe<NestedEnumenum_Conversations_Messages_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Conversations_Messages_Type>>;
};

export type Enumenum_Declined_Event_Requests_Declined_ReasonNullableFilter = {
  equals?: InputMaybe<Enum_Declined_Event_Requests_Declined_Reason>;
  in?: InputMaybe<Array<Enum_Declined_Event_Requests_Declined_Reason>>;
  not?: InputMaybe<NestedEnumenum_Declined_Event_Requests_Declined_ReasonNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Declined_Event_Requests_Declined_Reason>>;
};

export type Enumenum_Event_Areas_AreaFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Areas_Area>;
};

export type Enumenum_Event_Areas_AreaFilter = {
  equals?: InputMaybe<Enum_Event_Areas_Area>;
  in?: InputMaybe<Array<Enum_Event_Areas_Area>>;
  not?: InputMaybe<NestedEnumenum_Event_Areas_AreaFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Areas_Area>>;
};

export type Enumenum_Event_Dates_StateNullableFilter = {
  equals?: InputMaybe<Enum_Event_Dates_State>;
  in?: InputMaybe<Array<Enum_Event_Dates_State>>;
  not?: InputMaybe<NestedEnumenum_Event_Dates_StateNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Dates_State>>;
};

export type Enumenum_Event_Request_Additional_Info_Bar_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Bar_Type>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Bar_Type>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_Bar_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Bar_Type>>;
};

export type Enumenum_Event_Request_Additional_Info_ChildrenNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Children>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Children>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_ChildrenNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Children>>;
};

export type Enumenum_Event_Request_Additional_Info_Courses_CourseNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Courses_Course>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Courses_Course>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_Courses_CourseNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Courses_Course>>;
};

export type Enumenum_Event_Request_Additional_Info_CrockeryNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Crockery>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Crockery>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_CrockeryNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Crockery>>;
};

export type Enumenum_Event_Request_Additional_Info_PowerNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Power>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Power>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_PowerNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Power>>;
};

export type Enumenum_Event_Request_Additional_Info_WaitersNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Waiters>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Waiters>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_WaitersNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Waiters>>;
};

export type Enumenum_Event_Request_Additional_Info_WaterNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Water>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Water>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_WaterNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Water>>;
};

export type Enumenum_Event_Request_Supplier_Notified_Call_MethodNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Supplier_Notified_Call_Method>;
  in?: InputMaybe<Array<Enum_Event_Request_Supplier_Notified_Call_Method>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Supplier_Notified_Call_MethodNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Supplier_Notified_Call_Method>>;
};

export type Enumenum_External_Payment_Info_ProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_External_Payment_Info_Provider>;
};

export type Enumenum_External_Payment_Info_ProviderFilter = {
  equals?: InputMaybe<Enum_External_Payment_Info_Provider>;
  in?: InputMaybe<Array<Enum_External_Payment_Info_Provider>>;
  not?: InputMaybe<NestedEnumenum_External_Payment_Info_ProviderFilter>;
  notIn?: InputMaybe<Array<Enum_External_Payment_Info_Provider>>;
};

export type Enumenum_Quote_Line_Item_Templates_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quote_Line_Item_Templates_Type>;
  in?: InputMaybe<Array<Enum_Quote_Line_Item_Templates_Type>>;
  not?: InputMaybe<NestedEnumenum_Quote_Line_Item_Templates_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quote_Line_Item_Templates_Type>>;
};

export type Enumenum_Quote_Line_Items_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quote_Line_Items_Type>;
  in?: InputMaybe<Array<Enum_Quote_Line_Items_Type>>;
  not?: InputMaybe<NestedEnumenum_Quote_Line_Items_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quote_Line_Items_Type>>;
};

export type Enumenum_Quote_Template_Line_Items_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quote_Template_Line_Items_Type>;
  in?: InputMaybe<Array<Enum_Quote_Template_Line_Items_Type>>;
  not?: InputMaybe<NestedEnumenum_Quote_Template_Line_Items_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quote_Template_Line_Items_Type>>;
};

export type Enumenum_Quotes_Declined_ReasonNullableFilter = {
  equals?: InputMaybe<Enum_Quotes_Declined_Reason>;
  in?: InputMaybe<Array<Enum_Quotes_Declined_Reason>>;
  not?: InputMaybe<NestedEnumenum_Quotes_Declined_ReasonNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quotes_Declined_Reason>>;
};

export type Enumenum_Quotes_Payment_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quotes_Payment_Type>;
  in?: InputMaybe<Array<Enum_Quotes_Payment_Type>>;
  not?: InputMaybe<NestedEnumenum_Quotes_Payment_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quotes_Payment_Type>>;
};

export type Enumenum_Quotes_StateFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Quotes_State>;
};

export type Enumenum_Quotes_StateFilter = {
  equals?: InputMaybe<Enum_Quotes_State>;
  in?: InputMaybe<Array<Enum_Quotes_State>>;
  not?: InputMaybe<NestedEnumenum_Quotes_StateFilter>;
  notIn?: InputMaybe<Array<Enum_Quotes_State>>;
};

export type Enumenum_Reviews_SourceNullableFilter = {
  equals?: InputMaybe<Enum_Reviews_Source>;
  in?: InputMaybe<Array<Enum_Reviews_Source>>;
  not?: InputMaybe<NestedEnumenum_Reviews_SourceNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Reviews_Source>>;
};

export type Enumenum_Robex_Notifications_Notification_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Robex_Notifications_Notification_Status>;
  in?: InputMaybe<Array<Enum_Robex_Notifications_Notification_Status>>;
  not?: InputMaybe<NestedEnumenum_Robex_Notifications_Notification_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Robex_Notifications_Notification_Status>>;
};

export type Enumenum_Scheduled_Payments_MethodFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Scheduled_Payments_Method>;
};

export type Enumenum_Scheduled_Payments_MethodFilter = {
  equals?: InputMaybe<Enum_Scheduled_Payments_Method>;
  in?: InputMaybe<Array<Enum_Scheduled_Payments_Method>>;
  not?: InputMaybe<NestedEnumenum_Scheduled_Payments_MethodFilter>;
  notIn?: InputMaybe<Array<Enum_Scheduled_Payments_Method>>;
};

export type Enumenum_Scheduled_Payments_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Scheduled_Payments_Type>;
};

export type Enumenum_Scheduled_Payments_TypeFilter = {
  equals?: InputMaybe<Enum_Scheduled_Payments_Type>;
  in?: InputMaybe<Array<Enum_Scheduled_Payments_Type>>;
  not?: InputMaybe<NestedEnumenum_Scheduled_Payments_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Scheduled_Payments_Type>>;
};

export type Enumenum_Supplier_Calendars_Events_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Calendars_Events_Type>;
  in?: InputMaybe<Array<Enum_Supplier_Calendars_Events_Type>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Calendars_Events_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Calendars_Events_Type>>;
};

export type Enumenum_Supplier_Documents_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Documents_Type>;
};

export type Enumenum_Supplier_Documents_TypeFilter = {
  equals?: InputMaybe<Enum_Supplier_Documents_Type>;
  in?: InputMaybe<Array<Enum_Supplier_Documents_Type>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Documents_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Documents_Type>>;
};

export type Enumenum_Supplier_Flexible_Pricing_Day_Of_WeekNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Flexible_Pricing_Day_Of_Week>;
  in?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Day_Of_Week>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Flexible_Pricing_Day_Of_WeekNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Day_Of_Week>>;
};

export type Enumenum_Supplier_Flexible_Pricing_MonthNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Flexible_Pricing_Month>;
  in?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Month>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Flexible_Pricing_MonthNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Month>>;
};

export type Enumenum_Supplier_Flexible_Pricing_Price_AdjustmentFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Flexible_Pricing_Price_Adjustment>;
};

export type Enumenum_Supplier_Flexible_Pricing_Price_AdjustmentFilter = {
  equals?: InputMaybe<Enum_Supplier_Flexible_Pricing_Price_Adjustment>;
  in?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Price_Adjustment>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Flexible_Pricing_Price_AdjustmentFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Price_Adjustment>>;
};

export type Enumenum_Supplier_Payments_MethodFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Payments_Method>;
};

export type Enumenum_Supplier_Payments_MethodFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Method>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Method>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_MethodFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Method>>;
};

export type Enumenum_Supplier_Payments_Payment_MethodFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Payments_Payment_Method>;
};

export type Enumenum_Supplier_Payments_Payment_MethodFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Payment_Method>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Payment_Method>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_Payment_MethodFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Payment_Method>>;
};

export type Enumenum_Supplier_Payments_StatusFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Payments_Status>;
};

export type Enumenum_Supplier_Payments_StatusFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Status>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Status>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_StatusFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Status>>;
};

export type Enumenum_Supplier_Payments_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Payments_Type>;
};

export type Enumenum_Supplier_Payments_TypeFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Type>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Type>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Type>>;
};

export type Enumenum_Supplier_Stats_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Stats_Status>;
  in?: InputMaybe<Array<Enum_Supplier_Stats_Status>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Stats_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Stats_Status>>;
};

export type Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Suppliers_Kyb_Status>;
};

export type Enumenum_Suppliers_Kyb_StatusFilter = {
  equals?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  in?: InputMaybe<Array<Enum_Suppliers_Kyb_Status>>;
  not?: InputMaybe<NestedEnumenum_Suppliers_Kyb_StatusFilter>;
  notIn?: InputMaybe<Array<Enum_Suppliers_Kyb_Status>>;
};

export type Enumenum_Suppliers_StateNullableFilter = {
  equals?: InputMaybe<Enum_Suppliers_State>;
  in?: InputMaybe<Array<Enum_Suppliers_State>>;
  not?: InputMaybe<NestedEnumenum_Suppliers_StateNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Suppliers_State>>;
};

export type Enumenum_User_External_Ids_ProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_User_External_Ids_Provider>;
};

export type Enumenum_User_External_Ids_ProviderFilter = {
  equals?: InputMaybe<Enum_User_External_Ids_Provider>;
  in?: InputMaybe<Array<Enum_User_External_Ids_Provider>>;
  not?: InputMaybe<NestedEnumenum_User_External_Ids_ProviderFilter>;
  notIn?: InputMaybe<Array<Enum_User_External_Ids_Provider>>;
};

export type Enumenum_Users_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Users_Type>;
  in?: InputMaybe<Array<Enum_Users_Type>>;
  not?: InputMaybe<NestedEnumenum_Users_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Users_Type>>;
};

export type Enumenum_Voice_Calling_Recipient_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Voice_Calling_Recipient_Type>;
};

export type Enumenum_Voice_Calling_Recipient_TypeFilter = {
  equals?: InputMaybe<Enum_Voice_Calling_Recipient_Type>;
  in?: InputMaybe<Array<Enum_Voice_Calling_Recipient_Type>>;
  not?: InputMaybe<NestedEnumenum_Voice_Calling_Recipient_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Voice_Calling_Recipient_Type>>;
};

export type Enumenum_Voice_Calls_Primary_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Voice_Calls_Primary_Status>;
  in?: InputMaybe<Array<Enum_Voice_Calls_Primary_Status>>;
  not?: InputMaybe<NestedEnumenum_Voice_Calls_Primary_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Voice_Calls_Primary_Status>>;
};

export type Enumenum_Voice_Calls_Secondary_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Voice_Calls_Secondary_Status>;
  in?: InputMaybe<Array<Enum_Voice_Calls_Secondary_Status>>;
  not?: InputMaybe<NestedEnumenum_Voice_Calls_Secondary_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Voice_Calls_Secondary_Status>>;
};

export type Enumenum_Workflow_Automations_Message_Templates_Automation_TriggerFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Workflow_Automations_Message_Templates_Automation_Trigger>;
};

export type Enumenum_Workflow_Automations_Message_Templates_Automation_TriggerFilter = {
  equals?: InputMaybe<Enum_Workflow_Automations_Message_Templates_Automation_Trigger>;
  in?: InputMaybe<Array<Enum_Workflow_Automations_Message_Templates_Automation_Trigger>>;
  not?: InputMaybe<NestedEnumenum_Workflow_Automations_Message_Templates_Automation_TriggerFilter>;
  notIn?: InputMaybe<Array<Enum_Workflow_Automations_Message_Templates_Automation_Trigger>>;
};

export type Enumenum_Xero_Invoices_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Xero_Invoices_Type>;
};

export type Enumenum_Xero_Invoices_TypeFilter = {
  equals?: InputMaybe<Enum_Xero_Invoices_Type>;
  in?: InputMaybe<Array<Enum_Xero_Invoices_Type>>;
  not?: InputMaybe<NestedEnumenum_Xero_Invoices_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Xero_Invoices_Type>>;
};

export type Enumevent_TypeNullableFilter = {
  equals?: InputMaybe<Event_Type>;
  in?: InputMaybe<Array<Event_Type>>;
  not?: InputMaybe<NestedEnumevent_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Event_Type>>;
};

export enum EventCancelReason {
  FoundElsewhere = 'FOUND_ELSEWHERE',
  NotWhatIWant = 'NOT_WHAT_I_WANT',
  NoLongerTakingPlace = 'NO_LONGER_TAKING_PLACE',
  Other = 'OTHER'
}

export type EventDeliveriesFilter = {
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<EventDeliveriesOrderByInput>;
  stages?: InputMaybe<Array<EventDeliveryStage>>;
};

export type EventDeliveriesOrderByInput = {
  eventDate?: InputMaybe<SortOrder>;
};

export type EventDelivery = {
  __typename?: 'EventDelivery';
  applicationDeadline?: Maybe<Scalars['DateTime']['output']>;
  barPitchCount?: Maybe<Scalars['Int']['output']>;
  closedDates?: Maybe<Scalars['String']['output']>;
  contacts: Array<EventDeliveryContact>;
  created: Scalars['DateTime']['output'];
  createdDate: Scalars['DateTime']['output'];
  documentsPublished: Scalars['Boolean']['output'];
  estimatedFootfall?: Maybe<Scalars['Int']['output']>;
  eventAddressCity?: Maybe<Scalars['String']['output']>;
  eventAddressCountryCode?: Maybe<EventDeliveryEventAddressCountryCode>;
  eventAddressPostalCode?: Maybe<Scalars['String']['output']>;
  eventAddressStreet?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  eventDeliveryStage: EventDeliveryStage;
  eventDescription?: Maybe<Scalars['String']['output']>;
  eventEndDate?: Maybe<Scalars['DateTime']['output']>;
  eventImageUrl?: Maybe<Scalars['String']['output']>;
  hotDrinkPitchCount?: Maybe<Scalars['Int']['output']>;
  indoorOutdoor?: Maybe<EventDeliveryIndoorOutdoor>;
  infrastructureFees?: Maybe<Scalars['String']['output']>;
  loadInDate?: Maybe<Scalars['DateTime']['output']>;
  loadInTime?: Maybe<Scalars['String']['output']>;
  loadOutDate?: Maybe<Scalars['DateTime']['output']>;
  loadOutTime?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  organisationUuid?: Maybe<Scalars['String']['output']>;
  otherPitchCount?: Maybe<Scalars['Int']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  pitchGroups: Array<PitchGroup>;
  retailPitchCount?: Maybe<Scalars['Int']['output']>;
  salesHistory?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  savouryPitchCount?: Maybe<Scalars['Int']['output']>;
  serviceTimes?: Maybe<Scalars['String']['output']>;
  siteRestrictions?: Maybe<Scalars['String']['output']>;
  staffVoucherDeal?: Maybe<Scalars['String']['output']>;
  supplyManagerId?: Maybe<Scalars['String']['output']>;
  sweetPitchCount?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedEventName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type EventDeliveryContact = {
  __typename?: 'EventDeliveryContact';
  created: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EventDeliveryDocument = {
  __typename?: 'EventDeliveryDocument';
  created: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type EventDeliveryDocumentInput = {
  filename: Scalars['String']['input'];
  url: Scalars['URL']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum EventDeliveryEventAddressCountryCode {
  Gb = 'GB'
}

export enum EventDeliveryIndoorOutdoor {
  Both = 'BOTH',
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR'
}

export enum EventDeliveryStage {
  Applications = 'APPLICATIONS',
  Briefed = 'BRIEFED',
  Lost = 'LOST',
  New = 'NEW',
  PitchBooked = 'PITCH_BOOKED',
  PostEvent = 'POST_EVENT',
  PreEvent = 'PRE_EVENT',
  Won = 'WON'
}

export type EventDeliverySupplierDocumentsDownload = {
  __typename?: 'EventDeliverySupplierDocumentsDownload';
  created: Scalars['DateTime']['output'];
  eventDeliveryUuid: Scalars['String']['output'];
  status: SuppliersDocumentsDownloadStatus;
  updated: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum EventState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE'
}

export type EventStateFilter = {
  equals?: InputMaybe<EventState>;
  in?: InputMaybe<Array<EventState>>;
  not?: InputMaybe<EventState>;
  notIn?: InputMaybe<Array<EventState>>;
};

export enum EventTypeEnum {
  Birthday = 'birthday',
  Celebration = 'celebration',
  CorporateEvent = 'corporate_event',
  DinnerParty = 'dinner_party',
  PublicFacingEvent = 'public_facing_event',
  Virtual = 'virtual',
  Wedding = 'wedding'
}

export type Event_AreasListRelationFilter = {
  every?: InputMaybe<Event_AreasWhereInput>;
  none?: InputMaybe<Event_AreasWhereInput>;
  some?: InputMaybe<Event_AreasWhereInput>;
};

export type Event_DatesListRelationFilter = {
  every?: InputMaybe<Event_DatesWhereInput>;
  none?: InputMaybe<Event_DatesWhereInput>;
  some?: InputMaybe<Event_DatesWhereInput>;
};

export type Event_Request_Additional_InfoListRelationFilter = {
  every?: InputMaybe<Event_Request_Additional_InfoWhereInput>;
  none?: InputMaybe<Event_Request_Additional_InfoWhereInput>;
  some?: InputMaybe<Event_Request_Additional_InfoWhereInput>;
};

export type Event_Request_Additional_Info_CoursesListRelationFilter = {
  every?: InputMaybe<Event_Request_Additional_Info_CoursesWhereInput>;
  none?: InputMaybe<Event_Request_Additional_Info_CoursesWhereInput>;
  some?: InputMaybe<Event_Request_Additional_Info_CoursesWhereInput>;
};

export type Event_Request_Priority_TagsListRelationFilter = {
  every?: InputMaybe<Event_Request_Priority_TagsWhereInput>;
  none?: InputMaybe<Event_Request_Priority_TagsWhereInput>;
  some?: InputMaybe<Event_Request_Priority_TagsWhereInput>;
};

export type Event_Request_Supplier_NotifiedListRelationFilter = {
  every?: InputMaybe<Event_Request_Supplier_NotifiedWhereInput>;
  none?: InputMaybe<Event_Request_Supplier_NotifiedWhereInput>;
  some?: InputMaybe<Event_Request_Supplier_NotifiedWhereInput>;
};

export type Event_Request_TagsListRelationFilter = {
  every?: InputMaybe<Event_Request_TagsWhereInput>;
  none?: InputMaybe<Event_Request_TagsWhereInput>;
  some?: InputMaybe<Event_Request_TagsWhereInput>;
};

export type Event_RequestsListRelationFilter = {
  every?: InputMaybe<Event_RequestsWhereInput>;
  none?: InputMaybe<Event_RequestsWhereInput>;
  some?: InputMaybe<Event_RequestsWhereInput>;
};

export type Event_SetupsListRelationFilter = {
  every?: InputMaybe<Event_SetupsWhereInput>;
  none?: InputMaybe<Event_SetupsWhereInput>;
  some?: InputMaybe<Event_SetupsWhereInput>;
};

export type Event_TagsListRelationFilter = {
  every?: InputMaybe<Event_TagsWhereInput>;
  none?: InputMaybe<Event_TagsWhereInput>;
  some?: InputMaybe<Event_TagsWhereInput>;
};

export type EventsListRelationFilter = {
  every?: InputMaybe<EventsWhereInput>;
  none?: InputMaybe<EventsWhereInput>;
  some?: InputMaybe<EventsWhereInput>;
};

export type ExternalSupplierInfo = {
  __typename?: 'ExternalSupplierInfo';
  foodSafetyAgencyId?: Maybe<Scalars['String']['output']>;
  hygieneRating?: Maybe<Scalars['String']['output']>;
  iZettleStaffName?: Maybe<Scalars['String']['output']>;
  numReviews?: Maybe<Scalars['Int']['output']>;
};

export type FavouriteSupplier = {
  __typename?: 'FavouriteSupplier';
  average_rating?: Maybe<Scalars['Float']['output']>;
  categoryTier1?: Maybe<Scalars['String']['output']>;
  dietary: Array<FavouriteSupplierTag>;
  name?: Maybe<Scalars['String']['output']>;
  public: FavouriteSupplierPublic;
  slug?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<FavouriteSupplierTag>;
  uuid: Scalars['String']['output'];
};

export type FavouriteSupplierPublic = {
  __typename?: 'FavouriteSupplierPublic';
  images?: Maybe<Scalars['Json']['output']>;
};

export type FavouriteSupplierTag = {
  __typename?: 'FavouriteSupplierTag';
  name?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
};

export type FavouritesListRelationFilter = {
  every?: InputMaybe<FavouritesWhereInput>;
  none?: InputMaybe<FavouritesWhereInput>;
  some?: InputMaybe<FavouritesWhereInput>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GetLegacyQuoteLineItemTemplates = {
  __typename?: 'GetLegacyQuoteLineItemTemplates';
  menuItems: Array<QuoteLineItemTemplate>;
  quoteLineItemTemplates: Array<QuoteLineItemTemplate>;
  quoteTemplateLineItems: Array<QuoteLineItemTemplate>;
};

export type GetPitchGroupsResponse = {
  __typename?: 'GetPitchGroupsResponse';
  results: Array<PitchGroup>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type GetQuoteLineItemTemplatesSections = {
  __typename?: 'GetQuoteLineItemTemplatesSections';
  main: Array<QuoteLineItemTemplatesSection>;
};

export type GetSupplierLineItemsForCustomerInput = {
  quoteUuid: Scalars['String']['input'];
  supplierUuid: Scalars['String']['input'];
};

export type GetSupplierPitchApplicationResponse = {
  __typename?: 'GetSupplierPitchApplicationResponse';
  results: Array<PitchApplication>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type Hidden_Event_RequestsListRelationFilter = {
  every?: InputMaybe<Hidden_Event_RequestsWhereInput>;
  none?: InputMaybe<Hidden_Event_RequestsWhereInput>;
  some?: InputMaybe<Hidden_Event_RequestsWhereInput>;
};

export type IdentifyUser = {
  __typename?: 'IdentifyUser';
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  address_city: Scalars['String']['output'];
  address_line1: Scalars['String']['output'];
  address_line2?: Maybe<Scalars['String']['output']>;
  address_postcode: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceDetailsInput = {
  addressCity: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressPostcode: Scalars['String']['input'];
  includeProtectPlus?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceDetailId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  poNumber?: InputMaybe<Scalars['String']['input']>;
  signatoryEmail?: InputMaybe<Scalars['String']['input']>;
  signatoryName?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  equals?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export type JsonNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Json']['input']>>;
  has?: InputMaybe<Scalars['Json']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['Json']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['Json']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkUserInput = {
  cognitoUsername: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  linkExistingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  type: LinkUserType;
};

export enum LinkUserType {
  Admin = 'admin',
  Customer = 'customer',
  Supplier = 'supplier'
}

export type LiveAccountManagers = {
  __typename?: 'LiveAccountManagers';
  eventProducer?: Maybe<SalesforceAccountManagerV2>;
  supplyManager?: Maybe<SalesforceAccountManagerV2>;
};

export enum LoginAccountType {
  Cognito = 'COGNITO',
  Legacy = 'LEGACY',
  Sso = 'SSO'
}

export type MatchReason = {
  __typename?: 'MatchReason';
  contribution?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MatchedQuoteTemplate = {
  __typename?: 'MatchedQuoteTemplate';
  created?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<EventTypeEnum>;
  menu?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  priceMatchScore?: Maybe<Scalars['Float']['output']>;
  price_per_head?: Maybe<Scalars['Int']['output']>;
  quote_template_tags?: Maybe<Array<Maybe<QuoteTemplateTagNamesAndIds>>>;
  requestQuotePrice?: Maybe<Scalars['Float']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  tagMatchScore?: Maybe<Scalars['Float']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type MatchedQuoteTemplates = {
  __typename?: 'MatchedQuoteTemplates';
  requestId?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<MatchedQuoteTemplate>>>;
};

export enum MobilePushApnsEnvironment {
  Production = 'PRODUCTION',
  Sandbox = 'SANDBOX'
}

export enum MobilePushPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Mutation = {
  __typename?: 'Mutation';
  addCategoryTier2Tag: Tier2Tags;
  addFeedback?: Maybe<Void>;
  addSupplierImage?: Maybe<Update_Supplier_Images>;
  addTag: Tags;
  adminCreateUser: Users;
  adminRegisterSupplierEvent: SupplierActivityEvent;
  adminResetPassword?: Maybe<Scalars['Void']['output']>;
  /**
   * Records which public listing belongs to a supplier, or that none of the
   * candidates do. Writing replaces whatever was decided before.
   */
  adminSetSupplierReviewListing: AdminSupplierReviewListing;
  adminUpdateCognitoUserOptions: AdminCognitoUser;
  adminUpdateSupplier: Suppliers;
  applyPromotion?: Maybe<Void>;
  attachPaymentMethod?: Maybe<Scalars['Void']['output']>;
  callCustomer?: Maybe<CallUserType>;
  callSupplier?: Maybe<CallUserType>;
  cancelEvent?: Maybe<Scalars['Boolean']['output']>;
  cancelEventRequest?: Maybe<Void>;
  checkoutPayment: CheckoutPaymentResponse;
  closeCustomerAccount?: Maybe<Scalars['Void']['output']>;
  completeEventRequest?: Maybe<Event_Requests>;
  completeLegacyPasswordReset?: Maybe<Scalars['Void']['output']>;
  confirmPayment: PaymentInformation;
  confirmQuotePricing?: Maybe<Quotes>;
  connectItemToGroup: Suppliers_Groups_Items;
  convertSupplierLead?: Maybe<Void>;
  createAndAssociateInvoiceDetails: InvoiceDetails;
  createCustomerReferralLinks?: Maybe<CustomerReferralLinksResponse>;
  createDeclinedEventRequest?: Maybe<Declined_Event_Requests>;
  createDirectRequest?: Maybe<DirectRequest>;
  createEventRequest?: Maybe<Event_Requests>;
  createEventWithRequests?: Maybe<EventWithRequests>;
  createFavouriteSupplier?: Maybe<Scalars['Void']['output']>;
  createManualSupplierDepositPayment?: Maybe<Scalars['Void']['output']>;
  createMenuGroup: Suppliers_Groups;
  createPartnership: Partnership;
  createPayment: CreatePaymentResponse;
  createPaymentSubscription?: Maybe<Scalars['Void']['output']>;
  createPitchApplication?: Maybe<PitchApplication>;
  createQuoteLineItemTemplate?: Maybe<QuoteLineItemTemplate>;
  createQuoteLineItemTemplatesSection?: Maybe<QuoteLineItemTemplatesSection>;
  createQuoteTemplate?: Maybe<Quote_Templates>;
  createReview: Reviews;
  createShortLead?: Maybe<Scalars['Void']['output']>;
  createSpace: Venue_Spaces;
  createSpaceGroup: Space_Groups;
  createSupplier: Suppliers;
  createSupplierCalendarEventV2?: Maybe<SupplierCalendarEvent>;
  createSupplierFlexiblePricing?: Maybe<Supplier_Flexible_Pricing>;
  createSupplierReferralLink: SupplierReferralLink;
  createSupplierSetup?: Maybe<SupplierSetup>;
  createSupplierSetupDocument?: Maybe<UploadFileResponse>;
  createSupplierUser: Suppliers_Users;
  createWorkflowAutomationsMessageTemplate?: Maybe<Workflow_Automations_Message_Templates>;
  customerUpdateQuote?: Maybe<Quotes>;
  declinePendingQuotes?: Maybe<Void>;
  declineQuote?: Maybe<Void>;
  deleteAllSupplierDocuments?: Maybe<Scalars['Void']['output']>;
  deleteAllSupplierSetups?: Maybe<Scalars['Void']['output']>;
  deleteAllUserEvents?: Maybe<Scalars['Void']['output']>;
  deleteAttachment?: Maybe<Scalars['Void']['output']>;
  deleteCategoryTier2Tag?: Maybe<Scalars['Void']['output']>;
  deleteCognitoUser?: Maybe<Scalars['Void']['output']>;
  deleteDeclinedEventRequest?: Maybe<Void>;
  deleteEventDeliveryDocument?: Maybe<EventDeliveryDocument>;
  deleteFavouriteSuppliers?: Maybe<Scalars['Void']['output']>;
  deleteFile?: Maybe<Void>;
  deleteMenuGroup?: Maybe<Suppliers_Groups>;
  deleteMenuItem?: Maybe<Suppliers_Items>;
  deletePartnership?: Maybe<Scalars['Void']['output']>;
  deletePaymentMethod?: Maybe<Scalars['Void']['output']>;
  deletePitchApplicationDocument?: Maybe<Scalars['Void']['output']>;
  deleteQuote?: Maybe<Scalars['Void']['output']>;
  deleteQuoteLineItemTemplate?: Maybe<Void>;
  deleteQuoteLineItemTemplatesSection?: Maybe<Scalars['Void']['output']>;
  deleteQuoteTemplate?: Maybe<Scalars['Void']['output']>;
  deleteSpace?: Maybe<Venue_Spaces>;
  deleteSpaceGroup?: Maybe<Space_Groups>;
  deleteSpaceTag?: Maybe<Space_Tags>;
  deleteSupplierCalendarEventV2?: Maybe<Void>;
  deleteSupplierDocument?: Maybe<Scalars['Void']['output']>;
  deleteSupplierFlexiblePricing?: Maybe<Scalars['Void']['output']>;
  deleteSupplierSetup?: Maybe<SupplierSetup>;
  deleteUser?: Maybe<Scalars['Void']['output']>;
  deleteUserAndSupplier?: Maybe<Scalars['Void']['output']>;
  deleteWorkflowAutomationsMessageTemplate?: Maybe<Scalars['Void']['output']>;
  deregisterDevicePushToken: DeregisterDevicePushTokenResponse;
  documentAIChecker: SupplierDocumentCheckResult;
  editEvent?: Maybe<Events>;
  editEventRequest?: Maybe<Event_Requests>;
  editPartnership: Partnership;
  editPartnershipActiveStatus: Partnership;
  editSupplierFlexiblePricing?: Maybe<Supplier_Flexible_Pricing>;
  editTag: Tags;
  editUser: Users;
  exchangeExternalOTP?: Maybe<InitialExternalAppToken>;
  failSubscriptionSetup?: Maybe<Scalars['Void']['output']>;
  generateEventDeliverySuppliersDocumentsFile?: Maybe<EventDeliverySupplierDocumentsDownload>;
  generateExternalAccessToken?: Maybe<InitialExternalAppToken>;
  generateSupplierInvoices: SupplierInvoices;
  getLLMResponse: Scalars['Json']['output'];
  getOrCreateQuoteConversation?: Maybe<Conversations>;
  impersonateUser?: Maybe<ImpersonateUserType>;
  initialiseExternalAppUrl?: Maybe<InitialiseExternalAppUrl>;
  inviteUserToLive360?: Maybe<Scalars['Void']['output']>;
  legacyResetPasswordMigration?: Maybe<Scalars['Void']['output']>;
  linkUser: Users;
  makeCarbonOffsetPayment?: Maybe<PaymentStatus>;
  markQuoteAsPaid?: Maybe<Scalars['Void']['output']>;
  markQuoteRead?: Maybe<Void>;
  markQuoteTemplateLineItemAsMigrated?: Maybe<Quote_Template_Line_Items>;
  markStageComplete?: Maybe<Void>;
  markSupplierAsPaid?: Maybe<Supplier_Payments>;
  paymentAccountOnboard?: Maybe<PaymentAccountOnboardResult>;
  paymentAccountSignIn?: Maybe<PaymentAccountSignInResult>;
  prefilterSuppliers: Array<Suppliers>;
  processSubscriptionSetup?: Maybe<Scalars['Void']['output']>;
  reRunMatchmaking?: Maybe<Scalars['Void']['output']>;
  readEventRequest?: Maybe<Supplier_Event_Requests>;
  registerDevicePushToken: RegisterDevicePushTokenResponse;
  removeExternalAuth?: Maybe<Scalars['Void']['output']>;
  removeSupplierImage?: Maybe<Update_Supplier_Images>;
  removeUserFromOrganisation?: Maybe<Scalars['Void']['output']>;
  reopenEventRequest?: Maybe<Void>;
  reopenSupplierOnboarding?: Maybe<Scalars['String']['output']>;
  requestAdminSupplierStatisticsUpdate: Scalars['Boolean']['output'];
  requestChange?: Maybe<Void>;
  requestLive360MagicLink: Scalars['String']['output'];
  requestResetPassword?: Maybe<Scalars['String']['output']>;
  resetPassword?: Maybe<Scalars['String']['output']>;
  runRobexMatching: RunRobexMatching;
  runVenuesMatching?: Maybe<RunVenuesMatching>;
  saveEventRequest?: Maybe<Supplier_Event_Requests>;
  saveEventRequestImageDescriptions: Event_Request_Image_Descriptions;
  /**
   * Sends the amendment chasers due today or earlier, at most once each. Called
   * daily by a cron; safe to re-run, since a chaser already attempted is
   * skipped.
   */
  sendDueSupplierOnboardingFollowUps: SendDueSupplierOnboardingFollowUpsResult;
  sendPlatformMagicLink?: Maybe<SendPlatformMagicLinkResponse>;
  setAgencyCommission?: Maybe<AgencyCommissionMutationResponse>;
  setAnonymousIdToUserId?: Maybe<AssignAnonymousIdToUserId>;
  setPriorityTag?: Maybe<PriorityTagStatus>;
  setQuoteToPending?: Maybe<Quotes>;
  setSupplierOnboardingStatus?: Maybe<Scalars['String']['output']>;
  setWeddingLead?: Maybe<WeddingLeadResponse>;
  startOfflineMatchmaking: OfflineMatchmakingBatch;
  supplierCreateQuote?: Maybe<Quotes>;
  supplierOnboarding?: Maybe<Suppliers_Users>;
  supplierUpdateQuoteMessage?: Maybe<Quotes>;
  supplierWithdrawQuote?: Maybe<Quotes>;
  toggleEventRequestQuoteLimiting?: Maybe<Event_Requests>;
  trackAnalyticsEvent?: Maybe<Scalars['Void']['output']>;
  triggerCreateSupplierInSF?: Maybe<Scalars['Void']['output']>;
  updateCustomEventName?: Maybe<Events>;
  updateMenuGroup?: Maybe<Suppliers_Groups>;
  updateMenuItemGroup?: Maybe<Suppliers_Groups_Items>;
  updateProfilePhoto?: Maybe<Update_Profile_Photo>;
  updateQuote?: Maybe<Quotes>;
  updateQuoteLineItemTemplate?: Maybe<QuoteLineItemTemplate>;
  updateQuoteLineItemTemplatesSection?: Maybe<QuoteLineItemTemplatesSection>;
  updateQuoteTemplate?: Maybe<Quote_Templates>;
  updateSpace?: Maybe<Venue_Spaces>;
  updateSpaceGroup?: Maybe<Space_Groups>;
  updateStatistics?: Maybe<Void>;
  updateSupplier?: Maybe<Suppliers>;
  updateSupplierCalendarEventV2?: Maybe<SupplierCalendarEvent>;
  updateSupplierLinks?: Maybe<Scalars['Void']['output']>;
  updateSupplierSetup?: Maybe<SupplierSetup>;
  updateTags?: Maybe<Update_Tags>;
  updateTierTwo?: Maybe<Update_Tier_Two>;
  updateUser?: Maybe<Users>;
  updateUserPreferences?: Maybe<User_Preferences>;
  updateWorkflowAutomationsMessageTemplate?: Maybe<Workflow_Automations_Message_Templates>;
  uploadAttachment?: Maybe<UploadFileResponse>;
  uploadFile?: Maybe<File_Data>;
  uploadMenuPitchApplication?: Maybe<Scalars['Void']['output']>;
  uploadPublicEventImage?: Maybe<UploadPublicEventImageType>;
  uploadPublicImage: UploadFileResponse;
  uploadSupplierDocument?: Maybe<UploadFileResponse>;
  upsertEventDeliveryDocument?: Maybe<EventDeliveryDocument>;
};


export type MutationAddCategoryTier2TagArgs = {
  categoryTier2: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};


export type MutationAddFeedbackArgs = {
  feedback?: InputMaybe<FeedbackInput>;
};


export type MutationAddSupplierImageArgs = {
  file: Scalars['Upload']['input'];
  supplierId: Scalars['String']['input'];
};


export type MutationAddTagArgs = {
  input: TagsCreateInput;
};


export type MutationAdminCreateUserArgs = {
  data: AdminCreateUserInput;
};


export type MutationAdminRegisterSupplierEventArgs = {
  input: AdminRegisterSupplierEventInput;
};


export type MutationAdminResetPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminSetSupplierReviewListingArgs = {
  input: AdminSetSupplierReviewListingInput;
};


export type MutationAdminUpdateCognitoUserOptionsArgs = {
  userOptions: CognitoUserOptionsInput;
  username: Scalars['String']['input'];
};


export type MutationAdminUpdateSupplierArgs = {
  data: AdminUpdateSupplierInput;
  supplierUuid: Scalars['String']['input'];
};


export type MutationApplyPromotionArgs = {
  promotionFields?: InputMaybe<PromotionFieldsInput>;
  promotionName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAttachPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationCallCustomerArgs = {
  conversationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCallSupplierArgs = {
  conversationId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type MutationCancelEventArgs = {
  eventUuid: Scalars['String']['input'];
  reason: EventCancelReason;
};


export type MutationCancelEventRequestArgs = {
  reason: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationCheckoutPaymentArgs = {
  input: CheckoutPaymentInput;
};


export type MutationCloseCustomerAccountArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteEventRequestArgs = {
  data: CompleteEventRequestData;
  requestId: Scalars['String']['input'];
};


export type MutationCompleteLegacyPasswordResetArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationConfirmPaymentArgs = {
  amount: Scalars['Float']['input'];
  analyticsContext: EventAnalytics;
  paymentIntentId: Scalars['String']['input'];
  protectionType: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
};


export type MutationConfirmQuotePricingArgs = {
  hasProtection: Scalars['Boolean']['input'];
  paymentMethod?: InputMaybe<Enum_Quotes_Payment_Type>;
  quoteUuid: Scalars['String']['input'];
};


export type MutationConnectItemToGroupArgs = {
  data: Suppliers_Groups_ItemsCreateInput;
};


export type MutationConvertSupplierLeadArgs = {
  supplierId: Scalars['String']['input'];
};


export type MutationCreateAndAssociateInvoiceDetailsArgs = {
  data: InvoiceDetailsInput;
  quoteId: Scalars['String']['input'];
};


export type MutationCreateCustomerReferralLinksArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationCreateDeclinedEventRequestArgs = {
  declineReason?: InputMaybe<Scalars['String']['input']>;
  eventRequestId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type MutationCreateDirectRequestArgs = {
  requestUuid: Scalars['String']['input'];
  supplierUuid: Scalars['String']['input'];
};


export type MutationCreateEventRequestArgs = {
  data: CreateEventRequestInput;
};


export type MutationCreateEventWithRequestsArgs = {
  event: CreateEventInput;
  request: CreateRequestWithInput;
};


export type MutationCreateFavouriteSupplierArgs = {
  supplierId: Scalars['String']['input'];
};


export type MutationCreateManualSupplierDepositPaymentArgs = {
  amount: Scalars['Int']['input'];
  quoteId: Scalars['String']['input'];
  stripeAccountId: Scalars['String']['input'];
};


export type MutationCreateMenuGroupArgs = {
  data: Suppliers_GroupsCreateInput;
};


export type MutationCreatePartnershipArgs = {
  data: PartnershipInput;
};


export type MutationCreatePaymentArgs = {
  amount: Scalars['Float']['input'];
  analyticsContext: EventAnalytics;
  protectionType: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
};


export type MutationCreatePaymentSubscriptionArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationCreatePitchApplicationArgs = {
  data: CreatePitchApplicationInput;
};


export type MutationCreateQuoteLineItemTemplateArgs = {
  data: QuoteLineItemTemplateInput;
};


export type MutationCreateQuoteLineItemTemplatesSectionArgs = {
  data: UpsertQuoteLineItemTemplatesSectionInput;
};


export type MutationCreateQuoteTemplateArgs = {
  event_type?: InputMaybe<EventTypeEnum>;
  menu?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price_per_head?: InputMaybe<Scalars['Int']['input']>;
  quoteTemplateAttachments?: InputMaybe<Array<AttachmentInput>>;
  quote_template_line_items?: InputMaybe<Array<InputMaybe<QuoteTemplateLineItemsUpsert>>>;
  supplier_id: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateReviewArgs = {
  data: ReviewsCreateInput;
};


export type MutationCreateShortLeadArgs = {
  data: ShortLeadData;
};


export type MutationCreateSpaceArgs = {
  data: Venue_SpacesCreateInput;
};


export type MutationCreateSpaceGroupArgs = {
  data: Space_GroupsCreateInput;
};


export type MutationCreateSupplierArgs = {
  data: SuppliersCreateInput;
};


export type MutationCreateSupplierCalendarEventV2Args = {
  calendarId: Scalars['String']['input'];
  end_time: Scalars['String']['input'];
  start_time: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateSupplierFlexiblePricingArgs = {
  data: CreateSupplierFlexiblePricingInput;
};


export type MutationCreateSupplierSetupArgs = {
  data: CreateSupplierSetupInput;
};


export type MutationCreateSupplierSetupDocumentArgs = {
  documentType: SetupDocumentType;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationCreateSupplierUserArgs = {
  data: Suppliers_UsersCreateInput;
};


export type MutationCreateWorkflowAutomationsMessageTemplateArgs = {
  automationTrigger: AutomationTriggerEnum;
  isActive: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
  triggerInterval: Scalars['Int']['input'];
};


export type MutationCustomerUpdateQuoteArgs = {
  data: CustomerUpdateQuoteInput;
  quoteUuid: Scalars['String']['input'];
};


export type MutationDeclinePendingQuotesArgs = {
  requestUuid: Scalars['String']['input'];
};


export type MutationDeclineQuoteArgs = {
  declinedContext?: InputMaybe<DeclinedContext>;
  declinedReason: Declined_Reason;
  quoteId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteAllSupplierDocumentsArgs = {
  supplierId: Scalars['String']['input'];
};


export type MutationDeleteAllSupplierSetupsArgs = {
  supplierUuid: Scalars['String']['input'];
};


export type MutationDeleteAllUserEventsArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteAttachmentArgs = {
  documentKey: Scalars['String']['input'];
  entityType: AttachmentEntityType;
};


export type MutationDeleteCategoryTier2TagArgs = {
  categoryTier2: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};


export type MutationDeleteCognitoUserArgs = {
  username: Scalars['String']['input'];
};


export type MutationDeleteDeclinedEventRequestArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteEventDeliveryDocumentArgs = {
  eventDeliveryDocumentUuid: Scalars['String']['input'];
};


export type MutationDeleteFavouriteSuppliersArgs = {
  supplierId: Scalars['String']['input'];
};


export type MutationDeleteFileArgs = {
  key: Scalars['String']['input'];
};


export type MutationDeleteMenuGroupArgs = {
  where: Suppliers_GroupsWhereUniqueInput;
};


export type MutationDeleteMenuItemArgs = {
  where: Suppliers_ItemsWhereUniqueInput;
};


export type MutationDeletePartnershipArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationDeletePitchApplicationDocumentArgs = {
  documentUuid: Scalars['String']['input'];
};


export type MutationDeleteQuoteArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationDeleteQuoteLineItemTemplateArgs = {
  lineItemId: Scalars['String']['input'];
};


export type MutationDeleteQuoteLineItemTemplatesSectionArgs = {
  sectionUuid: Scalars['String']['input'];
};


export type MutationDeleteQuoteTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSpaceArgs = {
  where: Venue_SpacesWhereUniqueInput;
};


export type MutationDeleteSpaceGroupArgs = {
  where: Space_GroupsWhereUniqueInput;
};


export type MutationDeleteSpaceTagArgs = {
  where: Space_TagsWhereUniqueInput;
};


export type MutationDeleteSupplierCalendarEventV2Args = {
  calendarEventId: Scalars['String']['input'];
};


export type MutationDeleteSupplierDocumentArgs = {
  documentKey: Scalars['String']['input'];
  documentType: DocumentFileTypeEnum;
  supplierId: Scalars['String']['input'];
};


export type MutationDeleteSupplierFlexiblePricingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSupplierSetupArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  email: Scalars['String']['input'];
};


export type MutationDeleteUserAndSupplierArgs = {
  email: Scalars['String']['input'];
};


export type MutationDeleteWorkflowAutomationsMessageTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeregisterDevicePushTokenArgs = {
  input: DeregisterDevicePushTokenInput;
};


export type MutationDocumentAiCheckerArgs = {
  documentType: DocumentFileTypeEnum;
  file: Scalars['Upload']['input'];
  pageRef?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['String']['input'];
};


export type MutationEditEventArgs = {
  data: EditEventInput;
  eventUuid: Scalars['String']['input'];
};


export type MutationEditEventRequestArgs = {
  data: CompleteEventRequestData;
  requestId: Scalars['String']['input'];
};


export type MutationEditPartnershipArgs = {
  data: PartnershipInput;
  uuid: Scalars['String']['input'];
};


export type MutationEditPartnershipActiveStatusArgs = {
  isActive: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationEditSupplierFlexiblePricingArgs = {
  data: EditSupplieFlexiblePricingInput;
  uuid: Scalars['String']['input'];
};


export type MutationEditTagArgs = {
  input: EditTagInput;
};


export type MutationEditUserArgs = {
  data: EditUserInput;
  userId: Scalars['String']['input'];
};


export type MutationExchangeExternalOtpArgs = {
  code: Scalars['String']['input'];
  provider: Enum_User_External_Ids_Provider;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationFailSubscriptionSetupArgs = {
  lastError: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
};


export type MutationGenerateEventDeliverySuppliersDocumentsFileArgs = {
  eventDeliveryUuid: Scalars['String']['input'];
  organisationUuid: Scalars['String']['input'];
};


export type MutationGenerateExternalAccessTokenArgs = {
  provider: Enum_User_External_Ids_Provider;
  userId: Scalars['String']['input'];
};


export type MutationGenerateSupplierInvoicesArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationGetLlmResponseArgs = {
  data: Scalars['Json']['input'];
  prompt: Scalars['String']['input'];
};


export type MutationGetOrCreateQuoteConversationArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationImpersonateUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInitialiseExternalAppUrlArgs = {
  externalApp: Enum_User_External_Ids_Provider;
  redirectUrl: Scalars['String']['input'];
};


export type MutationInviteUserToLive360Args = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organisationUuid: Scalars['String']['input'];
  role: OrganisationUserRoleType;
};


export type MutationLegacyResetPasswordMigrationArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationLinkUserArgs = {
  input: LinkUserInput;
};


export type MutationMakeCarbonOffsetPaymentArgs = {
  offsetData: CarbonOffsetInput;
  paymentData: CarbonOffsetPaymentInput;
};


export type MutationMarkQuoteAsPaidArgs = {
  contractType?: InputMaybe<QuoteContractType>;
  isProtectPlus: Scalars['Boolean']['input'];
  quoteId: Scalars['String']['input'];
};


export type MutationMarkQuoteReadArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationMarkQuoteTemplateLineItemAsMigratedArgs = {
  itemUuid: Scalars['String']['input'];
};


export type MutationMarkStageCompleteArgs = {
  stage: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type MutationMarkSupplierAsPaidArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationPrefilterSuppliersArgs = {
  eventRequestUuid: Scalars['String']['input'];
  options: PrefilterSuppliersOptions;
};


export type MutationProcessSubscriptionSetupArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationReRunMatchmakingArgs = {
  eventRequestUuid: Scalars['String']['input'];
};


export type MutationReadEventRequestArgs = {
  event_request_id: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};


export type MutationRegisterDevicePushTokenArgs = {
  input: RegisterDevicePushTokenInput;
};


export type MutationRemoveExternalAuthArgs = {
  provider: Enum_User_External_Ids_Provider;
  userId: Scalars['String']['input'];
};


export type MutationRemoveSupplierImageArgs = {
  imageKey: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type MutationRemoveUserFromOrganisationArgs = {
  organisationUuid: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationReopenEventRequestArgs = {
  requestUuid: Scalars['String']['input'];
};


export type MutationReopenSupplierOnboardingArgs = {
  supplierUuid: Scalars['String']['input'];
};


export type MutationRequestAdminSupplierStatisticsUpdateArgs = {
  supplierUuid: Scalars['String']['input'];
};


export type MutationRequestChangeArgs = {
  change: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRequestLive360MagicLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestResetPasswordArgs = {
  input: RequestPasswordResetInput;
};


export type MutationResetPasswordArgs = {
  input: PasswordResetInput;
};


export type MutationRunRobexMatchingArgs = {
  callMethod: CallMethod;
  requestId: Scalars['String']['input'];
  robexOptions?: InputMaybe<RobexOptions>;
  sendToFreshsales?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRunVenuesMatchingArgs = {
  callMethod: CallMethod;
  requestId: Scalars['String']['input'];
  sendEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendToFreshsales?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSaveEventRequestArgs = {
  event_request_id: Scalars['String']['input'];
  saved: Scalars['Boolean']['input'];
  supplier_id: Scalars['String']['input'];
};


export type MutationSaveEventRequestImageDescriptionsArgs = {
  data: SaveEventRequestImageDescriptionsInput;
};


export type MutationSendPlatformMagicLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationSetAgencyCommissionArgs = {
  commission: Scalars['Float']['input'];
  user_id: Scalars['String']['input'];
};


export type MutationSetAnonymousIdToUserIdArgs = {
  anonymousId: Scalars['String']['input'];
  anonymousIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};


export type MutationSetPriorityTagArgs = {
  event_request_id: Scalars['String']['input'];
  tag_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetQuoteToPendingArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationSetSupplierOnboardingStatusArgs = {
  closedReason?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<SupplierOnboardingEmailInput>;
  followUpDate?: InputMaybe<Scalars['String']['input']>;
  status: OnboardingStatus;
  supplierUuid: Scalars['String']['input'];
};


export type MutationSetWeddingLeadArgs = {
  budget: Scalars['Float']['input'];
  catering: CateringEnum;
  courses: Array<InputMaybe<CoursesEnum>>;
  email: Scalars['String']['input'];
  guests: Scalars['Int']['input'];
  region: RegionEnum;
  season: SeasonEnum;
  tableware: Scalars['Boolean']['input'];
  waiter: Scalars['Boolean']['input'];
  weekday: WeekDayEnum;
};


export type MutationStartOfflineMatchmakingArgs = {
  input: OfflineMatchmakingInput;
};


export type MutationSupplierCreateQuoteArgs = {
  data: CreateQuoteInput;
};


export type MutationSupplierOnboardingArgs = {
  supplierData: SupplierOnboardingSupplierInput;
  userData: SupplierOnboardingUserInput;
};


export type MutationSupplierUpdateQuoteMessageArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSupplierWithdrawQuoteArgs = {
  quoteId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleEventRequestQuoteLimitingArgs = {
  quoteLimited: Scalars['Boolean']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationTrackAnalyticsEventArgs = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  event: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['Json']['input']>;
  userIdOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerCreateSupplierInSfArgs = {
  supplierUuid: Scalars['String']['input'];
};


export type MutationUpdateCustomEventNameArgs = {
  data?: InputMaybe<CreateCustomEventNameInput>;
  eventUuid: Scalars['String']['input'];
};


export type MutationUpdateMenuGroupArgs = {
  data: Suppliers_GroupsUpdateInput;
  where: Suppliers_GroupsWhereUniqueInput;
};


export type MutationUpdateMenuItemGroupArgs = {
  data: Suppliers_Groups_ItemsUpdateInput;
  where: Suppliers_Groups_ItemsWhereUniqueInput;
};


export type MutationUpdateProfilePhotoArgs = {
  file: Scalars['Upload']['input'];
  supplierId: Scalars['String']['input'];
};


export type MutationUpdateQuoteArgs = {
  data: UpdateQuoteInput;
  quoteId: Scalars['String']['input'];
};


export type MutationUpdateQuoteLineItemTemplateArgs = {
  data: QuoteLineItemTemplateInput;
  lineItemId: Scalars['String']['input'];
};


export type MutationUpdateQuoteLineItemTemplatesSectionArgs = {
  data: UpsertQuoteLineItemTemplatesSectionInput;
  sectionUuid: Scalars['String']['input'];
};


export type MutationUpdateQuoteTemplateArgs = {
  event_type?: InputMaybe<EventTypeEnum>;
  menu?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price_per_head?: InputMaybe<Scalars['Int']['input']>;
  quoteTemplateAttachments?: InputMaybe<Array<AttachmentInput>>;
  quote_template_line_items?: InputMaybe<Array<InputMaybe<QuoteTemplateLineItemsUpsert>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateSpaceArgs = {
  data: Venue_SpacesUpdateInput;
  where: Venue_SpacesWhereUniqueInput;
};


export type MutationUpdateSpaceGroupArgs = {
  data: Space_GroupsUpdateInput;
  where: Space_GroupsWhereUniqueInput;
};


export type MutationUpdateSupplierArgs = {
  data: SuppliersUpdateInput;
  where: SuppliersWhereUniqueInput;
};


export type MutationUpdateSupplierCalendarEventV2Args = {
  calendarEventId: Scalars['String']['input'];
  end_time: Scalars['String']['input'];
  start_time: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationUpdateSupplierLinksArgs = {
  instagram?: InputMaybe<Scalars['URL']['input']>;
  tiktok?: InputMaybe<Scalars['URL']['input']>;
  website?: InputMaybe<Scalars['URL']['input']>;
  youtube?: InputMaybe<Scalars['URL']['input']>;
};


export type MutationUpdateSupplierSetupArgs = {
  data: UpdateSupplierSetupInput;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateTagsArgs = {
  supplierId: Scalars['String']['input'];
  tags: Array<InputMaybe<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTierTwoArgs = {
  supplierId: Scalars['String']['input'];
  tierTwoCategories: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdateUserArgs = {
  data: UsersUpdateInput;
  where: UsersWhereUniqueInput;
};


export type MutationUpdateUserPreferencesArgs = {
  data: User_PreferencesUpdateInput;
  where: User_PreferencesWhereUniqueInput;
};


export type MutationUpdateWorkflowAutomationsMessageTemplateArgs = {
  automationTrigger: AutomationTriggerEnum;
  isActive: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  triggerInterval: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationUploadAttachmentArgs = {
  entityType: AttachmentEntityType;
  file: Scalars['Upload']['input'];
  supplierUuid: Scalars['String']['input'];
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadMenuPitchApplicationArgs = {
  pitchApplicationUuid: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationUploadPublicEventImageArgs = {
  file: Scalars['Upload']['input'];
  publicEventId: Scalars['String']['input'];
};


export type MutationUploadPublicImageArgs = {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadSupplierDocumentArgs = {
  documentType: DocumentFileTypeEnum;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  liabilityCoverAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierId: Scalars['String']['input'];
};


export type MutationUpsertEventDeliveryDocumentArgs = {
  eventDeliveryDocument: EventDeliveryDocumentInput;
  eventDeliveryUuid: Scalars['String']['input'];
  organisationUuid: Scalars['String']['input'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumenum_Bookings_StateNullableFilter = {
  equals?: InputMaybe<Enum_Bookings_State>;
  in?: InputMaybe<Array<Enum_Bookings_State>>;
  not?: InputMaybe<NestedEnumenum_Bookings_StateNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Bookings_State>>;
};

export type NestedEnumenum_Calls_Call_ToNullableFilter = {
  equals?: InputMaybe<Enum_Calls_Call_To>;
  in?: InputMaybe<Array<Enum_Calls_Call_To>>;
  not?: InputMaybe<NestedEnumenum_Calls_Call_ToNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Calls_Call_To>>;
};

export type NestedEnumenum_Conversations_Messages_TypeFilter = {
  equals?: InputMaybe<Enum_Conversations_Messages_Type>;
  in?: InputMaybe<Array<Enum_Conversations_Messages_Type>>;
  not?: InputMaybe<NestedEnumenum_Conversations_Messages_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Conversations_Messages_Type>>;
};

export type NestedEnumenum_Declined_Event_Requests_Declined_ReasonNullableFilter = {
  equals?: InputMaybe<Enum_Declined_Event_Requests_Declined_Reason>;
  in?: InputMaybe<Array<Enum_Declined_Event_Requests_Declined_Reason>>;
  not?: InputMaybe<NestedEnumenum_Declined_Event_Requests_Declined_ReasonNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Declined_Event_Requests_Declined_Reason>>;
};

export type NestedEnumenum_Event_Areas_AreaFilter = {
  equals?: InputMaybe<Enum_Event_Areas_Area>;
  in?: InputMaybe<Array<Enum_Event_Areas_Area>>;
  not?: InputMaybe<NestedEnumenum_Event_Areas_AreaFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Areas_Area>>;
};

export type NestedEnumenum_Event_Dates_StateNullableFilter = {
  equals?: InputMaybe<Enum_Event_Dates_State>;
  in?: InputMaybe<Array<Enum_Event_Dates_State>>;
  not?: InputMaybe<NestedEnumenum_Event_Dates_StateNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Dates_State>>;
};

export type NestedEnumenum_Event_Request_Additional_Info_Bar_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Bar_Type>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Bar_Type>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_Bar_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Bar_Type>>;
};

export type NestedEnumenum_Event_Request_Additional_Info_ChildrenNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Children>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Children>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_ChildrenNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Children>>;
};

export type NestedEnumenum_Event_Request_Additional_Info_Courses_CourseNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Courses_Course>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Courses_Course>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_Courses_CourseNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Courses_Course>>;
};

export type NestedEnumenum_Event_Request_Additional_Info_CrockeryNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Crockery>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Crockery>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_CrockeryNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Crockery>>;
};

export type NestedEnumenum_Event_Request_Additional_Info_PowerNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Power>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Power>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_PowerNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Power>>;
};

export type NestedEnumenum_Event_Request_Additional_Info_WaitersNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Waiters>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Waiters>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_WaitersNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Waiters>>;
};

export type NestedEnumenum_Event_Request_Additional_Info_WaterNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Additional_Info_Water>;
  in?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Water>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Additional_Info_WaterNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Additional_Info_Water>>;
};

export type NestedEnumenum_Event_Request_Supplier_Notified_Call_MethodNullableFilter = {
  equals?: InputMaybe<Enum_Event_Request_Supplier_Notified_Call_Method>;
  in?: InputMaybe<Array<Enum_Event_Request_Supplier_Notified_Call_Method>>;
  not?: InputMaybe<NestedEnumenum_Event_Request_Supplier_Notified_Call_MethodNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Event_Request_Supplier_Notified_Call_Method>>;
};

export type NestedEnumenum_External_Payment_Info_ProviderFilter = {
  equals?: InputMaybe<Enum_External_Payment_Info_Provider>;
  in?: InputMaybe<Array<Enum_External_Payment_Info_Provider>>;
  not?: InputMaybe<NestedEnumenum_External_Payment_Info_ProviderFilter>;
  notIn?: InputMaybe<Array<Enum_External_Payment_Info_Provider>>;
};

export type NestedEnumenum_Quote_Line_Item_Templates_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quote_Line_Item_Templates_Type>;
  in?: InputMaybe<Array<Enum_Quote_Line_Item_Templates_Type>>;
  not?: InputMaybe<NestedEnumenum_Quote_Line_Item_Templates_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quote_Line_Item_Templates_Type>>;
};

export type NestedEnumenum_Quote_Line_Items_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quote_Line_Items_Type>;
  in?: InputMaybe<Array<Enum_Quote_Line_Items_Type>>;
  not?: InputMaybe<NestedEnumenum_Quote_Line_Items_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quote_Line_Items_Type>>;
};

export type NestedEnumenum_Quote_Template_Line_Items_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quote_Template_Line_Items_Type>;
  in?: InputMaybe<Array<Enum_Quote_Template_Line_Items_Type>>;
  not?: InputMaybe<NestedEnumenum_Quote_Template_Line_Items_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quote_Template_Line_Items_Type>>;
};

export type NestedEnumenum_Quotes_Declined_ReasonNullableFilter = {
  equals?: InputMaybe<Enum_Quotes_Declined_Reason>;
  in?: InputMaybe<Array<Enum_Quotes_Declined_Reason>>;
  not?: InputMaybe<NestedEnumenum_Quotes_Declined_ReasonNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quotes_Declined_Reason>>;
};

export type NestedEnumenum_Quotes_Payment_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Quotes_Payment_Type>;
  in?: InputMaybe<Array<Enum_Quotes_Payment_Type>>;
  not?: InputMaybe<NestedEnumenum_Quotes_Payment_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Quotes_Payment_Type>>;
};

export type NestedEnumenum_Quotes_StateFilter = {
  equals?: InputMaybe<Enum_Quotes_State>;
  in?: InputMaybe<Array<Enum_Quotes_State>>;
  not?: InputMaybe<NestedEnumenum_Quotes_StateFilter>;
  notIn?: InputMaybe<Array<Enum_Quotes_State>>;
};

export type NestedEnumenum_Reviews_SourceNullableFilter = {
  equals?: InputMaybe<Enum_Reviews_Source>;
  in?: InputMaybe<Array<Enum_Reviews_Source>>;
  not?: InputMaybe<NestedEnumenum_Reviews_SourceNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Reviews_Source>>;
};

export type NestedEnumenum_Robex_Notifications_Notification_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Robex_Notifications_Notification_Status>;
  in?: InputMaybe<Array<Enum_Robex_Notifications_Notification_Status>>;
  not?: InputMaybe<NestedEnumenum_Robex_Notifications_Notification_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Robex_Notifications_Notification_Status>>;
};

export type NestedEnumenum_Scheduled_Payments_MethodFilter = {
  equals?: InputMaybe<Enum_Scheduled_Payments_Method>;
  in?: InputMaybe<Array<Enum_Scheduled_Payments_Method>>;
  not?: InputMaybe<NestedEnumenum_Scheduled_Payments_MethodFilter>;
  notIn?: InputMaybe<Array<Enum_Scheduled_Payments_Method>>;
};

export type NestedEnumenum_Scheduled_Payments_TypeFilter = {
  equals?: InputMaybe<Enum_Scheduled_Payments_Type>;
  in?: InputMaybe<Array<Enum_Scheduled_Payments_Type>>;
  not?: InputMaybe<NestedEnumenum_Scheduled_Payments_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Scheduled_Payments_Type>>;
};

export type NestedEnumenum_Supplier_Calendars_Events_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Calendars_Events_Type>;
  in?: InputMaybe<Array<Enum_Supplier_Calendars_Events_Type>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Calendars_Events_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Calendars_Events_Type>>;
};

export type NestedEnumenum_Supplier_Documents_TypeFilter = {
  equals?: InputMaybe<Enum_Supplier_Documents_Type>;
  in?: InputMaybe<Array<Enum_Supplier_Documents_Type>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Documents_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Documents_Type>>;
};

export type NestedEnumenum_Supplier_Flexible_Pricing_Day_Of_WeekNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Flexible_Pricing_Day_Of_Week>;
  in?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Day_Of_Week>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Flexible_Pricing_Day_Of_WeekNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Day_Of_Week>>;
};

export type NestedEnumenum_Supplier_Flexible_Pricing_MonthNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Flexible_Pricing_Month>;
  in?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Month>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Flexible_Pricing_MonthNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Month>>;
};

export type NestedEnumenum_Supplier_Flexible_Pricing_Price_AdjustmentFilter = {
  equals?: InputMaybe<Enum_Supplier_Flexible_Pricing_Price_Adjustment>;
  in?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Price_Adjustment>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Flexible_Pricing_Price_AdjustmentFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Flexible_Pricing_Price_Adjustment>>;
};

export type NestedEnumenum_Supplier_Payments_MethodFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Method>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Method>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_MethodFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Method>>;
};

export type NestedEnumenum_Supplier_Payments_Payment_MethodFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Payment_Method>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Payment_Method>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_Payment_MethodFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Payment_Method>>;
};

export type NestedEnumenum_Supplier_Payments_StatusFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Status>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Status>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_StatusFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Status>>;
};

export type NestedEnumenum_Supplier_Payments_TypeFilter = {
  equals?: InputMaybe<Enum_Supplier_Payments_Type>;
  in?: InputMaybe<Array<Enum_Supplier_Payments_Type>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Payments_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Payments_Type>>;
};

export type NestedEnumenum_Supplier_Stats_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Supplier_Stats_Status>;
  in?: InputMaybe<Array<Enum_Supplier_Stats_Status>>;
  not?: InputMaybe<NestedEnumenum_Supplier_Stats_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Supplier_Stats_Status>>;
};

export type NestedEnumenum_Suppliers_Kyb_StatusFilter = {
  equals?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  in?: InputMaybe<Array<Enum_Suppliers_Kyb_Status>>;
  not?: InputMaybe<NestedEnumenum_Suppliers_Kyb_StatusFilter>;
  notIn?: InputMaybe<Array<Enum_Suppliers_Kyb_Status>>;
};

export type NestedEnumenum_Suppliers_StateNullableFilter = {
  equals?: InputMaybe<Enum_Suppliers_State>;
  in?: InputMaybe<Array<Enum_Suppliers_State>>;
  not?: InputMaybe<NestedEnumenum_Suppliers_StateNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Suppliers_State>>;
};

export type NestedEnumenum_User_External_Ids_ProviderFilter = {
  equals?: InputMaybe<Enum_User_External_Ids_Provider>;
  in?: InputMaybe<Array<Enum_User_External_Ids_Provider>>;
  not?: InputMaybe<NestedEnumenum_User_External_Ids_ProviderFilter>;
  notIn?: InputMaybe<Array<Enum_User_External_Ids_Provider>>;
};

export type NestedEnumenum_Users_TypeNullableFilter = {
  equals?: InputMaybe<Enum_Users_Type>;
  in?: InputMaybe<Array<Enum_Users_Type>>;
  not?: InputMaybe<NestedEnumenum_Users_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Users_Type>>;
};

export type NestedEnumenum_Voice_Calling_Recipient_TypeFilter = {
  equals?: InputMaybe<Enum_Voice_Calling_Recipient_Type>;
  in?: InputMaybe<Array<Enum_Voice_Calling_Recipient_Type>>;
  not?: InputMaybe<NestedEnumenum_Voice_Calling_Recipient_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Voice_Calling_Recipient_Type>>;
};

export type NestedEnumenum_Voice_Calls_Primary_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Voice_Calls_Primary_Status>;
  in?: InputMaybe<Array<Enum_Voice_Calls_Primary_Status>>;
  not?: InputMaybe<NestedEnumenum_Voice_Calls_Primary_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Voice_Calls_Primary_Status>>;
};

export type NestedEnumenum_Voice_Calls_Secondary_StatusNullableFilter = {
  equals?: InputMaybe<Enum_Voice_Calls_Secondary_Status>;
  in?: InputMaybe<Array<Enum_Voice_Calls_Secondary_Status>>;
  not?: InputMaybe<NestedEnumenum_Voice_Calls_Secondary_StatusNullableFilter>;
  notIn?: InputMaybe<Array<Enum_Voice_Calls_Secondary_Status>>;
};

export type NestedEnumenum_Workflow_Automations_Message_Templates_Automation_TriggerFilter = {
  equals?: InputMaybe<Enum_Workflow_Automations_Message_Templates_Automation_Trigger>;
  in?: InputMaybe<Array<Enum_Workflow_Automations_Message_Templates_Automation_Trigger>>;
  not?: InputMaybe<NestedEnumenum_Workflow_Automations_Message_Templates_Automation_TriggerFilter>;
  notIn?: InputMaybe<Array<Enum_Workflow_Automations_Message_Templates_Automation_Trigger>>;
};

export type NestedEnumenum_Xero_Invoices_TypeFilter = {
  equals?: InputMaybe<Enum_Xero_Invoices_Type>;
  in?: InputMaybe<Array<Enum_Xero_Invoices_Type>>;
  not?: InputMaybe<NestedEnumenum_Xero_Invoices_TypeFilter>;
  notIn?: InputMaybe<Array<Enum_Xero_Invoices_Type>>;
};

export type NestedEnumevent_TypeNullableFilter = {
  equals?: InputMaybe<Event_Type>;
  in?: InputMaybe<Array<Event_Type>>;
  not?: InputMaybe<NestedEnumevent_TypeNullableFilter>;
  notIn?: InputMaybe<Array<Event_Type>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableEnumenum_Bookings_StateFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Bookings_State>;
};

export type NullableEnumenum_Calls_Call_ToFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Calls_Call_To>;
};

export type NullableEnumenum_Declined_Event_Requests_Declined_ReasonFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Declined_Event_Requests_Declined_Reason>;
};

export type NullableEnumenum_Event_Dates_StateFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Dates_State>;
};

export type NullableEnumenum_Event_Request_Additional_Info_Bar_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Additional_Info_Bar_Type>;
};

export type NullableEnumenum_Event_Request_Additional_Info_ChildrenFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Additional_Info_Children>;
};

export type NullableEnumenum_Event_Request_Additional_Info_Courses_CourseFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Additional_Info_Courses_Course>;
};

export type NullableEnumenum_Event_Request_Additional_Info_CrockeryFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Additional_Info_Crockery>;
};

export type NullableEnumenum_Event_Request_Additional_Info_PowerFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Additional_Info_Power>;
};

export type NullableEnumenum_Event_Request_Additional_Info_WaitersFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Additional_Info_Waiters>;
};

export type NullableEnumenum_Event_Request_Additional_Info_WaterFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Additional_Info_Water>;
};

export type NullableEnumenum_Event_Request_Supplier_Notified_Call_MethodFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Event_Request_Supplier_Notified_Call_Method>;
};

export type NullableEnumenum_Quote_Line_Item_Templates_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Quote_Line_Item_Templates_Type>;
};

export type NullableEnumenum_Quote_Line_Items_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Quote_Line_Items_Type>;
};

export type NullableEnumenum_Quote_Template_Line_Items_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Quote_Template_Line_Items_Type>;
};

export type NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Quotes_Declined_Reason>;
};

export type NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Quotes_Payment_Type>;
};

export type NullableEnumenum_Reviews_SourceFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Reviews_Source>;
};

export type NullableEnumenum_Robex_Notifications_Notification_StatusFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Robex_Notifications_Notification_Status>;
};

export type NullableEnumenum_Supplier_Calendars_Events_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Calendars_Events_Type>;
};

export type NullableEnumenum_Supplier_Flexible_Pricing_Day_Of_WeekFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Flexible_Pricing_Day_Of_Week>;
};

export type NullableEnumenum_Supplier_Flexible_Pricing_MonthFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Flexible_Pricing_Month>;
};

export type NullableEnumenum_Supplier_Stats_StatusFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Supplier_Stats_Status>;
};

export type NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Suppliers_State>;
};

export type NullableEnumenum_Users_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Users_Type>;
};

export type NullableEnumenum_Voice_Calls_Primary_StatusFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Voice_Calls_Primary_Status>;
};

export type NullableEnumenum_Voice_Calls_Secondary_StatusFieldUpdateOperationsInput = {
  set?: InputMaybe<Enum_Voice_Calls_Secondary_Status>;
};

export type NullableEnumevent_TypeFieldUpdateOperationsInput = {
  set?: InputMaybe<Event_Type>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type OfflineMatchmakingBatch = {
  __typename?: 'OfflineMatchmakingBatch';
  batchId: Scalars['String']['output'];
  totalRequests: Scalars['Int']['output'];
};

export type OfflineMatchmakingBatchCsv = {
  __typename?: 'OfflineMatchmakingBatchCsv';
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export enum OfflineMatchmakingBatchStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type OfflineMatchmakingBatchSummary = {
  __typename?: 'OfflineMatchmakingBatchSummary';
  batchId: Scalars['String']['output'];
  completedRequests: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  failedRequests: Scalars['Int']['output'];
  method?: Maybe<Scalars['String']['output']>;
  status: OfflineMatchmakingBatchStatus;
  totalRequests: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type OfflineMatchmakingInput = {
  eventRequestUuids: Array<Scalars['String']['input']>;
  ignoreActivity?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tier1: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export enum OnboardingStatus {
  ActivationCallBooked = 'ACTIVATION_CALL_BOOKED',
  ActivationCallReady = 'ACTIVATION_CALL_READY',
  ClosedLost = 'CLOSED_LOST',
  ClosedWon = 'CLOSED_WON',
  RequestedAmendments = 'REQUESTED_AMENDMENTS'
}

export type OpenEventType = {
  __typename?: 'OpenEventType';
  approxLocation?: Maybe<Scalars['Boolean']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  budgetFlexible: Scalars['Boolean']['output'];
  categoryTier2?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dateFlexibilityNotes?: Maybe<Scalars['String']['output']>;
  dateFlexible?: Maybe<Scalars['Boolean']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  directRequestSuppliers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  distance?: Maybe<Scalars['String']['output']>;
  eventEndTime?: Maybe<Scalars['String']['output']>;
  eventStartTime?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  itemQuantity?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  locationCity?: Maybe<Scalars['String']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  notifiedMethod: Array<Maybe<Scalars['String']['output']>>;
  partialPostcode?: Maybe<Scalars['String']['output']>;
  priorityTag?: Maybe<Scalars['String']['output']>;
  quotesCount: Scalars['Int']['output'];
  readTimestamp?: Maybe<Scalars['DateTime']['output']>;
  requestEndTime?: Maybe<Scalars['String']['output']>;
  requestStartTime?: Maybe<Scalars['String']['output']>;
  saved?: Maybe<Scalars['Boolean']['output']>;
  supplierNotificationDate?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type OpenEventsFilterInput = {
  budgetMax?: InputMaybe<Scalars['Int']['input']>;
  budgetMin?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notifiedMethod?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priorityTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  radius?: InputMaybe<Scalars['Int']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tier2?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpensearchOpenEvents = {
  __typename?: 'OpensearchOpenEvents';
  openEvents?: Maybe<Array<Maybe<OpenEventType>>>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type Organisation = {
  __typename?: 'Organisation';
  created?: Maybe<Scalars['DateTime']['output']>;
  eventDeliveries: Array<EventDelivery>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationUsers: Array<OrganisationUser>;
  salesforceId: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};


export type OrganisationEventDeliveriesArgs = {
  filter?: InputMaybe<EventDeliveriesFilter>;
};

export type OrganisationUser = {
  __typename?: 'OrganisationUser';
  created?: Maybe<Scalars['DateTime']['output']>;
  organisation?: Maybe<Organisation>;
  organisationUuid: Scalars['String']['output'];
  role: OrganisationUserRoleType;
  updated?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<RestrictedUser>;
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum OrganisationUserRoleType {
  Admin = 'ADMIN',
  Basic = 'BASIC',
  SuperAdmin = 'SUPER_ADMIN'
}

export type Partnership = {
  __typename?: 'Partnership';
  commission: Scalars['Float']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  location_city?: Maybe<Scalars['String']['output']>;
  location_line1?: Maybe<Scalars['String']['output']>;
  location_line2?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partnershipType?: Maybe<PartnershipTypeEnum>;
  postcode: Scalars['String']['output'];
  power: Scalars['Boolean']['output'];
  salesforceOpportunityId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
  water: Scalars['Boolean']['output'];
};

export type PartnershipInput = {
  commission: Scalars['Float']['input'];
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line1?: InputMaybe<Scalars['String']['input']>;
  location_line2?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partnershipType?: InputMaybe<PartnershipTypeEnum>;
  postcode: Scalars['String']['input'];
  power: Scalars['Boolean']['input'];
  salesforceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  water: Scalars['Boolean']['input'];
};

export enum PartnershipTypeEnum {
  Agency = 'AGENCY',
  Hospitality = 'HOSPITALITY',
  VenuePartner = 'VENUE_PARTNER'
}

export type PartnershipsResult = {
  __typename?: 'PartnershipsResult';
  numPages: Scalars['Int']['output'];
  results: Array<Partnership>;
  totalRecords: Scalars['Int']['output'];
};

export type PasswordResetInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  level: PaymentErrorLevel;
};

export enum PaymentErrorLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type PaymentInformation = {
  __typename?: 'PaymentInformation';
  bookingProtection: BookingProtection;
  payment: Payments;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card: Card;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export enum PaymentMethods {
  Automatic = 'automatic',
  Manual = 'manual'
}

export enum PaymentState {
  Awaiting = 'AWAITING',
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN'
}

export type Payments = {
  __typename?: 'Payments';
  booking_id?: Maybe<Scalars['String']['output']>;
  carbon_offset_id?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  external_payment_info_id?: Maybe<Scalars['String']['output']>;
  flow_type: Enum_Payments_Flow_Type;
  id: Scalars['String']['output'];
  quote_id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type PercentageMatch = PercentageMatchWithBooleanMatchValue | PercentageMatchWithFloatMatchValue | PercentageMatchWithStringMatchValue;

export type PercentageMatchWithBooleanMatchValue = {
  __typename?: 'PercentageMatchWithBooleanMatchValue';
  algorithm?: Maybe<Scalars['String']['output']>;
  filter_type?: Maybe<Scalars['String']['output']>;
  is_binary: Scalars['Boolean']['output'];
  match_value?: Maybe<Scalars['Boolean']['output']>;
  max_score?: Maybe<Scalars['Float']['output']>;
  metricId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentageScore?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  sortingContribution?: Maybe<Scalars['Float']['output']>;
  source_field?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PercentageMatchWithFloatMatchValue = {
  __typename?: 'PercentageMatchWithFloatMatchValue';
  algorithm?: Maybe<Scalars['String']['output']>;
  filter_type?: Maybe<Scalars['String']['output']>;
  is_binary: Scalars['Boolean']['output'];
  match_value?: Maybe<Scalars['Float']['output']>;
  max_score?: Maybe<Scalars['Float']['output']>;
  metricId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentageScore?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  sortingContribution?: Maybe<Scalars['Float']['output']>;
  source_field?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PercentageMatchWithStringMatchValue = {
  __typename?: 'PercentageMatchWithStringMatchValue';
  algorithm?: Maybe<Scalars['String']['output']>;
  filter_type?: Maybe<Scalars['String']['output']>;
  is_binary: Scalars['Boolean']['output'];
  match_value?: Maybe<Scalars['String']['output']>;
  max_score?: Maybe<Scalars['Float']['output']>;
  metricId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentageScore?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  sortingContribution?: Maybe<Scalars['Float']['output']>;
  source_field?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PitchApplication = {
  __typename?: 'PitchApplication';
  applicationId?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  createdDate: Scalars['DateTime']['output'];
  isAdditional: Scalars['Boolean']['output'];
  pitchApplicationDocuments?: Maybe<Array<Maybe<PitchApplicationDocument>>>;
  pitchGroupForApplication?: Maybe<PitchGroup>;
  pitchGroupUuid: Scalars['String']['output'];
  pitchStatus: PitchStatus;
  salesforceId?: Maybe<Scalars['String']['output']>;
  setupNotes?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Suppliers>;
  supplierSetup?: Maybe<SupplierSetup>;
  supplierSetupUuid?: Maybe<Scalars['String']['output']>;
  supplierUuid: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PitchApplicationDocument = {
  __typename?: 'PitchApplicationDocument';
  created: Scalars['DateTime']['output'];
  pitchApplicationSupplierDocument?: Maybe<SupplierDocument>;
  pitchApplicationUuid: Scalars['String']['output'];
  supplierDocumentUuid: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PitchGroup = {
  __typename?: 'PitchGroup';
  bookedPitchesCount?: Maybe<Scalars['Int']['output']>;
  booked_pitches_count: Scalars['Float']['output'];
  clientSalesCommissionShare?: Maybe<Scalars['Float']['output']>;
  client_pitch_fee: Scalars['Float']['output'];
  client_sales_commission_share: Scalars['Float']['output'];
  closed_date?: Maybe<Scalars['DateTime']['output']>;
  confirmationFee?: Maybe<Scalars['Float']['output']>;
  cooking?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  createdDate: Scalars['DateTime']['output'];
  cuisineSpecifics?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  end_date: Scalars['DateTime']['output'];
  estimated_footfall?: Maybe<Scalars['Float']['output']>;
  eventDelivery: EventDelivery;
  eventDeliveryUuid: Scalars['String']['output'];
  event_id: Scalars['String']['output'];
  feast_it_pitch_fee: Scalars['Float']['output'];
  feast_it_pitch_fee_share: Scalars['Float']['output'];
  feast_it_sales_commission_share: Scalars['Float']['output'];
  gross_commission: Scalars['Float']['output'];
  gross_sales: Scalars['Float']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  isPitchGroupClosed?: Maybe<Scalars['Boolean']['output']>;
  isPitchGroupVisible: Scalars['Boolean']['output'];
  isVisibleOnLive360: Scalars['Boolean']['output'];
  location_city: Scalars['String']['output'];
  movement?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  openPitchesCount?: Maybe<Scalars['Int']['output']>;
  open_pitches_count: Scalars['Float']['output'];
  output?: Maybe<Scalars['String']['output']>;
  owner_id: Scalars['String']['output'];
  perPitchFee?: Maybe<Scalars['Float']['output']>;
  pitchApplications: Array<PitchApplication>;
  pitchApplicationsFiltered: Array<PitchApplication>;
  pitchGroupDescription?: Maybe<Scalars['String']['output']>;
  pitchGroupName: Scalars['String']['output'];
  pitchGroupStage: PitchGroupStage;
  pitchGroupType: PitchGroupType;
  pitchGroupTypeUuid: Scalars['String']['output'];
  pitchGroupVariation?: Maybe<Scalars['String']['output']>;
  pitch_application_count: Scalars['Float']['output'];
  pitch_group_id?: Maybe<Scalars['String']['output']>;
  pitch_group_variation?: Maybe<Scalars['String']['output']>;
  pitch_type: PitchTypeEnums;
  pitches_count: Scalars['Float']['output'];
  predictedVendorSales?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<Scalars['String']['output']>;
  publicEventSupplierApplicationUrl?: Maybe<Scalars['String']['output']>;
  sales_deposit: Scalars['Float']['output'];
  salesforceId: Scalars['String']['output'];
  setUp?: Maybe<Scalars['String']['output']>;
  stage: PitchGroupStagesEnum;
  start_date: Scalars['DateTime']['output'];
  supplierSalesCommissionShare?: Maybe<Scalars['Float']['output']>;
  supplier_application_url: Scalars['String']['output'];
  supplier_sales_commission_share: Scalars['Float']['output'];
  sustainability?: Maybe<Scalars['String']['output']>;
  togatherSalesCommissionShare?: Maybe<Scalars['Float']['output']>;
  totalPitchesAvailable?: Maybe<Scalars['Int']['output']>;
  total_pitch_fee_value: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  voucherCommission?: Maybe<Scalars['Float']['output']>;
};


export type PitchGroupPitchApplicationsFilteredArgs = {
  pitchStatuses?: InputMaybe<Array<PitchStatus>>;
  supplierUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum PitchGroupStage {
  AgreementsPaid = 'AGREEMENTS_PAID',
  AgreementsSent = 'AGREEMENTS_SENT',
  Applications = 'APPLICATIONS',
  Default = 'DEFAULT',
  LineupApproved = 'LINEUP_APPROVED',
  Lost = 'LOST',
  New = 'NEW',
  Null = 'NULL',
  PostEvent = 'POST_EVENT',
  Won = 'WON'
}

export enum PitchGroupStagesEnum {
  AgreementsPaid = 'AGREEMENTS_PAID',
  AgreementsSent = 'AGREEMENTS_SENT',
  Applications = 'APPLICATIONS',
  LineupApproved = 'LINEUP_APPROVED',
  Lost = 'LOST',
  New = 'NEW',
  PostEvent = 'POST_EVENT',
  Won = 'WON'
}

export type PitchGroupType = {
  __typename?: 'PitchGroupType';
  created: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
  typeUserFriendlyName: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PitchGroupsByIdsList = {
  __typename?: 'PitchGroupsByIdsList';
  events: Array<Maybe<PitchGroup>>;
};

export type PitchGroupsFilter = {
  isVisibleOnLive360: Scalars['Boolean']['input'];
};

export type PitchGroupsList = {
  __typename?: 'PitchGroupsList';
  events: Array<Maybe<PitchGroup>>;
  totalRecords: Scalars['Int']['output'];
};

export enum PitchStatus {
  AgreementSent = 'AGREEMENT_SENT',
  Applied = 'APPLIED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  CancelledVisible = 'CANCELLED_VISIBLE',
  Default = 'DEFAULT',
  Null = 'NULL',
  PitchConfirmed = 'PITCH_CONFIRMED',
  Rejected = 'REJECTED',
  Shortlisted = 'SHORTLISTED'
}

export enum PitchTypeEnums {
  Bar = 'BAR',
  HotDrinks = 'HOT_DRINKS',
  Other = 'OTHER',
  Retail = 'RETAIL',
  SavouryFood = 'SAVOURY_FOOD',
  SweetFood = 'SWEET_FOOD'
}

export type PrefilterSuppliersOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  notify: Scalars['Boolean']['input'];
  source: PrefilterSuppliersSource;
  tagBoostIncrease?: InputMaybe<Scalars['Boolean']['input']>;
  useVisibleSuppliers: Scalars['Boolean']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum PrefilterSuppliersSource {
  Admin = 'ADMIN',
  New = 'NEW',
  Scheduled = 'SCHEDULED',
  Suggested = 'SUGGESTED',
  Updated = 'UPDATED'
}

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  excludingVatPrices?: Maybe<PriceFormats>;
  includingVatPrices?: Maybe<PriceFormats>;
};

export type PriceFormats = {
  __typename?: 'PriceFormats';
  formattedToCurrency?: Maybe<PricesFormattedCurrency>;
  inPennies?: Maybe<PricesNumberPennies>;
};

export enum PriceType {
  NoPrice = 'NO_PRICE',
  PricePerHead = 'PRICE_PER_HEAD',
  TotalPrice = 'TOTAL_PRICE'
}

export type PricesFormattedCurrency = {
  __typename?: 'PricesFormattedCurrency';
  commissionPrice?: Maybe<Scalars['String']['output']>;
  priceExclCommission?: Maybe<Scalars['String']['output']>;
  priceInclCommission?: Maybe<Scalars['String']['output']>;
  priceInclCommissionAndServiceFee?: Maybe<Scalars['String']['output']>;
  serviceFeePrice?: Maybe<Scalars['String']['output']>;
};

export type PricesNumberPennies = {
  __typename?: 'PricesNumberPennies';
  commissionPrice?: Maybe<Scalars['Int']['output']>;
  priceExclCommission?: Maybe<Scalars['Int']['output']>;
  priceInclCommission?: Maybe<Scalars['Int']['output']>;
  priceInclCommissionAndServiceFee?: Maybe<Scalars['Int']['output']>;
  serviceFeePrice?: Maybe<Scalars['Int']['output']>;
};

export type PublicSupplier = {
  __typename?: 'PublicSupplier';
  description?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<SupplierImage>>>;
  logistics?: Maybe<SupplierLogistics>;
  profilePicture?: Maybe<SupplierImage>;
  social?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  video_url?: Maybe<Scalars['String']['output']>;
};

export type PublicSupplierReview = {
  __typename?: 'PublicSupplierReview';
  booking?: Maybe<PublicSupplierReviewBooking>;
  created?: Maybe<Scalars['DateTime']['output']>;
  externalEvent?: Maybe<PublicSupplierReviewExternalEvent>;
  fields: PublicSupplierReviewFields;
  ratings: PublicSupplierReviewRatings;
  source?: Maybe<Enum_Reviews_Source>;
  uuid: Scalars['String']['output'];
};

export type PublicSupplierReviewBooking = {
  __typename?: 'PublicSupplierReviewBooking';
  customer?: Maybe<PublicSupplierReviewCustomer>;
  date?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PublicSupplierReviewCustomer = {
  __typename?: 'PublicSupplierReviewCustomer';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PublicSupplierReviewExternalEvent = {
  __typename?: 'PublicSupplierReviewExternalEvent';
  eventDate: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  userFullName: Scalars['String']['output'];
};

export type PublicSupplierReviewFields = {
  __typename?: 'PublicSupplierReviewFields';
  publicComment?: Maybe<Scalars['String']['output']>;
};

export type PublicSupplierReviewRatings = {
  __typename?: 'PublicSupplierReviewRatings';
  friendliness?: Maybe<Scalars['Int']['output']>;
  overall: Scalars['Float']['output'];
  professionalism?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<Scalars['Int']['output']>;
  valueForMoney?: Maybe<Scalars['Int']['output']>;
};

export type PublicSupplierReviewsResult = {
  __typename?: 'PublicSupplierReviewsResult';
  noOfPages: Scalars['Int']['output'];
  pageNo: Scalars['Int']['output'];
  reviews: Array<PublicSupplierReview>;
  totalResults: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  accountManager?: Maybe<AccountManagerLegacy>;
  accountManagerForUserEvent?: Maybe<AccountManager>;
  accountManagersForUserEvents: Array<Maybe<AccountManagerLegacy>>;
  adminCognitoUsersSearch: AdminCognitoUsersSearchResult;
  adminEventsSearch: AdminEventsSearchResult;
  adminGetPartnershipEvents: AdminGetPartnershipEventsResult;
  adminGetSupplierPitchApplications?: Maybe<GetSupplierPitchApplicationResponse>;
  adminPartnershipsSearch: AdminPartnershipsSearchResult;
  adminQuotesSearch: AdminQuotesSearchResult;
  adminRequestsSearch: AdminRequestsSearchResult;
  adminReviewsSearch: AdminReviewsSearchResult;
  adminSupplierEvents: Array<SupplierActivityEvent>;
  adminSupplierOnboardingBoard: AdminSupplierOnboardingBoardResult;
  /**
   * Everything behind one card, loaded when the supplier modal opens. Null when
   * no supplier has that uuid.
   */
  adminSupplierOnboardingDetail?: Maybe<AdminOnboardingSupplierDetail>;
  /**
   * Public listings a person could pick as this supplier's, for the review
   * modal. Nothing is matched automatically and nothing is ranked: the operator
   * chooses, and that choice is the confirmation. An empty list is a valid
   * answer, not an error.
   */
  adminSupplierReviewCandidates: Array<AdminReviewCandidate>;
  /**
   * What was decided for this supplier and provider, and the review data behind
   * it. Null when nobody has looked yet — which is not the same as having
   * looked and found nothing, which comes back as an outcome of NO_MATCH.
   */
  adminSupplierReviewListing?: Maybe<AdminSupplierReviewListing>;
  /**
   * Everything we know to have happened to a supplier, newest first. Empty for
   * a supplier that does not exist rather than an error: the tab renders the
   * same either way.
   */
  adminSupplierTimeline: Array<AdminSupplierTimelineEvent>;
  adminSuppliersSearch: AdminSuppliersSearchResult;
  adminUsersSearch: AdminUsersSearchResult;
  agency?: Maybe<AgencyQueryResponse>;
  categoriesTier1S: Array<Categories_Tier1>;
  categoriesTier2S: Array<Categories_Tier2>;
  categoriesTier2TagGroups: Array<Categories_Tier2_Tag_Groups>;
  checkDisintermediation?: Maybe<DisintermediationTypes>;
  checkPromotion?: Maybe<Scalars['Boolean']['output']>;
  completedPayment?: Maybe<CompletedPaymentResponse>;
  completedPayments?: Maybe<CompletedPaymentsResponse>;
  conversations: Array<Conversations>;
  countSupplierUnreadMessages: Scalars['Int']['output'];
  customerAccountManager?: Maybe<SalesforceAccountManagerV2>;
  customerEvent?: Maybe<Events>;
  customerEventRequest?: Maybe<Event_Requests>;
  customerEventRequests: Array<Maybe<Event_Requests>>;
  customerEvents: Array<Events>;
  customerQuotes?: Maybe<CustomerQuotes>;
  eventDeliveries: Array<EventDelivery>;
  eventDelivery?: Maybe<EventDelivery>;
  eventDeliveryDocuments: Array<EventDeliveryDocument>;
  eventRequests: Array<Event_Requests>;
  events: Array<Events>;
  favouriteSuppliers: Array<FavouriteSupplier>;
  getAdminSupplierStatistics?: Maybe<Supplier_Statistics>;
  getCategoryTier2Tags: Array<Tier2Tags>;
  getCognitoUsername?: Maybe<Scalars['String']['output']>;
  getConversation?: Maybe<Conversations>;
  getDrivingDistanceToEventRequest?: Maybe<DrivingDistanceToEventRequest>;
  getInvoiceAsHexString?: Maybe<Scalars['String']['output']>;
  getLastInvoiceDetailsByUserId?: Maybe<InvoiceDetails>;
  getLegacyQuoteLineItemTemplates: GetLegacyQuoteLineItemTemplates;
  getMatchedQuoteTemplates?: Maybe<MatchedQuoteTemplates>;
  getSupplierFlexiblePricingForRequestDate: GetSupplierFlexiblePricingForRequestDateTypes;
  getSupplierStatistics?: Maybe<Supplier_Statistics>;
  /** @deprecated Use getTreatmentV2 instead */
  getTreatment: Treatment;
  getTreatmentV2?: Maybe<Treatment>;
  googleCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  identifyUserType?: Maybe<IdentifyUser>;
  latestUnreadConversationMessage?: Maybe<Latest_Unread_Conversation_Message>;
  liveAccountManagers?: Maybe<LiveAccountManagers>;
  localisedSupplierCount: Scalars['Int']['output'];
  offlineMatchmakingBatchCsv?: Maybe<OfflineMatchmakingBatchCsv>;
  offlineMatchmakingBatches: Array<OfflineMatchmakingBatchSummary>;
  onboardingRequestsCount?: Maybe<Scalars['Int']['output']>;
  openEvents?: Maybe<Open_Events>;
  organisationUsersByContext: Array<OrganisationUser>;
  organisationUsersByOrgUuid: Array<OrganisationUser>;
  osOpenEvents?: Maybe<OpensearchOpenEvents>;
  outlookCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  partnershipBySlug?: Maybe<Partnership>;
  partnershipByUuid?: Maybe<Partnership>;
  partnerships?: Maybe<PartnershipsResult>;
  paymentMethod?: Maybe<PaymentType>;
  paymentMethods: Array<Maybe<PaymentMethod>>;
  pitchApplicationByUuid?: Maybe<PitchApplication>;
  pitchApplications?: Maybe<PitchApplicationsType>;
  pitchApplicationsByPitchGroupIds?: Maybe<PitchApplicationsByPitchGroupIdsType>;
  pitchGroup?: Maybe<PitchGroup>;
  pitchGroups: GetPitchGroupsResponse;
  pitchGroupsByEventDeliveryUuid: Array<PitchGroup>;
  publicEvent?: Maybe<PitchGroup>;
  publicEvents?: Maybe<PitchGroupsList>;
  publicEventsByIds?: Maybe<PitchGroupsByIdsList>;
  publicQuote?: Maybe<Public_Quote>;
  publicSupplier?: Maybe<Public_Supplier>;
  publicSupplierReviews: PublicSupplierReviewsResult;
  quoteLineItemTemplate?: Maybe<QuoteLineItemTemplate>;
  quoteLineItemTemplates?: Maybe<Array<Maybe<QuoteLineItemTemplate>>>;
  quoteLineItemTemplatesSections: GetQuoteLineItemTemplatesSections;
  quoteTemplates: Array<Quote_Templates>;
  quotes: Array<Quotes>;
  quotesSearch?: Maybe<Quote_Search_Results>;
  scheduledPayment?: Maybe<Scheduled_Payments>;
  scheduledPayments?: Maybe<ScheduledPaymentsResponse>;
  settings: Array<Settings>;
  simpleSupplierSearch?: Maybe<SimpleSupplierSearchResult>;
  suggestedSuppliers?: Maybe<SuggestedSuppliers>;
  supplier?: Maybe<Suppliers>;
  supplierAccountManager?: Maybe<SalesforceAccountManagerV2>;
  supplierCalendar?: Maybe<SupplierCalendar>;
  supplierDocs?: Maybe<SupplierDocsListType>;
  supplierDocsPresignedURL?: Maybe<Supplier_Docs_Presigned_Url>;
  supplierFlexiblePricing: Array<Maybe<Supplier_Flexible_Pricing>>;
  supplierLineItemsForCustomer: Array<QuoteLineItemTemplatesSection>;
  supplierPayments?: Maybe<Array<Maybe<Supplier_Payments>>>;
  supplierPitchApplications?: Maybe<GetSupplierPitchApplicationResponse>;
  supplierReferrals: SupplierReferrals;
  supplierSetup?: Maybe<SupplierSetup>;
  supplierSetups: Array<SupplierSetup>;
  supplierTotalQuotes?: Maybe<Total_Count>;
  suppliers: Array<Suppliers>;
  suppliersEventRequest?: Maybe<SuppliersEventRequest>;
  suppliersSlugs?: Maybe<Array<Maybe<SuppliersSlugs>>>;
  tags: Array<Tags>;
  tagsForType: Array<Tags>;
  userFromContext?: Maybe<Users>;
  users: Array<Users>;
  usersMe?: Maybe<UsersMe>;
  vatRates?: Maybe<Array<Maybe<VatRate>>>;
  venueSpacesAndQuoteLineItemTemplates?: Maybe<VenueSpacesAndQuoteLineItemTemplates>;
  verifyToken?: Maybe<Scalars['String']['output']>;
  workflowAutomationsMessageTemplates?: Maybe<Array<Maybe<Workflow_Automations_Message_Templates>>>;
};


export type QueryAccountManagerArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountManagerForUserEventArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryAdminCognitoUsersSearchArgs = {
  filters: AdminCognitoUsersSearchFilters;
};


export type QueryAdminEventsSearchArgs = {
  filters: AdminEventsSearchFilters;
};


export type QueryAdminGetPartnershipEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partnershipUuid: Scalars['String']['input'];
};


export type QueryAdminGetSupplierPitchApplicationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pitchGroupStage?: InputMaybe<Array<PitchGroupStage>>;
  pitchGroupType?: InputMaybe<Array<Scalars['String']['input']>>;
  pitchStatus?: InputMaybe<Array<PitchStatus>>;
  supplierId: Scalars['String']['input'];
};


export type QueryAdminPartnershipsSearchArgs = {
  filters: AdminPartnershipsSearchFilters;
};


export type QueryAdminQuotesSearchArgs = {
  filters: AdminQuotesSearchFilters;
};


export type QueryAdminRequestsSearchArgs = {
  filters: AdminRequestsSearchFilters;
};


export type QueryAdminReviewsSearchArgs = {
  filters: AdminReviewsSearchFilters;
};


export type QueryAdminSupplierEventsArgs = {
  filters: AdminSupplierEventsFilters;
};


export type QueryAdminSupplierOnboardingBoardArgs = {
  filters?: InputMaybe<AdminSupplierOnboardingBoardFilters>;
};


export type QueryAdminSupplierOnboardingDetailArgs = {
  filters: AdminSupplierOnboardingDetailFilters;
};


export type QueryAdminSupplierReviewCandidatesArgs = {
  filters: AdminSupplierReviewCandidatesFilters;
};


export type QueryAdminSupplierReviewListingArgs = {
  filters: AdminSupplierReviewListingFilters;
};


export type QueryAdminSupplierTimelineArgs = {
  filters: AdminSupplierTimelineFilters;
};


export type QueryAdminSuppliersSearchArgs = {
  filters: AdminSuppliersSearchFilters;
};


export type QueryAdminUsersSearchArgs = {
  filters: AdminUsersSearchFilters;
};


export type QueryAgencyArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoriesTier1SArgs = {
  cursor?: InputMaybe<Categories_Tier1WhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  supplierOnly?: InputMaybe<Scalars['Boolean']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Categories_Tier1WhereInput>;
};


export type QueryCategoriesTier2SArgs = {
  cursor?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Categories_Tier2WhereInput>;
};


export type QueryCategoriesTier2TagGroupsArgs = {
  cursor?: InputMaybe<Categories_Tier2_Tag_GroupsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckDisintermediationArgs = {
  textInput?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckPromotionArgs = {
  promotionFields?: InputMaybe<PromotionFieldsInput>;
  promotionName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompletedPaymentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCompletedPaymentsArgs = {
  filter: CompletedPaymentsFilter;
};


export type QueryConversationsArgs = {
  cursor?: InputMaybe<ConversationsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ConversationsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConversationsWhereInput>;
};


export type QueryCountSupplierUnreadMessagesArgs = {
  supplierId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryCustomerEventArgs = {
  filter: CustomerEventFilter;
};


export type QueryCustomerEventRequestArgs = {
  filter: CustomerEventRequestFilter;
};


export type QueryCustomerEventRequestsArgs = {
  filter: CustomerEventRequestsFilter;
};


export type QueryCustomerEventsArgs = {
  filter?: InputMaybe<CustomerEventsFilter>;
};


export type QueryCustomerQuotesArgs = {
  eventRequestId: Scalars['String']['input'];
  filter?: InputMaybe<CustomerQuotesFilter>;
  orderBy?: InputMaybe<Array<CustomerQuotesOrderByInput>>;
};


export type QueryEventDeliveriesArgs = {
  filter?: InputMaybe<EventDeliveriesFilter>;
  organisationUuid: Scalars['String']['input'];
};


export type QueryEventDeliveryArgs = {
  eventDeliveryUuid: Scalars['String']['input'];
  organisationUuid: Scalars['String']['input'];
};


export type QueryEventDeliveryDocumentsArgs = {
  documentsPublished?: InputMaybe<Scalars['Boolean']['input']>;
  eventDeliveryUuid: Scalars['String']['input'];
  organisationUuid: Scalars['String']['input'];
};


export type QueryEventRequestsArgs = {
  cursor?: InputMaybe<Event_RequestsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<Event_RequestsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Event_RequestsWhereInput>;
};


export type QueryEventsArgs = {
  cursor?: InputMaybe<EventsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventsWhereInput>;
};


export type QueryGetAdminSupplierStatisticsArgs = {
  supplierUuid: Scalars['String']['input'];
};


export type QueryGetCategoryTier2TagsArgs = {
  cursor?: InputMaybe<Tier2TagsWhereUniqueInput>;
  distinctByTag?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tier2TagsWhereInput>;
};


export type QueryGetCognitoUsernameArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetConversationArgs = {
  eventRequestId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type QueryGetDrivingDistanceToEventRequestArgs = {
  eventRequestId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type QueryGetInvoiceAsHexStringArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryGetMatchedQuoteTemplatesArgs = {
  eventRequestUuid: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type QueryGetSupplierFlexiblePricingForRequestDateArgs = {
  date: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type QueryGetTreatmentArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  test?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTreatmentV2Args = {
  identifier: Scalars['String']['input'];
  splitName: Scalars['String']['input'];
  type: TreatmentTestIdentifierEnum;
};


export type QueryGoogleCalendarEventsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryIdentifyUserTypeArgs = {
  email: Scalars['String']['input'];
};


export type QueryLatestUnreadConversationMessageArgs = {
  eventRequestId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveAccountManagersArgs = {
  eventDeliveryUuid: Scalars['String']['input'];
  organisationUuid: Scalars['String']['input'];
};


export type QueryLocalisedSupplierCountArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  tier1: Scalars['String']['input'];
};


export type QueryOfflineMatchmakingBatchCsvArgs = {
  batchId: Scalars['String']['input'];
  includeDebugData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOfflineMatchmakingBatchesArgs = {
  batchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOnboardingRequestsCountArgs = {
  data: OnboardingRequestsInput;
};


export type QueryOpenEventsArgs = {
  budgetMax?: InputMaybe<Scalars['Int']['input']>;
  budgetMin?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notifiedMethod?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priorityTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  radius?: InputMaybe<Scalars['Int']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tier2?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganisationUsersByOrgUuidArgs = {
  organisationUuid: Scalars['String']['input'];
};


export type QueryOsOpenEventsArgs = {
  filter: OpenEventsFilterInput;
};


export type QueryOutlookCalendarEventsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryPartnershipBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPartnershipByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPartnershipsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentMethodArgs = {
  quoteId: Scalars['String']['input'];
};


export type QueryPitchApplicationByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPitchApplicationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPitchApplicationsByPitchGroupIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPitchGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPitchGroupsArgs = {
  hasSupplierApplication?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pitchApplicationStatuses?: InputMaybe<Array<PitchStatus>>;
  pitchGroupStages?: InputMaybe<Array<PitchGroupStage>>;
  pitchGroupTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPitchGroupsByEventDeliveryUuidArgs = {
  eventDeliveryUuid: Scalars['String']['input'];
  filter?: InputMaybe<PitchGroupsFilter>;
  organisationUuid: Scalars['String']['input'];
};


export type QueryPublicEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublicEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pitchTypes?: InputMaybe<Array<InputMaybe<PitchTypeEnums>>>;
};


export type QueryPublicEventsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryPublicQuoteArgs = {
  quote_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicSupplierArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicSupplierReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  supplierUuid: Scalars['String']['input'];
};


export type QueryQuoteLineItemTemplateArgs = {
  lineItemId: Scalars['String']['input'];
};


export type QueryQuoteLineItemTemplatesArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<QuoteLineItemTemplatesWhere>;
};


export type QueryQuoteTemplatesArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuotesArgs = {
  cursor?: InputMaybe<QuotesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<QuotesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuotesWhereInput>;
};


export type QueryQuotesSearchArgs = {
  budgetMax?: InputMaybe<Scalars['Int']['input']>;
  budgetMin?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  quoteState?: InputMaybe<Scalars['String']['input']>;
  quoteView?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['String']['input'];
};


export type QueryScheduledPaymentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScheduledPaymentsArgs = {
  filter: ScheduledPaymentsFilter;
};


export type QuerySettingsArgs = {
  cursor?: InputMaybe<SettingsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SettingsWhereInput>;
};


export type QuerySimpleSupplierSearchArgs = {
  filters: SimpleSupplierSearchFilters;
};


export type QuerySuggestedSuppliersArgs = {
  eventRequestUuid: Scalars['String']['input'];
  options?: InputMaybe<SuggestedSuppliersOptions>;
};


export type QuerySupplierArgs = {
  filter: SuppliersFilter;
};


export type QuerySupplierAccountManagerArgs = {
  salesforceId: Scalars['String']['input'];
};


export type QuerySupplierCalendarArgs = {
  calendarView: Scalars['String']['input'];
  calendarViewEndDate?: InputMaybe<Scalars['String']['input']>;
  calendarViewStartDate: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type QuerySupplierDocsArgs = {
  filter?: InputMaybe<SupplierDocsFilters>;
  supplierId: Scalars['String']['input'];
};


export type QuerySupplierDocsPresignedUrlArgs = {
  key: Scalars['String']['input'];
};


export type QuerySupplierFlexiblePricingArgs = {
  supplierId: Scalars['String']['input'];
};


export type QuerySupplierLineItemsForCustomerArgs = {
  quoteUuid: Scalars['String']['input'];
  supplierUuid: Scalars['String']['input'];
};


export type QuerySupplierPaymentsArgs = {
  quoteId: Scalars['String']['input'];
};


export type QuerySupplierPitchApplicationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pitchGroupStage?: InputMaybe<Array<PitchGroupStage>>;
  pitchGroupType?: InputMaybe<Array<Scalars['String']['input']>>;
  pitchStatus?: InputMaybe<Array<PitchStatus>>;
};


export type QuerySupplierSetupArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySupplierSetupsArgs = {
  eventType?: InputMaybe<SupplierSetupEventType>;
  state?: InputMaybe<Array<SupplierSetupState>>;
  supplierUuid: Scalars['String']['input'];
};


export type QuerySupplierTotalQuotesArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuppliersArgs = {
  cursor?: InputMaybe<SuppliersWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SuppliersWhereInput>;
};


export type QuerySuppliersEventRequestArgs = {
  eventRequestId: Scalars['String']['input'];
};


export type QueryTagsArgs = {
  cursor?: InputMaybe<TagsWhereUniqueInput>;
  filter?: InputMaybe<TagsFilter>;
  orderBy?: InputMaybe<Array<TagsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagsWhereInput>;
};


export type QueryTagsForTypeArgs = {
  filter?: InputMaybe<TagsFilter>;
  type: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UsersWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UsersWhereInput>;
};


export type QueryVatRatesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  rateTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVenueSpacesAndQuoteLineItemTemplatesArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifyTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryWorkflowAutomationsMessageTemplatesArgs = {
  supplierId: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export enum QuoteContractType {
  DirectContract = 'DIRECT_CONTRACT'
}

export type QuoteLineItemInput = {
  customerTotalAmount?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  priceType?: InputMaybe<PriceType>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<QuoteLineItemTypeEnum>;
  vatAmount?: InputMaybe<Scalars['Int']['input']>;
  vatPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  vatRateId?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteLineItemTemplate = {
  __typename?: 'QuoteLineItemTemplate';
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  has_quantity: Scalars['Boolean']['output'];
  image?: Maybe<Supplier_Images>;
  image_id?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  priceBreakdown?: Maybe<PriceBreakdown>;
  priceType?: Maybe<PriceType>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quoteLineItemTemplatesSectionUuid?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<QuoteLineItemTypeEnum>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vatRateId?: Maybe<Scalars['String']['output']>;
};

export type QuoteLineItemTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  has_quantity: Scalars['Boolean']['input'];
  image_id?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  priceType?: InputMaybe<PriceType>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quoteLineItemTemplatesSectionUuid?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<QuoteLineItemTypeEnum>;
  vatRateId?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteLineItemTemplatesSection = {
  __typename?: 'QuoteLineItemTemplatesSection';
  created?: Maybe<Scalars['DateTime']['output']>;
  quoteLineItemTemplates: Array<QuoteLineItemTemplate>;
  supplier: Suppliers;
  supplierUuid: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: QuoteLineItemTypeEnum;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type QuoteLineItemTemplatesWhere = {
  title?: InputMaybe<QuoteLineItemTemplatesWhereTitle>;
  type?: InputMaybe<QuoteLineItemTemplatesWhereType>;
};

export type QuoteLineItemTemplatesWhereTitle = {
  contains: Scalars['String']['input'];
};

export type QuoteLineItemTemplatesWhereType = {
  in: Array<QuoteLineItemTypeEnum>;
};

export type QuotePriceBreakdown = {
  __typename?: 'QuotePriceBreakdown';
  excludingVatPrices?: Maybe<QuotePriceFormats>;
  includingVatPrices?: Maybe<QuotePriceFormats>;
};

export type QuotePriceDetails = {
  __typename?: 'QuotePriceDetails';
  affiliateCommissionAmount: Scalars['Int']['output'];
  affiliateCommissionRate: Scalars['Float']['output'];
  combinedServiceFeeAmount: Scalars['Int']['output'];
  combinedServiceFeeRate: Scalars['Float']['output'];
  commissionFeeAmount: Scalars['Int']['output'];
  commissionFeeRate: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  customerTotalAmount: Scalars['Int']['output'];
  customerTotalPriceExclVat: Scalars['Int']['output'];
  partnerCommissionAmount: Scalars['Int']['output'];
  partnerCommissionRate: Scalars['Float']['output'];
  protectPlusAmount: Scalars['Int']['output'];
  protectPlusRate: Scalars['Float']['output'];
  quoteTotalAmount: Scalars['Int']['output'];
  quoteTotalExclVatAmount: Scalars['Int']['output'];
  quoteUuid: Scalars['String']['output'];
  serviceFeeAmount: Scalars['Int']['output'];
  serviceFeeRate: Scalars['Float']['output'];
  supplierTakeHomeAmount: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vatAmount: Scalars['Int']['output'];
};

export type QuotePriceDetailsInput = {
  affiliateCommissionAmount?: InputMaybe<Scalars['Int']['input']>;
  affiliateCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  commissionFeeAmount: Scalars['Int']['input'];
  commissionFeeRate: Scalars['Float']['input'];
  customerTotalAmount: Scalars['Int']['input'];
  partnerCommissionAmount?: InputMaybe<Scalars['Int']['input']>;
  partnerCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  protectPlusAmount?: InputMaybe<Scalars['Int']['input']>;
  protectPlusRate?: InputMaybe<Scalars['Float']['input']>;
  quoteTotalAmount: Scalars['Int']['input'];
  serviceFeeAmount: Scalars['Int']['input'];
  serviceFeeRate: Scalars['Float']['input'];
  supplierTakeHomeAmount: Scalars['Int']['input'];
  vatAmount: Scalars['Int']['input'];
};

export type QuotePriceFormats = {
  __typename?: 'QuotePriceFormats';
  formattedToCurrency?: Maybe<QuotePricesFormattedCurrency>;
  inPennies?: Maybe<QuotePricesNumberPennies>;
};

export type QuotePricesFormattedCurrency = {
  __typename?: 'QuotePricesFormattedCurrency';
  commissionPrice?: Maybe<Scalars['String']['output']>;
  priceExclCommission?: Maybe<Scalars['String']['output']>;
  priceInclCommission?: Maybe<Scalars['String']['output']>;
  priceInclCommissionAndServiceFee?: Maybe<Scalars['String']['output']>;
  priceInclCommissionAndServiceFeeAndProtection?: Maybe<Scalars['String']['output']>;
  protectionPrice?: Maybe<Scalars['String']['output']>;
  serviceFeePrice?: Maybe<Scalars['String']['output']>;
};

export type QuotePricesNumberPennies = {
  __typename?: 'QuotePricesNumberPennies';
  commissionPrice?: Maybe<Scalars['Int']['output']>;
  priceExclCommission?: Maybe<Scalars['Int']['output']>;
  priceInclCommission?: Maybe<Scalars['Int']['output']>;
  priceInclCommissionAndServiceFee?: Maybe<Scalars['Int']['output']>;
  priceInclCommissionAndServiceFeeAndProtection?: Maybe<Scalars['Int']['output']>;
  protectionPrice?: Maybe<Scalars['Int']['output']>;
  serviceFeePrice?: Maybe<Scalars['Int']['output']>;
};

export enum QuoteSource {
  AppAndroid = 'app_android',
  AppIos = 'app_ios',
  Platform = 'platform'
}

export enum QuoteTemplateLineItemsType {
  AdditionalCosts = 'additional_costs',
  Food = 'food',
  Legacy = 'legacy',
  Main = 'main',
  Space = 'space'
}

export type QuoteTemplateLineItemsUpsert = {
  description?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  priceType?: InputMaybe<PriceType>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<QuoteTemplateLineItemsType>;
  vatRateId?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteTemplateTags = {
  __typename?: 'QuoteTemplateTags';
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Quote_Line_Item_TemplatesListRelationFilter = {
  every?: InputMaybe<Quote_Line_Item_TemplatesWhereInput>;
  none?: InputMaybe<Quote_Line_Item_TemplatesWhereInput>;
  some?: InputMaybe<Quote_Line_Item_TemplatesWhereInput>;
};

export type Quote_Line_ItemsListRelationFilter = {
  every?: InputMaybe<Quote_Line_ItemsWhereInput>;
  none?: InputMaybe<Quote_Line_ItemsWhereInput>;
  some?: InputMaybe<Quote_Line_ItemsWhereInput>;
};

export type Quote_Template_Line_ItemsListRelationFilter = {
  every?: InputMaybe<Quote_Template_Line_ItemsWhereInput>;
  none?: InputMaybe<Quote_Template_Line_ItemsWhereInput>;
  some?: InputMaybe<Quote_Template_Line_ItemsWhereInput>;
};

export type Quote_Template_TagsListRelationFilter = {
  every?: InputMaybe<Quote_Template_TagsWhereInput>;
  none?: InputMaybe<Quote_Template_TagsWhereInput>;
  some?: InputMaybe<Quote_Template_TagsWhereInput>;
};

export type Quote_TemplatesListRelationFilter = {
  every?: InputMaybe<Quote_TemplatesWhereInput>;
  none?: InputMaybe<Quote_TemplatesWhereInput>;
  some?: InputMaybe<Quote_TemplatesWhereInput>;
};

export type QuotesListRelationFilter = {
  every?: InputMaybe<QuotesWhereInput>;
  none?: InputMaybe<QuotesWhereInput>;
  some?: InputMaybe<QuotesWhereInput>;
};

export type RecommendationsListRelationFilter = {
  every?: InputMaybe<RecommendationsWhereInput>;
  none?: InputMaybe<RecommendationsWhereInput>;
  some?: InputMaybe<RecommendationsWhereInput>;
};

export enum RegionEnum {
  ChannelIslands = 'channel_islands',
  EastMidlands = 'east_midlands',
  EastOfEngland = 'east_of_england',
  GreaterLondon = 'greater_london',
  IsleOfMan = 'isle_of_man',
  NorthEast = 'north_east',
  NorthWest = 'north_west',
  NorthernIreland = 'northern_ireland',
  Scotland = 'scotland',
  SouthEast = 'south_east',
  SouthWest = 'south_west',
  Wales = 'wales',
  WestMidlands = 'west_midlands'
}

export type Regions = {
  __typename?: 'Regions';
  created?: Maybe<Scalars['DateTime']['output']>;
  district: Scalars['String']['output'];
  postcode_prefix: Scalars['String']['output'];
  uk_region: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type RegisterDevicePushTokenInput = {
  apnsEnvironment?: InputMaybe<MobilePushApnsEnvironment>;
  deviceUuid: Scalars['String']['input'];
  platform: MobilePushPlatform;
  pushToken: Scalars['String']['input'];
};

export type RegisterDevicePushTokenResponse = {
  __typename?: 'RegisterDevicePushTokenResponse';
  success: Scalars['Boolean']['output'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RestrictedUser = {
  __typename?: 'RestrictedUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export enum ReviewListingOutcome {
  NoMatch = 'NO_MATCH',
  Selected = 'SELECTED'
}

/** Public review sources. */
export enum ReviewProvider {
  Google = 'GOOGLE',
  Tripadvisor = 'TRIPADVISOR'
}

export type ReviewsExternalEvent = {
  __typename?: 'ReviewsExternalEvent';
  date: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  userFullName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ReviewsListRelationFilter = {
  every?: InputMaybe<ReviewsWhereInput>;
  none?: InputMaybe<ReviewsWhereInput>;
  some?: InputMaybe<ReviewsWhereInput>;
};

export type RobexOptions = {
  enableEmails?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  removePreviouslyRobexed?: InputMaybe<Scalars['Boolean']['input']>;
  requireSupplierVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Robex_NotificationsListRelationFilter = {
  every?: InputMaybe<Robex_NotificationsWhereInput>;
  none?: InputMaybe<Robex_NotificationsWhereInput>;
  some?: InputMaybe<Robex_NotificationsWhereInput>;
};

export type Robex_Version_Vertical_MetricListRelationFilter = {
  every?: InputMaybe<Robex_Version_Vertical_MetricWhereInput>;
  none?: InputMaybe<Robex_Version_Vertical_MetricWhereInput>;
  some?: InputMaybe<Robex_Version_Vertical_MetricWhereInput>;
};

export type RootTag = {
  __typename?: 'RootTag';
  created?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type RunRobexMatching = {
  __typename?: 'RunRobexMatching';
  potentialSuppliers?: Maybe<Scalars['Int']['output']>;
  suppliers?: Maybe<Array<Maybe<SuppliersWithPercentageMatches>>>;
  suppliersNotified?: Maybe<Scalars['Int']['output']>;
};

export type RunVenuesMatching = {
  __typename?: 'RunVenuesMatching';
  coreMatchedSpaces: Array<Venue_Spaces>;
  coreMatchedSuppliersCount: Scalars['Int']['output'];
  firstSegmentOverBudgetSpaces: Array<Venue_Spaces>;
  secondSegmentOverBudgetSpaces: Array<Venue_Spaces>;
};

export type SalesforceAccountManagerV2 = {
  __typename?: 'SalesforceAccountManagerV2';
  defaultFor?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isBot?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type SalesforceEvent = {
  __typename?: 'SalesforceEvent';
  created: Scalars['DateTime']['output'];
  eventId: Scalars['String']['output'];
  leadId?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Enum_Salesforce_Events_Method>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Enum_Salesforce_Events_Stage>;
  stageReason?: Maybe<Enum_Salesforce_Events_Stage_Reason>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SalesforceSuppliers = {
  __typename?: 'SalesforceSuppliers';
  approval_state: Enum_Salesforce_Suppliers_Approval_State;
  created: Scalars['DateTime']['output'];
  public_approval_state: Enum_Salesforce_Suppliers_Public_Approval_State;
  salesforce_account_id?: Maybe<Scalars['String']['output']>;
  salesforce_lead_id?: Maybe<Scalars['String']['output']>;
  supplier_id: Scalars['String']['output'];
  suppliers: Suppliers;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScheduledPayment = {
  __typename?: 'ScheduledPayment';
  amount: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  currentState?: Maybe<PaymentState>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  method: Scalars['String']['output'];
  paymentErrors?: Maybe<PaymentError>;
  quoteId: Scalars['String']['output'];
  scheduledDate: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScheduledPaymentsFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScheduledPaymentsOrderByInput>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paymentYearMonth?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['String']['input'];
  type?: InputMaybe<Enum_Scheduled_Payments_Type>;
};

export type ScheduledPaymentsOrderByInput = {
  amount?: InputMaybe<SortOrder>;
  eventDate?: InputMaybe<SortOrder>;
  scheduledDate?: InputMaybe<SortOrder>;
};

export type ScheduledPaymentsResponse = {
  __typename?: 'ScheduledPaymentsResponse';
  currentPage?: Maybe<Scalars['Int']['output']>;
  scheduledPayments: Array<ScheduledPayment>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Scheduled_PaymentsListRelationFilter = {
  every?: InputMaybe<Scheduled_PaymentsWhereInput>;
  none?: InputMaybe<Scheduled_PaymentsWhereInput>;
  some?: InputMaybe<Scheduled_PaymentsWhereInput>;
};

export enum SeasonEnum {
  Autumn = 'autumn',
  Spring = 'spring',
  Summer = 'summer',
  Winter = 'winter'
}

export type SendDueSupplierOnboardingFollowUpsResult = {
  __typename?: 'SendDueSupplierOnboardingFollowUpsResult';
  failed: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type SendPlatformMagicLinkResponse = {
  __typename?: 'SendPlatformMagicLinkResponse';
  success: Scalars['Boolean']['output'];
};

export type SetInteger = {
  set?: InputMaybe<Scalars['Int']['input']>;
};

export enum SetupDocumentType {
  AllergensChart = 'allergens_chart',
  Coshh = 'coshh',
  ElectricalInstallationCertificate = 'electrical_installation_certificate',
  FireRiskAssessment = 'fire_risk_assessment',
  FoodHygieneCertificate = 'food_hygiene_certificate',
  FoodHygieneRating = 'food_hygiene_rating',
  GasSafetyCertificate = 'gas_safety_certificate',
  Haccp = 'haccp',
  PatTestCertificate = 'pat_test_certificate',
  RiskAssessmentMethodStatement = 'risk_assessment_method_statement'
}

export type SimpleSupplier = {
  __typename?: 'SimpleSupplier';
  average_rating?: Maybe<Scalars['Float']['output']>;
  base_price?: Maybe<Scalars['Float']['output']>;
  categoryTier1?: Maybe<Scalars['String']['output']>;
  dietary?: Maybe<Array<Maybe<SupplierDietary>>>;
  distance?: Maybe<Scalars['Float']['output']>;
  external?: Maybe<ExternalSupplierInfo>;
  name?: Maybe<Scalars['String']['output']>;
  overall_message_response_rate?: Maybe<Scalars['Float']['output']>;
  public?: Maybe<PublicSupplier>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Enum_Suppliers_State>;
  tagline?: Maybe<Scalars['String']['output']>;
  tier2?: Maybe<Array<Maybe<Public_Supplier_Tier2>>>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SimpleSupplierSearchFilters = {
  budget?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dietary?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  limit: Scalars['Int']['input'];
  lon?: InputMaybe<Scalars['Float']['input']>;
  mandatoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SimpleSupplierSearchSort>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tier1?: InputMaybe<Scalars['String']['input']>;
  tier2?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SimpleSupplierSearchResult = {
  __typename?: 'SimpleSupplierSearchResult';
  noOfPages: Scalars['Int']['output'];
  pageNo: Scalars['Int']['output'];
  suppliers: Array<SimpleSupplier>;
  totalResults: Scalars['Int']['output'];
};

export enum SimpleSupplierSearchSort {
  Distance = 'distance'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Space_GroupsListRelationFilter = {
  every?: InputMaybe<Space_GroupsWhereInput>;
  none?: InputMaybe<Space_GroupsWhereInput>;
  some?: InputMaybe<Space_GroupsWhereInput>;
};

export type Space_TagsListRelationFilter = {
  every?: InputMaybe<Space_TagsWhereInput>;
  none?: InputMaybe<Space_TagsWhereInput>;
  some?: InputMaybe<Space_TagsWhereInput>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuggestedSuppliers = {
  __typename?: 'SuggestedSuppliers';
  noOfPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  resultType: SuggestedSuppliersResultType;
  suppliers: Array<Suppliers>;
  totalResults: Scalars['Int']['output'];
};

export type SuggestedSuppliersOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export enum SuggestedSuppliersResultType {
  Matched = 'MATCHED',
  Prefiltered = 'PREFILTERED'
}

export type SupplierActivityEvent = {
  __typename?: 'SupplierActivityEvent';
  body: Scalars['Json']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SupplierDietary = {
  __typename?: 'SupplierDietary';
  name?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
};

export type SupplierDocsFilters = {
  level?: InputMaybe<SupplierDocsLevelFilter>;
  supplierSetupUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SupplierDocsTypeFilter>;
};

export type SupplierDocsLevelFilter = {
  in: Array<DocumentLevelEnum>;
};

export type SupplierDocsPresignedUrl = {
  __typename?: 'SupplierDocsPresignedURL';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupplierDocsTypeFilter = {
  in?: InputMaybe<Array<DocumentFileTypeEnum>>;
  notIn?: InputMaybe<Array<DocumentFileTypeEnum>>;
};

export type SupplierDocument = {
  __typename?: 'SupplierDocument';
  expiry_date?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  supplierDocsPresignedURL?: Maybe<SupplierDocsPresignedUrl>;
  supplier_id: Scalars['String']['output'];
  type: DocumentFileTypeEnum;
  uuid: Scalars['String']['output'];
};

export type SupplierDocumentCheckResult = {
  __typename?: 'SupplierDocumentCheckResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  liabilityCoverAmount?: Maybe<Scalars['Float']['output']>;
  status: SupplierDocumentCheckStatus;
  warnings: Array<Scalars['String']['output']>;
};

export enum SupplierDocumentCheckStatus {
  Checked = 'checked',
  Failed = 'failed'
}

export type SupplierImage = {
  __typename?: 'SupplierImage';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupplierInvoices = {
  __typename?: 'SupplierInvoices';
  invoicesIds: Array<Scalars['String']['output']>;
};

export enum SupplierLinkType {
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  Website = 'WEBSITE',
  Youtube = 'YOUTUBE'
}

export type SupplierLinks = {
  __typename?: 'SupplierLinks';
  completeUrl?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  supplierUuid: Scalars['String']['output'];
  type: SupplierLinkType;
  updated?: Maybe<Scalars['DateTime']['output']>;
  urlPath?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type SupplierLogistics = {
  __typename?: 'SupplierLogistics';
  registeredCity?: Maybe<Scalars['String']['output']>;
};

export type SupplierOnboardingEmailInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SupplierOnboardingSupplierInput = {
  categories_tier1: Scalars['String']['input'];
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  external_links: Scalars['Json']['input'];
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  state: Scalars['String']['input'];
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierOnboardingUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  terms?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SupplierPermissionType {
  CustomerPhoneNumberAllowed = 'CUSTOMER_PHONE_NUMBER_ALLOWED'
}

export type SupplierPermissions = {
  __typename?: 'SupplierPermissions';
  permissionType: SupplierPermissionType;
  supplierUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SupplierPermissionsCreateManyDataInput = {
  permissionType: SupplierPermissionType;
  uuid: Scalars['String']['input'];
};

export type SupplierPermissionsCreateManyInput = {
  data: Array<SupplierPermissionsCreateManyDataInput>;
};

export type SupplierPermissionsDeleteManyDataInput = {
  in: Array<Scalars['String']['input']>;
};

export type SupplierPermissionsDeleteManyInput = {
  uuid: SupplierPermissionsDeleteManyDataInput;
};

export type SupplierPermissionsInput = {
  createMany?: InputMaybe<SupplierPermissionsCreateManyInput>;
  deleteMany?: InputMaybe<SupplierPermissionsDeleteManyInput>;
};

export type SupplierPitchGroupType = {
  __typename?: 'SupplierPitchGroupType';
  created: Scalars['DateTime']['output'];
  pitchGroupType: PitchGroupType;
  pitchGroupTypeUuid: Scalars['String']['output'];
  supplierUuid: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SupplierReferralEvent = {
  __typename?: 'SupplierReferralEvent';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SupplierReferralLink = {
  __typename?: 'SupplierReferralLink';
  referralLink: Scalars['String']['output'];
};

export type SupplierReferrals = {
  __typename?: 'SupplierReferrals';
  bookedReferredEvents: Array<BookedSupplierReferralEvent>;
  referredEvents: Array<SupplierReferralEvent>;
};

export type SupplierSetup = {
  __typename?: 'SupplierSetup';
  PitchApplications?: Maybe<Array<Maybe<PitchApplication>>>;
  availability?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  eventType: SupplierSetupEventType;
  isMissingDocuments?: Maybe<Scalars['Boolean']['output']>;
  setupType: SupplierSetupType;
  state: SupplierSetupState;
  supplierSetupBackDimensions?: Maybe<SupplierSetupDimensions>;
  supplierSetupDocuments?: Maybe<Array<SupplierDocType>>;
  supplierSetupFrontDimensions?: Maybe<SupplierSetupDimensions>;
  supplierSetupImages: Array<SupplierSetupImages>;
  supplierSetupPowerConnections?: Maybe<SupplierSetupPowerConnections>;
  supplierSetupRequirements?: Maybe<SupplierSetupRequirements>;
  supplierUuid: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SupplierSetupDimensions = {
  __typename?: 'SupplierSetupDimensions';
  depth: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum SupplierSetupEventType {
  Both = 'BOTH',
  Prepaid = 'PREPAID',
  Public = 'PUBLIC'
}

export type SupplierSetupImages = {
  __typename?: 'SupplierSetupImages';
  created: Scalars['String']['output'];
  supplierImage: Supplier_Images;
  supplierImageUuid: Scalars['String']['output'];
  updated: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SupplierSetupPowerConnections = {
  __typename?: 'SupplierSetupPowerConnections';
  uuid: Scalars['String']['output'];
  x13amp: Scalars['Int']['output'];
  x16ThreePhase: Scalars['Int']['output'];
  x16amp: Scalars['Int']['output'];
  x32amp: Scalars['Int']['output'];
  x33ThreePhase: Scalars['Int']['output'];
  x63ThreePhase: Scalars['Int']['output'];
};

export type SupplierSetupRequirements = {
  __typename?: 'SupplierSetupRequirements';
  additionalNotes?: Maybe<Scalars['String']['output']>;
  fullyElectric: Scalars['Boolean']['output'];
  hotHoldOnly: Scalars['Boolean']['output'];
  loadRequirements?: Maybe<Scalars['String']['output']>;
  lowSmoke: Scalars['Boolean']['output'];
  usesGas: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export enum SupplierSetupState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum SupplierSetupType {
  Airstream = 'AIRSTREAM',
  Cart = 'CART',
  Chalet = 'CHALET',
  CitroenH = 'CITROEN_H',
  Container = 'CONTAINER',
  FoodTruck = 'FOOD_TRUCK',
  HorseBox = 'HORSE_BOX',
  MarketStall = 'MARKET_STALL',
  Piaggio = 'PIAGGIO',
  Trailer = 'TRAILER',
  Trike = 'TRIKE'
}

export type Supplier_CalendarsListRelationFilter = {
  every?: InputMaybe<Supplier_CalendarsWhereInput>;
  none?: InputMaybe<Supplier_CalendarsWhereInput>;
  some?: InputMaybe<Supplier_CalendarsWhereInput>;
};

export type Supplier_Calendars_EventsListRelationFilter = {
  every?: InputMaybe<Supplier_Calendars_EventsWhereInput>;
  none?: InputMaybe<Supplier_Calendars_EventsWhereInput>;
  some?: InputMaybe<Supplier_Calendars_EventsWhereInput>;
};

export type Supplier_Categories_Tier2ListRelationFilter = {
  every?: InputMaybe<Supplier_Categories_Tier2WhereInput>;
  none?: InputMaybe<Supplier_Categories_Tier2WhereInput>;
  some?: InputMaybe<Supplier_Categories_Tier2WhereInput>;
};

export type Supplier_DocumentsListRelationFilter = {
  every?: InputMaybe<Supplier_DocumentsWhereInput>;
  none?: InputMaybe<Supplier_DocumentsWhereInput>;
  some?: InputMaybe<Supplier_DocumentsWhereInput>;
};

export type Supplier_Event_RequestsListRelationFilter = {
  every?: InputMaybe<Supplier_Event_RequestsWhereInput>;
  none?: InputMaybe<Supplier_Event_RequestsWhereInput>;
  some?: InputMaybe<Supplier_Event_RequestsWhereInput>;
};

export type Supplier_Flexible_PricingListRelationFilter = {
  every?: InputMaybe<Supplier_Flexible_PricingWhereInput>;
  none?: InputMaybe<Supplier_Flexible_PricingWhereInput>;
  some?: InputMaybe<Supplier_Flexible_PricingWhereInput>;
};

export type Supplier_ImagesListRelationFilter = {
  every?: InputMaybe<Supplier_ImagesWhereInput>;
  none?: InputMaybe<Supplier_ImagesWhereInput>;
  some?: InputMaybe<Supplier_ImagesWhereInput>;
};

export type Supplier_Images_SpacesListRelationFilter = {
  every?: InputMaybe<Supplier_Images_SpacesWhereInput>;
  none?: InputMaybe<Supplier_Images_SpacesWhereInput>;
  some?: InputMaybe<Supplier_Images_SpacesWhereInput>;
};

export type Supplier_PaymentsListRelationFilter = {
  every?: InputMaybe<Supplier_PaymentsWhereInput>;
  none?: InputMaybe<Supplier_PaymentsWhereInput>;
  some?: InputMaybe<Supplier_PaymentsWhereInput>;
};

export enum SuppliersDocumentsDownloadStatus {
  Complete = 'COMPLETE',
  Processing = 'PROCESSING'
}

export type SuppliersFilter = {
  uuid: Scalars['String']['input'];
};

export type SuppliersListRelationFilter = {
  every?: InputMaybe<SuppliersWhereInput>;
  none?: InputMaybe<SuppliersWhereInput>;
  some?: InputMaybe<SuppliersWhereInput>;
};

export type SuppliersSlugs = {
  __typename?: 'SuppliersSlugs';
  slug?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type SuppliersWithPercentageMatches = {
  __typename?: 'SuppliersWithPercentageMatches';
  activity?: Maybe<Scalars['Int']['output']>;
  alcohol_permit?: Maybe<Scalars['Boolean']['output']>;
  average_rating?: Maybe<Scalars['Float']['output']>;
  base_price?: Maybe<Scalars['Float']['output']>;
  calendars?: Maybe<Array<Maybe<Calendar>>>;
  categories_tier2?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category_tier1?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  coordinates?: Maybe<Scalars['Json']['output']>;
  declined_event_requests: Array<Declined_Event_Requests>;
  description?: Maybe<Scalars['String']['output']>;
  distanceToEvent?: Maybe<Scalars['Float']['output']>;
  employers_liability_certificate?: Maybe<Scalars['Json']['output']>;
  external_links?: Maybe<Scalars['Json']['output']>;
  food_hygiene_certificate?: Maybe<Scalars['Json']['output']>;
  freshsales_stage?: Maybe<Scalars['String']['output']>;
  hygiene_rating?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Scalars['json']['output']>>>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_line_1?: Maybe<Scalars['String']['output']>;
  location_line_2?: Maybe<Scalars['String']['output']>;
  matchReasons: Array<MatchReason>;
  matterport_url?: Maybe<Scalars['String']['output']>;
  max_bookings_per_day: Scalars['Int']['output'];
  min_spend?: Maybe<Scalars['Float']['output']>;
  muta_accredited?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentageMatch: Scalars['Float']['output'];
  percentageMatches: Array<PercentageMatch>;
  photoshoot_interested?: Maybe<Scalars['Boolean']['output']>;
  portions_per_hour?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  press_awards?: Maybe<Scalars['String']['output']>;
  price_per_mile?: Maybe<Scalars['Int']['output']>;
  profile_picture?: Maybe<Scalars['Json']['output']>;
  public_events_count?: Maybe<Scalars['Int']['output']>;
  public_events_visible: Scalars['Boolean']['output'];
  public_liability_certificate?: Maybe<Scalars['Json']['output']>;
  quote_templates: Array<Quote_Templates>;
  radius?: Maybe<Scalars['Float']['output']>;
  recommendations: Array<Recommendations>;
  referrals?: Maybe<Supplier_Referrals>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews: Array<Reviews>;
  risk_assessment_document?: Maybe<Scalars['Json']['output']>;
  risk_assessment_score?: Maybe<Scalars['String']['output']>;
  setup_details?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  space_groups: Array<Space_Groups>;
  state?: Maybe<Enum_Suppliers_State>;
  supplier_images_table: Array<Supplier_Images>;
  suppliers_groups: Array<Suppliers_Groups>;
  suppliers_tags: Array<Suppliers_Tags>;
  suppliers_users: Array<Suppliers_Users>;
  tagline?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tagsByRoot?: Maybe<Array<Maybe<Tags>>>;
  totalPercentageMatch: Scalars['Float']['output'];
  trusted: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  vat_number?: Maybe<Scalars['String']['output']>;
  venue_services: Array<Venue_Services>;
  venue_spaces: Array<Venue_Spaces>;
  video_url?: Maybe<Scalars['String']['output']>;
};


export type SuppliersWithPercentageMatchesDeclined_Event_RequestsArgs = {
  cursor?: InputMaybe<Declined_Event_RequestsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesQuote_TemplatesArgs = {
  cursor?: InputMaybe<Quote_TemplatesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesRecommendationsArgs = {
  cursor?: InputMaybe<RecommendationsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesReviewsArgs = {
  cursor?: InputMaybe<ReviewsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewsWhereInput>;
};


export type SuppliersWithPercentageMatchesSpace_GroupsArgs = {
  cursor?: InputMaybe<Space_GroupsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesSupplier_Images_TableArgs = {
  cursor?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesSuppliers_GroupsArgs = {
  cursor?: InputMaybe<Suppliers_GroupsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesSuppliers_UsersArgs = {
  cursor?: InputMaybe<Suppliers_UsersWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesTagsByRootArgs = {
  rootTag: Array<Scalars['String']['input']>;
};


export type SuppliersWithPercentageMatchesVenue_ServicesArgs = {
  cursor?: InputMaybe<Venue_ServicesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersWithPercentageMatchesVenue_SpacesArgs = {
  cursor?: InputMaybe<Venue_SpacesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Suppliers_GroupsListRelationFilter = {
  every?: InputMaybe<Suppliers_GroupsWhereInput>;
  none?: InputMaybe<Suppliers_GroupsWhereInput>;
  some?: InputMaybe<Suppliers_GroupsWhereInput>;
};

export type Suppliers_Groups_ItemsListRelationFilter = {
  every?: InputMaybe<Suppliers_Groups_ItemsWhereInput>;
  none?: InputMaybe<Suppliers_Groups_ItemsWhereInput>;
  some?: InputMaybe<Suppliers_Groups_ItemsWhereInput>;
};

export type Suppliers_ItemsListRelationFilter = {
  every?: InputMaybe<Suppliers_ItemsWhereInput>;
  none?: InputMaybe<Suppliers_ItemsWhereInput>;
  some?: InputMaybe<Suppliers_ItemsWhereInput>;
};

export type Suppliers_TagsListRelationFilter = {
  every?: InputMaybe<Suppliers_TagsWhereInput>;
  none?: InputMaybe<Suppliers_TagsWhereInput>;
  some?: InputMaybe<Suppliers_TagsWhereInput>;
};

export type Suppliers_TypesListRelationFilter = {
  every?: InputMaybe<Suppliers_TypesWhereInput>;
  none?: InputMaybe<Suppliers_TypesWhereInput>;
  some?: InputMaybe<Suppliers_TypesWhereInput>;
};

export type Suppliers_UsersListRelationFilter = {
  every?: InputMaybe<Suppliers_UsersWhereInput>;
  none?: InputMaybe<Suppliers_UsersWhereInput>;
  some?: InputMaybe<Suppliers_UsersWhereInput>;
};

export type TagsFilter = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TagsListRelationFilter = {
  every?: InputMaybe<TagsWhereInput>;
  none?: InputMaybe<TagsWhereInput>;
  some?: InputMaybe<TagsWhereInput>;
};

export type Test_TreatmentsListRelationFilter = {
  every?: InputMaybe<Test_TreatmentsWhereInput>;
  none?: InputMaybe<Test_TreatmentsWhereInput>;
  some?: InputMaybe<Test_TreatmentsWhereInput>;
};

export type Tier2Tags = {
  __typename?: 'Tier2Tags';
  categories_tier2?: Maybe<Categories_Tier2>;
  categoryTier2: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  tagUuid: Scalars['String']['output'];
  tags?: Maybe<Tags>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type Tier2TagsTagsWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Tier2TagsWhereInput = {
  categoryTier2?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Tier2TagsTagsWhereInput>;
};

export type Tier2TagsWhereUniqueInput = {
  uuid: Scalars['String']['input'];
};

export enum TreatmentTestIdentifierEnum {
  AnonymousId = 'ANONYMOUS_ID',
  UserId = 'USER_ID'
}

export type UpdateQuoteInput = {
  covers?: InputMaybe<Scalars['Int']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  quoteAttachments?: InputMaybe<Array<AttachmentInput>>;
  quoteLineItems?: InputMaybe<Array<QuoteLineItemInput>>;
  quotePriceDetails?: InputMaybe<QuotePriceDetailsInput>;
  source?: InputMaybe<QuoteSource>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSupplierSetupDimensionsInput = {
  depth?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSupplierSetupImagesInput = {
  supplierImageUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierSetupInput = {
  availability?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<SupplierSetupEventType>;
  setupType?: InputMaybe<SupplierSetupType>;
  state?: InputMaybe<SupplierSetupState>;
  supplierSetupBackDimensions?: InputMaybe<UpdateSupplierSetupDimensionsInput>;
  supplierSetupFrontDimensions?: InputMaybe<UpdateSupplierSetupDimensionsInput>;
  supplierSetupImages?: InputMaybe<Array<UpdateSupplierSetupImagesInput>>;
  supplierSetupPowerConnections?: InputMaybe<UpdateSupplierSetupPowerConnectionsInput>;
  supplierSetupRequirements?: InputMaybe<UpdateSupplierSetupRequirementsInput>;
  supplierUuid?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierSetupPowerConnectionsInput = {
  x13amp?: InputMaybe<Scalars['Int']['input']>;
  x16ThreePhase?: InputMaybe<Scalars['Int']['input']>;
  x16amp?: InputMaybe<Scalars['Int']['input']>;
  x32amp?: InputMaybe<Scalars['Int']['input']>;
  x33ThreePhase?: InputMaybe<Scalars['Int']['input']>;
  x63ThreePhase?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSupplierSetupRequirementsInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  fullyElectric?: InputMaybe<Scalars['Boolean']['input']>;
  hotHoldOnly?: InputMaybe<Scalars['Boolean']['input']>;
  loadRequirements?: InputMaybe<Scalars['String']['input']>;
  lowSmoke?: InputMaybe<Scalars['Boolean']['input']>;
  usesGas?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadFileResponse = {
  __typename?: 'UploadFileResponse';
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UpsertQuoteLineItemTemplatesSectionInput = {
  title: Scalars['String']['input'];
  type: QuoteLineItemTypeEnum;
};

export type UserPreferencesRestricted = {
  __typename?: 'UserPreferencesRestricted';
  showCustomerPhoneNumber: Scalars['Boolean']['output'];
};

export type UserRestricted = {
  __typename?: 'UserRestricted';
  created?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  userPreferences?: Maybe<UserPreferencesRestricted>;
};

export type User_External_IdsListRelationFilter = {
  every?: InputMaybe<User_External_IdsWhereInput>;
  none?: InputMaybe<User_External_IdsWhereInput>;
  some?: InputMaybe<User_External_IdsWhereInput>;
};

export type UsersMe = {
  __typename?: 'UsersMe';
  accountClosedAt?: Maybe<Scalars['DateTime']['output']>;
  business_user?: Maybe<Scalars['Boolean']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  ethnic_origin?: Maybe<Scalars['String']['output']>;
  favourites: Array<UsersMeFavourite>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  heardAboutUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isLgbtq?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  links: UsersMeLinks;
  paymentProvider: UsersMePaymentProvider;
  phone?: Maybe<Scalars['String']['output']>;
  reset_token?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  smsNotifications?: Maybe<Scalars['Boolean']['output']>;
  state: UsersMeState;
  suppliers: Array<UsersMeSupplier>;
  type?: Maybe<Enum_Users_Type>;
};

export type UsersMeFavourite = {
  __typename?: 'UsersMeFavourite';
  uuid: Scalars['String']['output'];
};

export type UsersMeLinks = {
  __typename?: 'UsersMeLinks';
  self: Scalars['String']['output'];
};

export type UsersMePaymentProvider = {
  __typename?: 'UsersMePaymentProvider';
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type UsersMeSalesforceSupplier = {
  __typename?: 'UsersMeSalesforceSupplier';
  approval_state: Enum_Salesforce_Suppliers_Approval_State;
  created: Scalars['DateTime']['output'];
  public_approval_state: Enum_Salesforce_Suppliers_Public_Approval_State;
  salesforce_account_id?: Maybe<Scalars['String']['output']>;
  salesforce_lead_id?: Maybe<Scalars['String']['output']>;
  supplier_id: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type UsersMeState = {
  __typename?: 'UsersMeState';
  created?: Maybe<Scalars['DateTime']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  tandc?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersMeSupplier = {
  __typename?: 'UsersMeSupplier';
  algorithm_discoverable: Scalars['Boolean']['output'];
  category_tier1?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  deposits_enabled?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<Maybe<Scalars['json']['output']>>>;
  kyb_status: Enum_Suppliers_Kyb_Status;
  min_spend?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardingStatus?: Maybe<OnboardingStatus>;
  profile_picture?: Maybe<Scalars['Json']['output']>;
  public_events_visible: Scalars['Boolean']['output'];
  radius?: Maybe<Scalars['Float']['output']>;
  registered_city?: Maybe<Scalars['String']['output']>;
  registered_company_name?: Maybe<Scalars['String']['output']>;
  registered_location_line1?: Maybe<Scalars['String']['output']>;
  registered_postcode?: Maybe<Scalars['String']['output']>;
  salesforce_suppliers?: Maybe<UsersMeSalesforceSupplier>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Enum_Suppliers_State>;
  supplier_images?: Maybe<Scalars['Json']['output']>;
  suppliersUsers: UsersMeSupplierUser;
  tier2: Array<UsersMeSupplierTier2>;
  trusted: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  vat_number?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export type UsersMeSupplierTier2 = {
  __typename?: 'UsersMeSupplierTier2';
  name: Scalars['String']['output'];
  sys_name: Scalars['String']['output'];
};

export type UsersMeSupplierUser = {
  __typename?: 'UsersMeSupplierUser';
  created?: Maybe<Scalars['DateTime']['output']>;
  supplier_id: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type VatRate = {
  __typename?: 'VatRate';
  created: Scalars['DateTime']['output'];
  dateFrom: Scalars['DateTime']['output'];
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  rate: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vatRateType: VatRateType;
  vatRateTypeId: Scalars['String']['output'];
};

export type VatRateConnectArgs = {
  connect?: InputMaybe<ConnectUuid>;
};

export type VatRateType = {
  __typename?: 'VatRateType';
  created: Scalars['DateTime']['output'];
  rateType: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum VatStatus {
  ExVatEligible = 'exVatEligible',
  NotExVatEligible = 'notExVatEligible',
  SupplierIsVatRegistered = 'supplierIsVatRegistered'
}

export type VenueSpace = {
  __typename?: 'VenueSpace';
  description: Scalars['String']['output'];
  image?: Maybe<Supplier_Images>;
  image_id?: Maybe<Scalars['String']['output']>;
  minSpendSubtotal?: Maybe<Scalars['Int']['output']>;
  priceBreakdown?: Maybe<PriceBreakdown>;
  price_pennies: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  vatRateId?: Maybe<Scalars['String']['output']>;
};

export type VenueSpacesAndQuoteLineItemTemplates = {
  __typename?: 'VenueSpacesAndQuoteLineItemTemplates';
  quote_line_item_templates?: Maybe<Array<Maybe<QuoteLineItemTemplate>>>;
  venue_spaces?: Maybe<Array<Maybe<VenueSpace>>>;
};

export type Venue_ServicesListRelationFilter = {
  every?: InputMaybe<Venue_ServicesWhereInput>;
  none?: InputMaybe<Venue_ServicesWhereInput>;
  some?: InputMaybe<Venue_ServicesWhereInput>;
};

export type Venue_SpacesListRelationFilter = {
  every?: InputMaybe<Venue_SpacesWhereInput>;
  none?: InputMaybe<Venue_SpacesWhereInput>;
  some?: InputMaybe<Venue_SpacesWhereInput>;
};

export type Voice_CallsListRelationFilter = {
  every?: InputMaybe<Voice_CallsWhereInput>;
  none?: InputMaybe<Voice_CallsWhereInput>;
  some?: InputMaybe<Voice_CallsWhereInput>;
};

export type WeddingLeadResponse = {
  __typename?: 'WeddingLeadResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum WeekDayEnum {
  MondayToWednesday = 'monday_to_wednesday',
  ThursdayToSunday = 'thursday_to_sunday'
}

export type Workflow_Automations_Message_TemplatesListRelationFilter = {
  every?: InputMaybe<Workflow_Automations_Message_TemplatesWhereInput>;
  none?: InputMaybe<Workflow_Automations_Message_TemplatesWhereInput>;
  some?: InputMaybe<Workflow_Automations_Message_TemplatesWhereInput>;
};

export type Xero_ContactsListRelationFilter = {
  every?: InputMaybe<Xero_ContactsWhereInput>;
  none?: InputMaybe<Xero_ContactsWhereInput>;
  some?: InputMaybe<Xero_ContactsWhereInput>;
};

export type Xero_InvoicesListRelationFilter = {
  every?: InputMaybe<Xero_InvoicesWhereInput>;
  none?: InputMaybe<Xero_InvoicesWhereInput>;
  some?: InputMaybe<Xero_InvoicesWhereInput>;
};

export type AddSupplierDocType = {
  __typename?: 'addSupplierDocType';
  expiryDate?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type Add_Supplier_Document = {
  __typename?: 'add_supplier_document';
  expiryDate?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AdditionalInfo = {
  bar_type?: InputMaybe<AdditionalInfoBarEnum>;
  children?: InputMaybe<AdditionalInfoChildrenEnum>;
  courses?: InputMaybe<Array<InputMaybe<AdditionalInfoCoursesEnum>>>;
  crockery?: InputMaybe<AdditionalInfoCrokeryEnum>;
  power?: InputMaybe<AdditionalInfoPowerEnum>;
  supplier_setup?: InputMaybe<Scalars['String']['input']>;
  waiters?: InputMaybe<AdditionalInfoWaitersEnum>;
  water?: InputMaybe<AdditionalInfoWaterEnum>;
};

export enum AdditionalInfoBarEnum {
  Cash = 'cash',
  Mixed = 'mixed',
  NotSure = 'not_sure',
  Open = 'open'
}

export enum AdditionalInfoChildrenEnum {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum AdditionalInfoCoursesEnum {
  Canapes = 'canapes',
  Desserts = 'desserts',
  Mains = 'mains',
  Starters = 'starters'
}

export enum AdditionalInfoCrokeryEnum {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum AdditionalInfoPowerEnum {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum AdditionalInfoWaitersEnum {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum AdditionalInfoWaterEnum {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export type Additional_Info = {
  __typename?: 'additional_info';
  bar_type?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Scalars['String']['output']>;
  courses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  crockery?: Maybe<Scalars['String']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  supplier_setup?: Maybe<Scalars['String']['output']>;
  waiters?: Maybe<Scalars['String']['output']>;
  water?: Maybe<Scalars['String']['output']>;
};

export type AgenciesCreateOneWithoutAgency_UsersInput = {
  connect?: InputMaybe<AgenciesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AgenciesCreateOrConnectWithoutagency_UsersInput>;
  create?: InputMaybe<AgenciesCreateWithoutAgency_UsersInput>;
};

export type AgenciesCreateOrConnectWithoutagency_UsersInput = {
  create: AgenciesCreateWithoutAgency_UsersInput;
  where: AgenciesWhereUniqueInput;
};

export type AgenciesCreateWithoutAgency_UsersInput = {
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  created: Scalars['DateTime']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type AgenciesUpdateOneRequiredWithoutAgency_UsersInput = {
  connect?: InputMaybe<AgenciesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AgenciesCreateOrConnectWithoutagency_UsersInput>;
  create?: InputMaybe<AgenciesCreateWithoutAgency_UsersInput>;
  update?: InputMaybe<AgenciesUpdateWithoutAgency_UsersInput>;
  upsert?: InputMaybe<AgenciesUpsertWithoutAgency_UsersInput>;
};

export type AgenciesUpdateWithoutAgency_UsersInput = {
  commission_rate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AgenciesUpsertWithoutAgency_UsersInput = {
  create: AgenciesCreateWithoutAgency_UsersInput;
  update: AgenciesUpdateWithoutAgency_UsersInput;
};

export type AgenciesWhereInput = {
  AND?: InputMaybe<Array<AgenciesWhereInput>>;
  NOT?: InputMaybe<Array<AgenciesWhereInput>>;
  OR?: InputMaybe<Array<AgenciesWhereInput>>;
  agency_users?: InputMaybe<Agency_UsersListRelationFilter>;
  commission_rate?: InputMaybe<FloatFilter>;
  created?: InputMaybe<DateTimeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type AgenciesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AgencyCommissionMutationResponse = {
  __typename?: 'agencyCommissionMutationResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type AgencyQueryResponse = {
  __typename?: 'agencyQueryResponse';
  commission?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Agency_Fee = {
  __typename?: 'agency_fee';
  commission?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Agency_UsersCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Agency_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Agency_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Agency_UsersCreateWithoutUsersInput>>;
};

export type Agency_UsersCreateOrConnectWithoutusersInput = {
  create: Agency_UsersCreateWithoutUsersInput;
  where: Agency_UsersWhereUniqueInput;
};

export type Agency_UsersCreateWithoutUsersInput = {
  agencies: AgenciesCreateOneWithoutAgency_UsersInput;
  created: Scalars['DateTime']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Agency_UsersScalarWhereInput = {
  AND?: InputMaybe<Array<Agency_UsersScalarWhereInput>>;
  NOT?: InputMaybe<Array<Agency_UsersScalarWhereInput>>;
  OR?: InputMaybe<Array<Agency_UsersScalarWhereInput>>;
  agency_id?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_id?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Agency_UsersUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Agency_UsersUpdateManyWithWhereWithoutUsersInput = {
  data: Agency_UsersUpdateManyMutationInput;
  where: Agency_UsersScalarWhereInput;
};

export type Agency_UsersUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Agency_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Agency_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Agency_UsersCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Agency_UsersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Agency_UsersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Agency_UsersWhereUniqueInput>>;
  set?: InputMaybe<Array<Agency_UsersWhereUniqueInput>>;
  update?: InputMaybe<Array<Agency_UsersUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Agency_UsersUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Agency_UsersUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Agency_UsersUpdateWithWhereUniqueWithoutUsersInput = {
  data: Agency_UsersUpdateWithoutUsersInput;
  where: Agency_UsersWhereUniqueInput;
};

export type Agency_UsersUpdateWithoutUsersInput = {
  agencies?: InputMaybe<AgenciesUpdateOneRequiredWithoutAgency_UsersInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Agency_UsersUpsertWithWhereUniqueWithoutUsersInput = {
  create: Agency_UsersCreateWithoutUsersInput;
  update: Agency_UsersUpdateWithoutUsersInput;
  where: Agency_UsersWhereUniqueInput;
};

export type Agency_UsersWhereInput = {
  AND?: InputMaybe<Array<Agency_UsersWhereInput>>;
  NOT?: InputMaybe<Array<Agency_UsersWhereInput>>;
  OR?: InputMaybe<Array<Agency_UsersWhereInput>>;
  agencies?: InputMaybe<AgenciesWhereInput>;
  agency_id?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Agency_UsersWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Anonymous_UsersCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Anonymous_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Anonymous_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Anonymous_UsersCreateWithoutUsersInput>>;
};

export type Anonymous_UsersCreateOrConnectWithoutusersInput = {
  create: Anonymous_UsersCreateWithoutUsersInput;
  where: Anonymous_UsersWhereUniqueInput;
};

export type Anonymous_UsersCreateWithoutUsersInput = {
  created: Scalars['DateTime']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Anonymous_UsersScalarWhereInput = {
  AND?: InputMaybe<Array<Anonymous_UsersScalarWhereInput>>;
  NOT?: InputMaybe<Array<Anonymous_UsersScalarWhereInput>>;
  OR?: InputMaybe<Array<Anonymous_UsersScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_id?: InputMaybe<StringNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Anonymous_UsersUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Anonymous_UsersUpdateManyWithWhereWithoutUsersInput = {
  data: Anonymous_UsersUpdateManyMutationInput;
  where: Anonymous_UsersScalarWhereInput;
};

export type Anonymous_UsersUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Anonymous_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Anonymous_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Anonymous_UsersCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Anonymous_UsersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Anonymous_UsersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Anonymous_UsersWhereUniqueInput>>;
  set?: InputMaybe<Array<Anonymous_UsersWhereUniqueInput>>;
  update?: InputMaybe<Array<Anonymous_UsersUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Anonymous_UsersUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Anonymous_UsersUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Anonymous_UsersUpdateWithWhereUniqueWithoutUsersInput = {
  data: Anonymous_UsersUpdateWithoutUsersInput;
  where: Anonymous_UsersWhereUniqueInput;
};

export type Anonymous_UsersUpdateWithoutUsersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Anonymous_UsersUpsertWithWhereUniqueWithoutUsersInput = {
  create: Anonymous_UsersCreateWithoutUsersInput;
  update: Anonymous_UsersUpdateWithoutUsersInput;
  where: Anonymous_UsersWhereUniqueInput;
};

export type Anonymous_UsersWhereInput = {
  AND?: InputMaybe<Array<Anonymous_UsersWhereInput>>;
  NOT?: InputMaybe<Array<Anonymous_UsersWhereInput>>;
  OR?: InputMaybe<Array<Anonymous_UsersWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_id?: InputMaybe<StringNullableFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Anonymous_UsersWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AreasCreateOneWithoutEvent_AreasInput = {
  connect?: InputMaybe<AreasWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AreasCreateOrConnectWithoutevent_AreasInput>;
  create?: InputMaybe<AreasCreateWithoutEvent_AreasInput>;
};

export type AreasCreateOrConnectWithoutevent_AreasInput = {
  create: AreasCreateWithoutEvent_AreasInput;
  where: AreasWhereUniqueInput;
};

export type AreasCreateWithoutEvent_AreasInput = {
  created: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  postcodes?: InputMaybe<AreasCreatepostcodesInput>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type AreasCreatepostcodesInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AreasUpdateOneWithoutEvent_AreasInput = {
  connect?: InputMaybe<AreasWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AreasCreateOrConnectWithoutevent_AreasInput>;
  create?: InputMaybe<AreasCreateWithoutEvent_AreasInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<AreasUpdateWithoutEvent_AreasInput>;
  upsert?: InputMaybe<AreasUpsertWithoutEvent_AreasInput>;
};

export type AreasUpdateWithoutEvent_AreasInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  postcodes?: InputMaybe<AreasUpdatepostcodesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AreasUpdatepostcodesInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AreasUpsertWithoutEvent_AreasInput = {
  create: AreasCreateWithoutEvent_AreasInput;
  update: AreasUpdateWithoutEvent_AreasInput;
};

export type AreasWhereInput = {
  AND?: InputMaybe<Array<AreasWhereInput>>;
  NOT?: InputMaybe<Array<AreasWhereInput>>;
  OR?: InputMaybe<Array<AreasWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  event_areas?: InputMaybe<Event_AreasListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  postcodes?: InputMaybe<StringNullableListFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type AreasWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AssignAnonymousIdToUserId = {
  __typename?: 'assignAnonymousIdToUserId';
  updatedTreatmentsCount?: Maybe<Scalars['Float']['output']>;
};

export type Attribution_DataCreateOneWithoutBookingsInput = {
  connect?: InputMaybe<Attribution_DataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Attribution_DataCreateOrConnectWithoutbookingsInput>;
  create?: InputMaybe<Attribution_DataCreateWithoutBookingsInput>;
};

export type Attribution_DataCreateOneWithoutEventsInput = {
  connect?: InputMaybe<Attribution_DataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Attribution_DataCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<Attribution_DataCreateWithoutEventsInput>;
};

export type Attribution_DataCreateOrConnectWithoutbookingsInput = {
  create: Attribution_DataCreateWithoutBookingsInput;
  where: Attribution_DataWhereUniqueInput;
};

export type Attribution_DataCreateOrConnectWithouteventsInput = {
  create: Attribution_DataCreateWithoutEventsInput;
  where: Attribution_DataWhereUniqueInput;
};

export type Attribution_DataCreateWithoutBookingsInput = {
  browsingHistory?: InputMaybe<Attribution_DataCreatebrowsingHistoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutAttribution_DataInput>;
  id: Scalars['String']['input'];
  referrer?: InputMaybe<Attribution_DataCreatereferrerInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type Attribution_DataCreateWithoutEventsInput = {
  bookings?: InputMaybe<BookingsCreateManyWithoutAttribution_DataInput>;
  browsingHistory?: InputMaybe<Attribution_DataCreatebrowsingHistoryInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  referrer?: InputMaybe<Attribution_DataCreatereferrerInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type Attribution_DataCreatebrowsingHistoryInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type Attribution_DataCreatereferrerInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Attribution_DataUpdateOneWithoutBookingsInput = {
  connect?: InputMaybe<Attribution_DataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Attribution_DataCreateOrConnectWithoutbookingsInput>;
  create?: InputMaybe<Attribution_DataCreateWithoutBookingsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Attribution_DataUpdateWithoutBookingsInput>;
  upsert?: InputMaybe<Attribution_DataUpsertWithoutBookingsInput>;
};

export type Attribution_DataUpdateOneWithoutEventsInput = {
  connect?: InputMaybe<Attribution_DataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Attribution_DataCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<Attribution_DataCreateWithoutEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Attribution_DataUpdateWithoutEventsInput>;
  upsert?: InputMaybe<Attribution_DataUpsertWithoutEventsInput>;
};

export type Attribution_DataUpdateWithoutBookingsInput = {
  browsingHistory?: InputMaybe<Attribution_DataUpdatebrowsingHistoryInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutAttribution_DataInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  referrer?: InputMaybe<Attribution_DataUpdatereferrerInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type Attribution_DataUpdateWithoutEventsInput = {
  bookings?: InputMaybe<BookingsUpdateManyWithoutAttribution_DataInput>;
  browsingHistory?: InputMaybe<Attribution_DataUpdatebrowsingHistoryInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  referrer?: InputMaybe<Attribution_DataUpdatereferrerInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type Attribution_DataUpdatebrowsingHistoryInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type Attribution_DataUpdatereferrerInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Attribution_DataUpsertWithoutBookingsInput = {
  create: Attribution_DataCreateWithoutBookingsInput;
  update: Attribution_DataUpdateWithoutBookingsInput;
};

export type Attribution_DataUpsertWithoutEventsInput = {
  create: Attribution_DataCreateWithoutEventsInput;
  update: Attribution_DataUpdateWithoutEventsInput;
};

export type Attribution_DataWhereInput = {
  AND?: InputMaybe<Array<Attribution_DataWhereInput>>;
  NOT?: InputMaybe<Array<Attribution_DataWhereInput>>;
  OR?: InputMaybe<Array<Attribution_DataWhereInput>>;
  bookings?: InputMaybe<BookingsListRelationFilter>;
  browsingHistory?: InputMaybe<JsonNullableListFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  referrer?: InputMaybe<StringNullableListFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  utmParams?: InputMaybe<JsonNullableFilter>;
};

export type Attribution_DataWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type BookingsCreateManyWithoutAttribution_DataInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutattribution_DataInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutAttribution_DataInput>>;
};

export type BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutsuppliers_Bookings_Supplier_IdTosuppliersInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>>;
};

export type BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutsuppliers_Bookings_Supplier_ReferralTosuppliersInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>>;
};

export type BookingsCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutUsersInput>>;
};

export type BookingsCreateOneWithoutQuotesInput = {
  connect?: InputMaybe<BookingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingsCreateOrConnectWithoutquotesInput>;
  create?: InputMaybe<BookingsCreateWithoutQuotesInput>;
};

export type BookingsCreateOneWithoutReviewsInput = {
  connect?: InputMaybe<BookingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingsCreateOrConnectWithoutreviewsInput>;
  create?: InputMaybe<BookingsCreateWithoutReviewsInput>;
};

export type BookingsCreateOrConnectWithoutattribution_DataInput = {
  create: BookingsCreateWithoutAttribution_DataInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsCreateOrConnectWithoutquotesInput = {
  create: BookingsCreateWithoutQuotesInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsCreateOrConnectWithoutreviewsInput = {
  create: BookingsCreateWithoutReviewsInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsCreateOrConnectWithoutsuppliers_Bookings_Supplier_IdTosuppliersInput = {
  create: BookingsCreateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsCreateOrConnectWithoutsuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  create: BookingsCreateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsCreateOrConnectWithoutusersInput = {
  create: BookingsCreateWithoutUsersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsCreateWithoutAttribution_DataInput = {
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dietaryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutBookingsInput>;
  service_fee: Scalars['Float']['input'];
  source?: InputMaybe<BookingsCreatesourceInput>;
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Bookings_State>;
  state_old?: InputMaybe<Scalars['String']['input']>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<UsersCreateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsCreateWithoutQuotesInput = {
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutBookingsInput>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dietaryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutBookingsInput>;
  service_fee: Scalars['Float']['input'];
  source?: InputMaybe<BookingsCreatesourceInput>;
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Bookings_State>;
  state_old?: InputMaybe<Scalars['String']['input']>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<UsersCreateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsCreateWithoutReviewsInput = {
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutBookingsInput>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dietaryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutBookingsInput>;
  service_fee: Scalars['Float']['input'];
  source?: InputMaybe<BookingsCreatesourceInput>;
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Bookings_State>;
  state_old?: InputMaybe<Scalars['String']['input']>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<UsersCreateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsCreateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput = {
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutBookingsInput>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dietaryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutBookingsInput>;
  service_fee: Scalars['Float']['input'];
  source?: InputMaybe<BookingsCreatesourceInput>;
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Bookings_State>;
  state_old?: InputMaybe<Scalars['String']['input']>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<UsersCreateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsCreateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutBookingsInput>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dietaryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutBookingsInput>;
  service_fee: Scalars['Float']['input'];
  source?: InputMaybe<BookingsCreatesourceInput>;
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Bookings_State>;
  state_old?: InputMaybe<Scalars['String']['input']>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<UsersCreateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsCreateWithoutUsersInput = {
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutBookingsInput>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dietaryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutBookingsInput>;
  service_fee: Scalars['Float']['input'];
  source?: InputMaybe<BookingsCreatesourceInput>;
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Bookings_State>;
  state_old?: InputMaybe<Scalars['String']['input']>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersCreateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsCreatesourceInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BookingsScalarWhereInput = {
  AND?: InputMaybe<Array<BookingsScalarWhereInput>>;
  NOT?: InputMaybe<Array<BookingsScalarWhereInput>>;
  OR?: InputMaybe<Array<BookingsScalarWhereInput>>;
  commission_fee?: InputMaybe<FloatFilter>;
  covers?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  customer_id?: InputMaybe<StringNullableFilter>;
  dietaryNotes?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  last_supplier_reminder?: InputMaybe<DateTimeNullableFilter>;
  location?: InputMaybe<JsonNullableFilter>;
  menuPrice?: InputMaybe<FloatNullableFilter>;
  old_commission?: InputMaybe<BoolFilter>;
  payment_timestamp?: InputMaybe<DateTimeNullableFilter>;
  protection_fee?: InputMaybe<FloatNullableFilter>;
  protection_rounding?: InputMaybe<FloatNullableFilter>;
  protection_type?: InputMaybe<StringNullableFilter>;
  seo_data_id?: InputMaybe<StringNullableFilter>;
  service_fee?: InputMaybe<FloatFilter>;
  source?: InputMaybe<StringNullableListFilter>;
  specialPrice?: InputMaybe<FloatNullableFilter>;
  state?: InputMaybe<Enumenum_Bookings_StateNullableFilter>;
  state_old?: InputMaybe<StringNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  supplier_referral?: InputMaybe<StringNullableFilter>;
  timings?: InputMaybe<JsonNullableFilter>;
  total?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  utmParams?: InputMaybe<JsonNullableFilter>;
};

export type BookingsUpdateManyMutationInput = {
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dietaryNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  source?: InputMaybe<BookingsUpdatesourceInput>;
  specialPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Bookings_StateFieldUpdateOperationsInput>;
  state_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsUpdateManyWithWhereWithoutAttribution_DataInput = {
  data: BookingsUpdateManyMutationInput;
  where: BookingsScalarWhereInput;
};

export type BookingsUpdateManyWithWhereWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput = {
  data: BookingsUpdateManyMutationInput;
  where: BookingsScalarWhereInput;
};

export type BookingsUpdateManyWithWhereWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  data: BookingsUpdateManyMutationInput;
  where: BookingsScalarWhereInput;
};

export type BookingsUpdateManyWithWhereWithoutUsersInput = {
  data: BookingsUpdateManyMutationInput;
  where: BookingsScalarWhereInput;
};

export type BookingsUpdateManyWithoutAttribution_DataInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutattribution_DataInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutAttribution_DataInput>>;
  delete?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingsUpdateWithWhereUniqueWithoutAttribution_DataInput>>;
  updateMany?: InputMaybe<Array<BookingsUpdateManyWithWhereWithoutAttribution_DataInput>>;
  upsert?: InputMaybe<Array<BookingsUpsertWithWhereUniqueWithoutAttribution_DataInput>>;
};

export type BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutsuppliers_Bookings_Supplier_IdTosuppliersInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>>;
  delete?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingsUpdateWithWhereUniqueWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>>;
  updateMany?: InputMaybe<Array<BookingsUpdateManyWithWhereWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>>;
  upsert?: InputMaybe<Array<BookingsUpsertWithWhereUniqueWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>>;
};

export type BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutsuppliers_Bookings_Supplier_ReferralTosuppliersInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>>;
  delete?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingsUpdateWithWhereUniqueWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>>;
  updateMany?: InputMaybe<Array<BookingsUpdateManyWithWhereWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>>;
  upsert?: InputMaybe<Array<BookingsUpsertWithWhereUniqueWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>>;
};

export type BookingsUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<BookingsCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingsWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingsUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<BookingsUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<BookingsUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type BookingsUpdateOneWithoutQuotesInput = {
  connect?: InputMaybe<BookingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingsCreateOrConnectWithoutquotesInput>;
  create?: InputMaybe<BookingsCreateWithoutQuotesInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BookingsUpdateWithoutQuotesInput>;
  upsert?: InputMaybe<BookingsUpsertWithoutQuotesInput>;
};

export type BookingsUpdateOneWithoutReviewsInput = {
  connect?: InputMaybe<BookingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingsCreateOrConnectWithoutreviewsInput>;
  create?: InputMaybe<BookingsCreateWithoutReviewsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BookingsUpdateWithoutReviewsInput>;
  upsert?: InputMaybe<BookingsUpsertWithoutReviewsInput>;
};

export type BookingsUpdateWithWhereUniqueWithoutAttribution_DataInput = {
  data: BookingsUpdateWithoutAttribution_DataInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpdateWithWhereUniqueWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput = {
  data: BookingsUpdateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpdateWithWhereUniqueWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  data: BookingsUpdateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpdateWithWhereUniqueWithoutUsersInput = {
  data: BookingsUpdateWithoutUsersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpdateWithoutAttribution_DataInput = {
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dietaryNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutBookingsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  source?: InputMaybe<BookingsUpdatesourceInput>;
  specialPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Bookings_StateFieldUpdateOperationsInput>;
  state_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsUpdateWithoutQuotesInput = {
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutBookingsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dietaryNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutBookingsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  source?: InputMaybe<BookingsUpdatesourceInput>;
  specialPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Bookings_StateFieldUpdateOperationsInput>;
  state_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsUpdateWithoutReviewsInput = {
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutBookingsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dietaryNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutBookingsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  source?: InputMaybe<BookingsUpdatesourceInput>;
  specialPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Bookings_StateFieldUpdateOperationsInput>;
  state_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsUpdateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput = {
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutBookingsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dietaryNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutBookingsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  source?: InputMaybe<BookingsUpdatesourceInput>;
  specialPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Bookings_StateFieldUpdateOperationsInput>;
  state_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsUpdateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutBookingsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dietaryNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutBookingsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  source?: InputMaybe<BookingsUpdatesourceInput>;
  specialPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Bookings_StateFieldUpdateOperationsInput>;
  state_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneWithoutBookingsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsUpdateWithoutUsersInput = {
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutBookingsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dietaryNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<Scalars['Json']['input']>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutBookingsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutBookingsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  source?: InputMaybe<BookingsUpdatesourceInput>;
  specialPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Bookings_StateFieldUpdateOperationsInput>;
  state_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersUpdateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  timings?: InputMaybe<Scalars['Json']['input']>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  utmParams?: InputMaybe<Scalars['Json']['input']>;
};

export type BookingsUpdatesourceInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BookingsUpsertWithWhereUniqueWithoutAttribution_DataInput = {
  create: BookingsCreateWithoutAttribution_DataInput;
  update: BookingsUpdateWithoutAttribution_DataInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpsertWithWhereUniqueWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput = {
  create: BookingsCreateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput;
  update: BookingsUpdateWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpsertWithWhereUniqueWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput = {
  create: BookingsCreateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput;
  update: BookingsUpdateWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpsertWithWhereUniqueWithoutUsersInput = {
  create: BookingsCreateWithoutUsersInput;
  update: BookingsUpdateWithoutUsersInput;
  where: BookingsWhereUniqueInput;
};

export type BookingsUpsertWithoutQuotesInput = {
  create: BookingsCreateWithoutQuotesInput;
  update: BookingsUpdateWithoutQuotesInput;
};

export type BookingsUpsertWithoutReviewsInput = {
  create: BookingsCreateWithoutReviewsInput;
  update: BookingsUpdateWithoutReviewsInput;
};

export type BookingsWhereInput = {
  AND?: InputMaybe<Array<BookingsWhereInput>>;
  NOT?: InputMaybe<Array<BookingsWhereInput>>;
  OR?: InputMaybe<Array<BookingsWhereInput>>;
  attribution_data?: InputMaybe<Attribution_DataWhereInput>;
  commission_fee?: InputMaybe<FloatFilter>;
  covers?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  customer_id?: InputMaybe<StringNullableFilter>;
  dietaryNotes?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  last_supplier_reminder?: InputMaybe<DateTimeNullableFilter>;
  location?: InputMaybe<JsonNullableFilter>;
  menuPrice?: InputMaybe<FloatNullableFilter>;
  old_commission?: InputMaybe<BoolFilter>;
  payment_timestamp?: InputMaybe<DateTimeNullableFilter>;
  protection_fee?: InputMaybe<FloatNullableFilter>;
  protection_rounding?: InputMaybe<FloatNullableFilter>;
  protection_type?: InputMaybe<StringNullableFilter>;
  quotes?: InputMaybe<QuotesListRelationFilter>;
  reviews?: InputMaybe<ReviewsListRelationFilter>;
  seo_data_id?: InputMaybe<StringNullableFilter>;
  service_fee?: InputMaybe<FloatFilter>;
  source?: InputMaybe<StringNullableListFilter>;
  specialPrice?: InputMaybe<FloatNullableFilter>;
  state?: InputMaybe<Enumenum_Bookings_StateNullableFilter>;
  state_old?: InputMaybe<StringNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  supplier_referral?: InputMaybe<StringNullableFilter>;
  suppliers_bookings_supplier_idTosuppliers?: InputMaybe<SuppliersWhereInput>;
  suppliers_bookings_supplier_referralTosuppliers?: InputMaybe<SuppliersWhereInput>;
  timings?: InputMaybe<JsonNullableFilter>;
  total?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  users?: InputMaybe<UsersWhereInput>;
  utmParams?: InputMaybe<JsonNullableFilter>;
};

export type BookingsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type Calendar = {
  __typename?: 'calendar';
  id?: Maybe<Scalars['String']['output']>;
  supplierOwnerId?: Maybe<Scalars['String']['output']>;
};

export type CalendarDay = {
  __typename?: 'calendarDay';
  bookedEvents?: Maybe<Array<Maybe<SupplierCalendarQuote>>>;
  date?: Maybe<Scalars['String']['output']>;
  submittedQuotes?: Maybe<Array<Maybe<SupplierCalendarQuote>>>;
  supplierActivities?: Maybe<Array<Maybe<SupplierActivity>>>;
  totalBookedEvents?: Maybe<Scalars['Int']['output']>;
  totalSubmittedQuotes?: Maybe<Scalars['Int']['output']>;
  totalSupplierActivities?: Maybe<Scalars['Int']['output']>;
};

export type CalendarEvent = {
  __typename?: 'calendarEvent';
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type CallUserType = {
  __typename?: 'callUserType';
  message?: Maybe<Scalars['String']['output']>;
};

export type CarbonOffsetInput = {
  carbon: Scalars['Float']['input'];
  date: Scalars['String']['input'];
  distance: Scalars['String']['input'];
  email: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  guests: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  trees: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type CarbonOffsetPaymentInput = {
  amount: Scalars['Int']['input'];
  payment_method: Scalars['String']['input'];
};

export type Categories_Tier1 = {
  __typename?: 'categories_tier1';
  name: Scalars['String']['output'];
  supplierOnly: Scalars['Boolean']['output'];
  sys_name: Scalars['String']['output'];
};

export type Categories_Tier1CreateOneWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Categories_Tier1WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier1CreateOrConnectWithoutcategories_Tier2Input>;
  create?: InputMaybe<Categories_Tier1CreateWithoutCategories_Tier2Input>;
};

export type Categories_Tier1CreateOneWithoutSuppliersInput = {
  connect?: InputMaybe<Categories_Tier1WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier1CreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<Categories_Tier1CreateWithoutSuppliersInput>;
};

export type Categories_Tier1CreateOrConnectWithoutcategories_Tier2Input = {
  create: Categories_Tier1CreateWithoutCategories_Tier2Input;
  where: Categories_Tier1WhereUniqueInput;
};

export type Categories_Tier1CreateOrConnectWithoutsuppliersInput = {
  create: Categories_Tier1CreateWithoutSuppliersInput;
  where: Categories_Tier1WhereUniqueInput;
};

export type Categories_Tier1CreateWithoutCategories_Tier2Input = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  suppliers?: InputMaybe<SuppliersCreateManyWithoutCategories_Tier1Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Categories_Tier1CreateWithoutSuppliersInput = {
  categories_tier2?: InputMaybe<Categories_Tier2CreateManyWithoutCategories_Tier1Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Categories_Tier1UpdateOneWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Categories_Tier1WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier1CreateOrConnectWithoutcategories_Tier2Input>;
  create?: InputMaybe<Categories_Tier1CreateWithoutCategories_Tier2Input>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Categories_Tier1UpdateWithoutCategories_Tier2Input>;
  upsert?: InputMaybe<Categories_Tier1UpsertWithoutCategories_Tier2Input>;
};

export type Categories_Tier1UpdateOneWithoutSuppliersInput = {
  connect?: InputMaybe<Categories_Tier1WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier1CreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<Categories_Tier1CreateWithoutSuppliersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Categories_Tier1UpdateWithoutSuppliersInput>;
  upsert?: InputMaybe<Categories_Tier1UpsertWithoutSuppliersInput>;
};

export type Categories_Tier1UpdateWithoutCategories_Tier2Input = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutCategories_Tier1Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Categories_Tier1UpdateWithoutSuppliersInput = {
  categories_tier2?: InputMaybe<Categories_Tier2UpdateManyWithoutCategories_Tier1Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Categories_Tier1UpsertWithoutCategories_Tier2Input = {
  create: Categories_Tier1CreateWithoutCategories_Tier2Input;
  update: Categories_Tier1UpdateWithoutCategories_Tier2Input;
};

export type Categories_Tier1UpsertWithoutSuppliersInput = {
  create: Categories_Tier1CreateWithoutSuppliersInput;
  update: Categories_Tier1UpdateWithoutSuppliersInput;
};

export type Categories_Tier1WhereInput = {
  AND?: InputMaybe<Array<Categories_Tier1WhereInput>>;
  NOT?: InputMaybe<Array<Categories_Tier1WhereInput>>;
  OR?: InputMaybe<Array<Categories_Tier1WhereInput>>;
  categories_tier2?: InputMaybe<Categories_Tier2ListRelationFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  supplierOnly?: InputMaybe<BoolFilter>;
  suppliers?: InputMaybe<SuppliersListRelationFilter>;
  sys_name?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Categories_Tier1WhereUniqueInput = {
  sys_name?: InputMaybe<Scalars['String']['input']>;
};

export type Categories_Tier2 = {
  __typename?: 'categories_tier2';
  categories_tier2_tag_groups: Array<Categories_Tier2_Tag_Groups>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  sys_name: Scalars['String']['output'];
};


export type Categories_Tier2Categories_Tier2_Tag_GroupsArgs = {
  cursor?: InputMaybe<Categories_Tier2_Tag_GroupsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Categories_Tier2CreateManyWithoutCategories_Tier1Input = {
  connect?: InputMaybe<Array<Categories_Tier2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Categories_Tier2CreateOrConnectWithoutcategories_Tier1Input>>;
  create?: InputMaybe<Array<Categories_Tier2CreateWithoutCategories_Tier1Input>>;
};

export type Categories_Tier2CreateOneWithoutCategories_Tier2_Tag_GroupsInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutcategories_Tier2_Tag_GroupsInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutCategories_Tier2_Tag_GroupsInput>;
};

export type Categories_Tier2CreateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutEvent_RequestsInput>;
};

export type Categories_Tier2CreateOneWithoutEvent_SetupsInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutevent_SetupsInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutEvent_SetupsInput>;
};

export type Categories_Tier2CreateOneWithoutRobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutrobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutRobex_Version_Vertical_MetricInput>;
};

export type Categories_Tier2CreateOneWithoutSupplier_Categories_Tier2Input = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutsupplier_Categories_Tier2Input>;
  create?: InputMaybe<Categories_Tier2CreateWithoutSupplier_Categories_Tier2Input>;
};

export type Categories_Tier2CreateOneWithoutVenue_ServicesInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutvenue_ServicesInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutVenue_ServicesInput>;
};

export type Categories_Tier2CreateOrConnectWithoutcategories_Tier1Input = {
  create: Categories_Tier2CreateWithoutCategories_Tier1Input;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2CreateOrConnectWithoutcategories_Tier2_Tag_GroupsInput = {
  create: Categories_Tier2CreateWithoutCategories_Tier2_Tag_GroupsInput;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2CreateOrConnectWithoutevent_RequestsInput = {
  create: Categories_Tier2CreateWithoutEvent_RequestsInput;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2CreateOrConnectWithoutevent_SetupsInput = {
  create: Categories_Tier2CreateWithoutEvent_SetupsInput;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2CreateOrConnectWithoutrobex_Version_Vertical_MetricInput = {
  create: Categories_Tier2CreateWithoutRobex_Version_Vertical_MetricInput;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2CreateOrConnectWithoutsupplier_Categories_Tier2Input = {
  create: Categories_Tier2CreateWithoutSupplier_Categories_Tier2Input;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2CreateOrConnectWithoutvenue_ServicesInput = {
  create: Categories_Tier2CreateWithoutVenue_ServicesInput;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2CreateWithoutCategories_Tier1Input = {
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsCreateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsCreateManyWithoutCategories_Tier2Input>;
  name: Scalars['String']['input'];
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricCreateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutCategories_Tier2Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2CreateWithoutCategories_Tier2_Tag_GroupsInput = {
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutCategories_Tier2Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsCreateManyWithoutCategories_Tier2Input>;
  name: Scalars['String']['input'];
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricCreateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutCategories_Tier2Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2CreateWithoutEvent_RequestsInput = {
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsCreateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_setups?: InputMaybe<Event_SetupsCreateManyWithoutCategories_Tier2Input>;
  name: Scalars['String']['input'];
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricCreateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutCategories_Tier2Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2CreateWithoutEvent_SetupsInput = {
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsCreateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutCategories_Tier2Input>;
  name: Scalars['String']['input'];
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricCreateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutCategories_Tier2Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2CreateWithoutRobex_Version_Vertical_MetricInput = {
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsCreateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsCreateManyWithoutCategories_Tier2Input>;
  name: Scalars['String']['input'];
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutCategories_Tier2Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2CreateWithoutSupplier_Categories_Tier2Input = {
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsCreateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsCreateManyWithoutCategories_Tier2Input>;
  name: Scalars['String']['input'];
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricCreateManyWithoutCategories_Tier2Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2CreateWithoutVenue_ServicesInput = {
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsCreateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsCreateManyWithoutCategories_Tier2Input>;
  name: Scalars['String']['input'];
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricCreateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutCategories_Tier2Input>;
  sys_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Categories_Tier2ScalarWhereInput = {
  AND?: InputMaybe<Array<Categories_Tier2ScalarWhereInput>>;
  NOT?: InputMaybe<Array<Categories_Tier2ScalarWhereInput>>;
  OR?: InputMaybe<Array<Categories_Tier2ScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  parent?: InputMaybe<StringNullableFilter>;
  sys_name?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Categories_Tier2UpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Categories_Tier2UpdateManyWithWhereWithoutCategories_Tier1Input = {
  data: Categories_Tier2UpdateManyMutationInput;
  where: Categories_Tier2ScalarWhereInput;
};

export type Categories_Tier2UpdateManyWithoutCategories_Tier1Input = {
  connect?: InputMaybe<Array<Categories_Tier2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Categories_Tier2CreateOrConnectWithoutcategories_Tier1Input>>;
  create?: InputMaybe<Array<Categories_Tier2CreateWithoutCategories_Tier1Input>>;
  delete?: InputMaybe<Array<Categories_Tier2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Categories_Tier2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Categories_Tier2WhereUniqueInput>>;
  set?: InputMaybe<Array<Categories_Tier2WhereUniqueInput>>;
  update?: InputMaybe<Array<Categories_Tier2UpdateWithWhereUniqueWithoutCategories_Tier1Input>>;
  updateMany?: InputMaybe<Array<Categories_Tier2UpdateManyWithWhereWithoutCategories_Tier1Input>>;
  upsert?: InputMaybe<Array<Categories_Tier2UpsertWithWhereUniqueWithoutCategories_Tier1Input>>;
};

export type Categories_Tier2UpdateOneRequiredWithoutCategories_Tier2_Tag_GroupsInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutcategories_Tier2_Tag_GroupsInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutCategories_Tier2_Tag_GroupsInput>;
  update?: InputMaybe<Categories_Tier2UpdateWithoutCategories_Tier2_Tag_GroupsInput>;
  upsert?: InputMaybe<Categories_Tier2UpsertWithoutCategories_Tier2_Tag_GroupsInput>;
};

export type Categories_Tier2UpdateOneRequiredWithoutEvent_SetupsInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutevent_SetupsInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutEvent_SetupsInput>;
  update?: InputMaybe<Categories_Tier2UpdateWithoutEvent_SetupsInput>;
  upsert?: InputMaybe<Categories_Tier2UpsertWithoutEvent_SetupsInput>;
};

export type Categories_Tier2UpdateOneRequiredWithoutSupplier_Categories_Tier2Input = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutsupplier_Categories_Tier2Input>;
  create?: InputMaybe<Categories_Tier2CreateWithoutSupplier_Categories_Tier2Input>;
  update?: InputMaybe<Categories_Tier2UpdateWithoutSupplier_Categories_Tier2Input>;
  upsert?: InputMaybe<Categories_Tier2UpsertWithoutSupplier_Categories_Tier2Input>;
};

export type Categories_Tier2UpdateOneRequiredWithoutVenue_ServicesInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutvenue_ServicesInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutVenue_ServicesInput>;
  update?: InputMaybe<Categories_Tier2UpdateWithoutVenue_ServicesInput>;
  upsert?: InputMaybe<Categories_Tier2UpsertWithoutVenue_ServicesInput>;
};

export type Categories_Tier2UpdateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutEvent_RequestsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Categories_Tier2UpdateWithoutEvent_RequestsInput>;
  upsert?: InputMaybe<Categories_Tier2UpsertWithoutEvent_RequestsInput>;
};

export type Categories_Tier2UpdateOneWithoutRobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Categories_Tier2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<Categories_Tier2CreateOrConnectWithoutrobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Categories_Tier2CreateWithoutRobex_Version_Vertical_MetricInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Categories_Tier2UpdateWithoutRobex_Version_Vertical_MetricInput>;
  upsert?: InputMaybe<Categories_Tier2UpsertWithoutRobex_Version_Vertical_MetricInput>;
};

export type Categories_Tier2UpdateWithWhereUniqueWithoutCategories_Tier1Input = {
  data: Categories_Tier2UpdateWithoutCategories_Tier1Input;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2UpdateWithoutCategories_Tier1Input = {
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsUpdateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsUpdateManyWithoutCategories_Tier2Input>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricUpdateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutCategories_Tier2Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2UpdateWithoutCategories_Tier2_Tag_GroupsInput = {
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutCategories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsUpdateManyWithoutCategories_Tier2Input>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricUpdateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutCategories_Tier2Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2UpdateWithoutEvent_RequestsInput = {
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsUpdateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_setups?: InputMaybe<Event_SetupsUpdateManyWithoutCategories_Tier2Input>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricUpdateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutCategories_Tier2Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2UpdateWithoutEvent_SetupsInput = {
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsUpdateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutCategories_Tier2Input>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricUpdateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutCategories_Tier2Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2UpdateWithoutRobex_Version_Vertical_MetricInput = {
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsUpdateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsUpdateManyWithoutCategories_Tier2Input>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutCategories_Tier2Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2UpdateWithoutSupplier_Categories_Tier2Input = {
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsUpdateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsUpdateManyWithoutCategories_Tier2Input>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricUpdateManyWithoutCategories_Tier2Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutCategories_Tier2Input>;
};

export type Categories_Tier2UpdateWithoutVenue_ServicesInput = {
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutCategories_Tier2Input>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsUpdateManyWithoutCategories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutCategories_Tier2Input>;
  event_setups?: InputMaybe<Event_SetupsUpdateManyWithoutCategories_Tier2Input>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricUpdateManyWithoutCategories_Tier2Input>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutCategories_Tier2Input>;
  sys_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Categories_Tier2UpsertWithWhereUniqueWithoutCategories_Tier1Input = {
  create: Categories_Tier2CreateWithoutCategories_Tier1Input;
  update: Categories_Tier2UpdateWithoutCategories_Tier1Input;
  where: Categories_Tier2WhereUniqueInput;
};

export type Categories_Tier2UpsertWithoutCategories_Tier2_Tag_GroupsInput = {
  create: Categories_Tier2CreateWithoutCategories_Tier2_Tag_GroupsInput;
  update: Categories_Tier2UpdateWithoutCategories_Tier2_Tag_GroupsInput;
};

export type Categories_Tier2UpsertWithoutEvent_RequestsInput = {
  create: Categories_Tier2CreateWithoutEvent_RequestsInput;
  update: Categories_Tier2UpdateWithoutEvent_RequestsInput;
};

export type Categories_Tier2UpsertWithoutEvent_SetupsInput = {
  create: Categories_Tier2CreateWithoutEvent_SetupsInput;
  update: Categories_Tier2UpdateWithoutEvent_SetupsInput;
};

export type Categories_Tier2UpsertWithoutRobex_Version_Vertical_MetricInput = {
  create: Categories_Tier2CreateWithoutRobex_Version_Vertical_MetricInput;
  update: Categories_Tier2UpdateWithoutRobex_Version_Vertical_MetricInput;
};

export type Categories_Tier2UpsertWithoutSupplier_Categories_Tier2Input = {
  create: Categories_Tier2CreateWithoutSupplier_Categories_Tier2Input;
  update: Categories_Tier2UpdateWithoutSupplier_Categories_Tier2Input;
};

export type Categories_Tier2UpsertWithoutVenue_ServicesInput = {
  create: Categories_Tier2CreateWithoutVenue_ServicesInput;
  update: Categories_Tier2UpdateWithoutVenue_ServicesInput;
};

export type Categories_Tier2WhereInput = {
  AND?: InputMaybe<Array<Categories_Tier2WhereInput>>;
  NOT?: InputMaybe<Array<Categories_Tier2WhereInput>>;
  OR?: InputMaybe<Array<Categories_Tier2WhereInput>>;
  categories_tier1?: InputMaybe<Categories_Tier1WhereInput>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsListRelationFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_requests?: InputMaybe<Event_RequestsListRelationFilter>;
  event_setups?: InputMaybe<Event_SetupsListRelationFilter>;
  isActive?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  parent?: InputMaybe<StringNullableFilter>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricListRelationFilter>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2ListRelationFilter>;
  sys_name?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  venue_services?: InputMaybe<Venue_ServicesListRelationFilter>;
};

export type Categories_Tier2WhereUniqueInput = {
  sys_name?: InputMaybe<Scalars['String']['input']>;
};

export type Categories_Tier2_Tag_Groups = {
  __typename?: 'categories_tier2_tag_groups';
  categories_tier2: Categories_Tier2;
  category_tier2_name: Scalars['String']['output'];
  root_tags: Root_Tags;
  tag_group_root_uuid: Scalars['String']['output'];
};

export type Categories_Tier2_Tag_GroupsCategory_Tier2_NameTag_Group_Root_UuidCompoundUniqueInput = {
  category_tier2_name: Scalars['String']['input'];
  tag_group_root_uuid: Scalars['String']['input'];
};

export type Categories_Tier2_Tag_GroupsCreateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateWithoutCategories_Tier2Input>>;
};

export type Categories_Tier2_Tag_GroupsCreateManyWithoutRoot_TagsInput = {
  connect?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateOrConnectWithoutroot_TagsInput>>;
  create?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateWithoutRoot_TagsInput>>;
};

export type Categories_Tier2_Tag_GroupsCreateOrConnectWithoutcategories_Tier2Input = {
  create: Categories_Tier2_Tag_GroupsCreateWithoutCategories_Tier2Input;
  where: Categories_Tier2_Tag_GroupsWhereUniqueInput;
};

export type Categories_Tier2_Tag_GroupsCreateOrConnectWithoutroot_TagsInput = {
  create: Categories_Tier2_Tag_GroupsCreateWithoutRoot_TagsInput;
  where: Categories_Tier2_Tag_GroupsWhereUniqueInput;
};

export type Categories_Tier2_Tag_GroupsCreateWithoutCategories_Tier2Input = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  root_tags: Root_TagsCreateOneWithoutCategories_Tier2_Tag_GroupsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Categories_Tier2_Tag_GroupsCreateWithoutRoot_TagsInput = {
  categories_tier2: Categories_Tier2CreateOneWithoutCategories_Tier2_Tag_GroupsInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Categories_Tier2_Tag_GroupsScalarWhereInput = {
  AND?: InputMaybe<Array<Categories_Tier2_Tag_GroupsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Categories_Tier2_Tag_GroupsScalarWhereInput>>;
  OR?: InputMaybe<Array<Categories_Tier2_Tag_GroupsScalarWhereInput>>;
  category_tier2_name?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  tag_group_root_uuid?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Categories_Tier2_Tag_GroupsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Categories_Tier2_Tag_GroupsUpdateManyWithWhereWithoutCategories_Tier2Input = {
  data: Categories_Tier2_Tag_GroupsUpdateManyMutationInput;
  where: Categories_Tier2_Tag_GroupsScalarWhereInput;
};

export type Categories_Tier2_Tag_GroupsUpdateManyWithWhereWithoutRoot_TagsInput = {
  data: Categories_Tier2_Tag_GroupsUpdateManyMutationInput;
  where: Categories_Tier2_Tag_GroupsScalarWhereInput;
};

export type Categories_Tier2_Tag_GroupsUpdateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateWithoutCategories_Tier2Input>>;
  delete?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Categories_Tier2_Tag_GroupsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  set?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  update?: InputMaybe<Array<Categories_Tier2_Tag_GroupsUpdateWithWhereUniqueWithoutCategories_Tier2Input>>;
  updateMany?: InputMaybe<Array<Categories_Tier2_Tag_GroupsUpdateManyWithWhereWithoutCategories_Tier2Input>>;
  upsert?: InputMaybe<Array<Categories_Tier2_Tag_GroupsUpsertWithWhereUniqueWithoutCategories_Tier2Input>>;
};

export type Categories_Tier2_Tag_GroupsUpdateManyWithoutRoot_TagsInput = {
  connect?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateOrConnectWithoutroot_TagsInput>>;
  create?: InputMaybe<Array<Categories_Tier2_Tag_GroupsCreateWithoutRoot_TagsInput>>;
  delete?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Categories_Tier2_Tag_GroupsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  set?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereUniqueInput>>;
  update?: InputMaybe<Array<Categories_Tier2_Tag_GroupsUpdateWithWhereUniqueWithoutRoot_TagsInput>>;
  updateMany?: InputMaybe<Array<Categories_Tier2_Tag_GroupsUpdateManyWithWhereWithoutRoot_TagsInput>>;
  upsert?: InputMaybe<Array<Categories_Tier2_Tag_GroupsUpsertWithWhereUniqueWithoutRoot_TagsInput>>;
};

export type Categories_Tier2_Tag_GroupsUpdateWithWhereUniqueWithoutCategories_Tier2Input = {
  data: Categories_Tier2_Tag_GroupsUpdateWithoutCategories_Tier2Input;
  where: Categories_Tier2_Tag_GroupsWhereUniqueInput;
};

export type Categories_Tier2_Tag_GroupsUpdateWithWhereUniqueWithoutRoot_TagsInput = {
  data: Categories_Tier2_Tag_GroupsUpdateWithoutRoot_TagsInput;
  where: Categories_Tier2_Tag_GroupsWhereUniqueInput;
};

export type Categories_Tier2_Tag_GroupsUpdateWithoutCategories_Tier2Input = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneRequiredWithoutCategories_Tier2_Tag_GroupsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Categories_Tier2_Tag_GroupsUpdateWithoutRoot_TagsInput = {
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneRequiredWithoutCategories_Tier2_Tag_GroupsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Categories_Tier2_Tag_GroupsUpsertWithWhereUniqueWithoutCategories_Tier2Input = {
  create: Categories_Tier2_Tag_GroupsCreateWithoutCategories_Tier2Input;
  update: Categories_Tier2_Tag_GroupsUpdateWithoutCategories_Tier2Input;
  where: Categories_Tier2_Tag_GroupsWhereUniqueInput;
};

export type Categories_Tier2_Tag_GroupsUpsertWithWhereUniqueWithoutRoot_TagsInput = {
  create: Categories_Tier2_Tag_GroupsCreateWithoutRoot_TagsInput;
  update: Categories_Tier2_Tag_GroupsUpdateWithoutRoot_TagsInput;
  where: Categories_Tier2_Tag_GroupsWhereUniqueInput;
};

export type Categories_Tier2_Tag_GroupsWhereInput = {
  AND?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereInput>>;
  NOT?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereInput>>;
  OR?: InputMaybe<Array<Categories_Tier2_Tag_GroupsWhereInput>>;
  categories_tier2?: InputMaybe<Categories_Tier2WhereInput>;
  category_tier2_name?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  root_tags?: InputMaybe<Root_TagsWhereInput>;
  tag_group_root_uuid?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Categories_Tier2_Tag_GroupsWhereUniqueInput = {
  category_tier2_name_tag_group_root_uuid?: InputMaybe<Categories_Tier2_Tag_GroupsCategory_Tier2_NameTag_Group_Root_UuidCompoundUniqueInput>;
};

export type CloseByUser = {
  __typename?: 'closeByUser';
  email: Scalars['String']['output'];
  isImpersonating: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type CompleteEventRequestData = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  additionalInfo?: InputMaybe<AdditionalInfo>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  analytics_context?: InputMaybe<EventAnalytics>;
  budget: Scalars['Int']['input'];
  budget_flexible: Scalars['Boolean']['input'];
  category_tier1?: InputMaybe<Scalars['String']['input']>;
  category_tier2: Scalars['String']['input'];
  completed: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  radiusInKm?: InputMaybe<Scalars['Float']['input']>;
  sourceForm?: InputMaybe<Enum_Event_Request_Source_Form>;
  tag_uuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Conversations = {
  __typename?: 'conversations';
  conversations_messages: Array<Conversations_Messages>;
  conversations_users: Array<Conversations_Users>;
  event_request_id?: Maybe<Scalars['String']['output']>;
  event_requests?: Maybe<Event_Requests>;
  last_message_timestamp?: Maybe<Scalars['DateTime']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  suppliers?: Maybe<Suppliers>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};


export type ConversationsConversations_MessagesArgs = {
  cursor?: InputMaybe<Conversations_MessagesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<Conversations_MessagesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Conversations_MessagesWhereInput>;
};


export type ConversationsConversations_UsersArgs = {
  cursor?: InputMaybe<Conversations_UsersWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationsCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<ConversationsCreateWithoutEvent_RequestsInput>>;
};

export type ConversationsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<ConversationsCreateWithoutSuppliersInput>>;
};

export type ConversationsCreateOneWithoutConversations_MessagesInput = {
  connect?: InputMaybe<ConversationsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ConversationsCreateOrConnectWithoutconversations_MessagesInput>;
  create?: InputMaybe<ConversationsCreateWithoutConversations_MessagesInput>;
};

export type ConversationsCreateOneWithoutConversations_UsersInput = {
  connect?: InputMaybe<ConversationsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ConversationsCreateOrConnectWithoutconversations_UsersInput>;
  create?: InputMaybe<ConversationsCreateWithoutConversations_UsersInput>;
};

export type ConversationsCreateOneWithoutVoice_CallsInput = {
  connect?: InputMaybe<ConversationsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ConversationsCreateOrConnectWithoutvoice_CallsInput>;
  create?: InputMaybe<ConversationsCreateWithoutVoice_CallsInput>;
};

export type ConversationsCreateOrConnectWithoutconversations_MessagesInput = {
  create: ConversationsCreateWithoutConversations_MessagesInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsCreateOrConnectWithoutconversations_UsersInput = {
  create: ConversationsCreateWithoutConversations_UsersInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsCreateOrConnectWithoutevent_RequestsInput = {
  create: ConversationsCreateWithoutEvent_RequestsInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsCreateOrConnectWithoutsuppliersInput = {
  create: ConversationsCreateWithoutSuppliersInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsCreateOrConnectWithoutvoice_CallsInput = {
  create: ConversationsCreateWithoutVoice_CallsInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsCreateWithoutConversations_MessagesInput = {
  booking_id?: InputMaybe<Scalars['String']['input']>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutConversationsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutConversationsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  voice_calls?: InputMaybe<Voice_CallsCreateManyWithoutConversationsInput>;
};

export type ConversationsCreateWithoutConversations_UsersInput = {
  booking_id?: InputMaybe<Scalars['String']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutConversationsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutConversationsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  voice_calls?: InputMaybe<Voice_CallsCreateManyWithoutConversationsInput>;
};

export type ConversationsCreateWithoutEvent_RequestsInput = {
  booking_id?: InputMaybe<Scalars['String']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutConversationsInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutConversationsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  last_message_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutConversationsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  voice_calls?: InputMaybe<Voice_CallsCreateManyWithoutConversationsInput>;
};

export type ConversationsCreateWithoutSuppliersInput = {
  booking_id?: InputMaybe<Scalars['String']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutConversationsInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutConversationsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  voice_calls?: InputMaybe<Voice_CallsCreateManyWithoutConversationsInput>;
};

export type ConversationsCreateWithoutVoice_CallsInput = {
  booking_id?: InputMaybe<Scalars['String']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutConversationsInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutConversationsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutConversationsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type ConversationsOrderByInput = {
  booking_id?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  event_request_id?: InputMaybe<SortOrder>;
  last_message_timestamp?: InputMaybe<SortOrder>;
  supplier_id?: InputMaybe<SortOrder>;
  updated?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type ConversationsScalarWhereInput = {
  AND?: InputMaybe<Array<ConversationsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ConversationsScalarWhereInput>>;
  OR?: InputMaybe<Array<ConversationsScalarWhereInput>>;
  booking_id?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  last_message_timestamp?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type ConversationsSupplier_Event_Requests_Unique_Id_KeyCompoundUniqueInput = {
  event_request_id: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};

export type ConversationsUpdateManyMutationInput = {
  booking_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  last_message_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConversationsUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: ConversationsUpdateManyMutationInput;
  where: ConversationsScalarWhereInput;
};

export type ConversationsUpdateManyWithWhereWithoutSuppliersInput = {
  data: ConversationsUpdateManyMutationInput;
  where: ConversationsScalarWhereInput;
};

export type ConversationsUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<ConversationsCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConversationsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  set?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  update?: InputMaybe<Array<ConversationsUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<ConversationsUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<ConversationsUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type ConversationsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<ConversationsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConversationsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  set?: InputMaybe<Array<ConversationsWhereUniqueInput>>;
  update?: InputMaybe<Array<ConversationsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<ConversationsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<ConversationsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type ConversationsUpdateOneRequiredWithoutConversations_MessagesInput = {
  connect?: InputMaybe<ConversationsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ConversationsCreateOrConnectWithoutconversations_MessagesInput>;
  create?: InputMaybe<ConversationsCreateWithoutConversations_MessagesInput>;
  update?: InputMaybe<ConversationsUpdateWithoutConversations_MessagesInput>;
  upsert?: InputMaybe<ConversationsUpsertWithoutConversations_MessagesInput>;
};

export type ConversationsUpdateOneRequiredWithoutConversations_UsersInput = {
  connect?: InputMaybe<ConversationsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ConversationsCreateOrConnectWithoutconversations_UsersInput>;
  create?: InputMaybe<ConversationsCreateWithoutConversations_UsersInput>;
  update?: InputMaybe<ConversationsUpdateWithoutConversations_UsersInput>;
  upsert?: InputMaybe<ConversationsUpsertWithoutConversations_UsersInput>;
};

export type ConversationsUpdateOneRequiredWithoutVoice_CallsInput = {
  connect?: InputMaybe<ConversationsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ConversationsCreateOrConnectWithoutvoice_CallsInput>;
  create?: InputMaybe<ConversationsCreateWithoutVoice_CallsInput>;
  update?: InputMaybe<ConversationsUpdateWithoutVoice_CallsInput>;
  upsert?: InputMaybe<ConversationsUpsertWithoutVoice_CallsInput>;
};

export type ConversationsUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: ConversationsUpdateWithoutEvent_RequestsInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: ConversationsUpdateWithoutSuppliersInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsUpdateWithoutConversations_MessagesInput = {
  booking_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutConversationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutConversationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  voice_calls?: InputMaybe<Voice_CallsUpdateManyWithoutConversationsInput>;
};

export type ConversationsUpdateWithoutConversations_UsersInput = {
  booking_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutConversationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutConversationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  voice_calls?: InputMaybe<Voice_CallsUpdateManyWithoutConversationsInput>;
};

export type ConversationsUpdateWithoutEvent_RequestsInput = {
  booking_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutConversationsInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutConversationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  last_message_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutConversationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  voice_calls?: InputMaybe<Voice_CallsUpdateManyWithoutConversationsInput>;
};

export type ConversationsUpdateWithoutSuppliersInput = {
  booking_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutConversationsInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutConversationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  voice_calls?: InputMaybe<Voice_CallsUpdateManyWithoutConversationsInput>;
};

export type ConversationsUpdateWithoutVoice_CallsInput = {
  booking_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutConversationsInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutConversationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutConversationsInput>;
  last_message_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutConversationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ConversationsUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: ConversationsCreateWithoutEvent_RequestsInput;
  update: ConversationsUpdateWithoutEvent_RequestsInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: ConversationsCreateWithoutSuppliersInput;
  update: ConversationsUpdateWithoutSuppliersInput;
  where: ConversationsWhereUniqueInput;
};

export type ConversationsUpsertWithoutConversations_MessagesInput = {
  create: ConversationsCreateWithoutConversations_MessagesInput;
  update: ConversationsUpdateWithoutConversations_MessagesInput;
};

export type ConversationsUpsertWithoutConversations_UsersInput = {
  create: ConversationsCreateWithoutConversations_UsersInput;
  update: ConversationsUpdateWithoutConversations_UsersInput;
};

export type ConversationsUpsertWithoutVoice_CallsInput = {
  create: ConversationsCreateWithoutVoice_CallsInput;
  update: ConversationsUpdateWithoutVoice_CallsInput;
};

export type ConversationsWhereInput = {
  AND?: InputMaybe<Array<ConversationsWhereInput>>;
  NOT?: InputMaybe<Array<ConversationsWhereInput>>;
  OR?: InputMaybe<Array<ConversationsWhereInput>>;
  booking_id?: InputMaybe<StringNullableFilter>;
  conversations_messages?: InputMaybe<Conversations_MessagesListRelationFilter>;
  conversations_users?: InputMaybe<Conversations_UsersListRelationFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  last_message_timestamp?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
  voice_calls?: InputMaybe<Voice_CallsListRelationFilter>;
};

export type ConversationsWhereUniqueInput = {
  booking_id?: InputMaybe<Scalars['String']['input']>;
  supplier_event_requests_unique_id_key?: InputMaybe<ConversationsSupplier_Event_Requests_Unique_Id_KeyCompoundUniqueInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Conversations_Messages = {
  __typename?: 'conversations_messages';
  content: Scalars['String']['output'];
  conversations: Conversations;
  conversations_read_receipts: Array<Conversations_Read_Receipts>;
  created?: Maybe<Scalars['DateTime']['output']>;
  sender_user_id: Scalars['String']['output'];
  type: Enum_Conversations_Messages_Type;
  users: Users;
  uuid: Scalars['String']['output'];
};


export type Conversations_MessagesConversations_Read_ReceiptsArgs = {
  cursor?: InputMaybe<Conversations_Read_ReceiptsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Conversations_Read_ReceiptsWhereInput>;
};

export type Conversations_MessagesCreateManyWithoutConversationsInput = {
  connect?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_MessagesCreateOrConnectWithoutconversationsInput>>;
  create?: InputMaybe<Array<Conversations_MessagesCreateWithoutConversationsInput>>;
};

export type Conversations_MessagesCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_MessagesCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Conversations_MessagesCreateWithoutUsersInput>>;
};

export type Conversations_MessagesCreateOneWithoutConversations_Read_ReceiptsInput = {
  connect?: InputMaybe<Conversations_MessagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Conversations_MessagesCreateOrConnectWithoutconversations_Read_ReceiptsInput>;
  create?: InputMaybe<Conversations_MessagesCreateWithoutConversations_Read_ReceiptsInput>;
};

export type Conversations_MessagesCreateOrConnectWithoutconversationsInput = {
  create: Conversations_MessagesCreateWithoutConversationsInput;
  where: Conversations_MessagesWhereUniqueInput;
};

export type Conversations_MessagesCreateOrConnectWithoutconversations_Read_ReceiptsInput = {
  create: Conversations_MessagesCreateWithoutConversations_Read_ReceiptsInput;
  where: Conversations_MessagesWhereUniqueInput;
};

export type Conversations_MessagesCreateOrConnectWithoutusersInput = {
  create: Conversations_MessagesCreateWithoutUsersInput;
  where: Conversations_MessagesWhereUniqueInput;
};

export type Conversations_MessagesCreateWithoutConversationsInput = {
  content: Scalars['String']['input'];
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutConversations_MessagesInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  old_message_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Conversations_Messages_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users: UsersCreateOneWithoutConversations_MessagesInput;
  uuid: Scalars['String']['input'];
};

export type Conversations_MessagesCreateWithoutConversations_Read_ReceiptsInput = {
  content: Scalars['String']['input'];
  conversations: ConversationsCreateOneWithoutConversations_MessagesInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  old_message_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Conversations_Messages_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users: UsersCreateOneWithoutConversations_MessagesInput;
  uuid: Scalars['String']['input'];
};

export type Conversations_MessagesCreateWithoutUsersInput = {
  content: Scalars['String']['input'];
  conversations: ConversationsCreateOneWithoutConversations_MessagesInput;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutConversations_MessagesInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  old_message_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Conversations_Messages_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Conversations_MessagesOrderByInput = {
  content?: InputMaybe<SortOrder>;
  conversation_id?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  old_message_id?: InputMaybe<SortOrder>;
  sender_user_id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updated?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type Conversations_MessagesScalarWhereInput = {
  AND?: InputMaybe<Array<Conversations_MessagesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Conversations_MessagesScalarWhereInput>>;
  OR?: InputMaybe<Array<Conversations_MessagesScalarWhereInput>>;
  content?: InputMaybe<StringFilter>;
  conversation_id?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  old_message_id?: InputMaybe<StringNullableFilter>;
  sender_user_id?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Conversations_Messages_TypeFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Conversations_MessagesUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  old_message_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Conversations_Messages_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Conversations_MessagesUpdateManyWithWhereWithoutConversationsInput = {
  data: Conversations_MessagesUpdateManyMutationInput;
  where: Conversations_MessagesScalarWhereInput;
};

export type Conversations_MessagesUpdateManyWithWhereWithoutUsersInput = {
  data: Conversations_MessagesUpdateManyMutationInput;
  where: Conversations_MessagesScalarWhereInput;
};

export type Conversations_MessagesUpdateManyWithoutConversationsInput = {
  connect?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_MessagesCreateOrConnectWithoutconversationsInput>>;
  create?: InputMaybe<Array<Conversations_MessagesCreateWithoutConversationsInput>>;
  delete?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Conversations_MessagesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  set?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  update?: InputMaybe<Array<Conversations_MessagesUpdateWithWhereUniqueWithoutConversationsInput>>;
  updateMany?: InputMaybe<Array<Conversations_MessagesUpdateManyWithWhereWithoutConversationsInput>>;
  upsert?: InputMaybe<Array<Conversations_MessagesUpsertWithWhereUniqueWithoutConversationsInput>>;
};

export type Conversations_MessagesUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_MessagesCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Conversations_MessagesCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Conversations_MessagesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  set?: InputMaybe<Array<Conversations_MessagesWhereUniqueInput>>;
  update?: InputMaybe<Array<Conversations_MessagesUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Conversations_MessagesUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Conversations_MessagesUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Conversations_MessagesUpdateOneRequiredWithoutConversations_Read_ReceiptsInput = {
  connect?: InputMaybe<Conversations_MessagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Conversations_MessagesCreateOrConnectWithoutconversations_Read_ReceiptsInput>;
  create?: InputMaybe<Conversations_MessagesCreateWithoutConversations_Read_ReceiptsInput>;
  update?: InputMaybe<Conversations_MessagesUpdateWithoutConversations_Read_ReceiptsInput>;
  upsert?: InputMaybe<Conversations_MessagesUpsertWithoutConversations_Read_ReceiptsInput>;
};

export type Conversations_MessagesUpdateWithWhereUniqueWithoutConversationsInput = {
  data: Conversations_MessagesUpdateWithoutConversationsInput;
  where: Conversations_MessagesWhereUniqueInput;
};

export type Conversations_MessagesUpdateWithWhereUniqueWithoutUsersInput = {
  data: Conversations_MessagesUpdateWithoutUsersInput;
  where: Conversations_MessagesWhereUniqueInput;
};

export type Conversations_MessagesUpdateWithoutConversationsInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutConversations_MessagesInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  old_message_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Conversations_Messages_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutConversations_MessagesInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Conversations_MessagesUpdateWithoutConversations_Read_ReceiptsInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateOneRequiredWithoutConversations_MessagesInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  old_message_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Conversations_Messages_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutConversations_MessagesInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Conversations_MessagesUpdateWithoutUsersInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateOneRequiredWithoutConversations_MessagesInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutConversations_MessagesInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  old_message_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Conversations_Messages_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Conversations_MessagesUpsertWithWhereUniqueWithoutConversationsInput = {
  create: Conversations_MessagesCreateWithoutConversationsInput;
  update: Conversations_MessagesUpdateWithoutConversationsInput;
  where: Conversations_MessagesWhereUniqueInput;
};

export type Conversations_MessagesUpsertWithWhereUniqueWithoutUsersInput = {
  create: Conversations_MessagesCreateWithoutUsersInput;
  update: Conversations_MessagesUpdateWithoutUsersInput;
  where: Conversations_MessagesWhereUniqueInput;
};

export type Conversations_MessagesUpsertWithoutConversations_Read_ReceiptsInput = {
  create: Conversations_MessagesCreateWithoutConversations_Read_ReceiptsInput;
  update: Conversations_MessagesUpdateWithoutConversations_Read_ReceiptsInput;
};

export type Conversations_MessagesWhereInput = {
  AND?: InputMaybe<Array<Conversations_MessagesWhereInput>>;
  NOT?: InputMaybe<Array<Conversations_MessagesWhereInput>>;
  OR?: InputMaybe<Array<Conversations_MessagesWhereInput>>;
  content?: InputMaybe<StringFilter>;
  conversation_id?: InputMaybe<StringFilter>;
  conversations?: InputMaybe<ConversationsWhereInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsListRelationFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  old_message_id?: InputMaybe<StringNullableFilter>;
  sender_user_id?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Conversations_Messages_TypeFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Conversations_MessagesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Conversations_Read_Receipts = {
  __typename?: 'conversations_read_receipts';
  created?: Maybe<Scalars['DateTime']['output']>;
  message_id: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
};

export type Conversations_Read_ReceiptsCreateManyWithoutConversations_MessagesInput = {
  connect?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_Read_ReceiptsCreateOrConnectWithoutconversations_MessagesInput>>;
  create?: InputMaybe<Array<Conversations_Read_ReceiptsCreateWithoutConversations_MessagesInput>>;
};

export type Conversations_Read_ReceiptsCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_Read_ReceiptsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Conversations_Read_ReceiptsCreateWithoutUsersInput>>;
};

export type Conversations_Read_ReceiptsCreateOrConnectWithoutconversations_MessagesInput = {
  create: Conversations_Read_ReceiptsCreateWithoutConversations_MessagesInput;
  where: Conversations_Read_ReceiptsWhereUniqueInput;
};

export type Conversations_Read_ReceiptsCreateOrConnectWithoutusersInput = {
  create: Conversations_Read_ReceiptsCreateWithoutUsersInput;
  where: Conversations_Read_ReceiptsWhereUniqueInput;
};

export type Conversations_Read_ReceiptsCreateWithoutConversations_MessagesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users: UsersCreateOneWithoutConversations_Read_ReceiptsInput;
};

export type Conversations_Read_ReceiptsCreateWithoutUsersInput = {
  conversations_messages: Conversations_MessagesCreateOneWithoutConversations_Read_ReceiptsInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Conversations_Read_ReceiptsMessage_IdRecipientCompoundUniqueInput = {
  message_id: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
};

export type Conversations_Read_ReceiptsScalarWhereInput = {
  AND?: InputMaybe<Array<Conversations_Read_ReceiptsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Conversations_Read_ReceiptsScalarWhereInput>>;
  OR?: InputMaybe<Array<Conversations_Read_ReceiptsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  message_id?: InputMaybe<StringFilter>;
  recipient?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Conversations_Read_ReceiptsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Conversations_Read_ReceiptsUpdateManyWithWhereWithoutConversations_MessagesInput = {
  data: Conversations_Read_ReceiptsUpdateManyMutationInput;
  where: Conversations_Read_ReceiptsScalarWhereInput;
};

export type Conversations_Read_ReceiptsUpdateManyWithWhereWithoutUsersInput = {
  data: Conversations_Read_ReceiptsUpdateManyMutationInput;
  where: Conversations_Read_ReceiptsScalarWhereInput;
};

export type Conversations_Read_ReceiptsUpdateManyWithoutConversations_MessagesInput = {
  connect?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_Read_ReceiptsCreateOrConnectWithoutconversations_MessagesInput>>;
  create?: InputMaybe<Array<Conversations_Read_ReceiptsCreateWithoutConversations_MessagesInput>>;
  delete?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Conversations_Read_ReceiptsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  set?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  update?: InputMaybe<Array<Conversations_Read_ReceiptsUpdateWithWhereUniqueWithoutConversations_MessagesInput>>;
  updateMany?: InputMaybe<Array<Conversations_Read_ReceiptsUpdateManyWithWhereWithoutConversations_MessagesInput>>;
  upsert?: InputMaybe<Array<Conversations_Read_ReceiptsUpsertWithWhereUniqueWithoutConversations_MessagesInput>>;
};

export type Conversations_Read_ReceiptsUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_Read_ReceiptsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Conversations_Read_ReceiptsCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Conversations_Read_ReceiptsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  set?: InputMaybe<Array<Conversations_Read_ReceiptsWhereUniqueInput>>;
  update?: InputMaybe<Array<Conversations_Read_ReceiptsUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Conversations_Read_ReceiptsUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Conversations_Read_ReceiptsUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Conversations_Read_ReceiptsUpdateWithWhereUniqueWithoutConversations_MessagesInput = {
  data: Conversations_Read_ReceiptsUpdateWithoutConversations_MessagesInput;
  where: Conversations_Read_ReceiptsWhereUniqueInput;
};

export type Conversations_Read_ReceiptsUpdateWithWhereUniqueWithoutUsersInput = {
  data: Conversations_Read_ReceiptsUpdateWithoutUsersInput;
  where: Conversations_Read_ReceiptsWhereUniqueInput;
};

export type Conversations_Read_ReceiptsUpdateWithoutConversations_MessagesInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutConversations_Read_ReceiptsInput>;
};

export type Conversations_Read_ReceiptsUpdateWithoutUsersInput = {
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateOneRequiredWithoutConversations_Read_ReceiptsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Conversations_Read_ReceiptsUpsertWithWhereUniqueWithoutConversations_MessagesInput = {
  create: Conversations_Read_ReceiptsCreateWithoutConversations_MessagesInput;
  update: Conversations_Read_ReceiptsUpdateWithoutConversations_MessagesInput;
  where: Conversations_Read_ReceiptsWhereUniqueInput;
};

export type Conversations_Read_ReceiptsUpsertWithWhereUniqueWithoutUsersInput = {
  create: Conversations_Read_ReceiptsCreateWithoutUsersInput;
  update: Conversations_Read_ReceiptsUpdateWithoutUsersInput;
  where: Conversations_Read_ReceiptsWhereUniqueInput;
};

export type Conversations_Read_ReceiptsWhereInput = {
  AND?: InputMaybe<Array<Conversations_Read_ReceiptsWhereInput>>;
  NOT?: InputMaybe<Array<Conversations_Read_ReceiptsWhereInput>>;
  OR?: InputMaybe<Array<Conversations_Read_ReceiptsWhereInput>>;
  conversations_messages?: InputMaybe<Conversations_MessagesWhereInput>;
  created?: InputMaybe<DateTimeNullableFilter>;
  message_id?: InputMaybe<StringFilter>;
  recipient?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  users?: InputMaybe<UsersWhereInput>;
};

export type Conversations_Read_ReceiptsWhereUniqueInput = {
  message_id_recipient?: InputMaybe<Conversations_Read_ReceiptsMessage_IdRecipientCompoundUniqueInput>;
};

export type Conversations_Users = {
  __typename?: 'conversations_users';
  users: Users;
};

export type Conversations_UsersConversation_IdUser_IdCompoundUniqueInput = {
  conversation_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type Conversations_UsersCreateManyWithoutConversationsInput = {
  connect?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_UsersCreateOrConnectWithoutconversationsInput>>;
  create?: InputMaybe<Array<Conversations_UsersCreateWithoutConversationsInput>>;
};

export type Conversations_UsersCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Conversations_UsersCreateWithoutUsersInput>>;
};

export type Conversations_UsersCreateOrConnectWithoutconversationsInput = {
  create: Conversations_UsersCreateWithoutConversationsInput;
  where: Conversations_UsersWhereUniqueInput;
};

export type Conversations_UsersCreateOrConnectWithoutusersInput = {
  create: Conversations_UsersCreateWithoutUsersInput;
  where: Conversations_UsersWhereUniqueInput;
};

export type Conversations_UsersCreateWithoutConversationsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users: UsersCreateOneWithoutConversations_UsersInput;
};

export type Conversations_UsersCreateWithoutUsersInput = {
  conversations: ConversationsCreateOneWithoutConversations_UsersInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Conversations_UsersScalarWhereInput = {
  AND?: InputMaybe<Array<Conversations_UsersScalarWhereInput>>;
  NOT?: InputMaybe<Array<Conversations_UsersScalarWhereInput>>;
  OR?: InputMaybe<Array<Conversations_UsersScalarWhereInput>>;
  conversation_id?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
};

export type Conversations_UsersUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Conversations_UsersUpdateManyWithWhereWithoutConversationsInput = {
  data: Conversations_UsersUpdateManyMutationInput;
  where: Conversations_UsersScalarWhereInput;
};

export type Conversations_UsersUpdateManyWithWhereWithoutUsersInput = {
  data: Conversations_UsersUpdateManyMutationInput;
  where: Conversations_UsersScalarWhereInput;
};

export type Conversations_UsersUpdateManyWithoutConversationsInput = {
  connect?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_UsersCreateOrConnectWithoutconversationsInput>>;
  create?: InputMaybe<Array<Conversations_UsersCreateWithoutConversationsInput>>;
  delete?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Conversations_UsersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  set?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  update?: InputMaybe<Array<Conversations_UsersUpdateWithWhereUniqueWithoutConversationsInput>>;
  updateMany?: InputMaybe<Array<Conversations_UsersUpdateManyWithWhereWithoutConversationsInput>>;
  upsert?: InputMaybe<Array<Conversations_UsersUpsertWithWhereUniqueWithoutConversationsInput>>;
};

export type Conversations_UsersUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Conversations_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Conversations_UsersCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Conversations_UsersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  set?: InputMaybe<Array<Conversations_UsersWhereUniqueInput>>;
  update?: InputMaybe<Array<Conversations_UsersUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Conversations_UsersUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Conversations_UsersUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Conversations_UsersUpdateWithWhereUniqueWithoutConversationsInput = {
  data: Conversations_UsersUpdateWithoutConversationsInput;
  where: Conversations_UsersWhereUniqueInput;
};

export type Conversations_UsersUpdateWithWhereUniqueWithoutUsersInput = {
  data: Conversations_UsersUpdateWithoutUsersInput;
  where: Conversations_UsersWhereUniqueInput;
};

export type Conversations_UsersUpdateWithoutConversationsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutConversations_UsersInput>;
};

export type Conversations_UsersUpdateWithoutUsersInput = {
  conversations?: InputMaybe<ConversationsUpdateOneRequiredWithoutConversations_UsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Conversations_UsersUpsertWithWhereUniqueWithoutConversationsInput = {
  create: Conversations_UsersCreateWithoutConversationsInput;
  update: Conversations_UsersUpdateWithoutConversationsInput;
  where: Conversations_UsersWhereUniqueInput;
};

export type Conversations_UsersUpsertWithWhereUniqueWithoutUsersInput = {
  create: Conversations_UsersCreateWithoutUsersInput;
  update: Conversations_UsersUpdateWithoutUsersInput;
  where: Conversations_UsersWhereUniqueInput;
};

export type Conversations_UsersWhereInput = {
  AND?: InputMaybe<Array<Conversations_UsersWhereInput>>;
  NOT?: InputMaybe<Array<Conversations_UsersWhereInput>>;
  OR?: InputMaybe<Array<Conversations_UsersWhereInput>>;
  conversation_id?: InputMaybe<StringFilter>;
  conversations?: InputMaybe<ConversationsWhereInput>;
  created?: InputMaybe<DateTimeNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
};

export type Conversations_UsersWhereUniqueInput = {
  conversation_id_user_id?: InputMaybe<Conversations_UsersConversation_IdUser_IdCompoundUniqueInput>;
};

export type Coordinates = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCustomEventNameInput = {
  customEventName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventInput = {
  analyticsContext?: InputMaybe<EventAnalytics>;
  approximate_location: Scalars['Boolean']['input'];
  browsingHistory?: InputMaybe<Array<InputMaybe<EventBrowsingHistory>>>;
  coordinates?: InputMaybe<EventCoordinatesInput>;
  customer_referral?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  dateFlexibilityNotes?: InputMaybe<Scalars['String']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  event_areas?: InputMaybe<Array<InputMaybe<EventAreasEnum>>>;
  freshsalesRequestInfo?: InputMaybe<EventFreshsalesInfo>;
  isPartnerBooked?: InputMaybe<Scalars['Boolean']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  session_tracking?: InputMaybe<SessionTrackingDetails>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  supplier_referral?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
  urgency: Scalars['String']['input'];
  utmParams?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEventRequestInput = {
  additional_info?: InputMaybe<AdditionalInfo>;
  analyticsContext?: InputMaybe<EventAnalytics>;
  analytics_context?: InputMaybe<EventAnalytics>;
  budget: Scalars['Float']['input'];
  budgetFlexible?: InputMaybe<Scalars['Boolean']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  category_tier1?: InputMaybe<Scalars['String']['input']>;
  category_tier2: Scalars['String']['input'];
  completed: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['String']['input'];
  gclid?: InputMaybe<Scalars['String']['input']>;
  incomplete_verticals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  radiusInKm?: InputMaybe<Scalars['Float']['input']>;
  sourceForm?: InputMaybe<Enum_Event_Request_Source_Form>;
  tag_uuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateQuoteInput = {
  attachmentText?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  covers?: InputMaybe<Scalars['Int']['input']>;
  eventRequestId: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  isExclVatPrice?: InputMaybe<Scalars['Boolean']['input']>;
  isShortlisted?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipCommission?: InputMaybe<Scalars['Float']['input']>;
  quoteAttachments?: InputMaybe<Array<AttachmentInput>>;
  quoteLineItems?: InputMaybe<Array<InputMaybe<QuoteLineItemInput>>>;
  quotePriceDetails?: InputMaybe<QuotePriceDetailsInput>;
  serviceFee?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<QuoteSource>;
  supplierId: Scalars['String']['input'];
  supportText?: InputMaybe<Scalars['String']['input']>;
  total: Scalars['Float']['input'];
};

export type CreateRequestWithInput = {
  additional_info?: InputMaybe<AdditionalInfo>;
  analyticsContext?: InputMaybe<EventAnalytics>;
  analytics_context?: InputMaybe<EventAnalytics>;
  budget: Scalars['Float']['input'];
  budgetFlexible?: InputMaybe<Scalars['Boolean']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  category_tier1: Scalars['String']['input'];
  category_tier2: Scalars['String']['input'];
  completed: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  incomplete_verticals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  radiusInKm?: InputMaybe<Scalars['Float']['input']>;
  sourceForm?: InputMaybe<Enum_Event_Request_Source_Form>;
  tag_uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSupplierFlexiblePricingInput = {
  day_of_week?: InputMaybe<Enum_Supplier_Flexible_Pricing_Day_Of_Week>;
  month?: InputMaybe<Enum_Supplier_Flexible_Pricing_Month>;
  price: Scalars['Int']['input'];
  price_adjustment: Enum_Supplier_Flexible_Pricing_Price_Adjustment;
  supplierId: Scalars['String']['input'];
};

export type CreatedEventWithRequestsData = {
  __typename?: 'createdEventWithRequestsData';
  eventIds?: Maybe<CreatedIds>;
  incompleteRequestIds?: Maybe<Array<Maybe<CreatedIds>>>;
  requestIds?: Maybe<CreatedIds>;
};

export type CreatedIds = {
  __typename?: 'createdIds';
  id?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CustomerReferralLinksResponse = {
  __typename?: 'customerReferralLinksResponse';
  longUrl?: Maybe<Scalars['String']['output']>;
  shortUrl?: Maybe<Scalars['String']['output']>;
};

export enum DeclinedReasonType {
  BudgetTooLow = 'budget_too_low',
  GuestCountTooLow = 'guest_count_too_low',
  LocationTooFar = 'location_too_far',
  NotInterested = 'not_interested',
  UnableToProvideServiceRequested = 'unable_to_provide_service_requested',
  UnavailableOnDate = 'unavailable_on_date'
}

export type Declined_Event_Requests = {
  __typename?: 'declined_event_requests';
  created?: Maybe<Scalars['String']['output']>;
  declined_reason?: Maybe<DeclinedReasonType>;
  event_request_id?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  supplier_name?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Declined_Event_RequestsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Declined_Event_RequestsCreateWithoutEvent_RequestsInput>>;
};

export type Declined_Event_RequestsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Declined_Event_RequestsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Declined_Event_RequestsCreateWithoutSuppliersInput>>;
};

export type Declined_Event_RequestsCreateOrConnectWithoutevent_RequestsInput = {
  create: Declined_Event_RequestsCreateWithoutEvent_RequestsInput;
  where: Declined_Event_RequestsWhereUniqueInput;
};

export type Declined_Event_RequestsCreateOrConnectWithoutsuppliersInput = {
  create: Declined_Event_RequestsCreateWithoutSuppliersInput;
  where: Declined_Event_RequestsWhereUniqueInput;
};

export type Declined_Event_RequestsCreateWithoutEvent_RequestsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Declined_Event_Requests_Declined_Reason>;
  suppliers: SuppliersCreateOneWithoutDeclined_Event_RequestsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Declined_Event_RequestsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Declined_Event_Requests_Declined_Reason>;
  event_requests: Event_RequestsCreateOneWithoutDeclined_Event_RequestsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Declined_Event_RequestsScalarWhereInput = {
  AND?: InputMaybe<Array<Declined_Event_RequestsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Declined_Event_RequestsScalarWhereInput>>;
  OR?: InputMaybe<Array<Declined_Event_RequestsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  declined_reason?: InputMaybe<Enumenum_Declined_Event_Requests_Declined_ReasonNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Declined_Event_RequestsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Declined_Event_Requests_Declined_ReasonFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Declined_Event_RequestsUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: Declined_Event_RequestsUpdateManyMutationInput;
  where: Declined_Event_RequestsScalarWhereInput;
};

export type Declined_Event_RequestsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Declined_Event_RequestsUpdateManyMutationInput;
  where: Declined_Event_RequestsScalarWhereInput;
};

export type Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Declined_Event_RequestsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Declined_Event_RequestsCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Declined_Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Declined_Event_RequestsUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<Declined_Event_RequestsUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<Declined_Event_RequestsUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type Declined_Event_RequestsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Declined_Event_RequestsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Declined_Event_RequestsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Declined_Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Declined_Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Declined_Event_RequestsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Declined_Event_RequestsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Declined_Event_RequestsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Declined_Event_RequestsUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: Declined_Event_RequestsUpdateWithoutEvent_RequestsInput;
  where: Declined_Event_RequestsWhereUniqueInput;
};

export type Declined_Event_RequestsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Declined_Event_RequestsUpdateWithoutSuppliersInput;
  where: Declined_Event_RequestsWhereUniqueInput;
};

export type Declined_Event_RequestsUpdateWithoutEvent_RequestsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Declined_Event_Requests_Declined_ReasonFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutDeclined_Event_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Declined_Event_RequestsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Declined_Event_Requests_Declined_ReasonFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneRequiredWithoutDeclined_Event_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Declined_Event_RequestsUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: Declined_Event_RequestsCreateWithoutEvent_RequestsInput;
  update: Declined_Event_RequestsUpdateWithoutEvent_RequestsInput;
  where: Declined_Event_RequestsWhereUniqueInput;
};

export type Declined_Event_RequestsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Declined_Event_RequestsCreateWithoutSuppliersInput;
  update: Declined_Event_RequestsUpdateWithoutSuppliersInput;
  where: Declined_Event_RequestsWhereUniqueInput;
};

export type Declined_Event_RequestsWhereInput = {
  AND?: InputMaybe<Array<Declined_Event_RequestsWhereInput>>;
  NOT?: InputMaybe<Array<Declined_Event_RequestsWhereInput>>;
  OR?: InputMaybe<Array<Declined_Event_RequestsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  declined_reason?: InputMaybe<Enumenum_Declined_Event_Requests_Declined_ReasonNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Declined_Event_RequestsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum Declined_Reason {
  BookedAnotherSupplier = 'BOOKED_ANOTHER_SUPPLIER',
  BookedElsewhere = 'BOOKED_ELSEWHERE',
  ClosedByFreshsales = 'CLOSED_BY_FRESHSALES',
  LookingForSomethingDifferent = 'LOOKING_FOR_SOMETHING_DIFFERENT',
  NotSuitable = 'NOT_SUITABLE',
  Other = 'OTHER',
  RequestCancelled = 'REQUEST_CANCELLED',
  RequestDatePassed = 'REQUEST_DATE_PASSED',
  TooExpensive = 'TOO_EXPENSIVE'
}

export type DisintermediationTypes = {
  __typename?: 'disintermediationTypes';
  containsContactDetails?: Maybe<Scalars['Boolean']['output']>;
  containsPrice?: Maybe<Scalars['Boolean']['output']>;
};

export enum DocumentFileStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum DocumentFileTypeEnum {
  AlcoholLicenceDocument = 'alcohol_licence_document',
  AllergensChart = 'allergens_chart',
  Coshh = 'coshh',
  DbsCheck = 'dbs_check',
  ElectricalInstallationCertificate = 'electrical_installation_certificate',
  EmployerLiabilityInsurance = 'employer_liability_insurance',
  FireRiskAssessment = 'fire_risk_assessment',
  FoodHygieneCertificate = 'food_hygiene_certificate',
  FoodHygieneRating = 'food_hygiene_rating',
  GasSafetyCertificate = 'gas_safety_certificate',
  Haccp = 'haccp',
  HealthAndSafetyPolicy = 'health_and_safety_policy',
  HealthAndSafetyRiskAssessment = 'health_and_safety_risk_assessment',
  HygieneCertificateLevel_2And_3 = 'hygiene_certificate_level_2_and_3',
  PatTestCertificate = 'pat_test_certificate',
  PitchApplicationMenu = 'pitch_application_menu',
  PublicLiabilityInsurance = 'public_liability_insurance',
  RiskAssessment = 'risk_assessment',
  RiskAssessmentMethodStatement = 'risk_assessment_method_statement',
  SiteRiskAssessment = 'site_risk_assessment',
  SpecialTreatmentsLicence = 'special_treatments_licence'
}

export enum DocumentLevelEnum {
  Application = 'APPLICATION',
  Business = 'BUSINESS',
  Setup = 'SETUP'
}

export type EditEventInput = {
  approximate_location?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<EventCoordinatesInput>;
  custom_event_name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateFlexibilityNotes?: InputMaybe<Scalars['String']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  isPartnerBooked?: InputMaybe<Scalars['Boolean']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  partnershipId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
};

export type EditSupplieFlexiblePricingInput = {
  day_of_week?: InputMaybe<Enum_Supplier_Flexible_Pricing_Day_Of_Week>;
  month?: InputMaybe<Enum_Supplier_Flexible_Pricing_Month>;
  price: Scalars['Int']['input'];
  price_adjustment: Enum_Supplier_Flexible_Pricing_Price_Adjustment;
};

export enum Enum_Bookings_State {
  Booked = 'booked',
  Declined = 'declined',
  Pending = 'pending'
}

export enum Enum_Calls_Call_To {
  Supplier = 'supplier',
  User = 'user'
}

export enum Enum_Conversations_Messages_Type {
  Attachment = 'attachment',
  Auto = 'auto',
  Call = 'call',
  EventEdit = 'event_edit',
  NewPrice = 'newPrice',
  Quote = 'quote',
  Regular = 'regular',
  WorkflowAutomationsAutoMessaging = 'workflow_automations_auto_messaging'
}

export enum Enum_Declined_Event_Requests_Declined_Reason {
  BudgetTooLow = 'budget_too_low',
  GuestCountTooLow = 'guest_count_too_low',
  LocationTooFar = 'location_too_far',
  NotInterested = 'not_interested',
  UnableToProvideServiceRequested = 'unable_to_provide_service_requested',
  UnavailableOnDate = 'unavailable_on_date'
}

export enum Enum_Event_Areas_Area {
  AllLondon = 'all_london',
  CentralLondon = 'central_london',
  EastLondon = 'east_london',
  NorthLondon = 'north_london',
  SouthLondon = 'south_london',
  WestLondon = 'west_london'
}

export enum Enum_Event_Dates_State {
  Booked = 'booked'
}

export enum Enum_Event_Request_Additional_Info_Bar_Type {
  Cash = 'cash',
  Mixed = 'mixed',
  NotSure = 'not_sure',
  Open = 'open'
}

export enum Enum_Event_Request_Additional_Info_Children {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum Enum_Event_Request_Additional_Info_Courses_Course {
  Canapes = 'canapes',
  Desserts = 'desserts',
  Mains = 'mains',
  Starters = 'starters'
}

export enum Enum_Event_Request_Additional_Info_Crockery {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum Enum_Event_Request_Additional_Info_Power {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum Enum_Event_Request_Additional_Info_Waiters {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum Enum_Event_Request_Additional_Info_Water {
  No = 'no',
  NotSure = 'not_sure',
  Yes = 'yes'
}

export enum Enum_Event_Request_Quote_Limited_Source {
  Admin = 'admin',
  User = 'user'
}

export enum Enum_Event_Request_Source_Form {
  AiEnquiry = 'AI_ENQUIRY',
  Enquiry = 'ENQUIRY',
  EnquiryV2 = 'ENQUIRY_V2'
}

export enum Enum_Event_Request_Supplier_Notified_Call_Method {
  Admin = 'admin',
  CompleteCustomer = 'complete_customer',
  CompleteImpersonate = 'complete_impersonate',
  CreateCustomer = 'create_customer',
  CreateImpersonate = 'create_impersonate',
  EditCustomer = 'edit_customer',
  EditImpersonate = 'edit_impersonate',
  ServiceCall = 'service_call'
}

export enum Enum_External_Payment_Info_Provider {
  Stripe = 'STRIPE'
}

export enum Enum_Payments_Flow_Type {
  Deposits = 'DEPOSITS',
  Standard = 'STANDARD'
}

export enum Enum_Quote_Line_Item_Templates_Type {
  AdditionalCosts = 'additional_costs',
  Food = 'food',
  Space = 'space'
}

export enum Enum_Quote_Line_Items_Type {
  AdditionalCosts = 'additional_costs',
  Food = 'food',
  Space = 'space'
}

export enum Enum_Quote_Template_Line_Items_Type {
  AdditionalCosts = 'additional_costs',
  Food = 'food',
  Legacy = 'legacy',
  Main = 'main',
  Space = 'space'
}

export enum Enum_Quotes_Declined_Reason {
  BookedAnotherSupplier = 'BOOKED_ANOTHER_SUPPLIER',
  BookedElsewhere = 'BOOKED_ELSEWHERE',
  ClosedByFreshsales = 'CLOSED_BY_FRESHSALES',
  LookingForSomethingDifferent = 'LOOKING_FOR_SOMETHING_DIFFERENT',
  NotSuitable = 'NOT_SUITABLE',
  Other = 'OTHER',
  RequestCancelled = 'REQUEST_CANCELLED',
  RequestDatePassed = 'REQUEST_DATE_PASSED',
  TooExpensive = 'TOO_EXPENSIVE'
}

export enum Enum_Quotes_Payment_Type {
  Invoice = 'invoice',
  StripePaymentPlan = 'stripe_payment_plan',
  StripeSinglePayment = 'stripe_single_payment'
}

export enum Enum_Quotes_State {
  Approved = 'approved',
  Booked = 'booked',
  Cancelled = 'cancelled',
  Declined = 'declined',
  DeclinedAdmin = 'declinedAdmin',
  InvoiceRequested = 'invoiceRequested',
  Pending = 'pending',
  Withdrawn = 'withdrawn'
}

export enum Enum_Reviews_Source {
  Admin = 'admin',
  Booking = 'booking',
  External = 'external',
  Legacy = 'legacy'
}

export enum Enum_Robex_Notifications_Notification_Status {
  Digest = 'digest',
  DigestPending = 'digestPending',
  Immediately = 'immediately'
}

export enum Enum_Salesforce_Events_Method {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export enum Enum_Salesforce_Events_Stage {
  Lost = 'LOST',
  Won = 'WON'
}

export enum Enum_Salesforce_Events_Stage_Reason {
  AutocloseEventDate = 'AUTOCLOSE_EVENT_DATE',
  BookedElsewhere = 'BOOKED_ELSEWHERE',
  BudgetMisalignment = 'BUDGET_MISALIGNMENT',
  CancelledByCustomer = 'CANCELLED_BY_CUSTOMER',
  CancelledBySupplier = 'CANCELLED_BY_SUPPLIER',
  ClosedByPlatform = 'CLOSED_BY_PLATFORM',
  CloseAccountTooManyEmails = 'CLOSE_ACCOUNT_TOO_MANY_EMAILS',
  DuplicateEnquiry = 'DUPLICATE_ENQUIRY',
  NotGoingAhead = 'NOT_GOING_AHEAD',
  NotHappyWithProduct = 'NOT_HAPPY_WITH_PRODUCT',
  NotReadyToBookOrBrowsing = 'NOT_READY_TO_BOOK_OR_BROWSING',
  NoSuitableLocation = 'NO_SUITABLE_LOCATION',
  NoSuitableStyle = 'NO_SUITABLE_STYLE',
  NoSuitableSupply = 'NO_SUITABLE_SUPPLY',
  Other = 'OTHER',
  OutOfBudget = 'OUT_OF_BUDGET',
  PreferredOptionUnavailable = 'PREFERRED_OPTION_UNAVAILABLE',
  RejectedTsAndCs = 'REJECTED_TS_AND_CS',
  UnknownCantEngageCustomer = 'UNKNOWN_CANT_ENGAGE_CUSTOMER',
  UnsuitablePublic = 'UNSUITABLE_PUBLIC',
  VenueRestrictions = 'VENUE_RESTRICTIONS'
}

export enum Enum_Salesforce_Suppliers_Approval_State {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export enum Enum_Salesforce_Suppliers_Public_Approval_State {
  Approved = 'APPROVED',
  Exclusive = 'EXCLUSIVE',
  Interested = 'INTERESTED',
  NotApplied = 'NOT_APPLIED',
  NotApproved = 'NOT_APPROVED',
  Preferred = 'PREFERRED'
}

export enum Enum_Scheduled_Payments_Method {
  Deposits = 'DEPOSITS',
  Manual = 'MANUAL'
}

export enum Enum_Scheduled_Payments_Type {
  Balance = 'BALANCE',
  Deposit = 'DEPOSIT'
}

export enum Enum_Supplier_Calendars_Events_Type {
  AutoCreatedFromBooking = 'auto_created_from_booking',
  Booked = 'booked',
  Unavailable = 'unavailable'
}

export enum Enum_Supplier_Documents_Type {
  AllergensChart = 'allergens_chart',
  Coshh = 'coshh',
  ElectricalInstallationCertificate = 'electrical_installation_certificate',
  EmployerLiabilityInsurance = 'employer_liability_insurance',
  FireRiskAssessment = 'fire_risk_assessment',
  FoodHygieneCertificate = 'food_hygiene_certificate',
  GasSafetyCertificate = 'gas_safety_certificate',
  Haccp = 'haccp',
  HealthAndSafetyPolicy = 'health_and_safety_policy',
  HygieneCertificateLevel_2And_3 = 'hygiene_certificate_level_2_and_3',
  PatTestCertificate = 'pat_test_certificate',
  PublicLiabilityInsurance = 'public_liability_insurance',
  RiskAssessment = 'risk_assessment',
  RiskAssessmentMethodStatement = 'risk_assessment_method_statement',
  SiteRiskAssessment = 'site_risk_assessment'
}

export enum Enum_Supplier_Flexible_Pricing_Day_Of_Week {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum Enum_Supplier_Flexible_Pricing_Month {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export enum Enum_Supplier_Flexible_Pricing_Price_Adjustment {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export enum Enum_Supplier_Payments_Method {
  Deposits = 'DEPOSITS',
  Manual = 'MANUAL'
}

export enum Enum_Supplier_Payments_Payment_Method {
  Automatic = 'automatic',
  Manual = 'manual'
}

export enum Enum_Supplier_Payments_Status {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum Enum_Supplier_Payments_Type {
  Balance = 'BALANCE',
  Deposit = 'DEPOSIT'
}

export enum Enum_Supplier_Stats_Status {
  Refreshing = 'refreshing',
  Requested = 'requested',
  Scheduled = 'scheduled'
}

export enum Enum_Suppliers_Kyb_Status {
  ApplicationStarted = 'APPLICATION_STARTED',
  Complete = 'COMPLETE',
  Enabled = 'ENABLED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Sanctioned = 'SANCTIONED'
}

export enum Enum_Suppliers_State {
  Active = 'active',
  Approved = 'approved',
  Deactivated = 'deactivated',
  Declined = 'declined',
  Pending = 'pending',
  Rejected = 'rejected',
  Submitted = 'submitted'
}

export enum Enum_User_External_Ids_Provider {
  Google = 'google',
  Outlook = 'outlook'
}

export enum Enum_Users_Type {
  Admin = 'admin',
  Customer = 'customer',
  Supplier = 'supplier'
}

export enum Enum_Voice_Calling_Recipient_Type {
  Customer = 'customer',
  Supplier = 'supplier'
}

export enum Enum_Voice_Calls_Primary_Status {
  Answered = 'answered',
  Busy = 'busy',
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Initiated = 'initiated',
  Missed = 'missed',
  NoAnswer = 'no_answer',
  Ringing = 'ringing'
}

export enum Enum_Voice_Calls_Secondary_Status {
  Answered = 'answered',
  Busy = 'busy',
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Initiated = 'initiated',
  Missed = 'missed',
  NoAnswer = 'no_answer',
  Ringing = 'ringing'
}

export enum Enum_Workflow_Automations_Message_Templates_Automation_Trigger {
  XDaysAfterBookingConfirmed = 'x_days_after_booking_confirmed',
  XDaysAfterQuoteSubmittedAndCustomerNotReplied = 'x_days_after_quote_submitted_and_customer_not_replied',
  XDaysBeforeEventAfterBookingConfirmed = 'x_days_before_event_after_booking_confirmed'
}

export enum Enum_Xero_Invoices_Type {
  CustomerPayment = 'CUSTOMER_PAYMENT',
  CustomerVatFeastItFee = 'CUSTOMER_VAT_FEAST_IT_FEE',
  CustomerVatSupplierCommission = 'CUSTOMER_VAT_SUPPLIER_COMMISSION',
  SupplierCommission = 'SUPPLIER_COMMISSION',
  SupplierPayment = 'SUPPLIER_PAYMENT'
}

export type EventAnalytics = {
  page?: InputMaybe<EventAnalyticsPage>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type EventAnalyticsPage = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum EventAreasEnum {
  AllLondon = 'all_london',
  CentralLondon = 'central_london',
  EastLondon = 'east_london',
  NorthLondon = 'north_london',
  SouthLondon = 'south_london',
  WestLondon = 'west_london'
}

export type EventBrowsingHistory = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type EventCoordinatesInput = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type EventFreshsalesInfo = {
  budget: Scalars['Float']['input'];
  requestCount: Scalars['Int']['input'];
};

export type EventWithRequests = {
  __typename?: 'eventWithRequests';
  data?: Maybe<CreatedEventWithRequestsData>;
  error?: Maybe<FailedEventWithRequestsError>;
};

export type Event_Areas = {
  __typename?: 'event_areas';
  area?: Maybe<Scalars['String']['output']>;
  area_uuid?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  event_id: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type Event_AreasCreateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_AreasWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_AreasCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_AreasCreateWithoutEventsInput>>;
};

export type Event_AreasCreateOrConnectWithouteventsInput = {
  create: Event_AreasCreateWithoutEventsInput;
  where: Event_AreasWhereUniqueInput;
};

export type Event_AreasCreateWithoutEventsInput = {
  area: Enum_Event_Areas_Area;
  areas?: InputMaybe<AreasCreateOneWithoutEvent_AreasInput>;
  created: Scalars['DateTime']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Event_AreasScalarWhereInput = {
  AND?: InputMaybe<Array<Event_AreasScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_AreasScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_AreasScalarWhereInput>>;
  area?: InputMaybe<Enumenum_Event_Areas_AreaFilter>;
  area_uuid?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  event_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_AreasUpdateManyMutationInput = {
  area?: InputMaybe<Enumenum_Event_Areas_AreaFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_AreasUpdateManyWithWhereWithoutEventsInput = {
  data: Event_AreasUpdateManyMutationInput;
  where: Event_AreasScalarWhereInput;
};

export type Event_AreasUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_AreasWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_AreasCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_AreasCreateWithoutEventsInput>>;
  delete?: InputMaybe<Array<Event_AreasWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_AreasScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_AreasWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_AreasWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_AreasUpdateWithWhereUniqueWithoutEventsInput>>;
  updateMany?: InputMaybe<Array<Event_AreasUpdateManyWithWhereWithoutEventsInput>>;
  upsert?: InputMaybe<Array<Event_AreasUpsertWithWhereUniqueWithoutEventsInput>>;
};

export type Event_AreasUpdateWithWhereUniqueWithoutEventsInput = {
  data: Event_AreasUpdateWithoutEventsInput;
  where: Event_AreasWhereUniqueInput;
};

export type Event_AreasUpdateWithoutEventsInput = {
  area?: InputMaybe<Enumenum_Event_Areas_AreaFieldUpdateOperationsInput>;
  areas?: InputMaybe<AreasUpdateOneWithoutEvent_AreasInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_AreasUpsertWithWhereUniqueWithoutEventsInput = {
  create: Event_AreasCreateWithoutEventsInput;
  update: Event_AreasUpdateWithoutEventsInput;
  where: Event_AreasWhereUniqueInput;
};

export type Event_AreasWhereInput = {
  AND?: InputMaybe<Array<Event_AreasWhereInput>>;
  NOT?: InputMaybe<Array<Event_AreasWhereInput>>;
  OR?: InputMaybe<Array<Event_AreasWhereInput>>;
  area?: InputMaybe<Enumenum_Event_Areas_AreaFilter>;
  area_uuid?: InputMaybe<StringNullableFilter>;
  areas?: InputMaybe<AreasWhereInput>;
  created?: InputMaybe<DateTimeFilter>;
  event_id?: InputMaybe<StringFilter>;
  events?: InputMaybe<EventsWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_AreasWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Dates = {
  __typename?: 'event_dates';
  created: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  event_id: Scalars['String']['output'];
  state?: Maybe<Enum_Event_Dates_State>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type Event_DatesCreateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_DatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_DatesCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_DatesCreateWithoutEventsInput>>;
};

export type Event_DatesCreateOrConnectWithouteventsInput = {
  create: Event_DatesCreateWithoutEventsInput;
  where: Event_DatesWhereUniqueInput;
};

export type Event_DatesCreateWithoutEventsInput = {
  created: Scalars['DateTime']['input'];
  date: Scalars['DateTime']['input'];
  state?: InputMaybe<Enum_Event_Dates_State>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Event_DatesScalarWhereInput = {
  AND?: InputMaybe<Array<Event_DatesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_DatesScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_DatesScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  event_id?: InputMaybe<StringFilter>;
  state?: InputMaybe<Enumenum_Event_Dates_StateNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_DatesUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Event_Dates_StateFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_DatesUpdateManyWithWhereWithoutEventsInput = {
  data: Event_DatesUpdateManyMutationInput;
  where: Event_DatesScalarWhereInput;
};

export type Event_DatesUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_DatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_DatesCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_DatesCreateWithoutEventsInput>>;
  delete?: InputMaybe<Array<Event_DatesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_DatesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_DatesWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_DatesWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_DatesUpdateWithWhereUniqueWithoutEventsInput>>;
  updateMany?: InputMaybe<Array<Event_DatesUpdateManyWithWhereWithoutEventsInput>>;
  upsert?: InputMaybe<Array<Event_DatesUpsertWithWhereUniqueWithoutEventsInput>>;
};

export type Event_DatesUpdateWithWhereUniqueWithoutEventsInput = {
  data: Event_DatesUpdateWithoutEventsInput;
  where: Event_DatesWhereUniqueInput;
};

export type Event_DatesUpdateWithoutEventsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Event_Dates_StateFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_DatesUpsertWithWhereUniqueWithoutEventsInput = {
  create: Event_DatesCreateWithoutEventsInput;
  update: Event_DatesUpdateWithoutEventsInput;
  where: Event_DatesWhereUniqueInput;
};

export type Event_DatesWhereInput = {
  AND?: InputMaybe<Array<Event_DatesWhereInput>>;
  NOT?: InputMaybe<Array<Event_DatesWhereInput>>;
  OR?: InputMaybe<Array<Event_DatesWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  event_id?: InputMaybe<StringFilter>;
  events?: InputMaybe<EventsWhereInput>;
  state?: InputMaybe<Enumenum_Event_Dates_StateNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_DatesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Additional_InfoCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Additional_InfoCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput>>;
};

export type Event_Request_Additional_InfoCreateManyWithoutEvent_SetupsInput = {
  connect?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Additional_InfoCreateOrConnectWithoutevent_SetupsInput>>;
  create?: InputMaybe<Array<Event_Request_Additional_InfoCreateWithoutEvent_SetupsInput>>;
};

export type Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Event_Request_Additional_InfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_Request_Additional_InfoCreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput>;
};

export type Event_Request_Additional_InfoCreateOrConnectWithoutevent_RequestsInput = {
  create: Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput;
  where: Event_Request_Additional_InfoWhereUniqueInput;
};

export type Event_Request_Additional_InfoCreateOrConnectWithoutevent_SetupsInput = {
  create: Event_Request_Additional_InfoCreateWithoutEvent_SetupsInput;
  where: Event_Request_Additional_InfoWhereUniqueInput;
};

export type Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput = {
  bar_type?: InputMaybe<Enum_Event_Request_Additional_Info_Bar_Type>;
  children?: InputMaybe<Enum_Event_Request_Additional_Info_Children>;
  created: Scalars['DateTime']['input'];
  crockery?: InputMaybe<Enum_Event_Request_Additional_Info_Crockery>;
  event_setups?: InputMaybe<Event_SetupsCreateOneWithoutEvent_Request_Additional_InfoInput>;
  power?: InputMaybe<Enum_Event_Request_Additional_Info_Power>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
  waiters?: InputMaybe<Enum_Event_Request_Additional_Info_Waiters>;
  water?: InputMaybe<Enum_Event_Request_Additional_Info_Water>;
};

export type Event_Request_Additional_InfoCreateWithoutEvent_SetupsInput = {
  bar_type?: InputMaybe<Enum_Event_Request_Additional_Info_Bar_Type>;
  children?: InputMaybe<Enum_Event_Request_Additional_Info_Children>;
  created: Scalars['DateTime']['input'];
  crockery?: InputMaybe<Enum_Event_Request_Additional_Info_Crockery>;
  event_requests: Event_RequestsCreateOneWithoutEvent_Request_Additional_InfoInput;
  power?: InputMaybe<Enum_Event_Request_Additional_Info_Power>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
  waiters?: InputMaybe<Enum_Event_Request_Additional_Info_Waiters>;
  water?: InputMaybe<Enum_Event_Request_Additional_Info_Water>;
};

export type Event_Request_Additional_InfoScalarWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Additional_InfoScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Additional_InfoScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Additional_InfoScalarWhereInput>>;
  bar_type?: InputMaybe<Enumenum_Event_Request_Additional_Info_Bar_TypeNullableFilter>;
  children?: InputMaybe<Enumenum_Event_Request_Additional_Info_ChildrenNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  crockery?: InputMaybe<Enumenum_Event_Request_Additional_Info_CrockeryNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  event_setup_id?: InputMaybe<StringNullableFilter>;
  power?: InputMaybe<Enumenum_Event_Request_Additional_Info_PowerNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
  waiters?: InputMaybe<Enumenum_Event_Request_Additional_Info_WaitersNullableFilter>;
  water?: InputMaybe<Enumenum_Event_Request_Additional_Info_WaterNullableFilter>;
};

export type Event_Request_Additional_InfoUpdateManyMutationInput = {
  bar_type?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_Bar_TypeFieldUpdateOperationsInput>;
  children?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_ChildrenFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crockery?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_CrockeryFieldUpdateOperationsInput>;
  power?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_PowerFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  waiters?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_WaitersFieldUpdateOperationsInput>;
  water?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_WaterFieldUpdateOperationsInput>;
};

export type Event_Request_Additional_InfoUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: Event_Request_Additional_InfoUpdateManyMutationInput;
  where: Event_Request_Additional_InfoScalarWhereInput;
};

export type Event_Request_Additional_InfoUpdateManyWithWhereWithoutEvent_SetupsInput = {
  data: Event_Request_Additional_InfoUpdateManyMutationInput;
  where: Event_Request_Additional_InfoScalarWhereInput;
};

export type Event_Request_Additional_InfoUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Additional_InfoCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_Additional_InfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_Additional_InfoUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_Additional_InfoUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<Event_Request_Additional_InfoUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type Event_Request_Additional_InfoUpdateManyWithoutEvent_SetupsInput = {
  connect?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Additional_InfoCreateOrConnectWithoutevent_SetupsInput>>;
  create?: InputMaybe<Array<Event_Request_Additional_InfoCreateWithoutEvent_SetupsInput>>;
  delete?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_Additional_InfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_Additional_InfoWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_Additional_InfoUpdateWithWhereUniqueWithoutEvent_SetupsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_Additional_InfoUpdateManyWithWhereWithoutEvent_SetupsInput>>;
  upsert?: InputMaybe<Array<Event_Request_Additional_InfoUpsertWithWhereUniqueWithoutEvent_SetupsInput>>;
};

export type Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Event_Request_Additional_InfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_Request_Additional_InfoCreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Event_Request_Additional_InfoUpdateWithoutEvent_RequestsInput>;
  upsert?: InputMaybe<Event_Request_Additional_InfoUpsertWithoutEvent_RequestsInput>;
};

export type Event_Request_Additional_InfoUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: Event_Request_Additional_InfoUpdateWithoutEvent_RequestsInput;
  where: Event_Request_Additional_InfoWhereUniqueInput;
};

export type Event_Request_Additional_InfoUpdateWithWhereUniqueWithoutEvent_SetupsInput = {
  data: Event_Request_Additional_InfoUpdateWithoutEvent_SetupsInput;
  where: Event_Request_Additional_InfoWhereUniqueInput;
};

export type Event_Request_Additional_InfoUpdateWithoutEvent_RequestsInput = {
  bar_type?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_Bar_TypeFieldUpdateOperationsInput>;
  children?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_ChildrenFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crockery?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_CrockeryFieldUpdateOperationsInput>;
  event_setups?: InputMaybe<Event_SetupsUpdateOneWithoutEvent_Request_Additional_InfoInput>;
  power?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_PowerFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  waiters?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_WaitersFieldUpdateOperationsInput>;
  water?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_WaterFieldUpdateOperationsInput>;
};

export type Event_Request_Additional_InfoUpdateWithoutEvent_SetupsInput = {
  bar_type?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_Bar_TypeFieldUpdateOperationsInput>;
  children?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_ChildrenFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crockery?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_CrockeryFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneRequiredWithoutEvent_Request_Additional_InfoInput>;
  power?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_PowerFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  waiters?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_WaitersFieldUpdateOperationsInput>;
  water?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_WaterFieldUpdateOperationsInput>;
};

export type Event_Request_Additional_InfoUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput;
  update: Event_Request_Additional_InfoUpdateWithoutEvent_RequestsInput;
  where: Event_Request_Additional_InfoWhereUniqueInput;
};

export type Event_Request_Additional_InfoUpsertWithWhereUniqueWithoutEvent_SetupsInput = {
  create: Event_Request_Additional_InfoCreateWithoutEvent_SetupsInput;
  update: Event_Request_Additional_InfoUpdateWithoutEvent_SetupsInput;
  where: Event_Request_Additional_InfoWhereUniqueInput;
};

export type Event_Request_Additional_InfoUpsertWithoutEvent_RequestsInput = {
  create: Event_Request_Additional_InfoCreateWithoutEvent_RequestsInput;
  update: Event_Request_Additional_InfoUpdateWithoutEvent_RequestsInput;
};

export type Event_Request_Additional_InfoWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Additional_InfoWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Additional_InfoWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Additional_InfoWhereInput>>;
  bar_type?: InputMaybe<Enumenum_Event_Request_Additional_Info_Bar_TypeNullableFilter>;
  children?: InputMaybe<Enumenum_Event_Request_Additional_Info_ChildrenNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  crockery?: InputMaybe<Enumenum_Event_Request_Additional_Info_CrockeryNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  event_setup_id?: InputMaybe<StringNullableFilter>;
  event_setups?: InputMaybe<Event_SetupsWhereInput>;
  power?: InputMaybe<Enumenum_Event_Request_Additional_Info_PowerNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
  waiters?: InputMaybe<Enumenum_Event_Request_Additional_Info_WaitersNullableFilter>;
  water?: InputMaybe<Enumenum_Event_Request_Additional_Info_WaterNullableFilter>;
};

export type Event_Request_Additional_InfoWhereUniqueInput = {
  event_request_id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Additional_Info_CoursesCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_Additional_Info_CoursesCreateWithoutEvent_RequestsInput>>;
};

export type Event_Request_Additional_Info_CoursesCreateOrConnectWithoutevent_RequestsInput = {
  create: Event_Request_Additional_Info_CoursesCreateWithoutEvent_RequestsInput;
  where: Event_Request_Additional_Info_CoursesWhereUniqueInput;
};

export type Event_Request_Additional_Info_CoursesCreateWithoutEvent_RequestsInput = {
  course?: InputMaybe<Enum_Event_Request_Additional_Info_Courses_Course>;
  created: Scalars['DateTime']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Event_Request_Additional_Info_CoursesScalarWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Additional_Info_CoursesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Additional_Info_CoursesScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Additional_Info_CoursesScalarWhereInput>>;
  course?: InputMaybe<Enumenum_Event_Request_Additional_Info_Courses_CourseNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_Request_Additional_Info_CoursesUpdateManyMutationInput = {
  course?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_Courses_CourseFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_Additional_Info_CoursesUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: Event_Request_Additional_Info_CoursesUpdateManyMutationInput;
  where: Event_Request_Additional_Info_CoursesScalarWhereInput;
};

export type Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Additional_Info_CoursesCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_Additional_Info_CoursesCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_Additional_Info_CoursesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_Additional_Info_CoursesUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_Additional_Info_CoursesUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<Event_Request_Additional_Info_CoursesUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type Event_Request_Additional_Info_CoursesUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: Event_Request_Additional_Info_CoursesUpdateWithoutEvent_RequestsInput;
  where: Event_Request_Additional_Info_CoursesWhereUniqueInput;
};

export type Event_Request_Additional_Info_CoursesUpdateWithoutEvent_RequestsInput = {
  course?: InputMaybe<NullableEnumenum_Event_Request_Additional_Info_Courses_CourseFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_Additional_Info_CoursesUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: Event_Request_Additional_Info_CoursesCreateWithoutEvent_RequestsInput;
  update: Event_Request_Additional_Info_CoursesUpdateWithoutEvent_RequestsInput;
  where: Event_Request_Additional_Info_CoursesWhereUniqueInput;
};

export type Event_Request_Additional_Info_CoursesWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Additional_Info_CoursesWhereInput>>;
  course?: InputMaybe<Enumenum_Event_Request_Additional_Info_Courses_CourseNullableFilter>;
  created?: InputMaybe<DateTimeFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_Request_Additional_Info_CoursesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Image_Descriptions = {
  __typename?: 'event_request_image_descriptions';
  created: Scalars['DateTime']['output'];
  event_request_id: Scalars['String']['output'];
  event_request_uuid: Scalars['String']['output'];
  image_descriptions: Scalars['Json']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type Event_Request_Priority_TagsCreateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Event_Request_Priority_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Priority_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Event_Request_Priority_TagsCreateWithoutTagsInput>>;
};

export type Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Event_Request_Priority_TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_Request_Priority_TagsCreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<Event_Request_Priority_TagsCreateWithoutEvent_RequestsInput>;
};

export type Event_Request_Priority_TagsCreateOrConnectWithoutevent_RequestsInput = {
  create: Event_Request_Priority_TagsCreateWithoutEvent_RequestsInput;
  where: Event_Request_Priority_TagsWhereUniqueInput;
};

export type Event_Request_Priority_TagsCreateOrConnectWithouttagsInput = {
  create: Event_Request_Priority_TagsCreateWithoutTagsInput;
  where: Event_Request_Priority_TagsWhereUniqueInput;
};

export type Event_Request_Priority_TagsCreateWithoutEvent_RequestsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutEvent_Request_Priority_TagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Event_Request_Priority_TagsCreateWithoutTagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests: Event_RequestsCreateOneWithoutEvent_Request_Priority_TagsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Event_Request_Priority_TagsScalarWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Priority_TagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Priority_TagsScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Priority_TagsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  tag_id?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Event_Request_Priority_TagsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Event_Request_Priority_TagsUpdateManyWithWhereWithoutTagsInput = {
  data: Event_Request_Priority_TagsUpdateManyMutationInput;
  where: Event_Request_Priority_TagsScalarWhereInput;
};

export type Event_Request_Priority_TagsUpdateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Event_Request_Priority_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Priority_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Event_Request_Priority_TagsCreateWithoutTagsInput>>;
  delete?: InputMaybe<Array<Event_Request_Priority_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_Priority_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_Priority_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_Priority_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_Priority_TagsUpdateWithWhereUniqueWithoutTagsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_Priority_TagsUpdateManyWithWhereWithoutTagsInput>>;
  upsert?: InputMaybe<Array<Event_Request_Priority_TagsUpsertWithWhereUniqueWithoutTagsInput>>;
};

export type Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Event_Request_Priority_TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_Request_Priority_TagsCreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<Event_Request_Priority_TagsCreateWithoutEvent_RequestsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Event_Request_Priority_TagsUpdateWithoutEvent_RequestsInput>;
  upsert?: InputMaybe<Event_Request_Priority_TagsUpsertWithoutEvent_RequestsInput>;
};

export type Event_Request_Priority_TagsUpdateWithWhereUniqueWithoutTagsInput = {
  data: Event_Request_Priority_TagsUpdateWithoutTagsInput;
  where: Event_Request_Priority_TagsWhereUniqueInput;
};

export type Event_Request_Priority_TagsUpdateWithoutEvent_RequestsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutEvent_Request_Priority_TagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Event_Request_Priority_TagsUpdateWithoutTagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneRequiredWithoutEvent_Request_Priority_TagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Event_Request_Priority_TagsUpsertWithWhereUniqueWithoutTagsInput = {
  create: Event_Request_Priority_TagsCreateWithoutTagsInput;
  update: Event_Request_Priority_TagsUpdateWithoutTagsInput;
  where: Event_Request_Priority_TagsWhereUniqueInput;
};

export type Event_Request_Priority_TagsUpsertWithoutEvent_RequestsInput = {
  create: Event_Request_Priority_TagsCreateWithoutEvent_RequestsInput;
  update: Event_Request_Priority_TagsUpdateWithoutEvent_RequestsInput;
};

export type Event_Request_Priority_TagsWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Priority_TagsWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Priority_TagsWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Priority_TagsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  tag_id?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<TagsWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Event_Request_Priority_TagsWhereUniqueInput = {
  event_request_id?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Supplier_Notified = {
  __typename?: 'event_request_supplier_notified';
  created?: Maybe<Scalars['DateTime']['output']>;
  event_request_id?: Maybe<Scalars['String']['output']>;
  event_requests?: Maybe<Event_Requests>;
  matchingAdditionalData?: Maybe<Scalars['Json']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  percentage_match?: Maybe<Scalars['Float']['output']>;
  robex_metric_version?: Maybe<Scalars['String']['output']>;
  robex_package_version?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  suppliers?: Maybe<Suppliers>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateWithoutEvent_RequestsInput>>;
};

export type Event_Request_Supplier_NotifiedCreateManyWithoutRobex_VersionInput = {
  connect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateOrConnectWithoutrobex_VersionInput>>;
  create?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateWithoutRobex_VersionInput>>;
};

export type Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateWithoutSuppliersInput>>;
};

export type Event_Request_Supplier_NotifiedCreateOneWithoutRobex_NotificationsInput = {
  connect?: InputMaybe<Event_Request_Supplier_NotifiedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_Request_Supplier_NotifiedCreateOrConnectWithoutrobex_NotificationsInput>;
  create?: InputMaybe<Event_Request_Supplier_NotifiedCreateWithoutRobex_NotificationsInput>;
};

export type Event_Request_Supplier_NotifiedCreateOrConnectWithoutevent_RequestsInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutEvent_RequestsInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedCreateOrConnectWithoutrobex_NotificationsInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutRobex_NotificationsInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedCreateOrConnectWithoutrobex_VersionInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutRobex_VersionInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedCreateOrConnectWithoutsuppliersInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutSuppliersInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedCreateWithoutEvent_RequestsInput = {
  call_method?: InputMaybe<Enum_Event_Request_Supplier_Notified_Call_Method>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedCreatematch_MetricsInput>;
  method?: InputMaybe<Scalars['String']['input']>;
  percentage_match?: InputMaybe<Scalars['Float']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutEvent_Request_Supplier_NotifiedInput>;
  robex_package_version?: InputMaybe<Scalars['String']['input']>;
  robex_version?: InputMaybe<Robex_VersionCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Supplier_NotifiedCreateWithoutRobex_NotificationsInput = {
  call_method?: InputMaybe<Enum_Event_Request_Supplier_Notified_Call_Method>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedCreatematch_MetricsInput>;
  method?: InputMaybe<Scalars['String']['input']>;
  percentage_match?: InputMaybe<Scalars['Float']['input']>;
  robex_package_version?: InputMaybe<Scalars['String']['input']>;
  robex_version?: InputMaybe<Robex_VersionCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Supplier_NotifiedCreateWithoutRobex_VersionInput = {
  call_method?: InputMaybe<Enum_Event_Request_Supplier_Notified_Call_Method>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedCreatematch_MetricsInput>;
  method?: InputMaybe<Scalars['String']['input']>;
  percentage_match?: InputMaybe<Scalars['Float']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutEvent_Request_Supplier_NotifiedInput>;
  robex_package_version?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Supplier_NotifiedCreateWithoutSuppliersInput = {
  call_method?: InputMaybe<Enum_Event_Request_Supplier_Notified_Call_Method>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedCreatematch_MetricsInput>;
  method?: InputMaybe<Scalars['String']['input']>;
  percentage_match?: InputMaybe<Scalars['Float']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutEvent_Request_Supplier_NotifiedInput>;
  robex_package_version?: InputMaybe<Scalars['String']['input']>;
  robex_version?: InputMaybe<Robex_VersionCreateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Supplier_NotifiedCreatematch_MetricsInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type Event_Request_Supplier_NotifiedScalarWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Supplier_NotifiedScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Supplier_NotifiedScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Supplier_NotifiedScalarWhereInput>>;
  call_method?: InputMaybe<Enumenum_Event_Request_Supplier_Notified_Call_MethodNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  match_metrics?: InputMaybe<JsonNullableListFilter>;
  method?: InputMaybe<StringNullableFilter>;
  percentage_match?: InputMaybe<FloatNullableFilter>;
  robex_metric_version?: InputMaybe<StringNullableFilter>;
  robex_package_version?: InputMaybe<StringNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_Request_Supplier_NotifiedUpdateManyMutationInput = {
  call_method?: InputMaybe<NullableEnumenum_Event_Request_Supplier_Notified_Call_MethodFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedUpdatematch_MetricsInput>;
  method?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  percentage_match?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robex_package_version?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_Supplier_NotifiedUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: Event_Request_Supplier_NotifiedUpdateManyMutationInput;
  where: Event_Request_Supplier_NotifiedScalarWhereInput;
};

export type Event_Request_Supplier_NotifiedUpdateManyWithWhereWithoutRobex_VersionInput = {
  data: Event_Request_Supplier_NotifiedUpdateManyMutationInput;
  where: Event_Request_Supplier_NotifiedScalarWhereInput;
};

export type Event_Request_Supplier_NotifiedUpdateManyWithWhereWithoutSuppliersInput = {
  data: Event_Request_Supplier_NotifiedUpdateManyMutationInput;
  where: Event_Request_Supplier_NotifiedScalarWhereInput;
};

export type Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_Supplier_NotifiedScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type Event_Request_Supplier_NotifiedUpdateManyWithoutRobex_VersionInput = {
  connect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateOrConnectWithoutrobex_VersionInput>>;
  create?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateWithoutRobex_VersionInput>>;
  delete?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_Supplier_NotifiedScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpdateWithWhereUniqueWithoutRobex_VersionInput>>;
  updateMany?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpdateManyWithWhereWithoutRobex_VersionInput>>;
  upsert?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpsertWithWhereUniqueWithoutRobex_VersionInput>>;
};

export type Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Event_Request_Supplier_NotifiedCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_Supplier_NotifiedScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Event_Request_Supplier_NotifiedUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Event_Request_Supplier_NotifiedUpdateOneRequiredWithoutRobex_NotificationsInput = {
  connect?: InputMaybe<Event_Request_Supplier_NotifiedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_Request_Supplier_NotifiedCreateOrConnectWithoutrobex_NotificationsInput>;
  create?: InputMaybe<Event_Request_Supplier_NotifiedCreateWithoutRobex_NotificationsInput>;
  update?: InputMaybe<Event_Request_Supplier_NotifiedUpdateWithoutRobex_NotificationsInput>;
  upsert?: InputMaybe<Event_Request_Supplier_NotifiedUpsertWithoutRobex_NotificationsInput>;
};

export type Event_Request_Supplier_NotifiedUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: Event_Request_Supplier_NotifiedUpdateWithoutEvent_RequestsInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedUpdateWithWhereUniqueWithoutRobex_VersionInput = {
  data: Event_Request_Supplier_NotifiedUpdateWithoutRobex_VersionInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Event_Request_Supplier_NotifiedUpdateWithoutSuppliersInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedUpdateWithoutEvent_RequestsInput = {
  call_method?: InputMaybe<NullableEnumenum_Event_Request_Supplier_Notified_Call_MethodFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedUpdatematch_MetricsInput>;
  method?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  percentage_match?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutEvent_Request_Supplier_NotifiedInput>;
  robex_package_version?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_version?: InputMaybe<Robex_VersionUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_Supplier_NotifiedUpdateWithoutRobex_NotificationsInput = {
  call_method?: InputMaybe<NullableEnumenum_Event_Request_Supplier_Notified_Call_MethodFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedUpdatematch_MetricsInput>;
  method?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  percentage_match?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robex_package_version?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_version?: InputMaybe<Robex_VersionUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_Supplier_NotifiedUpdateWithoutRobex_VersionInput = {
  call_method?: InputMaybe<NullableEnumenum_Event_Request_Supplier_Notified_Call_MethodFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedUpdatematch_MetricsInput>;
  method?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  percentage_match?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutEvent_Request_Supplier_NotifiedInput>;
  robex_package_version?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_Supplier_NotifiedUpdateWithoutSuppliersInput = {
  call_method?: InputMaybe<NullableEnumenum_Event_Request_Supplier_Notified_Call_MethodFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  match_metrics?: InputMaybe<Event_Request_Supplier_NotifiedUpdatematch_MetricsInput>;
  method?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  percentage_match?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutEvent_Request_Supplier_NotifiedInput>;
  robex_package_version?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_version?: InputMaybe<Robex_VersionUpdateOneWithoutEvent_Request_Supplier_NotifiedInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_Supplier_NotifiedUpdatematch_MetricsInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type Event_Request_Supplier_NotifiedUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutEvent_RequestsInput;
  update: Event_Request_Supplier_NotifiedUpdateWithoutEvent_RequestsInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedUpsertWithWhereUniqueWithoutRobex_VersionInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutRobex_VersionInput;
  update: Event_Request_Supplier_NotifiedUpdateWithoutRobex_VersionInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutSuppliersInput;
  update: Event_Request_Supplier_NotifiedUpdateWithoutSuppliersInput;
  where: Event_Request_Supplier_NotifiedWhereUniqueInput;
};

export type Event_Request_Supplier_NotifiedUpsertWithoutRobex_NotificationsInput = {
  create: Event_Request_Supplier_NotifiedCreateWithoutRobex_NotificationsInput;
  update: Event_Request_Supplier_NotifiedUpdateWithoutRobex_NotificationsInput;
};

export type Event_Request_Supplier_NotifiedWhereInput = {
  AND?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_Supplier_NotifiedWhereInput>>;
  call_method?: InputMaybe<Enumenum_Event_Request_Supplier_Notified_Call_MethodNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  match_metrics?: InputMaybe<JsonNullableListFilter>;
  method?: InputMaybe<StringNullableFilter>;
  percentage_match?: InputMaybe<FloatNullableFilter>;
  robex_metric_version?: InputMaybe<StringNullableFilter>;
  robex_notifications?: InputMaybe<Robex_NotificationsListRelationFilter>;
  robex_package_version?: InputMaybe<StringNullableFilter>;
  robex_version?: InputMaybe<Robex_VersionWhereInput>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_Request_Supplier_NotifiedWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Request_Tags = {
  __typename?: 'event_request_tags';
  event_request_id?: Maybe<Scalars['String']['output']>;
  tags_event_request_tags_tag_uuidTotags?: Maybe<Tags>;
};

export type Event_Request_TagsCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_TagsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_TagsCreateWithoutEvent_RequestsInput>>;
};

export type Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_TagsCreateOrConnectWithouttags_Event_Request_Tags_Tag_IdTotagsInput>>;
  create?: InputMaybe<Array<Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>>;
};

export type Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_TagsCreateOrConnectWithouttags_Event_Request_Tags_Tag_UuidTotagsInput>>;
  create?: InputMaybe<Array<Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>>;
};

export type Event_Request_TagsCreateOrConnectWithoutevent_RequestsInput = {
  create: Event_Request_TagsCreateWithoutEvent_RequestsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsCreateOrConnectWithouttags_Event_Request_Tags_Tag_IdTotagsInput = {
  create: Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsCreateOrConnectWithouttags_Event_Request_Tags_Tag_UuidTotagsInput = {
  create: Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsCreateWithoutEvent_RequestsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  tags_event_request_tags_tag_idTotags?: InputMaybe<TagsCreateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  tags_event_request_tags_tag_uuidTotags?: InputMaybe<TagsCreateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutEvent_Request_TagsInput>;
  tags_event_request_tags_tag_uuidTotags?: InputMaybe<TagsCreateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutEvent_Request_TagsInput>;
  tags_event_request_tags_tag_idTotags?: InputMaybe<TagsCreateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_Request_TagsScalarWhereInput = {
  AND?: InputMaybe<Array<Event_Request_TagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_TagsScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_TagsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  tag_id?: InputMaybe<StringNullableFilter>;
  tag_uuid?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_Request_TagsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_TagsUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: Event_Request_TagsUpdateManyMutationInput;
  where: Event_Request_TagsScalarWhereInput;
};

export type Event_Request_TagsUpdateManyWithWhereWithoutTags_Event_Request_Tags_Tag_IdTotagsInput = {
  data: Event_Request_TagsUpdateManyMutationInput;
  where: Event_Request_TagsScalarWhereInput;
};

export type Event_Request_TagsUpdateManyWithWhereWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput = {
  data: Event_Request_TagsUpdateManyMutationInput;
  where: Event_Request_TagsScalarWhereInput;
};

export type Event_Request_TagsUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_TagsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Event_Request_TagsCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_TagsUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_TagsUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<Event_Request_TagsUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_TagsCreateOrConnectWithouttags_Event_Request_Tags_Tag_IdTotagsInput>>;
  create?: InputMaybe<Array<Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>>;
  delete?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_TagsUpdateWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_TagsUpdateManyWithWhereWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>>;
  upsert?: InputMaybe<Array<Event_Request_TagsUpsertWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>>;
};

export type Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_Request_TagsCreateOrConnectWithouttags_Event_Request_Tags_Tag_UuidTotagsInput>>;
  create?: InputMaybe<Array<Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>>;
  delete?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_Request_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_Request_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_Request_TagsUpdateWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>>;
  updateMany?: InputMaybe<Array<Event_Request_TagsUpdateManyWithWhereWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>>;
  upsert?: InputMaybe<Array<Event_Request_TagsUpsertWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>>;
};

export type Event_Request_TagsUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: Event_Request_TagsUpdateWithoutEvent_RequestsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsUpdateWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_IdTotagsInput = {
  data: Event_Request_TagsUpdateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsUpdateWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput = {
  data: Event_Request_TagsUpdateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsUpdateWithoutEvent_RequestsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tags_event_request_tags_tag_idTotags?: InputMaybe<TagsUpdateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  tags_event_request_tags_tag_uuidTotags?: InputMaybe<TagsUpdateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_TagsUpdateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutEvent_Request_TagsInput>;
  tags_event_request_tags_tag_uuidTotags?: InputMaybe<TagsUpdateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_TagsUpdateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutEvent_Request_TagsInput>;
  tags_event_request_tags_tag_idTotags?: InputMaybe<TagsUpdateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_Request_TagsUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: Event_Request_TagsCreateWithoutEvent_RequestsInput;
  update: Event_Request_TagsUpdateWithoutEvent_RequestsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsUpsertWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_IdTotagsInput = {
  create: Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput;
  update: Event_Request_TagsUpdateWithoutTags_Event_Request_Tags_Tag_IdTotagsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsUpsertWithWhereUniqueWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput = {
  create: Event_Request_TagsCreateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput;
  update: Event_Request_TagsUpdateWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput;
  where: Event_Request_TagsWhereUniqueInput;
};

export type Event_Request_TagsWhereInput = {
  AND?: InputMaybe<Array<Event_Request_TagsWhereInput>>;
  NOT?: InputMaybe<Array<Event_Request_TagsWhereInput>>;
  OR?: InputMaybe<Array<Event_Request_TagsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  tag_id?: InputMaybe<StringNullableFilter>;
  tag_uuid?: InputMaybe<StringNullableFilter>;
  tags_event_request_tags_tag_idTotags?: InputMaybe<TagsWhereInput>;
  tags_event_request_tags_tag_uuidTotags?: InputMaybe<TagsWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_Request_TagsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Requests = {
  __typename?: 'event_requests';
  accepting_quotes?: Maybe<Scalars['Boolean']['output']>;
  additional_info?: Maybe<Additional_Info>;
  admin_note?: Maybe<Scalars['String']['output']>;
  all_quotes_email_sent?: Maybe<Scalars['Boolean']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  budget_flexible?: Maybe<Scalars['Boolean']['output']>;
  categories_tier2?: Maybe<Categories_Tier2>;
  category_tier2?: Maybe<Scalars['String']['output']>;
  closeByUser?: Maybe<CloseByUser>;
  close_date?: Maybe<Scalars['DateTime']['output']>;
  close_reason?: Maybe<Scalars['String']['output']>;
  close_source?: Maybe<Scalars['String']['output']>;
  close_stage?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  conversations: Array<Conversations>;
  created?: Maybe<Scalars['DateTime']['output']>;
  declined_event_requests: Array<Declined_Event_Requests>;
  description?: Maybe<Scalars['String']['output']>;
  directRequests: Array<DirectRequest>;
  distance?: Maybe<Scalars['Float']['output']>;
  distanceSource?: Maybe<DistanceSource>;
  drivingDistanceEta?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['DateTime']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  event_request_supplier_notified: Array<Event_Request_Supplier_Notified>;
  event_request_tags: Array<Event_Request_Tags>;
  events?: Maybe<Events>;
  freshsales_id?: Maybe<Scalars['String']['output']>;
  freshsales_stage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incomplete_request_email_sent?: Maybe<Scalars['Boolean']['output']>;
  isHighValueLead?: Maybe<Scalars['Boolean']['output']>;
  isMatchedByMatchingService?: Maybe<Scalars['Boolean']['output']>;
  item_quantity?: Maybe<Scalars['Int']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  potential_suppliers?: Maybe<Scalars['Int']['output']>;
  preferredSuppliers: Array<Maybe<Suppliers>>;
  preferred_supplier_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preferred_suppliers: Array<Scalars['String']['output']>;
  priority_tag?: Maybe<Scalars['String']['output']>;
  quoteData?: Maybe<QuoteData>;
  quote_limited?: Maybe<Scalars['Boolean']['output']>;
  quote_limited_source?: Maybe<Enum_Event_Request_Quote_Limited_Source>;
  quotes: Array<Quotes>;
  recommendedSuppliers: Array<Maybe<Suppliers>>;
  salesforce_owner?: Maybe<SalesforceAccountManagerV2>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  sourceForm?: Maybe<Enum_Event_Request_Source_Form>;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  supplier_event_requests: Array<Supplier_Event_Requests>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};


export type Event_RequestsConversationsArgs = {
  cursor?: InputMaybe<ConversationsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConversationsWhereInput>;
};


export type Event_RequestsDeclined_Event_RequestsArgs = {
  cursor?: InputMaybe<Declined_Event_RequestsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type Event_RequestsDistanceArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};


export type Event_RequestsDistanceSourceArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};


export type Event_RequestsDrivingDistanceEtaArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};


export type Event_RequestsEvent_Request_Supplier_NotifiedArgs = {
  cursor?: InputMaybe<Event_Request_Supplier_NotifiedWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Event_Request_Supplier_NotifiedWhereInput>;
};


export type Event_RequestsEvent_Request_TagsArgs = {
  cursor?: InputMaybe<Event_Request_TagsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Event_Request_TagsWhereInput>;
};


export type Event_RequestsQuotesArgs = {
  cursor?: InputMaybe<QuotesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuotesWhereInput>;
};


export type Event_RequestsSupplier_Event_RequestsArgs = {
  cursor?: InputMaybe<Supplier_Event_RequestsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Event_RequestsCreateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_RequestsCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Event_RequestsCreateWithoutCategories_Tier2Input>>;
};

export type Event_RequestsCreateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_RequestsCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_RequestsCreateWithoutEventsInput>>;
};

export type Event_RequestsCreateOneWithoutConversationsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutconversationsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutConversationsInput>;
};

export type Event_RequestsCreateOneWithoutDeclined_Event_RequestsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutdeclined_Event_RequestsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutDeclined_Event_RequestsInput>;
};

export type Event_RequestsCreateOneWithoutEvent_Request_Additional_InfoInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_Additional_InfoInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_Additional_InfoInput>;
};

export type Event_RequestsCreateOneWithoutEvent_Request_Priority_TagsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_Priority_TagsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_Priority_TagsInput>;
};

export type Event_RequestsCreateOneWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_Supplier_NotifiedInput>;
};

export type Event_RequestsCreateOneWithoutEvent_Request_TagsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_TagsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_TagsInput>;
};

export type Event_RequestsCreateOneWithoutHidden_Event_RequestsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithouthidden_Event_RequestsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutHidden_Event_RequestsInput>;
};

export type Event_RequestsCreateOneWithoutQuotesInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutquotesInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutQuotesInput>;
};

export type Event_RequestsCreateOneWithoutSupplier_Event_RequestsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutsupplier_Event_RequestsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutSupplier_Event_RequestsInput>;
};

export type Event_RequestsCreateOrConnectWithoutcategories_Tier2Input = {
  create: Event_RequestsCreateWithoutCategories_Tier2Input;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutconversationsInput = {
  create: Event_RequestsCreateWithoutConversationsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutdeclined_Event_RequestsInput = {
  create: Event_RequestsCreateWithoutDeclined_Event_RequestsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutevent_Request_Additional_InfoInput = {
  create: Event_RequestsCreateWithoutEvent_Request_Additional_InfoInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutevent_Request_Priority_TagsInput = {
  create: Event_RequestsCreateWithoutEvent_Request_Priority_TagsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput = {
  create: Event_RequestsCreateWithoutEvent_Request_Supplier_NotifiedInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutevent_Request_TagsInput = {
  create: Event_RequestsCreateWithoutEvent_Request_TagsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithouteventsInput = {
  create: Event_RequestsCreateWithoutEventsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithouthidden_Event_RequestsInput = {
  create: Event_RequestsCreateWithoutHidden_Event_RequestsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutquotesInput = {
  create: Event_RequestsCreateWithoutQuotesInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateOrConnectWithoutsupplier_Event_RequestsInput = {
  create: Event_RequestsCreateWithoutSupplier_Event_RequestsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsCreateWithoutCategories_Tier2Input = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutConversationsInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutDeclined_Event_RequestsInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutEvent_Request_Additional_InfoInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutEvent_Request_Priority_TagsInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutEvent_Request_Supplier_NotifiedInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutEvent_Request_TagsInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutEventsInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutHidden_Event_RequestsInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutQuotesInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreateWithoutSupplier_Event_RequestsInput = {
  accepting_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  all_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  budget_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<Scalars['DateTime']['input']>;
  close_reason?: InputMaybe<Scalars['String']['input']>;
  close_source?: InputMaybe<Scalars['String']['input']>;
  close_stage?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesCreateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsCreateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsCreateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomplete_request_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  item_quantity?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  potential_suppliers?: InputMaybe<Scalars['Int']['input']>;
  preferred_suppliers?: InputMaybe<Event_RequestsCreatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesCreateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Event_RequestsCreatepreferred_SuppliersInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Event_RequestsOrderByInput = {
  accepting_quotes?: InputMaybe<SortOrder>;
  admin_note?: InputMaybe<SortOrder>;
  all_quotes_email_sent?: InputMaybe<SortOrder>;
  budget?: InputMaybe<SortOrder>;
  budget_flexible?: InputMaybe<SortOrder>;
  category_tier2?: InputMaybe<SortOrder>;
  close_date?: InputMaybe<SortOrder>;
  close_reason?: InputMaybe<SortOrder>;
  close_source?: InputMaybe<SortOrder>;
  close_stage?: InputMaybe<SortOrder>;
  completed?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  end_time?: InputMaybe<SortOrder>;
  event_id?: InputMaybe<SortOrder>;
  freshsales_id?: InputMaybe<SortOrder>;
  freshsales_stage?: InputMaybe<SortOrder>;
  gclid?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  incomplete_request_email_sent?: InputMaybe<SortOrder>;
  item_quantity?: InputMaybe<SortOrder>;
  open?: InputMaybe<SortOrder>;
  potential_suppliers?: InputMaybe<SortOrder>;
  preferred_suppliers?: InputMaybe<SortOrder>;
  start_time?: InputMaybe<SortOrder>;
  updated?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type Event_RequestsScalarWhereInput = {
  AND?: InputMaybe<Array<Event_RequestsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_RequestsScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_RequestsScalarWhereInput>>;
  accepting_quotes?: InputMaybe<BoolNullableFilter>;
  admin_note?: InputMaybe<StringNullableFilter>;
  all_quotes_email_sent?: InputMaybe<BoolNullableFilter>;
  budget?: InputMaybe<IntNullableFilter>;
  budget_flexible?: InputMaybe<BoolNullableFilter>;
  category_tier2?: InputMaybe<StringNullableFilter>;
  close_date?: InputMaybe<DateTimeNullableFilter>;
  close_reason?: InputMaybe<StringNullableFilter>;
  close_source?: InputMaybe<StringNullableFilter>;
  close_stage?: InputMaybe<StringNullableFilter>;
  completed?: InputMaybe<BoolNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  end_time?: InputMaybe<DateTimeNullableFilter>;
  event_id?: InputMaybe<StringNullableFilter>;
  freshsales_id?: InputMaybe<StringNullableFilter>;
  freshsales_stage?: InputMaybe<StringNullableFilter>;
  gclid?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringNullableFilter>;
  incomplete_request_email_sent?: InputMaybe<BoolNullableFilter>;
  item_quantity?: InputMaybe<IntNullableFilter>;
  open?: InputMaybe<BoolNullableFilter>;
  potential_suppliers?: InputMaybe<IntNullableFilter>;
  preferred_suppliers?: InputMaybe<StringNullableListFilter>;
  start_time?: InputMaybe<DateTimeNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_RequestsUpdateManyMutationInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateManyWithWhereWithoutCategories_Tier2Input = {
  data: Event_RequestsUpdateManyMutationInput;
  where: Event_RequestsScalarWhereInput;
};

export type Event_RequestsUpdateManyWithWhereWithoutEventsInput = {
  data: Event_RequestsUpdateManyMutationInput;
  where: Event_RequestsScalarWhereInput;
};

export type Event_RequestsUpdateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_RequestsCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Event_RequestsCreateWithoutCategories_Tier2Input>>;
  delete?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_RequestsUpdateWithWhereUniqueWithoutCategories_Tier2Input>>;
  updateMany?: InputMaybe<Array<Event_RequestsUpdateManyWithWhereWithoutCategories_Tier2Input>>;
  upsert?: InputMaybe<Array<Event_RequestsUpsertWithWhereUniqueWithoutCategories_Tier2Input>>;
};

export type Event_RequestsUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_RequestsCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_RequestsCreateWithoutEventsInput>>;
  delete?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_RequestsUpdateWithWhereUniqueWithoutEventsInput>>;
  updateMany?: InputMaybe<Array<Event_RequestsUpdateManyWithWhereWithoutEventsInput>>;
  upsert?: InputMaybe<Array<Event_RequestsUpsertWithWhereUniqueWithoutEventsInput>>;
};

export type Event_RequestsUpdateOneRequiredWithoutDeclined_Event_RequestsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutdeclined_Event_RequestsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutDeclined_Event_RequestsInput>;
  update?: InputMaybe<Event_RequestsUpdateWithoutDeclined_Event_RequestsInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutDeclined_Event_RequestsInput>;
};

export type Event_RequestsUpdateOneRequiredWithoutEvent_Request_Additional_InfoInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_Additional_InfoInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_Additional_InfoInput>;
  update?: InputMaybe<Event_RequestsUpdateWithoutEvent_Request_Additional_InfoInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutEvent_Request_Additional_InfoInput>;
};

export type Event_RequestsUpdateOneRequiredWithoutEvent_Request_Priority_TagsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_Priority_TagsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_Priority_TagsInput>;
  update?: InputMaybe<Event_RequestsUpdateWithoutEvent_Request_Priority_TagsInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutEvent_Request_Priority_TagsInput>;
};

export type Event_RequestsUpdateOneRequiredWithoutHidden_Event_RequestsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithouthidden_Event_RequestsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutHidden_Event_RequestsInput>;
  update?: InputMaybe<Event_RequestsUpdateWithoutHidden_Event_RequestsInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutHidden_Event_RequestsInput>;
};

export type Event_RequestsUpdateOneRequiredWithoutSupplier_Event_RequestsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutsupplier_Event_RequestsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutSupplier_Event_RequestsInput>;
  update?: InputMaybe<Event_RequestsUpdateWithoutSupplier_Event_RequestsInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutSupplier_Event_RequestsInput>;
};

export type Event_RequestsUpdateOneWithoutConversationsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutconversationsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutConversationsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Event_RequestsUpdateWithoutConversationsInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutConversationsInput>;
};

export type Event_RequestsUpdateOneWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_Supplier_NotifiedInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Event_RequestsUpdateWithoutEvent_Request_Supplier_NotifiedInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutEvent_Request_Supplier_NotifiedInput>;
};

export type Event_RequestsUpdateOneWithoutEvent_Request_TagsInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutevent_Request_TagsInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutEvent_Request_TagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Event_RequestsUpdateWithoutEvent_Request_TagsInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutEvent_Request_TagsInput>;
};

export type Event_RequestsUpdateOneWithoutQuotesInput = {
  connect?: InputMaybe<Event_RequestsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_RequestsCreateOrConnectWithoutquotesInput>;
  create?: InputMaybe<Event_RequestsCreateWithoutQuotesInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Event_RequestsUpdateWithoutQuotesInput>;
  upsert?: InputMaybe<Event_RequestsUpsertWithoutQuotesInput>;
};

export type Event_RequestsUpdateWithWhereUniqueWithoutCategories_Tier2Input = {
  data: Event_RequestsUpdateWithoutCategories_Tier2Input;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsUpdateWithWhereUniqueWithoutEventsInput = {
  data: Event_RequestsUpdateWithoutEventsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsUpdateWithoutCategories_Tier2Input = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutConversationsInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutDeclined_Event_RequestsInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutEvent_Request_Additional_InfoInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutEvent_Request_Priority_TagsInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutEvent_Request_Supplier_NotifiedInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutEvent_Request_TagsInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutEventsInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutHidden_Event_RequestsInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutQuotesInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdateWithoutSupplier_Event_RequestsInput = {
  accepting_quotes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  admin_note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  all_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  budget?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  budget_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutEvent_RequestsInput>;
  close_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  close_reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  close_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutEvent_RequestsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateOneWithoutEvent_RequestsInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesUpdateManyWithoutEvent_RequestsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateOneWithoutEvent_RequestsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutEvent_RequestsInput>;
  event_request_tags?: InputMaybe<Event_Request_TagsUpdateManyWithoutEvent_RequestsInput>;
  events?: InputMaybe<EventsUpdateOneWithoutEvent_RequestsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incomplete_request_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  item_quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  open?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  potential_suppliers?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  preferred_suppliers?: InputMaybe<Event_RequestsUpdatepreferred_SuppliersInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutEvent_RequestsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_RequestsUpdatepreferred_SuppliersInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Event_RequestsUpsertWithWhereUniqueWithoutCategories_Tier2Input = {
  create: Event_RequestsCreateWithoutCategories_Tier2Input;
  update: Event_RequestsUpdateWithoutCategories_Tier2Input;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsUpsertWithWhereUniqueWithoutEventsInput = {
  create: Event_RequestsCreateWithoutEventsInput;
  update: Event_RequestsUpdateWithoutEventsInput;
  where: Event_RequestsWhereUniqueInput;
};

export type Event_RequestsUpsertWithoutConversationsInput = {
  create: Event_RequestsCreateWithoutConversationsInput;
  update: Event_RequestsUpdateWithoutConversationsInput;
};

export type Event_RequestsUpsertWithoutDeclined_Event_RequestsInput = {
  create: Event_RequestsCreateWithoutDeclined_Event_RequestsInput;
  update: Event_RequestsUpdateWithoutDeclined_Event_RequestsInput;
};

export type Event_RequestsUpsertWithoutEvent_Request_Additional_InfoInput = {
  create: Event_RequestsCreateWithoutEvent_Request_Additional_InfoInput;
  update: Event_RequestsUpdateWithoutEvent_Request_Additional_InfoInput;
};

export type Event_RequestsUpsertWithoutEvent_Request_Priority_TagsInput = {
  create: Event_RequestsCreateWithoutEvent_Request_Priority_TagsInput;
  update: Event_RequestsUpdateWithoutEvent_Request_Priority_TagsInput;
};

export type Event_RequestsUpsertWithoutEvent_Request_Supplier_NotifiedInput = {
  create: Event_RequestsCreateWithoutEvent_Request_Supplier_NotifiedInput;
  update: Event_RequestsUpdateWithoutEvent_Request_Supplier_NotifiedInput;
};

export type Event_RequestsUpsertWithoutEvent_Request_TagsInput = {
  create: Event_RequestsCreateWithoutEvent_Request_TagsInput;
  update: Event_RequestsUpdateWithoutEvent_Request_TagsInput;
};

export type Event_RequestsUpsertWithoutHidden_Event_RequestsInput = {
  create: Event_RequestsCreateWithoutHidden_Event_RequestsInput;
  update: Event_RequestsUpdateWithoutHidden_Event_RequestsInput;
};

export type Event_RequestsUpsertWithoutQuotesInput = {
  create: Event_RequestsCreateWithoutQuotesInput;
  update: Event_RequestsUpdateWithoutQuotesInput;
};

export type Event_RequestsUpsertWithoutSupplier_Event_RequestsInput = {
  create: Event_RequestsCreateWithoutSupplier_Event_RequestsInput;
  update: Event_RequestsUpdateWithoutSupplier_Event_RequestsInput;
};

export type Event_RequestsWhereInput = {
  AND?: InputMaybe<Array<Event_RequestsWhereInput>>;
  NOT?: InputMaybe<Array<Event_RequestsWhereInput>>;
  OR?: InputMaybe<Array<Event_RequestsWhereInput>>;
  accepting_quotes?: InputMaybe<BoolNullableFilter>;
  admin_note?: InputMaybe<StringNullableFilter>;
  all_quotes_email_sent?: InputMaybe<BoolNullableFilter>;
  budget?: InputMaybe<IntNullableFilter>;
  budget_flexible?: InputMaybe<BoolNullableFilter>;
  categories_tier2?: InputMaybe<Categories_Tier2WhereInput>;
  category_tier2?: InputMaybe<StringNullableFilter>;
  close_date?: InputMaybe<DateTimeNullableFilter>;
  close_reason?: InputMaybe<StringNullableFilter>;
  close_source?: InputMaybe<StringNullableFilter>;
  close_stage?: InputMaybe<StringNullableFilter>;
  completed?: InputMaybe<BoolNullableFilter>;
  conversations?: InputMaybe<ConversationsListRelationFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  end_time?: InputMaybe<DateTimeNullableFilter>;
  event_id?: InputMaybe<StringNullableFilter>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoWhereInput>;
  event_request_additional_info_courses?: InputMaybe<Event_Request_Additional_Info_CoursesListRelationFilter>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsWhereInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedListRelationFilter>;
  event_request_tags?: InputMaybe<Event_Request_TagsListRelationFilter>;
  events?: InputMaybe<EventsWhereInput>;
  freshsales_id?: InputMaybe<StringNullableFilter>;
  freshsales_stage?: InputMaybe<StringNullableFilter>;
  gclid?: InputMaybe<StringNullableFilter>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsListRelationFilter>;
  id?: InputMaybe<StringNullableFilter>;
  incomplete_request_email_sent?: InputMaybe<BoolNullableFilter>;
  item_quantity?: InputMaybe<IntNullableFilter>;
  msclkid?: InputMaybe<StringNullableFilter>;
  open?: InputMaybe<BoolNullableFilter>;
  potential_suppliers?: InputMaybe<IntNullableFilter>;
  preferred_suppliers?: InputMaybe<StringNullableListFilter>;
  quotes?: InputMaybe<QuotesListRelationFilter>;
  start_time?: InputMaybe<DateTimeNullableFilter>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsListRelationFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_RequestsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_SetupsCreateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Event_SetupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_SetupsCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Event_SetupsCreateWithoutCategories_Tier2Input>>;
};

export type Event_SetupsCreateOneWithoutEvent_Request_Additional_InfoInput = {
  connect?: InputMaybe<Event_SetupsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_SetupsCreateOrConnectWithoutevent_Request_Additional_InfoInput>;
  create?: InputMaybe<Event_SetupsCreateWithoutEvent_Request_Additional_InfoInput>;
};

export type Event_SetupsCreateOrConnectWithoutcategories_Tier2Input = {
  create: Event_SetupsCreateWithoutCategories_Tier2Input;
  where: Event_SetupsWhereUniqueInput;
};

export type Event_SetupsCreateOrConnectWithoutevent_Request_Additional_InfoInput = {
  create: Event_SetupsCreateWithoutEvent_Request_Additional_InfoInput;
  where: Event_SetupsWhereUniqueInput;
};

export type Event_SetupsCreateWithoutCategories_Tier2Input = {
  created: Scalars['DateTime']['input'];
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoCreateManyWithoutEvent_SetupsInput>;
  name: Scalars['String']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Event_SetupsCreateWithoutEvent_Request_Additional_InfoInput = {
  categories_tier2: Categories_Tier2CreateOneWithoutEvent_SetupsInput;
  created: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Event_SetupsScalarWhereInput = {
  AND?: InputMaybe<Array<Event_SetupsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_SetupsScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_SetupsScalarWhereInput>>;
  category_tier2?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_SetupsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_SetupsUpdateManyWithWhereWithoutCategories_Tier2Input = {
  data: Event_SetupsUpdateManyMutationInput;
  where: Event_SetupsScalarWhereInput;
};

export type Event_SetupsUpdateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Event_SetupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_SetupsCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Event_SetupsCreateWithoutCategories_Tier2Input>>;
  delete?: InputMaybe<Array<Event_SetupsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_SetupsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_SetupsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_SetupsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_SetupsUpdateWithWhereUniqueWithoutCategories_Tier2Input>>;
  updateMany?: InputMaybe<Array<Event_SetupsUpdateManyWithWhereWithoutCategories_Tier2Input>>;
  upsert?: InputMaybe<Array<Event_SetupsUpsertWithWhereUniqueWithoutCategories_Tier2Input>>;
};

export type Event_SetupsUpdateOneWithoutEvent_Request_Additional_InfoInput = {
  connect?: InputMaybe<Event_SetupsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Event_SetupsCreateOrConnectWithoutevent_Request_Additional_InfoInput>;
  create?: InputMaybe<Event_SetupsCreateWithoutEvent_Request_Additional_InfoInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Event_SetupsUpdateWithoutEvent_Request_Additional_InfoInput>;
  upsert?: InputMaybe<Event_SetupsUpsertWithoutEvent_Request_Additional_InfoInput>;
};

export type Event_SetupsUpdateWithWhereUniqueWithoutCategories_Tier2Input = {
  data: Event_SetupsUpdateWithoutCategories_Tier2Input;
  where: Event_SetupsWhereUniqueInput;
};

export type Event_SetupsUpdateWithoutCategories_Tier2Input = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoUpdateManyWithoutEvent_SetupsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_SetupsUpdateWithoutEvent_Request_Additional_InfoInput = {
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneRequiredWithoutEvent_SetupsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Event_SetupsUpsertWithWhereUniqueWithoutCategories_Tier2Input = {
  create: Event_SetupsCreateWithoutCategories_Tier2Input;
  update: Event_SetupsUpdateWithoutCategories_Tier2Input;
  where: Event_SetupsWhereUniqueInput;
};

export type Event_SetupsUpsertWithoutEvent_Request_Additional_InfoInput = {
  create: Event_SetupsCreateWithoutEvent_Request_Additional_InfoInput;
  update: Event_SetupsUpdateWithoutEvent_Request_Additional_InfoInput;
};

export type Event_SetupsWhereInput = {
  AND?: InputMaybe<Array<Event_SetupsWhereInput>>;
  NOT?: InputMaybe<Array<Event_SetupsWhereInput>>;
  OR?: InputMaybe<Array<Event_SetupsWhereInput>>;
  categories_tier2?: InputMaybe<Categories_Tier2WhereInput>;
  category_tier2?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  event_request_additional_info?: InputMaybe<Event_Request_Additional_InfoListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Event_SetupsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Tags = {
  __typename?: 'event_tags';
  created?: Maybe<Scalars['DateTime']['output']>;
  event_id: Scalars['String']['output'];
  tag_uuid: Scalars['String']['output'];
  tags: Tags;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type Event_TagsCreateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_TagsCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_TagsCreateWithoutEventsInput>>;
};

export type Event_TagsCreateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Event_TagsCreateWithoutTagsInput>>;
};

export type Event_TagsCreateOrConnectWithouteventsInput = {
  create: Event_TagsCreateWithoutEventsInput;
  where: Event_TagsWhereUniqueInput;
};

export type Event_TagsCreateOrConnectWithouttagsInput = {
  create: Event_TagsCreateWithoutTagsInput;
  where: Event_TagsWhereUniqueInput;
};

export type Event_TagsCreateWithoutEventsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  tags: TagsCreateOneWithoutEvent_TagsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Event_TagsCreateWithoutTagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  events: EventsCreateOneWithoutEvent_TagsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Event_TagsEvent_IdTag_UuidCompoundUniqueInput = {
  event_id: Scalars['String']['input'];
  tag_uuid: Scalars['String']['input'];
};

export type Event_TagsScalarWhereInput = {
  AND?: InputMaybe<Array<Event_TagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Event_TagsScalarWhereInput>>;
  OR?: InputMaybe<Array<Event_TagsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_id?: InputMaybe<StringFilter>;
  tag_uuid?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Event_TagsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Event_TagsUpdateManyWithWhereWithoutEventsInput = {
  data: Event_TagsUpdateManyMutationInput;
  where: Event_TagsScalarWhereInput;
};

export type Event_TagsUpdateManyWithWhereWithoutTagsInput = {
  data: Event_TagsUpdateManyMutationInput;
  where: Event_TagsScalarWhereInput;
};

export type Event_TagsUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_TagsCreateOrConnectWithouteventsInput>>;
  create?: InputMaybe<Array<Event_TagsCreateWithoutEventsInput>>;
  delete?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_TagsUpdateWithWhereUniqueWithoutEventsInput>>;
  updateMany?: InputMaybe<Array<Event_TagsUpdateManyWithWhereWithoutEventsInput>>;
  upsert?: InputMaybe<Array<Event_TagsUpsertWithWhereUniqueWithoutEventsInput>>;
};

export type Event_TagsUpdateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Event_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Event_TagsCreateWithoutTagsInput>>;
  delete?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Event_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Event_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Event_TagsUpdateWithWhereUniqueWithoutTagsInput>>;
  updateMany?: InputMaybe<Array<Event_TagsUpdateManyWithWhereWithoutTagsInput>>;
  upsert?: InputMaybe<Array<Event_TagsUpsertWithWhereUniqueWithoutTagsInput>>;
};

export type Event_TagsUpdateWithWhereUniqueWithoutEventsInput = {
  data: Event_TagsUpdateWithoutEventsInput;
  where: Event_TagsWhereUniqueInput;
};

export type Event_TagsUpdateWithWhereUniqueWithoutTagsInput = {
  data: Event_TagsUpdateWithoutTagsInput;
  where: Event_TagsWhereUniqueInput;
};

export type Event_TagsUpdateWithoutEventsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneRequiredWithoutEvent_TagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Event_TagsUpdateWithoutTagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateOneRequiredWithoutEvent_TagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Event_TagsUpsertWithWhereUniqueWithoutEventsInput = {
  create: Event_TagsCreateWithoutEventsInput;
  update: Event_TagsUpdateWithoutEventsInput;
  where: Event_TagsWhereUniqueInput;
};

export type Event_TagsUpsertWithWhereUniqueWithoutTagsInput = {
  create: Event_TagsCreateWithoutTagsInput;
  update: Event_TagsUpdateWithoutTagsInput;
  where: Event_TagsWhereUniqueInput;
};

export type Event_TagsWhereInput = {
  AND?: InputMaybe<Array<Event_TagsWhereInput>>;
  NOT?: InputMaybe<Array<Event_TagsWhereInput>>;
  OR?: InputMaybe<Array<Event_TagsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_id?: InputMaybe<StringFilter>;
  events?: InputMaybe<EventsWhereInput>;
  tag_uuid?: InputMaybe<StringFilter>;
  tags?: InputMaybe<TagsWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Event_TagsWhereUniqueInput = {
  event_id_tag_uuid?: InputMaybe<Event_TagsEvent_IdTag_UuidCompoundUniqueInput>;
};

export enum Event_Type {
  Birthday = 'birthday',
  Celebration = 'celebration',
  CorporateEvent = 'corporate_event',
  DinnerParty = 'dinner_party',
  PublicFacingEvent = 'public_facing_event',
  Virtual = 'virtual',
  Wedding = 'wedding'
}

export type Events = {
  __typename?: 'events';
  accountManagerName?: Maybe<Scalars['String']['output']>;
  approximate_location?: Maybe<Scalars['Boolean']['output']>;
  attributionData?: Maybe<AttributionData>;
  attribution_data_id?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<EventCancelReason>;
  coordinates?: Maybe<Scalars['Json']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  custom_event_name?: Maybe<Scalars['String']['output']>;
  customer_referral?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  dateFlexibilityNotes?: Maybe<Scalars['String']['output']>;
  date_flexible?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  event_areas: Array<Event_Areas>;
  event_dates: Array<Event_Dates>;
  event_requests: Array<Event_Requests>;
  event_tags: Array<Event_Tags>;
  freshsales_id?: Maybe<Scalars['String']['output']>;
  freshsales_stage?: Maybe<Scalars['String']['output']>;
  high_demand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isPartnerBooked?: Maybe<Scalars['Boolean']['output']>;
  lead_time?: Maybe<Scalars['Int']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_line_1?: Maybe<Scalars['String']['output']>;
  location_line_2?: Maybe<Scalars['String']['output']>;
  location_notes?: Maybe<Scalars['String']['output']>;
  partnership?: Maybe<Scalars['Boolean']['output']>;
  partnership_id?: Maybe<Scalars['String']['output']>;
  partnerships?: Maybe<Partnership>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_prefix?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Regions>;
  salesforceEvent?: Maybe<SalesforceEvent>;
  source?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  state?: Maybe<EventState>;
  supplier_referral?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unread_quotes_email_sent?: Maybe<Scalars['Boolean']['output']>;
  upcoming_event_reminder_sent?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  urgency?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
  users: Users;
  uuid: Scalars['String']['output'];
};


export type EventsEvent_AreasArgs = {
  cursor?: InputMaybe<Event_AreasWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type EventsEvent_RequestsArgs = {
  cursor?: InputMaybe<Event_RequestsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type EventsEvent_TagsArgs = {
  cursor?: InputMaybe<Event_TagsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EventsCreateManyWithoutAttribution_DataInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutattribution_DataInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutAttribution_DataInput>>;
};

export type EventsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutSuppliersInput>>;
};

export type EventsCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutUsersInput>>;
};

export type EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutusers_Events_Customer_ReferralTousersInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutUsers_Events_Customer_ReferralTousersInput>>;
};

export type EventsCreateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<EventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventsCreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<EventsCreateWithoutEvent_RequestsInput>;
};

export type EventsCreateOneWithoutEvent_TagsInput = {
  connect?: InputMaybe<EventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventsCreateOrConnectWithoutevent_TagsInput>;
  create?: InputMaybe<EventsCreateWithoutEvent_TagsInput>;
};

export type EventsCreateOrConnectWithoutattribution_DataInput = {
  create: EventsCreateWithoutAttribution_DataInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutevent_RequestsInput = {
  create: EventsCreateWithoutEvent_RequestsInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutevent_TagsInput = {
  create: EventsCreateWithoutEvent_TagsInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutsuppliersInput = {
  create: EventsCreateWithoutSuppliersInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutusersInput = {
  create: EventsCreateWithoutUsersInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutusers_Events_Customer_ReferralTousersInput = {
  create: EventsCreateWithoutUsers_Events_Customer_ReferralTousersInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateWithoutAttribution_DataInput = {
  approximate_location?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  custom_event_name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  event_areas?: InputMaybe<Event_AreasCreateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesCreateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  high_demand?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  lead_time?: InputMaybe<Scalars['Int']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  location_notes?: InputMaybe<Scalars['String']['input']>;
  messages_reminder_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerships?: InputMaybe<PartnershipsCreateOneWithoutEventsInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<RegionsCreateOneWithoutEventsInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEventsInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  unread_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming_event_reminder_sent?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  users: UsersCreateOneWithoutEventsInput;
  users_events_customer_referralTousers?: InputMaybe<UsersCreateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid: Scalars['String']['input'];
};

export type EventsCreateWithoutEvent_RequestsInput = {
  approximate_location?: InputMaybe<Scalars['Boolean']['input']>;
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  custom_event_name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  event_areas?: InputMaybe<Event_AreasCreateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesCreateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  high_demand?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  lead_time?: InputMaybe<Scalars['Int']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  location_notes?: InputMaybe<Scalars['String']['input']>;
  messages_reminder_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerships?: InputMaybe<PartnershipsCreateOneWithoutEventsInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<RegionsCreateOneWithoutEventsInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEventsInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  unread_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming_event_reminder_sent?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  users: UsersCreateOneWithoutEventsInput;
  users_events_customer_referralTousers?: InputMaybe<UsersCreateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid: Scalars['String']['input'];
};

export type EventsCreateWithoutEvent_TagsInput = {
  approximate_location?: InputMaybe<Scalars['Boolean']['input']>;
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  custom_event_name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  event_areas?: InputMaybe<Event_AreasCreateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesCreateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  high_demand?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  lead_time?: InputMaybe<Scalars['Int']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  location_notes?: InputMaybe<Scalars['String']['input']>;
  messages_reminder_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerships?: InputMaybe<PartnershipsCreateOneWithoutEventsInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<RegionsCreateOneWithoutEventsInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEventsInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  unread_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming_event_reminder_sent?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  users: UsersCreateOneWithoutEventsInput;
  users_events_customer_referralTousers?: InputMaybe<UsersCreateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid: Scalars['String']['input'];
};

export type EventsCreateWithoutSuppliersInput = {
  approximate_location?: InputMaybe<Scalars['Boolean']['input']>;
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  custom_event_name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  event_areas?: InputMaybe<Event_AreasCreateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesCreateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  high_demand?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  lead_time?: InputMaybe<Scalars['Int']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  location_notes?: InputMaybe<Scalars['String']['input']>;
  messages_reminder_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerships?: InputMaybe<PartnershipsCreateOneWithoutEventsInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<RegionsCreateOneWithoutEventsInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unread_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming_event_reminder_sent?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  users: UsersCreateOneWithoutEventsInput;
  users_events_customer_referralTousers?: InputMaybe<UsersCreateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid: Scalars['String']['input'];
};

export type EventsCreateWithoutUsersInput = {
  approximate_location?: InputMaybe<Scalars['Boolean']['input']>;
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  custom_event_name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  event_areas?: InputMaybe<Event_AreasCreateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesCreateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  high_demand?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  lead_time?: InputMaybe<Scalars['Int']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  location_notes?: InputMaybe<Scalars['String']['input']>;
  messages_reminder_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerships?: InputMaybe<PartnershipsCreateOneWithoutEventsInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<RegionsCreateOneWithoutEventsInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEventsInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  unread_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming_event_reminder_sent?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  users_events_customer_referralTousers?: InputMaybe<UsersCreateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid: Scalars['String']['input'];
};

export type EventsCreateWithoutUsers_Events_Customer_ReferralTousersInput = {
  approximate_location?: InputMaybe<Scalars['Boolean']['input']>;
  attribution_data?: InputMaybe<Attribution_DataCreateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  custom_event_name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_flexible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  event_areas?: InputMaybe<Event_AreasCreateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesCreateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsCreateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  high_demand?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  lead_time?: InputMaybe<Scalars['Int']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  location_notes?: InputMaybe<Scalars['String']['input']>;
  messages_reminder_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  partnership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerships?: InputMaybe<PartnershipsCreateOneWithoutEventsInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<RegionsCreateOneWithoutEventsInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutEventsInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  unread_quotes_email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming_event_reminder_sent?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  users: UsersCreateOneWithoutEventsInput;
  uuid: Scalars['String']['input'];
};

export type EventsScalarWhereInput = {
  AND?: InputMaybe<Array<EventsScalarWhereInput>>;
  NOT?: InputMaybe<Array<EventsScalarWhereInput>>;
  OR?: InputMaybe<Array<EventsScalarWhereInput>>;
  approximate_location?: InputMaybe<BoolNullableFilter>;
  attribution_data_id?: InputMaybe<StringNullableFilter>;
  coordinates?: InputMaybe<JsonNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  custom_event_name?: InputMaybe<StringNullableFilter>;
  customer_referral?: InputMaybe<StringNullableFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  date_flexible?: InputMaybe<BoolNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  end_time?: InputMaybe<StringNullableFilter>;
  freshsales_id?: InputMaybe<StringNullableFilter>;
  freshsales_stage?: InputMaybe<StringNullableFilter>;
  high_demand?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lead_time?: InputMaybe<IntNullableFilter>;
  location_city?: InputMaybe<StringNullableFilter>;
  location_line_1?: InputMaybe<StringNullableFilter>;
  location_line_2?: InputMaybe<StringNullableFilter>;
  location_notes?: InputMaybe<StringNullableFilter>;
  messages_reminder_email_sent?: InputMaybe<BoolFilter>;
  partnership?: InputMaybe<BoolNullableFilter>;
  partnership_id?: InputMaybe<StringNullableFilter>;
  postcode?: InputMaybe<StringNullableFilter>;
  postcode_prefix?: InputMaybe<StringNullableFilter>;
  source?: InputMaybe<StringNullableFilter>;
  start_time?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  supplier_referral?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  unread_quotes_email_sent?: InputMaybe<BoolNullableFilter>;
  upcoming_event_reminder_sent?: InputMaybe<BoolNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  urgency?: InputMaybe<StringNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type EventsUpdateManyMutationInput = {
  approximate_location?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  custom_event_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  high_demand?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lead_time?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messages_reminder_email_sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partnership?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unread_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  upcoming_event_reminder_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  urgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateManyWithWhereWithoutAttribution_DataInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutSuppliersInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutUsersInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutUsers_Events_Customer_ReferralTousersInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithoutAttribution_DataInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutattribution_DataInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutAttribution_DataInput>>;
  delete?: InputMaybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  set?: InputMaybe<Array<EventsWhereUniqueInput>>;
  update?: InputMaybe<Array<EventsUpdateWithWhereUniqueWithoutAttribution_DataInput>>;
  updateMany?: InputMaybe<Array<EventsUpdateManyWithWhereWithoutAttribution_DataInput>>;
  upsert?: InputMaybe<Array<EventsUpsertWithWhereUniqueWithoutAttribution_DataInput>>;
};

export type EventsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  set?: InputMaybe<Array<EventsWhereUniqueInput>>;
  update?: InputMaybe<Array<EventsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<EventsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<EventsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type EventsUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  set?: InputMaybe<Array<EventsWhereUniqueInput>>;
  update?: InputMaybe<Array<EventsUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<EventsUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<EventsUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput = {
  connect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EventsCreateOrConnectWithoutusers_Events_Customer_ReferralTousersInput>>;
  create?: InputMaybe<Array<EventsCreateWithoutUsers_Events_Customer_ReferralTousersInput>>;
  delete?: InputMaybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EventsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EventsWhereUniqueInput>>;
  set?: InputMaybe<Array<EventsWhereUniqueInput>>;
  update?: InputMaybe<Array<EventsUpdateWithWhereUniqueWithoutUsers_Events_Customer_ReferralTousersInput>>;
  updateMany?: InputMaybe<Array<EventsUpdateManyWithWhereWithoutUsers_Events_Customer_ReferralTousersInput>>;
  upsert?: InputMaybe<Array<EventsUpsertWithWhereUniqueWithoutUsers_Events_Customer_ReferralTousersInput>>;
};

export type EventsUpdateOneRequiredWithoutEvent_TagsInput = {
  connect?: InputMaybe<EventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventsCreateOrConnectWithoutevent_TagsInput>;
  create?: InputMaybe<EventsCreateWithoutEvent_TagsInput>;
  update?: InputMaybe<EventsUpdateWithoutEvent_TagsInput>;
  upsert?: InputMaybe<EventsUpsertWithoutEvent_TagsInput>;
};

export type EventsUpdateOneWithoutEvent_RequestsInput = {
  connect?: InputMaybe<EventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventsCreateOrConnectWithoutevent_RequestsInput>;
  create?: InputMaybe<EventsCreateWithoutEvent_RequestsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<EventsUpdateWithoutEvent_RequestsInput>;
  upsert?: InputMaybe<EventsUpsertWithoutEvent_RequestsInput>;
};

export type EventsUpdateWithWhereUniqueWithoutAttribution_DataInput = {
  data: EventsUpdateWithoutAttribution_DataInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: EventsUpdateWithoutSuppliersInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutUsersInput = {
  data: EventsUpdateWithoutUsersInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutUsers_Events_Customer_ReferralTousersInput = {
  data: EventsUpdateWithoutUsers_Events_Customer_ReferralTousersInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithoutAttribution_DataInput = {
  approximate_location?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  custom_event_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event_areas?: InputMaybe<Event_AreasUpdateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesUpdateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  high_demand?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lead_time?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messages_reminder_email_sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partnership?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnerships?: InputMaybe<PartnershipsUpdateOneWithoutEventsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regions?: InputMaybe<RegionsUpdateOneWithoutEventsInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEventsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unread_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  upcoming_event_reminder_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  urgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutEventsInput>;
  users_events_customer_referralTousers?: InputMaybe<UsersUpdateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutEvent_RequestsInput = {
  approximate_location?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  custom_event_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event_areas?: InputMaybe<Event_AreasUpdateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesUpdateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  high_demand?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lead_time?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messages_reminder_email_sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partnership?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnerships?: InputMaybe<PartnershipsUpdateOneWithoutEventsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regions?: InputMaybe<RegionsUpdateOneWithoutEventsInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEventsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unread_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  upcoming_event_reminder_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  urgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutEventsInput>;
  users_events_customer_referralTousers?: InputMaybe<UsersUpdateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutEvent_TagsInput = {
  approximate_location?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  custom_event_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event_areas?: InputMaybe<Event_AreasUpdateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesUpdateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  high_demand?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lead_time?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messages_reminder_email_sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partnership?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnerships?: InputMaybe<PartnershipsUpdateOneWithoutEventsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regions?: InputMaybe<RegionsUpdateOneWithoutEventsInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEventsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unread_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  upcoming_event_reminder_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  urgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutEventsInput>;
  users_events_customer_referralTousers?: InputMaybe<UsersUpdateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutSuppliersInput = {
  approximate_location?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  custom_event_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event_areas?: InputMaybe<Event_AreasUpdateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesUpdateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  high_demand?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lead_time?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messages_reminder_email_sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partnership?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnerships?: InputMaybe<PartnershipsUpdateOneWithoutEventsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regions?: InputMaybe<RegionsUpdateOneWithoutEventsInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unread_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  upcoming_event_reminder_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  urgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutEventsInput>;
  users_events_customer_referralTousers?: InputMaybe<UsersUpdateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutUsersInput = {
  approximate_location?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  custom_event_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event_areas?: InputMaybe<Event_AreasUpdateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesUpdateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  high_demand?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lead_time?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messages_reminder_email_sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partnership?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnerships?: InputMaybe<PartnershipsUpdateOneWithoutEventsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regions?: InputMaybe<RegionsUpdateOneWithoutEventsInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEventsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unread_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  upcoming_event_reminder_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  urgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users_events_customer_referralTousers?: InputMaybe<UsersUpdateOneWithoutEvents_Events_Customer_ReferralTousersInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutUsers_Events_Customer_ReferralTousersInput = {
  approximate_location?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  attribution_data?: InputMaybe<Attribution_DataUpdateOneWithoutEventsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  custom_event_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date_flexible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event_areas?: InputMaybe<Event_AreasUpdateManyWithoutEventsInput>;
  event_dates?: InputMaybe<Event_DatesUpdateManyWithoutEventsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateManyWithoutEventsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutEventsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  high_demand?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lead_time?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messages_reminder_email_sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partnership?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnerships?: InputMaybe<PartnershipsUpdateOneWithoutEventsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regions?: InputMaybe<RegionsUpdateOneWithoutEventsInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutEventsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unread_quotes_email_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  upcoming_event_reminder_sent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  urgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutEventsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpsertWithWhereUniqueWithoutAttribution_DataInput = {
  create: EventsCreateWithoutAttribution_DataInput;
  update: EventsUpdateWithoutAttribution_DataInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: EventsCreateWithoutSuppliersInput;
  update: EventsUpdateWithoutSuppliersInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutUsersInput = {
  create: EventsCreateWithoutUsersInput;
  update: EventsUpdateWithoutUsersInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutUsers_Events_Customer_ReferralTousersInput = {
  create: EventsCreateWithoutUsers_Events_Customer_ReferralTousersInput;
  update: EventsUpdateWithoutUsers_Events_Customer_ReferralTousersInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithoutEvent_RequestsInput = {
  create: EventsCreateWithoutEvent_RequestsInput;
  update: EventsUpdateWithoutEvent_RequestsInput;
};

export type EventsUpsertWithoutEvent_TagsInput = {
  create: EventsCreateWithoutEvent_TagsInput;
  update: EventsUpdateWithoutEvent_TagsInput;
};

export type EventsWhereInput = {
  AND?: InputMaybe<Array<EventsWhereInput>>;
  NOT?: InputMaybe<Array<EventsWhereInput>>;
  OR?: InputMaybe<Array<EventsWhereInput>>;
  approximate_location?: InputMaybe<BoolNullableFilter>;
  attribution_data?: InputMaybe<Attribution_DataWhereInput>;
  attribution_data_id?: InputMaybe<StringNullableFilter>;
  coordinates?: InputMaybe<JsonNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  custom_event_name?: InputMaybe<StringNullableFilter>;
  customer_referral?: InputMaybe<StringNullableFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  dateFlexibilityNotes?: InputMaybe<StringNullableFilter>;
  date_flexible?: InputMaybe<BoolNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  end_time?: InputMaybe<StringNullableFilter>;
  event_areas?: InputMaybe<Event_AreasListRelationFilter>;
  event_dates?: InputMaybe<Event_DatesListRelationFilter>;
  event_requests?: InputMaybe<Event_RequestsListRelationFilter>;
  event_tags?: InputMaybe<Event_TagsListRelationFilter>;
  freshsales_id?: InputMaybe<StringNullableFilter>;
  freshsales_stage?: InputMaybe<StringNullableFilter>;
  high_demand?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lead_time?: InputMaybe<IntNullableFilter>;
  location_city?: InputMaybe<StringNullableFilter>;
  location_line_1?: InputMaybe<StringNullableFilter>;
  location_line_2?: InputMaybe<StringNullableFilter>;
  location_notes?: InputMaybe<StringNullableFilter>;
  messages_reminder_email_sent?: InputMaybe<BoolFilter>;
  partnership?: InputMaybe<BoolNullableFilter>;
  partnership_id?: InputMaybe<StringNullableFilter>;
  partnerships?: InputMaybe<PartnershipsWhereInput>;
  postcode?: InputMaybe<StringNullableFilter>;
  postcode_prefix?: InputMaybe<StringNullableFilter>;
  regions?: InputMaybe<RegionsWhereInput>;
  source?: InputMaybe<StringNullableFilter>;
  start_time?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<EventState>;
  supplier_referral?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  type?: InputMaybe<StringNullableFilter>;
  unread_quotes_email_sent?: InputMaybe<BoolNullableFilter>;
  upcoming_event_reminder_sent?: InputMaybe<BoolNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  urgency?: InputMaybe<StringNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
  users_events_customer_referralTousers?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type EventsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type External_Payment_InfoCreateOneWithoutSupplier_PaymentsInput = {
  connect?: InputMaybe<External_Payment_InfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<External_Payment_InfoCreateOrConnectWithoutsupplier_PaymentsInput>;
  create?: InputMaybe<External_Payment_InfoCreateWithoutSupplier_PaymentsInput>;
};

export type External_Payment_InfoCreateOrConnectWithoutsupplier_PaymentsInput = {
  create: External_Payment_InfoCreateWithoutSupplier_PaymentsInput;
  where: External_Payment_InfoWhereUniqueInput;
};

export type External_Payment_InfoCreateWithoutSupplier_PaymentsInput = {
  created: Scalars['DateTime']['input'];
  external_id: Scalars['String']['input'];
  provider: Enum_External_Payment_Info_Provider;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type External_Payment_InfoUpdateOneRequiredWithoutSupplier_PaymentsInput = {
  connect?: InputMaybe<External_Payment_InfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<External_Payment_InfoCreateOrConnectWithoutsupplier_PaymentsInput>;
  create?: InputMaybe<External_Payment_InfoCreateWithoutSupplier_PaymentsInput>;
  update?: InputMaybe<External_Payment_InfoUpdateWithoutSupplier_PaymentsInput>;
  upsert?: InputMaybe<External_Payment_InfoUpsertWithoutSupplier_PaymentsInput>;
};

export type External_Payment_InfoUpdateWithoutSupplier_PaymentsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  external_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<Enumenum_External_Payment_Info_ProviderFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type External_Payment_InfoUpsertWithoutSupplier_PaymentsInput = {
  create: External_Payment_InfoCreateWithoutSupplier_PaymentsInput;
  update: External_Payment_InfoUpdateWithoutSupplier_PaymentsInput;
};

export type External_Payment_InfoWhereInput = {
  AND?: InputMaybe<Array<External_Payment_InfoWhereInput>>;
  NOT?: InputMaybe<Array<External_Payment_InfoWhereInput>>;
  OR?: InputMaybe<Array<External_Payment_InfoWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  external_id?: InputMaybe<StringFilter>;
  provider?: InputMaybe<Enumenum_External_Payment_Info_ProviderFilter>;
  supplier_payments?: InputMaybe<Supplier_PaymentsWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type External_Payment_InfoWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type FailedEventWithRequestsError = {
  __typename?: 'failedEventWithRequestsError';
  message?: Maybe<Scalars['String']['output']>;
};

export type FavouritesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<FavouritesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavouritesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<FavouritesCreateWithoutSuppliersInput>>;
};

export type FavouritesCreateOrConnectWithoutsuppliersInput = {
  create: FavouritesCreateWithoutSuppliersInput;
  where: FavouritesWhereUniqueInput;
};

export type FavouritesCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FavouritesScalarWhereInput = {
  AND?: InputMaybe<Array<FavouritesScalarWhereInput>>;
  NOT?: InputMaybe<Array<FavouritesScalarWhereInput>>;
  OR?: InputMaybe<Array<FavouritesScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  customer_id?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type FavouritesUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FavouritesUpdateManyWithWhereWithoutSuppliersInput = {
  data: FavouritesUpdateManyMutationInput;
  where: FavouritesScalarWhereInput;
};

export type FavouritesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<FavouritesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavouritesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<FavouritesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<FavouritesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FavouritesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FavouritesWhereUniqueInput>>;
  set?: InputMaybe<Array<FavouritesWhereUniqueInput>>;
  update?: InputMaybe<Array<FavouritesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<FavouritesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<FavouritesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type FavouritesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: FavouritesUpdateWithoutSuppliersInput;
  where: FavouritesWhereUniqueInput;
};

export type FavouritesUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FavouritesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: FavouritesCreateWithoutSuppliersInput;
  update: FavouritesUpdateWithoutSuppliersInput;
  where: FavouritesWhereUniqueInput;
};

export type FavouritesWhereInput = {
  AND?: InputMaybe<Array<FavouritesWhereInput>>;
  NOT?: InputMaybe<Array<FavouritesWhereInput>>;
  OR?: InputMaybe<Array<FavouritesWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  customer_id?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type FavouritesWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackInput = {
  feature: Scalars['String']['input'];
  feedback: Array<FeedbackSections>;
  liked: Scalars['Boolean']['input'];
};

export type FeedbackSections = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type File_Data = {
  __typename?: 'file_data';
  filename?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GetSupplierFlexiblePricingForRequestDateTypes = {
  __typename?: 'getSupplierFlexiblePricingForRequestDateTypes';
  pricingForDay?: Maybe<Supplier_Flexible_Pricing>;
  pricingForMonth?: Maybe<Supplier_Flexible_Pricing>;
};

export type Hidden_Event_RequestsCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Hidden_Event_RequestsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Hidden_Event_RequestsCreateWithoutEvent_RequestsInput>>;
};

export type Hidden_Event_RequestsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Hidden_Event_RequestsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Hidden_Event_RequestsCreateWithoutSuppliersInput>>;
};

export type Hidden_Event_RequestsCreateOrConnectWithoutevent_RequestsInput = {
  create: Hidden_Event_RequestsCreateWithoutEvent_RequestsInput;
  where: Hidden_Event_RequestsWhereUniqueInput;
};

export type Hidden_Event_RequestsCreateOrConnectWithoutsuppliersInput = {
  create: Hidden_Event_RequestsCreateWithoutSuppliersInput;
  where: Hidden_Event_RequestsWhereUniqueInput;
};

export type Hidden_Event_RequestsCreateWithoutEvent_RequestsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers: SuppliersCreateOneWithoutHidden_Event_RequestsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Hidden_Event_RequestsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests: Event_RequestsCreateOneWithoutHidden_Event_RequestsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Hidden_Event_RequestsScalarWhereInput = {
  AND?: InputMaybe<Array<Hidden_Event_RequestsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Hidden_Event_RequestsScalarWhereInput>>;
  OR?: InputMaybe<Array<Hidden_Event_RequestsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Hidden_Event_RequestsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Hidden_Event_RequestsUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: Hidden_Event_RequestsUpdateManyMutationInput;
  where: Hidden_Event_RequestsScalarWhereInput;
};

export type Hidden_Event_RequestsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Hidden_Event_RequestsUpdateManyMutationInput;
  where: Hidden_Event_RequestsScalarWhereInput;
};

export type Hidden_Event_RequestsUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Hidden_Event_RequestsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Hidden_Event_RequestsCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Hidden_Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Hidden_Event_RequestsUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<Hidden_Event_RequestsUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<Hidden_Event_RequestsUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type Hidden_Event_RequestsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Hidden_Event_RequestsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Hidden_Event_RequestsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Hidden_Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Hidden_Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Hidden_Event_RequestsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Hidden_Event_RequestsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Hidden_Event_RequestsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Hidden_Event_RequestsUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: Hidden_Event_RequestsUpdateWithoutEvent_RequestsInput;
  where: Hidden_Event_RequestsWhereUniqueInput;
};

export type Hidden_Event_RequestsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Hidden_Event_RequestsUpdateWithoutSuppliersInput;
  where: Hidden_Event_RequestsWhereUniqueInput;
};

export type Hidden_Event_RequestsUpdateWithoutEvent_RequestsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutHidden_Event_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Hidden_Event_RequestsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneRequiredWithoutHidden_Event_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Hidden_Event_RequestsUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: Hidden_Event_RequestsCreateWithoutEvent_RequestsInput;
  update: Hidden_Event_RequestsUpdateWithoutEvent_RequestsInput;
  where: Hidden_Event_RequestsWhereUniqueInput;
};

export type Hidden_Event_RequestsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Hidden_Event_RequestsCreateWithoutSuppliersInput;
  update: Hidden_Event_RequestsUpdateWithoutSuppliersInput;
  where: Hidden_Event_RequestsWhereUniqueInput;
};

export type Hidden_Event_RequestsWhereInput = {
  AND?: InputMaybe<Array<Hidden_Event_RequestsWhereInput>>;
  NOT?: InputMaybe<Array<Hidden_Event_RequestsWhereInput>>;
  OR?: InputMaybe<Array<Hidden_Event_RequestsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Hidden_Event_RequestsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ImpersonateUserType = {
  __typename?: 'impersonateUserType';
  token?: Maybe<Scalars['String']['output']>;
};

export type InitialExternalAppToken = {
  __typename?: 'initialExternalAppToken';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type InitialiseExternalAppUrl = {
  __typename?: 'initialiseExternalAppUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type Latest_Unread_Conversation_Message = {
  __typename?: 'latest_unread_conversation_message';
  conversationMessage?: Maybe<Conversations_Messages>;
  user?: Maybe<Users>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type MarkSupplierAsPaidType = {
  __typename?: 'markSupplierAsPaidType';
  quoteId?: Maybe<Scalars['String']['output']>;
};

export type OnboardingRequestsInput = {
  categories_tier2: Array<Scalars['String']['input']>;
  coordinates?: InputMaybe<Coordinates>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  radius: Scalars['Int']['input'];
  tagUuids: Array<Scalars['String']['input']>;
};

export type Open_Event = {
  __typename?: 'open_event';
  acception_quotes?: Maybe<Scalars['String']['output']>;
  approxLocation?: Maybe<Scalars['Boolean']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  category_tier2?: Maybe<Scalars['String']['output']>;
  close_date?: Maybe<Scalars['Boolean']['output']>;
  close_reason?: Maybe<Scalars['Boolean']['output']>;
  close_source?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  custom_event_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  item_quantity?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  notified_method?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  partialPostcode?: Maybe<Scalars['String']['output']>;
  potential_suppliers?: Maybe<Scalars['Int']['output']>;
  preferred_suppliers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority_tag?: Maybe<Scalars['String']['output']>;
  quoteCount?: Maybe<Scalars['String']['output']>;
  read_timestamp?: Maybe<Scalars['String']['output']>;
  saved?: Maybe<Scalars['Boolean']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type Open_Events = {
  __typename?: 'open_events';
  numPages?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Open_Event>>>;
  totalRecords?: Maybe<Scalars['String']['output']>;
};

export type PartnershipsCreateOneWithoutEventsInput = {
  connect?: InputMaybe<PartnershipsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PartnershipsCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<PartnershipsCreateWithoutEventsInput>;
};

export type PartnershipsCreateOrConnectWithouteventsInput = {
  create: PartnershipsCreateWithoutEventsInput;
  where: PartnershipsWhereUniqueInput;
};

export type PartnershipsCreateWithoutEventsInput = {
  commission: Scalars['Float']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type PartnershipsUpdateOneWithoutEventsInput = {
  connect?: InputMaybe<PartnershipsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PartnershipsCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<PartnershipsCreateWithoutEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PartnershipsUpdateWithoutEventsInput>;
  upsert?: InputMaybe<PartnershipsUpsertWithoutEventsInput>;
};

export type PartnershipsUpdateWithoutEventsInput = {
  commission?: InputMaybe<FloatFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  postcode?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PartnershipsUpsertWithoutEventsInput = {
  create: PartnershipsCreateWithoutEventsInput;
  update: PartnershipsUpdateWithoutEventsInput;
};

export type PartnershipsWhereInput = {
  AND?: InputMaybe<Array<PartnershipsWhereInput>>;
  NOT?: InputMaybe<Array<PartnershipsWhereInput>>;
  OR?: InputMaybe<Array<PartnershipsWhereInput>>;
  commission?: InputMaybe<FloatFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventsListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  postcode?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type PartnershipsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentAccountOnboardResult = {
  __typename?: 'paymentAccountOnboardResult';
  session: Scalars['String']['output'];
};

export type PaymentAccountSignInResult = {
  __typename?: 'paymentAccountSignInResult';
  session: Scalars['String']['output'];
};

export type PaymentStatus = {
  __typename?: 'paymentStatus';
  status?: Maybe<Scalars['String']['output']>;
};

export type PaymentType = {
  __typename?: 'paymentType';
  active?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PitchApplicationType = {
  __typename?: 'pitchApplicationType';
  description?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pitch_fee?: Maybe<Scalars['Float']['output']>;
  pitch_group_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PitchApplicationsByPitchGroupIdsType = {
  __typename?: 'pitchApplicationsByPitchGroupIdsType';
  results?: Maybe<Array<Maybe<PitchApplicationType>>>;
};

export type PitchApplicationsType = {
  __typename?: 'pitchApplicationsType';
  results?: Maybe<Array<Maybe<PitchApplicationType>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type PriorityTagStatus = {
  __typename?: 'priorityTagStatus';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type PromotionFieldsInput = {
  eventUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PublicEventType = {
  __typename?: 'publicEventType';
  account_manager_id?: Maybe<Scalars['Float']['output']>;
  client_sales_commission?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimated_footfall?: Maybe<Scalars['Float']['output']>;
  event_city?: Maybe<Scalars['String']['output']>;
  event_date?: Maybe<Scalars['String']['output']>;
  event_end_date?: Maybe<Scalars['String']['output']>;
  feast_it_sales_commission?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  open_pitches_count?: Maybe<Scalars['Float']['output']>;
  pitch_fee?: Maybe<Scalars['Float']['output']>;
  pitch_type?: Maybe<Scalars['String']['output']>;
  pitches_count?: Maybe<Scalars['Float']['output']>;
  sales_deposit?: Maybe<Scalars['Float']['output']>;
  supplier_application_url?: Maybe<Scalars['String']['output']>;
};

export type PublicEventsByIdsListType = {
  __typename?: 'publicEventsByIdsListType';
  events?: Maybe<Array<Maybe<PublicEventType>>>;
};

export type PublicEventsListType = {
  __typename?: 'publicEventsListType';
  events?: Maybe<Array<Maybe<PublicEventType>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type Public_Quote = {
  __typename?: 'public_quote';
  agencyCommissionFee?: Maybe<Agency_Fee>;
  attachments: Array<Attachment>;
  commission_fee?: Maybe<Scalars['Float']['output']>;
  covers?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  introMessage?: Maybe<Scalars['String']['output']>;
  old_commission?: Maybe<Scalars['Boolean']['output']>;
  priceBreakdown?: Maybe<QuotePriceBreakdown>;
  protection_fee?: Maybe<Scalars['Float']['output']>;
  protection_rounding?: Maybe<Scalars['Float']['output']>;
  quotePriceDetails?: Maybe<QuotePriceDetails>;
  quote_line_items?: Maybe<Array<Maybe<Quote_Line_Items>>>;
  service_fee?: Maybe<Scalars['Float']['output']>;
  suppliers?: Maybe<Public_Quote_Supplier>;
  supportText?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
  vatStatus: VatStatus;
};

export type Public_Quote_Recommendation = {
  __typename?: 'public_quote_recommendation';
  highlight?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  team_member_name?: Maybe<Scalars['String']['output']>;
};

export type Public_Quote_Review = {
  __typename?: 'public_quote_review';
  averageRating?: Maybe<Scalars['Float']['output']>;
  event?: Maybe<Public_Review_Event>;
  external_event?: Maybe<Public_Review_External_Event>;
  field_public_comment?: Maybe<Scalars['String']['output']>;
};

export type Public_Quote_Supplier = {
  __typename?: 'public_quote_supplier';
  average_rating?: Maybe<Scalars['Float']['output']>;
  category_tier1?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Public_Supplier_Images>>;
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Public_Supplier_Rating>;
  recommendations?: Maybe<Array<Public_Quote_Recommendation>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews: Array<Reviews>;
  slug?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type Public_Review_Event = {
  __typename?: 'public_review_event';
  date?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Public_Review_External_Event = {
  __typename?: 'public_review_external_event';
  eventDate?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  userFullName?: Maybe<Scalars['String']['output']>;
};

export type Public_Space_Groups = {
  __typename?: 'public_space_groups';
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  venue_spaces?: Maybe<Array<Maybe<Public_Venue_Spaces>>>;
};

export type Public_Space_Tags = {
  __typename?: 'public_space_tags';
  max_capacity?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Public_Tags>;
};

export type Public_Supplier = {
  __typename?: 'public_supplier';
  activity?: Maybe<Scalars['Int']['output']>;
  alcohol_permit?: Maybe<Scalars['Boolean']['output']>;
  base_price?: Maybe<Scalars['Float']['output']>;
  coordinates?: Maybe<Public_Supplier_Coordinates>;
  cuisine?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  dietary?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  foodHygieneLocalAuthorityName?: Maybe<Scalars['String']['output']>;
  foodHygieneRatingScore?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Maybe<Public_Supplier_Image>>>;
  isGasUser?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Public_Supplier_Menu_Group>>>;
  localAuthorityName?: Maybe<Scalars['String']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_line_1?: Maybe<Scalars['String']['output']>;
  location_line_2?: Maybe<Scalars['String']['output']>;
  matterport_url?: Maybe<Scalars['String']['output']>;
  muta_accredited?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Public_Supplier_Rating>;
  recommendation?: Maybe<Public_Supplier_Recommendation>;
  registeredBusinessOwnerName?: Maybe<Scalars['String']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews: Array<Reviews>;
  risk_assessment_score?: Maybe<Scalars['String']['output']>;
  setup_details?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  space_groups?: Maybe<Array<Maybe<Public_Space_Groups>>>;
  tagline?: Maybe<Scalars['String']['output']>;
  tier1?: Maybe<Scalars['String']['output']>;
  tier2?: Maybe<Array<Maybe<Public_Supplier_Tier2>>>;
  uuid?: Maybe<Scalars['String']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
};


export type Public_SupplierReviewsArgs = {
  cursor?: InputMaybe<ReviewsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewsWhereInput>;
};

export type Public_Supplier_Coordinates = {
  __typename?: 'public_supplier_coordinates';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
};

export type Public_Supplier_Image = {
  __typename?: 'public_supplier_image';
  id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Public_Supplier_Images = {
  __typename?: 'public_supplier_images';
  url?: Maybe<Scalars['String']['output']>;
};

export type Public_Supplier_Images_Spaces = {
  __typename?: 'public_supplier_images_spaces';
  supplier_images?: Maybe<Public_Supplier_Images_Table>;
};

export type Public_Supplier_Images_Table = {
  __typename?: 'public_supplier_images_table';
  description?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Public_Supplier_Menu_Group = {
  __typename?: 'public_supplier_menu_group';
  description?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Public_Supplier_Menu_Items>>>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Public_Supplier_Menu_Items = {
  __typename?: 'public_supplier_menu_items';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Public_Supplier_Image>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Public_Supplier_Rating = {
  __typename?: 'public_supplier_rating';
  friendliness?: Maybe<Scalars['Float']['output']>;
  overall?: Maybe<Scalars['Float']['output']>;
  professionalism?: Maybe<Scalars['Float']['output']>;
  quality?: Maybe<Scalars['Float']['output']>;
  valueForMoney?: Maybe<Scalars['Float']['output']>;
};

export type Public_Supplier_Recommendation = {
  __typename?: 'public_supplier_recommendation';
  highlight?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  team_member_name?: Maybe<Scalars['String']['output']>;
};

export type Public_Supplier_Tier2 = {
  __typename?: 'public_supplier_tier2';
  name?: Maybe<Scalars['String']['output']>;
  sysName?: Maybe<Scalars['String']['output']>;
};

export type Public_Tags = {
  __typename?: 'public_tags';
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Public_Venue_Spaces = {
  __typename?: 'public_venue_spaces';
  description?: Maybe<Scalars['String']['output']>;
  min_spend_pennies?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  space_tags?: Maybe<Array<Maybe<Public_Space_Tags>>>;
  supplier_images_spaces?: Maybe<Array<Maybe<Public_Supplier_Images_Spaces>>>;
};

export type QuoteData = {
  __typename?: 'quoteData';
  averagePrice?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
};

export enum QuoteLineItemTypeEnum {
  AdditionalCosts = 'additional_costs',
  Food = 'food',
  Legacy = 'legacy',
  Main = 'main',
  Space = 'space'
}

export type QuoteTemplateTagNamesAndIds = {
  __typename?: 'quoteTemplateTagNamesAndIds';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type Quote_Line_Item_TemplatesCreateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateWithoutSupplier_ImagesInput>>;
};

export type Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateWithoutSuppliersInput>>;
};

export type Quote_Line_Item_TemplatesCreateOrConnectWithoutsupplier_ImagesInput = {
  create: Quote_Line_Item_TemplatesCreateWithoutSupplier_ImagesInput;
  where: Quote_Line_Item_TemplatesWhereUniqueInput;
};

export type Quote_Line_Item_TemplatesCreateOrConnectWithoutsuppliersInput = {
  create: Quote_Line_Item_TemplatesCreateWithoutSuppliersInput;
  where: Quote_Line_Item_TemplatesWhereUniqueInput;
};

export type Quote_Line_Item_TemplatesCreateWithoutSupplier_ImagesInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  has_quantity: Scalars['Boolean']['input'];
  price: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuote_Line_Item_TemplatesInput>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Enum_Quote_Line_Item_Templates_Type>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Line_Item_TemplatesCreateWithoutSuppliersInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  has_quantity: Scalars['Boolean']['input'];
  price: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  supplier_images?: InputMaybe<Supplier_ImagesCreateOneWithoutQuote_Line_Item_TemplatesInput>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Enum_Quote_Line_Item_Templates_Type>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Line_Item_TemplatesScalarWhereInput = {
  AND?: InputMaybe<Array<Quote_Line_Item_TemplatesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Line_Item_TemplatesScalarWhereInput>>;
  OR?: InputMaybe<Array<Quote_Line_Item_TemplatesScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  has_quantity?: InputMaybe<BoolFilter>;
  image_id?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<IntFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Quote_Line_Item_Templates_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Line_Item_TemplatesUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  has_quantity?: InputMaybe<BoolFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Line_Item_Templates_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Line_Item_TemplatesUpdateManyWithWhereWithoutSupplier_ImagesInput = {
  data: Quote_Line_Item_TemplatesUpdateManyMutationInput;
  where: Quote_Line_Item_TemplatesScalarWhereInput;
};

export type Quote_Line_Item_TemplatesUpdateManyWithWhereWithoutSuppliersInput = {
  data: Quote_Line_Item_TemplatesUpdateManyMutationInput;
  where: Quote_Line_Item_TemplatesScalarWhereInput;
};

export type Quote_Line_Item_TemplatesUpdateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateWithoutSupplier_ImagesInput>>;
  delete?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Line_Item_TemplatesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Line_Item_TemplatesUpdateWithWhereUniqueWithoutSupplier_ImagesInput>>;
  updateMany?: InputMaybe<Array<Quote_Line_Item_TemplatesUpdateManyWithWhereWithoutSupplier_ImagesInput>>;
  upsert?: InputMaybe<Array<Quote_Line_Item_TemplatesUpsertWithWhereUniqueWithoutSupplier_ImagesInput>>;
};

export type Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Quote_Line_Item_TemplatesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Line_Item_TemplatesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Line_Item_TemplatesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Quote_Line_Item_TemplatesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Quote_Line_Item_TemplatesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Quote_Line_Item_TemplatesUpdateWithWhereUniqueWithoutSupplier_ImagesInput = {
  data: Quote_Line_Item_TemplatesUpdateWithoutSupplier_ImagesInput;
  where: Quote_Line_Item_TemplatesWhereUniqueInput;
};

export type Quote_Line_Item_TemplatesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Quote_Line_Item_TemplatesUpdateWithoutSuppliersInput;
  where: Quote_Line_Item_TemplatesWhereUniqueInput;
};

export type Quote_Line_Item_TemplatesUpdateWithoutSupplier_ImagesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  has_quantity?: InputMaybe<BoolFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuote_Line_Item_TemplatesInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Line_Item_Templates_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Line_Item_TemplatesUpdateWithoutSuppliersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  has_quantity?: InputMaybe<BoolFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supplier_images?: InputMaybe<Supplier_ImagesUpdateOneWithoutQuote_Line_Item_TemplatesInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Line_Item_Templates_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Line_Item_TemplatesUpsertWithWhereUniqueWithoutSupplier_ImagesInput = {
  create: Quote_Line_Item_TemplatesCreateWithoutSupplier_ImagesInput;
  update: Quote_Line_Item_TemplatesUpdateWithoutSupplier_ImagesInput;
  where: Quote_Line_Item_TemplatesWhereUniqueInput;
};

export type Quote_Line_Item_TemplatesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Quote_Line_Item_TemplatesCreateWithoutSuppliersInput;
  update: Quote_Line_Item_TemplatesUpdateWithoutSuppliersInput;
  where: Quote_Line_Item_TemplatesWhereUniqueInput;
};

export type Quote_Line_Item_TemplatesWhereInput = {
  AND?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereInput>>;
  OR?: InputMaybe<Array<Quote_Line_Item_TemplatesWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  has_quantity?: InputMaybe<BoolFilter>;
  image_id?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<IntFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  supplier_images?: InputMaybe<Supplier_ImagesWhereInput>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Quote_Line_Item_Templates_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Line_Item_TemplatesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Quote_Line_Items = {
  __typename?: 'quote_line_items';
  customerTotalAmount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Supplier_Images>;
  image_id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priceBreakdown?: Maybe<PriceBreakdown>;
  pricePerHead?: Maybe<Scalars['Int']['output']>;
  priceType?: Maybe<PriceType>;
  quantity?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuoteLineItemTypeEnum>;
  uuid?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Scalars['Int']['output']>;
  vatPercentageRate?: Maybe<Scalars['Float']['output']>;
  vatRate?: Maybe<VatRate>;
  vatRateId?: Maybe<Scalars['String']['output']>;
};

export type Quote_Line_ItemsCreateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_ItemsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Quote_Line_ItemsCreateWithoutQuotesInput>>;
};

export type Quote_Line_ItemsCreateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_ItemsCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Quote_Line_ItemsCreateWithoutSupplier_ImagesInput>>;
};

export type Quote_Line_ItemsCreateOrConnectWithoutquotesInput = {
  create: Quote_Line_ItemsCreateWithoutQuotesInput;
  where: Quote_Line_ItemsWhereUniqueInput;
};

export type Quote_Line_ItemsCreateOrConnectWithoutsupplier_ImagesInput = {
  create: Quote_Line_ItemsCreateWithoutSupplier_ImagesInput;
  where: Quote_Line_ItemsWhereUniqueInput;
};

export type Quote_Line_ItemsCreateWithoutQuotesInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  supplier_images?: InputMaybe<Supplier_ImagesCreateOneWithoutQuote_Line_ItemsInput>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Enum_Quote_Line_Items_Type>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Line_ItemsCreateWithoutSupplier_ImagesInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quotes: QuotesCreateOneWithoutQuote_Line_ItemsInput;
  title: Scalars['String']['input'];
  type?: InputMaybe<Enum_Quote_Line_Items_Type>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Line_ItemsScalarWhereInput = {
  AND?: InputMaybe<Array<Quote_Line_ItemsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Line_ItemsScalarWhereInput>>;
  OR?: InputMaybe<Array<Quote_Line_ItemsScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  image_id?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  price?: InputMaybe<IntFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  quote_id?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Quote_Line_Items_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Line_ItemsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Line_Items_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Line_ItemsUpdateManyWithWhereWithoutQuotesInput = {
  data: Quote_Line_ItemsUpdateManyMutationInput;
  where: Quote_Line_ItemsScalarWhereInput;
};

export type Quote_Line_ItemsUpdateManyWithWhereWithoutSupplier_ImagesInput = {
  data: Quote_Line_ItemsUpdateManyMutationInput;
  where: Quote_Line_ItemsScalarWhereInput;
};

export type Quote_Line_ItemsUpdateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_ItemsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Quote_Line_ItemsCreateWithoutQuotesInput>>;
  delete?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Line_ItemsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Line_ItemsUpdateWithWhereUniqueWithoutQuotesInput>>;
  updateMany?: InputMaybe<Array<Quote_Line_ItemsUpdateManyWithWhereWithoutQuotesInput>>;
  upsert?: InputMaybe<Array<Quote_Line_ItemsUpsertWithWhereUniqueWithoutQuotesInput>>;
};

export type Quote_Line_ItemsUpdateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Line_ItemsCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Quote_Line_ItemsCreateWithoutSupplier_ImagesInput>>;
  delete?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Line_ItemsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Line_ItemsWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Line_ItemsUpdateWithWhereUniqueWithoutSupplier_ImagesInput>>;
  updateMany?: InputMaybe<Array<Quote_Line_ItemsUpdateManyWithWhereWithoutSupplier_ImagesInput>>;
  upsert?: InputMaybe<Array<Quote_Line_ItemsUpsertWithWhereUniqueWithoutSupplier_ImagesInput>>;
};

export type Quote_Line_ItemsUpdateWithWhereUniqueWithoutQuotesInput = {
  data: Quote_Line_ItemsUpdateWithoutQuotesInput;
  where: Quote_Line_ItemsWhereUniqueInput;
};

export type Quote_Line_ItemsUpdateWithWhereUniqueWithoutSupplier_ImagesInput = {
  data: Quote_Line_ItemsUpdateWithoutSupplier_ImagesInput;
  where: Quote_Line_ItemsWhereUniqueInput;
};

export type Quote_Line_ItemsUpdateWithoutQuotesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supplier_images?: InputMaybe<Supplier_ImagesUpdateOneWithoutQuote_Line_ItemsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Line_Items_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Line_ItemsUpdateWithoutSupplier_ImagesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateOneRequiredWithoutQuote_Line_ItemsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Line_Items_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Line_ItemsUpsertWithWhereUniqueWithoutQuotesInput = {
  create: Quote_Line_ItemsCreateWithoutQuotesInput;
  update: Quote_Line_ItemsUpdateWithoutQuotesInput;
  where: Quote_Line_ItemsWhereUniqueInput;
};

export type Quote_Line_ItemsUpsertWithWhereUniqueWithoutSupplier_ImagesInput = {
  create: Quote_Line_ItemsCreateWithoutSupplier_ImagesInput;
  update: Quote_Line_ItemsUpdateWithoutSupplier_ImagesInput;
  where: Quote_Line_ItemsWhereUniqueInput;
};

export type Quote_Line_ItemsWhereInput = {
  AND?: InputMaybe<Array<Quote_Line_ItemsWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Line_ItemsWhereInput>>;
  OR?: InputMaybe<Array<Quote_Line_ItemsWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  image_id?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  price?: InputMaybe<IntFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  quote_id?: InputMaybe<StringFilter>;
  quotes?: InputMaybe<QuotesWhereInput>;
  supplier_images?: InputMaybe<Supplier_ImagesWhereInput>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Quote_Line_Items_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Line_ItemsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Quote_Search = {
  __typename?: 'quote_search';
  custom_event_name?: Maybe<Scalars['String']['output']>;
  drivingDistance?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  event_location_city?: Maybe<Scalars['String']['output']>;
  event_request_budget?: Maybe<Scalars['Float']['output']>;
  event_request_category?: Maybe<Scalars['String']['output']>;
  event_request_guests?: Maybe<Scalars['Int']['output']>;
  event_request_tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  event_request_uuid?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  follow_up_reminder?: Maybe<Scalars['Boolean']['output']>;
  quoteCreated?: Maybe<Scalars['String']['output']>;
  quote_commission_fee?: Maybe<Scalars['Float']['output']>;
  quote_id?: Maybe<Scalars['String']['output']>;
  quote_old_commission?: Maybe<Scalars['Boolean']['output']>;
  quote_price?: Maybe<Scalars['Float']['output']>;
  quote_published?: Maybe<Scalars['Boolean']['output']>;
  quote_read_timestamp?: Maybe<Scalars['String']['output']>;
  user_first_name?: Maybe<Scalars['String']['output']>;
};

export type Quote_Search_Results = {
  __typename?: 'quote_search_results';
  numPages?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Quote_Search>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type Quote_Template_Line_Items = {
  __typename?: 'quote_template_line_items';
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Supplier_Images>;
  image_id?: Maybe<Scalars['String']['output']>;
  isMigratedToLineItem: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  priceBreakdown?: Maybe<PriceBreakdown>;
  priceType?: Maybe<PriceType>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quote_template_id: Scalars['String']['output'];
  subtotal?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Enum_Quote_Template_Line_Items_Type>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vatRateId?: Maybe<Scalars['String']['output']>;
};

export type Quote_Template_Line_ItemsCreateManyWithoutQuote_TemplatesInput = {
  connect?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_Line_ItemsCreateOrConnectWithoutquote_TemplatesInput>>;
  create?: InputMaybe<Array<Quote_Template_Line_ItemsCreateWithoutQuote_TemplatesInput>>;
};

export type Quote_Template_Line_ItemsCreateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_Line_ItemsCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Quote_Template_Line_ItemsCreateWithoutSupplier_ImagesInput>>;
};

export type Quote_Template_Line_ItemsCreateOrConnectWithoutquote_TemplatesInput = {
  create: Quote_Template_Line_ItemsCreateWithoutQuote_TemplatesInput;
  where: Quote_Template_Line_ItemsWhereUniqueInput;
};

export type Quote_Template_Line_ItemsCreateOrConnectWithoutsupplier_ImagesInput = {
  create: Quote_Template_Line_ItemsCreateWithoutSupplier_ImagesInput;
  where: Quote_Template_Line_ItemsWhereUniqueInput;
};

export type Quote_Template_Line_ItemsCreateWithoutQuote_TemplatesInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  supplier_images?: InputMaybe<Supplier_ImagesCreateOneWithoutQuote_Template_Line_ItemsInput>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Enum_Quote_Template_Line_Items_Type>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Template_Line_ItemsCreateWithoutSupplier_ImagesInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quote_templates: Quote_TemplatesCreateOneWithoutQuote_Template_Line_ItemsInput;
  title: Scalars['String']['input'];
  type?: InputMaybe<Enum_Quote_Template_Line_Items_Type>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Template_Line_ItemsScalarWhereInput = {
  AND?: InputMaybe<Array<Quote_Template_Line_ItemsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Template_Line_ItemsScalarWhereInput>>;
  OR?: InputMaybe<Array<Quote_Template_Line_ItemsScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  image_id?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  price?: InputMaybe<IntFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  quote_template_id?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Quote_Template_Line_Items_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Template_Line_ItemsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Template_Line_Items_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Template_Line_ItemsUpdateManyWithWhereWithoutQuote_TemplatesInput = {
  data: Quote_Template_Line_ItemsUpdateManyMutationInput;
  where: Quote_Template_Line_ItemsScalarWhereInput;
};

export type Quote_Template_Line_ItemsUpdateManyWithWhereWithoutSupplier_ImagesInput = {
  data: Quote_Template_Line_ItemsUpdateManyMutationInput;
  where: Quote_Template_Line_ItemsScalarWhereInput;
};

export type Quote_Template_Line_ItemsUpdateManyWithoutQuote_TemplatesInput = {
  connect?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_Line_ItemsCreateOrConnectWithoutquote_TemplatesInput>>;
  create?: InputMaybe<Array<Quote_Template_Line_ItemsCreateWithoutQuote_TemplatesInput>>;
  delete?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Template_Line_ItemsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Template_Line_ItemsUpdateWithWhereUniqueWithoutQuote_TemplatesInput>>;
  updateMany?: InputMaybe<Array<Quote_Template_Line_ItemsUpdateManyWithWhereWithoutQuote_TemplatesInput>>;
  upsert?: InputMaybe<Array<Quote_Template_Line_ItemsUpsertWithWhereUniqueWithoutQuote_TemplatesInput>>;
};

export type Quote_Template_Line_ItemsUpdateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_Line_ItemsCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Quote_Template_Line_ItemsCreateWithoutSupplier_ImagesInput>>;
  delete?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Template_Line_ItemsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Template_Line_ItemsWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Template_Line_ItemsUpdateWithWhereUniqueWithoutSupplier_ImagesInput>>;
  updateMany?: InputMaybe<Array<Quote_Template_Line_ItemsUpdateManyWithWhereWithoutSupplier_ImagesInput>>;
  upsert?: InputMaybe<Array<Quote_Template_Line_ItemsUpsertWithWhereUniqueWithoutSupplier_ImagesInput>>;
};

export type Quote_Template_Line_ItemsUpdateWithWhereUniqueWithoutQuote_TemplatesInput = {
  data: Quote_Template_Line_ItemsUpdateWithoutQuote_TemplatesInput;
  where: Quote_Template_Line_ItemsWhereUniqueInput;
};

export type Quote_Template_Line_ItemsUpdateWithWhereUniqueWithoutSupplier_ImagesInput = {
  data: Quote_Template_Line_ItemsUpdateWithoutSupplier_ImagesInput;
  where: Quote_Template_Line_ItemsWhereUniqueInput;
};

export type Quote_Template_Line_ItemsUpdateWithoutQuote_TemplatesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  supplier_images?: InputMaybe<Supplier_ImagesUpdateOneWithoutQuote_Template_Line_ItemsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Template_Line_Items_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Template_Line_ItemsUpdateWithoutSupplier_ImagesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateOneRequiredWithoutQuote_Template_Line_ItemsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Quote_Template_Line_Items_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Template_Line_ItemsUpsertWithWhereUniqueWithoutQuote_TemplatesInput = {
  create: Quote_Template_Line_ItemsCreateWithoutQuote_TemplatesInput;
  update: Quote_Template_Line_ItemsUpdateWithoutQuote_TemplatesInput;
  where: Quote_Template_Line_ItemsWhereUniqueInput;
};

export type Quote_Template_Line_ItemsUpsertWithWhereUniqueWithoutSupplier_ImagesInput = {
  create: Quote_Template_Line_ItemsCreateWithoutSupplier_ImagesInput;
  update: Quote_Template_Line_ItemsUpdateWithoutSupplier_ImagesInput;
  where: Quote_Template_Line_ItemsWhereUniqueInput;
};

export type Quote_Template_Line_ItemsWhereInput = {
  AND?: InputMaybe<Array<Quote_Template_Line_ItemsWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Template_Line_ItemsWhereInput>>;
  OR?: InputMaybe<Array<Quote_Template_Line_ItemsWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  image_id?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  price?: InputMaybe<IntFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  quote_template_id?: InputMaybe<StringFilter>;
  quote_templates?: InputMaybe<Quote_TemplatesWhereInput>;
  supplier_images?: InputMaybe<Supplier_ImagesWhereInput>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Quote_Template_Line_Items_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Template_Line_ItemsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Quote_Template_Tags = {
  __typename?: 'quote_template_tags';
  created: Scalars['DateTime']['output'];
  tag_id: Scalars['String']['output'];
  template_id: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type Quote_Template_TagsCreateManyWithoutQuote_TemplatesInput = {
  connect?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_TagsCreateOrConnectWithoutquote_TemplatesInput>>;
  create?: InputMaybe<Array<Quote_Template_TagsCreateWithoutQuote_TemplatesInput>>;
};

export type Quote_Template_TagsCreateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Quote_Template_TagsCreateWithoutTagsInput>>;
};

export type Quote_Template_TagsCreateOrConnectWithoutquote_TemplatesInput = {
  create: Quote_Template_TagsCreateWithoutQuote_TemplatesInput;
  where: Quote_Template_TagsWhereUniqueInput;
};

export type Quote_Template_TagsCreateOrConnectWithouttagsInput = {
  create: Quote_Template_TagsCreateWithoutTagsInput;
  where: Quote_Template_TagsWhereUniqueInput;
};

export type Quote_Template_TagsCreateWithoutQuote_TemplatesInput = {
  created: Scalars['DateTime']['input'];
  tags: TagsCreateOneWithoutQuote_Template_TagsInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Template_TagsCreateWithoutTagsInput = {
  created: Scalars['DateTime']['input'];
  quote_templates: Quote_TemplatesCreateOneWithoutQuote_Template_TagsInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Quote_Template_TagsScalarWhereInput = {
  AND?: InputMaybe<Array<Quote_Template_TagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Template_TagsScalarWhereInput>>;
  OR?: InputMaybe<Array<Quote_Template_TagsScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  tag_id?: InputMaybe<StringFilter>;
  template_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Template_TagsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Template_TagsUpdateManyWithWhereWithoutQuote_TemplatesInput = {
  data: Quote_Template_TagsUpdateManyMutationInput;
  where: Quote_Template_TagsScalarWhereInput;
};

export type Quote_Template_TagsUpdateManyWithWhereWithoutTagsInput = {
  data: Quote_Template_TagsUpdateManyMutationInput;
  where: Quote_Template_TagsScalarWhereInput;
};

export type Quote_Template_TagsUpdateManyWithoutQuote_TemplatesInput = {
  connect?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_TagsCreateOrConnectWithoutquote_TemplatesInput>>;
  create?: InputMaybe<Array<Quote_Template_TagsCreateWithoutQuote_TemplatesInput>>;
  delete?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Template_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Template_TagsUpdateWithWhereUniqueWithoutQuote_TemplatesInput>>;
  updateMany?: InputMaybe<Array<Quote_Template_TagsUpdateManyWithWhereWithoutQuote_TemplatesInput>>;
  upsert?: InputMaybe<Array<Quote_Template_TagsUpsertWithWhereUniqueWithoutQuote_TemplatesInput>>;
};

export type Quote_Template_TagsUpdateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_Template_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Quote_Template_TagsCreateWithoutTagsInput>>;
  delete?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_Template_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_Template_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_Template_TagsUpdateWithWhereUniqueWithoutTagsInput>>;
  updateMany?: InputMaybe<Array<Quote_Template_TagsUpdateManyWithWhereWithoutTagsInput>>;
  upsert?: InputMaybe<Array<Quote_Template_TagsUpsertWithWhereUniqueWithoutTagsInput>>;
};

export type Quote_Template_TagsUpdateWithWhereUniqueWithoutQuote_TemplatesInput = {
  data: Quote_Template_TagsUpdateWithoutQuote_TemplatesInput;
  where: Quote_Template_TagsWhereUniqueInput;
};

export type Quote_Template_TagsUpdateWithWhereUniqueWithoutTagsInput = {
  data: Quote_Template_TagsUpdateWithoutTagsInput;
  where: Quote_Template_TagsWhereUniqueInput;
};

export type Quote_Template_TagsUpdateWithoutQuote_TemplatesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneRequiredWithoutQuote_Template_TagsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Template_TagsUpdateWithoutTagsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateOneRequiredWithoutQuote_Template_TagsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_Template_TagsUpsertWithWhereUniqueWithoutQuote_TemplatesInput = {
  create: Quote_Template_TagsCreateWithoutQuote_TemplatesInput;
  update: Quote_Template_TagsUpdateWithoutQuote_TemplatesInput;
  where: Quote_Template_TagsWhereUniqueInput;
};

export type Quote_Template_TagsUpsertWithWhereUniqueWithoutTagsInput = {
  create: Quote_Template_TagsCreateWithoutTagsInput;
  update: Quote_Template_TagsUpdateWithoutTagsInput;
  where: Quote_Template_TagsWhereUniqueInput;
};

export type Quote_Template_TagsWhereInput = {
  AND?: InputMaybe<Array<Quote_Template_TagsWhereInput>>;
  NOT?: InputMaybe<Array<Quote_Template_TagsWhereInput>>;
  OR?: InputMaybe<Array<Quote_Template_TagsWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  quote_templates?: InputMaybe<Quote_TemplatesWhereInput>;
  tag_id?: InputMaybe<StringFilter>;
  tags?: InputMaybe<TagsWhereInput>;
  template_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_Template_TagsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Quote_Templates = {
  __typename?: 'quote_templates';
  attachments: Array<Attachment>;
  created?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Event_Type>;
  menu?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priceBreakdown?: Maybe<PriceBreakdown>;
  price_per_head?: Maybe<Scalars['Int']['output']>;
  quoteTemplateLineItems: Array<Quote_Template_Line_Items>;
  quote_template_line_items: Array<Quote_Template_Line_Items>;
  quote_template_tags: Array<QuoteTemplateTagNamesAndIds>;
  supplier_id?: Maybe<Scalars['String']['output']>;
  suppliers?: Maybe<Suppliers>;
  updated?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type Quote_TemplatesCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_type?: InputMaybe<Event_Type>;
  menu?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price_per_head?: InputMaybe<Scalars['Int']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Quote_TemplatesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Quote_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_TemplatesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Quote_TemplatesCreateWithoutSuppliersInput>>;
};

export type Quote_TemplatesCreateOneWithoutQuote_Template_Line_ItemsInput = {
  connect?: InputMaybe<Quote_TemplatesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Quote_TemplatesCreateOrConnectWithoutquote_Template_Line_ItemsInput>;
  create?: InputMaybe<Quote_TemplatesCreateWithoutQuote_Template_Line_ItemsInput>;
};

export type Quote_TemplatesCreateOneWithoutQuote_Template_TagsInput = {
  connect?: InputMaybe<Quote_TemplatesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Quote_TemplatesCreateOrConnectWithoutquote_Template_TagsInput>;
  create?: InputMaybe<Quote_TemplatesCreateWithoutQuote_Template_TagsInput>;
};

export type Quote_TemplatesCreateOrConnectWithoutquote_Template_Line_ItemsInput = {
  create: Quote_TemplatesCreateWithoutQuote_Template_Line_ItemsInput;
  where: Quote_TemplatesWhereUniqueInput;
};

export type Quote_TemplatesCreateOrConnectWithoutquote_Template_TagsInput = {
  create: Quote_TemplatesCreateWithoutQuote_Template_TagsInput;
  where: Quote_TemplatesWhereUniqueInput;
};

export type Quote_TemplatesCreateOrConnectWithoutsuppliersInput = {
  create: Quote_TemplatesCreateWithoutSuppliersInput;
  where: Quote_TemplatesWhereUniqueInput;
};

export type Quote_TemplatesCreateWithoutQuote_Template_Line_ItemsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_type?: InputMaybe<Event_Type>;
  menu?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price_per_head?: InputMaybe<Scalars['Int']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutQuote_TemplatesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Quote_TemplatesCreateWithoutQuote_Template_TagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_type?: InputMaybe<Event_Type>;
  menu?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price_per_head?: InputMaybe<Scalars['Int']['input']>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsCreateManyWithoutQuote_TemplatesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Quote_TemplatesCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_type?: InputMaybe<Event_Type>;
  menu?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price_per_head?: InputMaybe<Scalars['Int']['input']>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsCreateManyWithoutQuote_TemplatesInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Quote_TemplatesQuote_Templates_Supplier_Id_NameCompoundUniqueInput = {
  name: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};

export type Quote_TemplatesScalarWhereInput = {
  AND?: InputMaybe<Array<Quote_TemplatesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Quote_TemplatesScalarWhereInput>>;
  OR?: InputMaybe<Array<Quote_TemplatesScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_type?: InputMaybe<Enumevent_TypeNullableFilter>;
  menu?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  price_per_head?: InputMaybe<IntNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_TemplatesUpdateInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_type?: InputMaybe<NullableEnumevent_TypeFieldUpdateOperationsInput>;
  menu?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price_per_head?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_TemplatesUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_type?: InputMaybe<NullableEnumevent_TypeFieldUpdateOperationsInput>;
  menu?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price_per_head?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_TemplatesUpdateManyWithWhereWithoutSuppliersInput = {
  data: Quote_TemplatesUpdateManyMutationInput;
  where: Quote_TemplatesScalarWhereInput;
};

export type Quote_TemplatesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Quote_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Quote_TemplatesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Quote_TemplatesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Quote_TemplatesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Quote_TemplatesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Quote_TemplatesWhereUniqueInput>>;
  set?: InputMaybe<Array<Quote_TemplatesWhereUniqueInput>>;
  update?: InputMaybe<Array<Quote_TemplatesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Quote_TemplatesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Quote_TemplatesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Quote_TemplatesUpdateOneRequiredWithoutQuote_Template_Line_ItemsInput = {
  connect?: InputMaybe<Quote_TemplatesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Quote_TemplatesCreateOrConnectWithoutquote_Template_Line_ItemsInput>;
  create?: InputMaybe<Quote_TemplatesCreateWithoutQuote_Template_Line_ItemsInput>;
  update?: InputMaybe<Quote_TemplatesUpdateWithoutQuote_Template_Line_ItemsInput>;
  upsert?: InputMaybe<Quote_TemplatesUpsertWithoutQuote_Template_Line_ItemsInput>;
};

export type Quote_TemplatesUpdateOneRequiredWithoutQuote_Template_TagsInput = {
  connect?: InputMaybe<Quote_TemplatesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Quote_TemplatesCreateOrConnectWithoutquote_Template_TagsInput>;
  create?: InputMaybe<Quote_TemplatesCreateWithoutQuote_Template_TagsInput>;
  update?: InputMaybe<Quote_TemplatesUpdateWithoutQuote_Template_TagsInput>;
  upsert?: InputMaybe<Quote_TemplatesUpsertWithoutQuote_Template_TagsInput>;
};

export type Quote_TemplatesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Quote_TemplatesUpdateWithoutSuppliersInput;
  where: Quote_TemplatesWhereUniqueInput;
};

export type Quote_TemplatesUpdateWithoutQuote_Template_Line_ItemsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_type?: InputMaybe<NullableEnumevent_TypeFieldUpdateOperationsInput>;
  menu?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price_per_head?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutQuote_TemplatesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_TemplatesUpdateWithoutQuote_Template_TagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_type?: InputMaybe<NullableEnumevent_TypeFieldUpdateOperationsInput>;
  menu?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price_per_head?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsUpdateManyWithoutQuote_TemplatesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_TemplatesUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_type?: InputMaybe<NullableEnumevent_TypeFieldUpdateOperationsInput>;
  menu?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price_per_head?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsUpdateManyWithoutQuote_TemplatesInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutQuote_TemplatesInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Quote_TemplatesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Quote_TemplatesCreateWithoutSuppliersInput;
  update: Quote_TemplatesUpdateWithoutSuppliersInput;
  where: Quote_TemplatesWhereUniqueInput;
};

export type Quote_TemplatesUpsertWithoutQuote_Template_Line_ItemsInput = {
  create: Quote_TemplatesCreateWithoutQuote_Template_Line_ItemsInput;
  update: Quote_TemplatesUpdateWithoutQuote_Template_Line_ItemsInput;
};

export type Quote_TemplatesUpsertWithoutQuote_Template_TagsInput = {
  create: Quote_TemplatesCreateWithoutQuote_Template_TagsInput;
  update: Quote_TemplatesUpdateWithoutQuote_Template_TagsInput;
};

export type Quote_TemplatesWhereInput = {
  AND?: InputMaybe<Array<Quote_TemplatesWhereInput>>;
  NOT?: InputMaybe<Array<Quote_TemplatesWhereInput>>;
  OR?: InputMaybe<Array<Quote_TemplatesWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_type?: InputMaybe<Enumevent_TypeNullableFilter>;
  menu?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  price_per_head?: InputMaybe<IntNullableFilter>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsListRelationFilter>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsListRelationFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Quote_TemplatesWhereUniqueInput = {
  quote_templates_supplier_id_name?: InputMaybe<Quote_TemplatesQuote_Templates_Supplier_Id_NameCompoundUniqueInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Quotes = {
  __typename?: 'quotes';
  attachments: Array<Attachment>;
  commission_fee: Scalars['Float']['output'];
  contractType?: Maybe<QuoteContractType>;
  covers: Scalars['Int']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  custom_event_name?: Maybe<Scalars['String']['output']>;
  declined_reason?: Maybe<Enum_Quotes_Declined_Reason>;
  distance?: Maybe<Scalars['Float']['output']>;
  distanceSource?: Maybe<DistanceSource>;
  drivingDistanceEta?: Maybe<Scalars['String']['output']>;
  emailSent?: Maybe<Scalars['Boolean']['output']>;
  event_request_id?: Maybe<Scalars['String']['output']>;
  event_requests?: Maybe<Event_Requests>;
  freshdesk_ticket_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  introMessage?: Maybe<Scalars['String']['output']>;
  invoiceDetails?: Maybe<InvoiceDetails>;
  isDepositsEligible: Scalars['Boolean']['output'];
  isShortlisted: Scalars['Boolean']['output'];
  is_excl_vat_price: Scalars['Boolean']['output'];
  old_commission: Scalars['Boolean']['output'];
  partnershipCommission?: Maybe<Scalars['Float']['output']>;
  payment_type?: Maybe<Enum_Quotes_Payment_Type>;
  poNumber?: Maybe<Scalars['String']['output']>;
  priceBreakdown?: Maybe<QuotePriceBreakdown>;
  protection_fee?: Maybe<Scalars['Float']['output']>;
  protection_rounding?: Maybe<Scalars['Float']['output']>;
  protection_type?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  quotePriceDetails?: Maybe<QuotePriceDetails>;
  quote_line_items: Array<Quote_Line_Items>;
  read_timestamp?: Maybe<Scalars['DateTime']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  service_fee: Scalars['Float']['output'];
  showFollowUpReminder?: Maybe<Scalars['Boolean']['output']>;
  signatoryEmail?: Maybe<Scalars['String']['output']>;
  signatoryName?: Maybe<Scalars['String']['output']>;
  state: Enum_Quotes_State;
  supplier_id?: Maybe<Scalars['String']['output']>;
  supplier_payments: Array<Supplier_Payments>;
  suppliers?: Maybe<Suppliers>;
  supportText?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  vatStatus: VatStatus;
};


export type QuotesQuote_Line_ItemsArgs = {
  cursor?: InputMaybe<Quote_Line_ItemsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuotesCreateManyWithoutBookingsInput = {
  connect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuotesCreateOrConnectWithoutbookingsInput>>;
  create?: InputMaybe<Array<QuotesCreateWithoutBookingsInput>>;
};

export type QuotesCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuotesCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<QuotesCreateWithoutEvent_RequestsInput>>;
};

export type QuotesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuotesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<QuotesCreateWithoutSuppliersInput>>;
};

export type QuotesCreateOneWithoutQuote_Line_ItemsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutquote_Line_ItemsInput>;
  create?: InputMaybe<QuotesCreateWithoutQuote_Line_ItemsInput>;
};

export type QuotesCreateOneWithoutReviewsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutreviewsInput>;
  create?: InputMaybe<QuotesCreateWithoutReviewsInput>;
};

export type QuotesCreateOneWithoutScheduled_PaymentsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutscheduled_PaymentsInput>;
  create?: InputMaybe<QuotesCreateWithoutScheduled_PaymentsInput>;
};

export type QuotesCreateOneWithoutSupplier_Calendars_EventsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutsupplier_Calendars_EventsInput>;
  create?: InputMaybe<QuotesCreateWithoutSupplier_Calendars_EventsInput>;
};

export type QuotesCreateOneWithoutSupplier_PaymentsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutsupplier_PaymentsInput>;
  create?: InputMaybe<QuotesCreateWithoutSupplier_PaymentsInput>;
};

export type QuotesCreateOrConnectWithoutbookingsInput = {
  create: QuotesCreateWithoutBookingsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateOrConnectWithoutevent_RequestsInput = {
  create: QuotesCreateWithoutEvent_RequestsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateOrConnectWithoutquote_Line_ItemsInput = {
  create: QuotesCreateWithoutQuote_Line_ItemsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateOrConnectWithoutreviewsInput = {
  create: QuotesCreateWithoutReviewsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateOrConnectWithoutscheduled_PaymentsInput = {
  create: QuotesCreateWithoutScheduled_PaymentsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateOrConnectWithoutsupplier_Calendars_EventsInput = {
  create: QuotesCreateWithoutSupplier_Calendars_EventsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateOrConnectWithoutsupplier_PaymentsInput = {
  create: QuotesCreateWithoutSupplier_PaymentsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateOrConnectWithoutsuppliersInput = {
  create: QuotesCreateWithoutSuppliersInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesCreateWithoutBookingsInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesCreateWithoutEvent_RequestsInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesCreateWithoutQuote_Line_ItemsInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesCreateWithoutReviewsInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesCreateWithoutScheduled_PaymentsInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesCreateWithoutSupplier_Calendars_EventsInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesCreateWithoutSupplier_PaymentsInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesCreateWithoutSuppliersInput = {
  booked_date?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<Scalars['DateTime']['input']>;
  commission_fee: Scalars['Float']['input'];
  covers: Scalars['Int']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_date?: InputMaybe<Scalars['DateTime']['input']>;
  declined_reason?: InputMaybe<Enum_Quotes_Declined_Reason>;
  declined_reason_old?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  event_requests?: InputMaybe<Event_RequestsCreateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  last_supplier_reminder?: InputMaybe<Scalars['DateTime']['input']>;
  menuPrice?: InputMaybe<Scalars['Float']['input']>;
  old_commission?: InputMaybe<Scalars['Boolean']['input']>;
  payment_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  payment_type?: InputMaybe<Enum_Quotes_Payment_Type>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<Scalars['Float']['input']>;
  protection_rounding?: InputMaybe<Scalars['Float']['input']>;
  protection_type?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsCreateManyWithoutQuotesInput>;
  service_fee: Scalars['Float']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Enum_Quotes_State>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateManyWithoutQuotesInput>;
  supportText?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  withdrawn_date?: InputMaybe<Scalars['DateTime']['input']>;
  xero_invoices?: InputMaybe<Xero_InvoicesCreateManyWithoutQuotesInput>;
};

export type QuotesOrderByInput = {
  booked_date?: InputMaybe<SortOrder>;
  booking_id?: InputMaybe<SortOrder>;
  cancelled_date?: InputMaybe<SortOrder>;
  commission_fee?: InputMaybe<SortOrder>;
  covers?: InputMaybe<SortOrder>;
  created?: InputMaybe<SortOrder>;
  declined_date?: InputMaybe<SortOrder>;
  declined_reason?: InputMaybe<SortOrder>;
  declined_reason_old?: InputMaybe<SortOrder>;
  emailSent?: InputMaybe<SortOrder>;
  event_request_id?: InputMaybe<SortOrder>;
  freshdesk_ticket_id?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNote?: InputMaybe<SortOrder>;
  last_supplier_reminder?: InputMaybe<SortOrder>;
  menuPrice?: InputMaybe<SortOrder>;
  old_commission?: InputMaybe<SortOrder>;
  payment_timestamp?: InputMaybe<SortOrder>;
  payment_type?: InputMaybe<SortOrder>;
  promotions?: InputMaybe<SortOrder>;
  protection_fee?: InputMaybe<SortOrder>;
  protection_rounding?: InputMaybe<SortOrder>;
  protection_type?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  read_timestamp?: InputMaybe<SortOrder>;
  service_fee?: InputMaybe<SortOrder>;
  specialPrice?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  supplier_id?: InputMaybe<SortOrder>;
  supportText?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  updated?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
  withdrawn_date?: InputMaybe<SortOrder>;
};

export type QuotesScalarWhereInput = {
  AND?: InputMaybe<Array<QuotesScalarWhereInput>>;
  NOT?: InputMaybe<Array<QuotesScalarWhereInput>>;
  OR?: InputMaybe<Array<QuotesScalarWhereInput>>;
  booked_date?: InputMaybe<DateTimeNullableFilter>;
  booking_id?: InputMaybe<StringNullableFilter>;
  cancelled_date?: InputMaybe<DateTimeNullableFilter>;
  commission_fee?: InputMaybe<FloatFilter>;
  covers?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  declined_date?: InputMaybe<DateTimeNullableFilter>;
  declined_reason?: InputMaybe<Enumenum_Quotes_Declined_ReasonNullableFilter>;
  declined_reason_old?: InputMaybe<StringNullableFilter>;
  emailSent?: InputMaybe<BoolNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  freshdesk_ticket_id?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringNullableFilter>;
  internalNote?: InputMaybe<StringNullableFilter>;
  last_supplier_reminder?: InputMaybe<DateTimeNullableFilter>;
  menuPrice?: InputMaybe<FloatNullableFilter>;
  old_commission?: InputMaybe<BoolFilter>;
  payment_timestamp?: InputMaybe<DateTimeNullableFilter>;
  payment_type?: InputMaybe<Enumenum_Quotes_Payment_TypeNullableFilter>;
  promotions?: InputMaybe<JsonNullableFilter>;
  protection_fee?: InputMaybe<FloatNullableFilter>;
  protection_rounding?: InputMaybe<FloatNullableFilter>;
  protection_type?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  read_timestamp?: InputMaybe<DateTimeNullableFilter>;
  service_fee?: InputMaybe<FloatFilter>;
  specialPrice?: InputMaybe<FloatFilter>;
  state?: InputMaybe<Enumenum_Quotes_StateFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  supportText?: InputMaybe<StringNullableFilter>;
  total?: InputMaybe<IntFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
  withdrawn_date?: InputMaybe<DateTimeNullableFilter>;
};

export type QuotesUpdateInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateManyMutationInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type QuotesUpdateManyWithWhereWithoutBookingsInput = {
  data: QuotesUpdateManyMutationInput;
  where: QuotesScalarWhereInput;
};

export type QuotesUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: QuotesUpdateManyMutationInput;
  where: QuotesScalarWhereInput;
};

export type QuotesUpdateManyWithWhereWithoutSuppliersInput = {
  data: QuotesUpdateManyMutationInput;
  where: QuotesScalarWhereInput;
};

export type QuotesUpdateManyWithoutBookingsInput = {
  connect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuotesCreateOrConnectWithoutbookingsInput>>;
  create?: InputMaybe<Array<QuotesCreateWithoutBookingsInput>>;
  delete?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<QuotesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  set?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  update?: InputMaybe<Array<QuotesUpdateWithWhereUniqueWithoutBookingsInput>>;
  updateMany?: InputMaybe<Array<QuotesUpdateManyWithWhereWithoutBookingsInput>>;
  upsert?: InputMaybe<Array<QuotesUpsertWithWhereUniqueWithoutBookingsInput>>;
};

export type QuotesUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuotesCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<QuotesCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<QuotesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  set?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  update?: InputMaybe<Array<QuotesUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<QuotesUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<QuotesUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type QuotesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuotesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<QuotesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<QuotesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  set?: InputMaybe<Array<QuotesWhereUniqueInput>>;
  update?: InputMaybe<Array<QuotesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<QuotesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<QuotesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type QuotesUpdateOneRequiredWithoutQuote_Line_ItemsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutquote_Line_ItemsInput>;
  create?: InputMaybe<QuotesCreateWithoutQuote_Line_ItemsInput>;
  update?: InputMaybe<QuotesUpdateWithoutQuote_Line_ItemsInput>;
  upsert?: InputMaybe<QuotesUpsertWithoutQuote_Line_ItemsInput>;
};

export type QuotesUpdateOneRequiredWithoutScheduled_PaymentsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutscheduled_PaymentsInput>;
  create?: InputMaybe<QuotesCreateWithoutScheduled_PaymentsInput>;
  update?: InputMaybe<QuotesUpdateWithoutScheduled_PaymentsInput>;
  upsert?: InputMaybe<QuotesUpsertWithoutScheduled_PaymentsInput>;
};

export type QuotesUpdateOneRequiredWithoutSupplier_PaymentsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutsupplier_PaymentsInput>;
  create?: InputMaybe<QuotesCreateWithoutSupplier_PaymentsInput>;
  update?: InputMaybe<QuotesUpdateWithoutSupplier_PaymentsInput>;
  upsert?: InputMaybe<QuotesUpsertWithoutSupplier_PaymentsInput>;
};

export type QuotesUpdateOneWithoutReviewsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutreviewsInput>;
  create?: InputMaybe<QuotesCreateWithoutReviewsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<QuotesUpdateWithoutReviewsInput>;
  upsert?: InputMaybe<QuotesUpsertWithoutReviewsInput>;
};

export type QuotesUpdateOneWithoutSupplier_Calendars_EventsInput = {
  connect?: InputMaybe<QuotesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuotesCreateOrConnectWithoutsupplier_Calendars_EventsInput>;
  create?: InputMaybe<QuotesCreateWithoutSupplier_Calendars_EventsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<QuotesUpdateWithoutSupplier_Calendars_EventsInput>;
  upsert?: InputMaybe<QuotesUpsertWithoutSupplier_Calendars_EventsInput>;
};

export type QuotesUpdateWithWhereUniqueWithoutBookingsInput = {
  data: QuotesUpdateWithoutBookingsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: QuotesUpdateWithoutEvent_RequestsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: QuotesUpdateWithoutSuppliersInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesUpdateWithoutBookingsInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateWithoutEvent_RequestsInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateWithoutQuote_Line_ItemsInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateWithoutReviewsInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateWithoutScheduled_PaymentsInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateWithoutSupplier_Calendars_EventsInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateWithoutSupplier_PaymentsInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpdateWithoutSuppliersInput = {
  booked_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutQuotesInput>;
  cancelled_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commission_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  covers?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_reason?: InputMaybe<NullableEnumenum_Quotes_Declined_ReasonFieldUpdateOperationsInput>;
  declined_reason_old?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneWithoutQuotesInput>;
  freshdesk_ticket_id?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_supplier_reminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  menuPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  old_commission?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payment_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<NullableEnumenum_Quotes_Payment_TypeFieldUpdateOperationsInput>;
  promotions?: InputMaybe<Scalars['Json']['input']>;
  protection_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_rounding?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  protection_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutQuotesInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutQuotesInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateManyWithoutQuotesInput>;
  service_fee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  specialPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  state?: InputMaybe<Enumenum_Quotes_StateFieldUpdateOperationsInput>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutQuotesInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateManyWithoutQuotesInput>;
  supportText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  withdrawn_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  xero_invoices?: InputMaybe<Xero_InvoicesUpdateManyWithoutQuotesInput>;
};

export type QuotesUpsertWithWhereUniqueWithoutBookingsInput = {
  create: QuotesCreateWithoutBookingsInput;
  update: QuotesUpdateWithoutBookingsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: QuotesCreateWithoutEvent_RequestsInput;
  update: QuotesUpdateWithoutEvent_RequestsInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: QuotesCreateWithoutSuppliersInput;
  update: QuotesUpdateWithoutSuppliersInput;
  where: QuotesWhereUniqueInput;
};

export type QuotesUpsertWithoutQuote_Line_ItemsInput = {
  create: QuotesCreateWithoutQuote_Line_ItemsInput;
  update: QuotesUpdateWithoutQuote_Line_ItemsInput;
};

export type QuotesUpsertWithoutReviewsInput = {
  create: QuotesCreateWithoutReviewsInput;
  update: QuotesUpdateWithoutReviewsInput;
};

export type QuotesUpsertWithoutScheduled_PaymentsInput = {
  create: QuotesCreateWithoutScheduled_PaymentsInput;
  update: QuotesUpdateWithoutScheduled_PaymentsInput;
};

export type QuotesUpsertWithoutSupplier_Calendars_EventsInput = {
  create: QuotesCreateWithoutSupplier_Calendars_EventsInput;
  update: QuotesUpdateWithoutSupplier_Calendars_EventsInput;
};

export type QuotesUpsertWithoutSupplier_PaymentsInput = {
  create: QuotesCreateWithoutSupplier_PaymentsInput;
  update: QuotesUpdateWithoutSupplier_PaymentsInput;
};

export type QuotesWhereInput = {
  AND?: InputMaybe<Array<QuotesWhereInput>>;
  NOT?: InputMaybe<Array<QuotesWhereInput>>;
  OR?: InputMaybe<Array<QuotesWhereInput>>;
  booked_date?: InputMaybe<DateTimeNullableFilter>;
  booking_id?: InputMaybe<StringNullableFilter>;
  bookings?: InputMaybe<BookingsWhereInput>;
  cancelled_date?: InputMaybe<DateTimeNullableFilter>;
  commission_fee?: InputMaybe<FloatFilter>;
  covers?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  declined_date?: InputMaybe<DateTimeNullableFilter>;
  declined_reason?: InputMaybe<Enumenum_Quotes_Declined_ReasonNullableFilter>;
  declined_reason_old?: InputMaybe<StringNullableFilter>;
  emailSent?: InputMaybe<BoolNullableFilter>;
  event_request_id?: InputMaybe<StringNullableFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  freshdesk_ticket_id?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringNullableFilter>;
  internalNote?: InputMaybe<StringNullableFilter>;
  last_supplier_reminder?: InputMaybe<DateTimeNullableFilter>;
  menuPrice?: InputMaybe<FloatNullableFilter>;
  old_commission?: InputMaybe<BoolFilter>;
  payment_timestamp?: InputMaybe<DateTimeNullableFilter>;
  payment_type?: InputMaybe<Enumenum_Quotes_Payment_TypeNullableFilter>;
  promotions?: InputMaybe<JsonNullableFilter>;
  protection_fee?: InputMaybe<FloatNullableFilter>;
  protection_rounding?: InputMaybe<FloatNullableFilter>;
  protection_type?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsListRelationFilter>;
  read_timestamp?: InputMaybe<DateTimeNullableFilter>;
  reviews?: InputMaybe<ReviewsListRelationFilter>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsListRelationFilter>;
  service_fee?: InputMaybe<FloatFilter>;
  specialPrice?: InputMaybe<FloatFilter>;
  state?: InputMaybe<Enumenum_Quotes_StateFilter>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsListRelationFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  supplier_payments?: InputMaybe<Supplier_PaymentsListRelationFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  supportText?: InputMaybe<StringNullableFilter>;
  total?: InputMaybe<IntFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
  withdrawn_date?: InputMaybe<DateTimeNullableFilter>;
  xero_invoices?: InputMaybe<Xero_InvoicesListRelationFilter>;
};

export type QuotesWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type RankedSupplier = {
  __typename?: 'rankedSupplier';
  distance?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
};

export type Recommendations = {
  __typename?: 'recommendations';
  highlight?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  team_member_name?: Maybe<Scalars['String']['output']>;
};

export type RecommendationsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<RecommendationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RecommendationsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<RecommendationsCreateWithoutSuppliersInput>>;
};

export type RecommendationsCreateOrConnectWithoutsuppliersInput = {
  create: RecommendationsCreateWithoutSuppliersInput;
  where: RecommendationsWhereUniqueInput;
};

export type RecommendationsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  team_member_name?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type RecommendationsScalarWhereInput = {
  AND?: InputMaybe<Array<RecommendationsScalarWhereInput>>;
  NOT?: InputMaybe<Array<RecommendationsScalarWhereInput>>;
  OR?: InputMaybe<Array<RecommendationsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  highlight?: InputMaybe<StringNullableFilter>;
  recommendation?: InputMaybe<StringNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  team_member_name?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type RecommendationsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  highlight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  recommendation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  team_member_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RecommendationsUpdateManyWithWhereWithoutSuppliersInput = {
  data: RecommendationsUpdateManyMutationInput;
  where: RecommendationsScalarWhereInput;
};

export type RecommendationsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<RecommendationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RecommendationsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<RecommendationsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<RecommendationsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RecommendationsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RecommendationsWhereUniqueInput>>;
  set?: InputMaybe<Array<RecommendationsWhereUniqueInput>>;
  update?: InputMaybe<Array<RecommendationsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<RecommendationsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<RecommendationsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type RecommendationsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: RecommendationsUpdateWithoutSuppliersInput;
  where: RecommendationsWhereUniqueInput;
};

export type RecommendationsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  highlight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  recommendation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  team_member_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RecommendationsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: RecommendationsCreateWithoutSuppliersInput;
  update: RecommendationsUpdateWithoutSuppliersInput;
  where: RecommendationsWhereUniqueInput;
};

export type RecommendationsWhereInput = {
  AND?: InputMaybe<Array<RecommendationsWhereInput>>;
  NOT?: InputMaybe<Array<RecommendationsWhereInput>>;
  OR?: InputMaybe<Array<RecommendationsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  highlight?: InputMaybe<StringNullableFilter>;
  recommendation?: InputMaybe<StringNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  team_member_name?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type RecommendationsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Referral = {
  __typename?: 'referral';
  bookedDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  paymentTimestamp?: Maybe<Scalars['String']['output']>;
};

export type Referrals = {
  __typename?: 'referrals';
  count?: Maybe<Scalars['Int']['output']>;
  referrals?: Maybe<Array<Maybe<Referral>>>;
};

export type RegionsCreateOneWithoutEventsInput = {
  connect?: InputMaybe<RegionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegionsCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<RegionsCreateWithoutEventsInput>;
};

export type RegionsCreateOrConnectWithouteventsInput = {
  create: RegionsCreateWithoutEventsInput;
  where: RegionsWhereUniqueInput;
};

export type RegionsCreateWithoutEventsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  district: Scalars['String']['input'];
  postcode_prefix: Scalars['String']['input'];
  uk_region: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegionsUpdateOneWithoutEventsInput = {
  connect?: InputMaybe<RegionsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegionsCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<RegionsCreateWithoutEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<RegionsUpdateWithoutEventsInput>;
  upsert?: InputMaybe<RegionsUpsertWithoutEventsInput>;
};

export type RegionsUpdateWithoutEventsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  district?: InputMaybe<StringFieldUpdateOperationsInput>;
  postcode_prefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  uk_region?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type RegionsUpsertWithoutEventsInput = {
  create: RegionsCreateWithoutEventsInput;
  update: RegionsUpdateWithoutEventsInput;
};

export type RegionsWhereInput = {
  AND?: InputMaybe<Array<RegionsWhereInput>>;
  NOT?: InputMaybe<Array<RegionsWhereInput>>;
  OR?: InputMaybe<Array<RegionsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  district?: InputMaybe<StringFilter>;
  events?: InputMaybe<EventsListRelationFilter>;
  postcode_prefix?: InputMaybe<StringFilter>;
  uk_region?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type RegionsWhereUniqueInput = {
  postcode_prefix?: InputMaybe<Scalars['String']['input']>;
};

export type Reviews = {
  __typename?: 'reviews';
  authenticated?: Maybe<Scalars['Boolean']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  external_event?: Maybe<Scalars['Json']['output']>;
  fieldPublicComment?: Maybe<Scalars['String']['output']>;
  field_public_comment?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  quotes?: Maybe<Quotes>;
  reviewsExternalEvent?: Maybe<ReviewsExternalEvent>;
  source?: Maybe<Enum_Reviews_Source>;
  supplierId: Scalars['String']['output'];
  supplier_id: Scalars['String']['output'];
  suppliers?: Maybe<Suppliers>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ReviewsCreateInput = {
  authenticated?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  fieldCustomerMessage?: InputMaybe<Scalars['String']['input']>;
  fieldPrivateComment?: InputMaybe<Scalars['String']['input']>;
  fieldPublicComment?: InputMaybe<Scalars['String']['input']>;
  field_customer_message?: InputMaybe<Scalars['String']['input']>;
  field_private_comment?: InputMaybe<Scalars['String']['input']>;
  field_public_comment?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quotes?: InputMaybe<QuotesCreateOneWithoutReviewsInput>;
  ratingFriendliness?: InputMaybe<Scalars['Int']['input']>;
  ratingProfessionalism?: InputMaybe<Scalars['Int']['input']>;
  ratingQuality?: InputMaybe<Scalars['Int']['input']>;
  ratingValueForMoney?: InputMaybe<Scalars['Int']['input']>;
  rating_friendliness?: InputMaybe<Scalars['Int']['input']>;
  rating_professionalism?: InputMaybe<Scalars['Int']['input']>;
  rating_quality?: InputMaybe<Scalars['Int']['input']>;
  rating_value_for_money?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Enum_Reviews_Source>;
  suppliers: SuppliersCreateOneWithoutReviewsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type ReviewsCreateManyWithoutBookingsInput = {
  connect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewsCreateOrConnectWithoutbookingsInput>>;
  create?: InputMaybe<Array<ReviewsCreateWithoutBookingsInput>>;
};

export type ReviewsCreateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<ReviewsCreateWithoutQuotesInput>>;
};

export type ReviewsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<ReviewsCreateWithoutSuppliersInput>>;
};

export type ReviewsCreateOrConnectWithoutbookingsInput = {
  create: ReviewsCreateWithoutBookingsInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsCreateOrConnectWithoutquotesInput = {
  create: ReviewsCreateWithoutQuotesInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsCreateOrConnectWithoutsuppliersInput = {
  create: ReviewsCreateWithoutSuppliersInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsCreateWithoutBookingsInput = {
  authenticated?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  field_customer_message?: InputMaybe<Scalars['String']['input']>;
  field_private_comment?: InputMaybe<Scalars['String']['input']>;
  field_public_comment?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quotes?: InputMaybe<QuotesCreateOneWithoutReviewsInput>;
  rating_friendliness?: InputMaybe<Scalars['Int']['input']>;
  rating_professionalism?: InputMaybe<Scalars['Int']['input']>;
  rating_quality?: InputMaybe<Scalars['Int']['input']>;
  rating_value_for_money?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Enum_Reviews_Source>;
  suppliers: SuppliersCreateOneWithoutReviewsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type ReviewsCreateWithoutQuotesInput = {
  authenticated?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutReviewsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  field_customer_message?: InputMaybe<Scalars['String']['input']>;
  field_private_comment?: InputMaybe<Scalars['String']['input']>;
  field_public_comment?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rating_friendliness?: InputMaybe<Scalars['Int']['input']>;
  rating_professionalism?: InputMaybe<Scalars['Int']['input']>;
  rating_quality?: InputMaybe<Scalars['Int']['input']>;
  rating_value_for_money?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Enum_Reviews_Source>;
  suppliers: SuppliersCreateOneWithoutReviewsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type ReviewsCreateWithoutSuppliersInput = {
  authenticated?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingsCreateOneWithoutReviewsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  field_customer_message?: InputMaybe<Scalars['String']['input']>;
  field_private_comment?: InputMaybe<Scalars['String']['input']>;
  field_public_comment?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quotes?: InputMaybe<QuotesCreateOneWithoutReviewsInput>;
  rating_friendliness?: InputMaybe<Scalars['Int']['input']>;
  rating_professionalism?: InputMaybe<Scalars['Int']['input']>;
  rating_quality?: InputMaybe<Scalars['Int']['input']>;
  rating_value_for_money?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Enum_Reviews_Source>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type ReviewsScalarWhereInput = {
  AND?: InputMaybe<Array<ReviewsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReviewsScalarWhereInput>>;
  OR?: InputMaybe<Array<ReviewsScalarWhereInput>>;
  authenticated?: InputMaybe<BoolNullableFilter>;
  booking_id?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  external_event?: InputMaybe<JsonNullableFilter>;
  field_customer_message?: InputMaybe<StringNullableFilter>;
  field_private_comment?: InputMaybe<StringNullableFilter>;
  field_public_comment?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  quote_id?: InputMaybe<StringNullableFilter>;
  rating_friendliness?: InputMaybe<IntNullableFilter>;
  rating_professionalism?: InputMaybe<IntNullableFilter>;
  rating_quality?: InputMaybe<IntNullableFilter>;
  rating_value_for_money?: InputMaybe<IntNullableFilter>;
  source?: InputMaybe<Enumenum_Reviews_SourceNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type ReviewsUpdateManyMutationInput = {
  authenticated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  field_customer_message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_private_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_public_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating_friendliness?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_professionalism?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_quality?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_value_for_money?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  source?: InputMaybe<NullableEnumenum_Reviews_SourceFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReviewsUpdateManyWithWhereWithoutBookingsInput = {
  data: ReviewsUpdateManyMutationInput;
  where: ReviewsScalarWhereInput;
};

export type ReviewsUpdateManyWithWhereWithoutQuotesInput = {
  data: ReviewsUpdateManyMutationInput;
  where: ReviewsScalarWhereInput;
};

export type ReviewsUpdateManyWithWhereWithoutSuppliersInput = {
  data: ReviewsUpdateManyMutationInput;
  where: ReviewsScalarWhereInput;
};

export type ReviewsUpdateManyWithoutBookingsInput = {
  connect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewsCreateOrConnectWithoutbookingsInput>>;
  create?: InputMaybe<Array<ReviewsCreateWithoutBookingsInput>>;
  delete?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReviewsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  set?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  update?: InputMaybe<Array<ReviewsUpdateWithWhereUniqueWithoutBookingsInput>>;
  updateMany?: InputMaybe<Array<ReviewsUpdateManyWithWhereWithoutBookingsInput>>;
  upsert?: InputMaybe<Array<ReviewsUpsertWithWhereUniqueWithoutBookingsInput>>;
};

export type ReviewsUpdateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<ReviewsCreateWithoutQuotesInput>>;
  delete?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReviewsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  set?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  update?: InputMaybe<Array<ReviewsUpdateWithWhereUniqueWithoutQuotesInput>>;
  updateMany?: InputMaybe<Array<ReviewsUpdateManyWithWhereWithoutQuotesInput>>;
  upsert?: InputMaybe<Array<ReviewsUpsertWithWhereUniqueWithoutQuotesInput>>;
};

export type ReviewsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<ReviewsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReviewsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  set?: InputMaybe<Array<ReviewsWhereUniqueInput>>;
  update?: InputMaybe<Array<ReviewsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<ReviewsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<ReviewsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type ReviewsUpdateWithWhereUniqueWithoutBookingsInput = {
  data: ReviewsUpdateWithoutBookingsInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsUpdateWithWhereUniqueWithoutQuotesInput = {
  data: ReviewsUpdateWithoutQuotesInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: ReviewsUpdateWithoutSuppliersInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsUpdateWithoutBookingsInput = {
  authenticated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  field_customer_message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_private_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_public_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateOneWithoutReviewsInput>;
  rating_friendliness?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_professionalism?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_quality?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_value_for_money?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  source?: InputMaybe<NullableEnumenum_Reviews_SourceFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutReviewsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReviewsUpdateWithoutQuotesInput = {
  authenticated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutReviewsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  field_customer_message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_private_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_public_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating_friendliness?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_professionalism?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_quality?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_value_for_money?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  source?: InputMaybe<NullableEnumenum_Reviews_SourceFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutReviewsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReviewsUpdateWithoutSuppliersInput = {
  authenticated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingsUpdateOneWithoutReviewsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  external_event?: InputMaybe<Scalars['Json']['input']>;
  field_customer_message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_private_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  field_public_comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateOneWithoutReviewsInput>;
  rating_friendliness?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_professionalism?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_quality?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rating_value_for_money?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  source?: InputMaybe<NullableEnumenum_Reviews_SourceFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReviewsUpsertWithWhereUniqueWithoutBookingsInput = {
  create: ReviewsCreateWithoutBookingsInput;
  update: ReviewsUpdateWithoutBookingsInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsUpsertWithWhereUniqueWithoutQuotesInput = {
  create: ReviewsCreateWithoutQuotesInput;
  update: ReviewsUpdateWithoutQuotesInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: ReviewsCreateWithoutSuppliersInput;
  update: ReviewsUpdateWithoutSuppliersInput;
  where: ReviewsWhereUniqueInput;
};

export type ReviewsWhereInput = {
  AND?: InputMaybe<Array<ReviewsWhereInput>>;
  NOT?: InputMaybe<Array<ReviewsWhereInput>>;
  OR?: InputMaybe<Array<ReviewsWhereInput>>;
  authenticated?: InputMaybe<BoolNullableFilter>;
  booking_id?: InputMaybe<StringNullableFilter>;
  bookings?: InputMaybe<BookingsWhereInput>;
  created?: InputMaybe<DateTimeNullableFilter>;
  external_event?: InputMaybe<JsonNullableFilter>;
  field_customer_message?: InputMaybe<StringNullableFilter>;
  field_private_comment?: InputMaybe<StringNullableFilter>;
  field_public_comment?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  quote_id?: InputMaybe<StringNullableFilter>;
  quotes?: InputMaybe<QuotesWhereInput>;
  rating_friendliness?: InputMaybe<IntNullableFilter>;
  rating_professionalism?: InputMaybe<IntNullableFilter>;
  rating_quality?: InputMaybe<IntNullableFilter>;
  rating_value_for_money?: InputMaybe<IntNullableFilter>;
  source?: InputMaybe<Enumenum_Reviews_SourceNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type ReviewsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Robex_MetricCreateOneWithoutRobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Robex_MetricWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_MetricCreateOrConnectWithoutrobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Robex_MetricCreateWithoutRobex_Version_Vertical_MetricInput>;
};

export type Robex_MetricCreateOrConnectWithoutrobex_Version_Vertical_MetricInput = {
  create: Robex_MetricCreateWithoutRobex_Version_Vertical_MetricInput;
  where: Robex_MetricWhereUniqueInput;
};

export type Robex_MetricCreateWithoutRobex_Version_Vertical_MetricInput = {
  filter_type?: InputMaybe<Scalars['String']['input']>;
  is_binary?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source_field?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type Robex_MetricUpdateOneWithoutRobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Robex_MetricWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_MetricCreateOrConnectWithoutrobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Robex_MetricCreateWithoutRobex_Version_Vertical_MetricInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Robex_MetricUpdateWithoutRobex_Version_Vertical_MetricInput>;
  upsert?: InputMaybe<Robex_MetricUpsertWithoutRobex_Version_Vertical_MetricInput>;
};

export type Robex_MetricUpdateWithoutRobex_Version_Vertical_MetricInput = {
  filter_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  is_binary?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  source_field?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Robex_MetricUpsertWithoutRobex_Version_Vertical_MetricInput = {
  create: Robex_MetricCreateWithoutRobex_Version_Vertical_MetricInput;
  update: Robex_MetricUpdateWithoutRobex_Version_Vertical_MetricInput;
};

export type Robex_MetricWhereInput = {
  AND?: InputMaybe<Array<Robex_MetricWhereInput>>;
  NOT?: InputMaybe<Array<Robex_MetricWhereInput>>;
  OR?: InputMaybe<Array<Robex_MetricWhereInput>>;
  filter_type?: InputMaybe<StringNullableFilter>;
  is_binary?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricListRelationFilter>;
  source_field?: InputMaybe<StringNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Robex_MetricWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Robex_NotificationsCreateManyWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_NotificationsCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>>;
  create?: InputMaybe<Array<Robex_NotificationsCreateWithoutEvent_Request_Supplier_NotifiedInput>>;
};

export type Robex_NotificationsCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_NotificationsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Robex_NotificationsCreateWithoutUsersInput>>;
};

export type Robex_NotificationsCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput = {
  create: Robex_NotificationsCreateWithoutEvent_Request_Supplier_NotifiedInput;
  where: Robex_NotificationsWhereUniqueInput;
};

export type Robex_NotificationsCreateOrConnectWithoutusersInput = {
  create: Robex_NotificationsCreateWithoutUsersInput;
  where: Robex_NotificationsWhereUniqueInput;
};

export type Robex_NotificationsCreateWithoutEvent_Request_Supplier_NotifiedInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  notification_date?: InputMaybe<Scalars['DateTime']['input']>;
  notification_status?: InputMaybe<Enum_Robex_Notifications_Notification_Status>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users: UsersCreateOneWithoutRobex_NotificationsInput;
};

export type Robex_NotificationsCreateWithoutUsersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_supplier_notified: Event_Request_Supplier_NotifiedCreateOneWithoutRobex_NotificationsInput;
  notification_date?: InputMaybe<Scalars['DateTime']['input']>;
  notification_status?: InputMaybe<Enum_Robex_Notifications_Notification_Status>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Robex_NotificationsScalarWhereInput = {
  AND?: InputMaybe<Array<Robex_NotificationsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Robex_NotificationsScalarWhereInput>>;
  OR?: InputMaybe<Array<Robex_NotificationsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  match_uuid?: InputMaybe<StringFilter>;
  notification_date?: InputMaybe<DateTimeNullableFilter>;
  notification_status?: InputMaybe<Enumenum_Robex_Notifications_Notification_StatusNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
};

export type Robex_NotificationsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notification_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notification_status?: InputMaybe<NullableEnumenum_Robex_Notifications_Notification_StatusFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Robex_NotificationsUpdateManyWithWhereWithoutEvent_Request_Supplier_NotifiedInput = {
  data: Robex_NotificationsUpdateManyMutationInput;
  where: Robex_NotificationsScalarWhereInput;
};

export type Robex_NotificationsUpdateManyWithWhereWithoutUsersInput = {
  data: Robex_NotificationsUpdateManyMutationInput;
  where: Robex_NotificationsScalarWhereInput;
};

export type Robex_NotificationsUpdateManyWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_NotificationsCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>>;
  create?: InputMaybe<Array<Robex_NotificationsCreateWithoutEvent_Request_Supplier_NotifiedInput>>;
  delete?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Robex_NotificationsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  set?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  update?: InputMaybe<Array<Robex_NotificationsUpdateWithWhereUniqueWithoutEvent_Request_Supplier_NotifiedInput>>;
  updateMany?: InputMaybe<Array<Robex_NotificationsUpdateManyWithWhereWithoutEvent_Request_Supplier_NotifiedInput>>;
  upsert?: InputMaybe<Array<Robex_NotificationsUpsertWithWhereUniqueWithoutEvent_Request_Supplier_NotifiedInput>>;
};

export type Robex_NotificationsUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_NotificationsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Robex_NotificationsCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Robex_NotificationsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  set?: InputMaybe<Array<Robex_NotificationsWhereUniqueInput>>;
  update?: InputMaybe<Array<Robex_NotificationsUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Robex_NotificationsUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Robex_NotificationsUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Robex_NotificationsUpdateWithWhereUniqueWithoutEvent_Request_Supplier_NotifiedInput = {
  data: Robex_NotificationsUpdateWithoutEvent_Request_Supplier_NotifiedInput;
  where: Robex_NotificationsWhereUniqueInput;
};

export type Robex_NotificationsUpdateWithWhereUniqueWithoutUsersInput = {
  data: Robex_NotificationsUpdateWithoutUsersInput;
  where: Robex_NotificationsWhereUniqueInput;
};

export type Robex_NotificationsUpdateWithoutEvent_Request_Supplier_NotifiedInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notification_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notification_status?: InputMaybe<NullableEnumenum_Robex_Notifications_Notification_StatusFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutRobex_NotificationsInput>;
};

export type Robex_NotificationsUpdateWithoutUsersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateOneRequiredWithoutRobex_NotificationsInput>;
  notification_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notification_status?: InputMaybe<NullableEnumenum_Robex_Notifications_Notification_StatusFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Robex_NotificationsUpsertWithWhereUniqueWithoutEvent_Request_Supplier_NotifiedInput = {
  create: Robex_NotificationsCreateWithoutEvent_Request_Supplier_NotifiedInput;
  update: Robex_NotificationsUpdateWithoutEvent_Request_Supplier_NotifiedInput;
  where: Robex_NotificationsWhereUniqueInput;
};

export type Robex_NotificationsUpsertWithWhereUniqueWithoutUsersInput = {
  create: Robex_NotificationsCreateWithoutUsersInput;
  update: Robex_NotificationsUpdateWithoutUsersInput;
  where: Robex_NotificationsWhereUniqueInput;
};

export type Robex_NotificationsUser_IdMatch_UuidCompoundUniqueInput = {
  match_uuid: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type Robex_NotificationsWhereInput = {
  AND?: InputMaybe<Array<Robex_NotificationsWhereInput>>;
  NOT?: InputMaybe<Array<Robex_NotificationsWhereInput>>;
  OR?: InputMaybe<Array<Robex_NotificationsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedWhereInput>;
  match_uuid?: InputMaybe<StringFilter>;
  notification_date?: InputMaybe<DateTimeNullableFilter>;
  notification_status?: InputMaybe<Enumenum_Robex_Notifications_Notification_StatusNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
};

export type Robex_NotificationsWhereUniqueInput = {
  user_id_match_uuid?: InputMaybe<Robex_NotificationsUser_IdMatch_UuidCompoundUniqueInput>;
};

export type Robex_Sorting_Metric_ConfigCreateOneWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Robex_Sorting_Metric_ConfigWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_Sorting_Metric_ConfigCreateOrConnectWithoutrobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Robex_Sorting_Metric_ConfigCreateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
};

export type Robex_Sorting_Metric_ConfigCreateOrConnectWithoutrobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput = {
  create: Robex_Sorting_Metric_ConfigCreateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput;
  where: Robex_Sorting_Metric_ConfigWhereUniqueInput;
};

export type Robex_Sorting_Metric_ConfigCreateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput = {
  algorithm?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  match_value?: InputMaybe<Scalars['String']['input']>;
  max_score?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Robex_Sorting_Metric_ConfigUpdateOneWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Robex_Sorting_Metric_ConfigWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_Sorting_Metric_ConfigCreateOrConnectWithoutrobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Robex_Sorting_Metric_ConfigCreateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Robex_Sorting_Metric_ConfigUpdateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  upsert?: InputMaybe<Robex_Sorting_Metric_ConfigUpsertWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
};

export type Robex_Sorting_Metric_ConfigUpdateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput = {
  algorithm?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  match_value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_score?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priority?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Robex_Sorting_Metric_ConfigUpsertWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput = {
  create: Robex_Sorting_Metric_ConfigCreateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput;
  update: Robex_Sorting_Metric_ConfigUpdateWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput;
};

export type Robex_Sorting_Metric_ConfigWhereInput = {
  AND?: InputMaybe<Array<Robex_Sorting_Metric_ConfigWhereInput>>;
  NOT?: InputMaybe<Array<Robex_Sorting_Metric_ConfigWhereInput>>;
  OR?: InputMaybe<Array<Robex_Sorting_Metric_ConfigWhereInput>>;
  algorithm?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  match_value?: InputMaybe<StringNullableFilter>;
  max_score?: InputMaybe<FloatNullableFilter>;
  priority?: InputMaybe<FloatNullableFilter>;
  robex_version_vertical_metric?: InputMaybe<StringFilter>;
  robex_version_vertical_metric_robex_sorting_metric_configTorobex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Robex_Sorting_Metric_ConfigWhereUniqueInput = {
  robex_version_vertical_metric?: InputMaybe<Scalars['String']['input']>;
};

export type Robex_VersionCreateOneWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<Robex_VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_VersionCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>;
  create?: InputMaybe<Robex_VersionCreateWithoutEvent_Request_Supplier_NotifiedInput>;
};

export type Robex_VersionCreateOneWithoutRobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Robex_VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_VersionCreateOrConnectWithoutrobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Robex_VersionCreateWithoutRobex_Version_Vertical_MetricInput>;
};

export type Robex_VersionCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput = {
  create: Robex_VersionCreateWithoutEvent_Request_Supplier_NotifiedInput;
  where: Robex_VersionWhereUniqueInput;
};

export type Robex_VersionCreateOrConnectWithoutrobex_Version_Vertical_MetricInput = {
  create: Robex_VersionCreateWithoutRobex_Version_Vertical_MetricInput;
  where: Robex_VersionWhereUniqueInput;
};

export type Robex_VersionCreateWithoutEvent_Request_Supplier_NotifiedInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricCreateManyWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Robex_VersionCreateWithoutRobex_Version_Vertical_MetricInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutRobex_VersionInput>;
  id: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Robex_VersionUpdateOneWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<Robex_VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_VersionCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>;
  create?: InputMaybe<Robex_VersionCreateWithoutEvent_Request_Supplier_NotifiedInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Robex_VersionUpdateWithoutEvent_Request_Supplier_NotifiedInput>;
  upsert?: InputMaybe<Robex_VersionUpsertWithoutEvent_Request_Supplier_NotifiedInput>;
};

export type Robex_VersionUpdateOneWithoutRobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Robex_VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Robex_VersionCreateOrConnectWithoutrobex_Version_Vertical_MetricInput>;
  create?: InputMaybe<Robex_VersionCreateWithoutRobex_Version_Vertical_MetricInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Robex_VersionUpdateWithoutRobex_Version_Vertical_MetricInput>;
  upsert?: InputMaybe<Robex_VersionUpsertWithoutRobex_Version_Vertical_MetricInput>;
};

export type Robex_VersionUpdateWithoutEvent_Request_Supplier_NotifiedInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricUpdateManyWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Robex_VersionUpdateWithoutRobex_Version_Vertical_MetricInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutRobex_VersionInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Robex_VersionUpsertWithoutEvent_Request_Supplier_NotifiedInput = {
  create: Robex_VersionCreateWithoutEvent_Request_Supplier_NotifiedInput;
  update: Robex_VersionUpdateWithoutEvent_Request_Supplier_NotifiedInput;
};

export type Robex_VersionUpsertWithoutRobex_Version_Vertical_MetricInput = {
  create: Robex_VersionCreateWithoutRobex_Version_Vertical_MetricInput;
  update: Robex_VersionUpdateWithoutRobex_Version_Vertical_MetricInput;
};

export type Robex_VersionWhereInput = {
  AND?: InputMaybe<Array<Robex_VersionWhereInput>>;
  NOT?: InputMaybe<Array<Robex_VersionWhereInput>>;
  OR?: InputMaybe<Array<Robex_VersionWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  robex_version_vertical_metric?: InputMaybe<Robex_Version_Vertical_MetricListRelationFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Robex_VersionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type Robex_Version_Vertical_MetricCreateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateWithoutCategories_Tier2Input>>;
};

export type Robex_Version_Vertical_MetricCreateManyWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateOrConnectWithoutrobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>>;
  create?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>>;
};

export type Robex_Version_Vertical_MetricCreateOrConnectWithoutcategories_Tier2Input = {
  create: Robex_Version_Vertical_MetricCreateWithoutCategories_Tier2Input;
  where: Robex_Version_Vertical_MetricWhereUniqueInput;
};

export type Robex_Version_Vertical_MetricCreateOrConnectWithoutrobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  create: Robex_Version_Vertical_MetricCreateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput;
  where: Robex_Version_Vertical_MetricWhereUniqueInput;
};

export type Robex_Version_Vertical_MetricCreateWithoutCategories_Tier2Input = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  robex_metric?: InputMaybe<Robex_MetricCreateOneWithoutRobex_Version_Vertical_MetricInput>;
  robex_sorting_metric_config?: InputMaybe<Robex_Sorting_Metric_ConfigCreateOneWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  robex_version_robex_versionTorobex_version_vertical_metric?: InputMaybe<Robex_VersionCreateOneWithoutRobex_Version_Vertical_MetricInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Robex_Version_Vertical_MetricCreateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  categories_tier2?: InputMaybe<Categories_Tier2CreateOneWithoutRobex_Version_Vertical_MetricInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  robex_metric?: InputMaybe<Robex_MetricCreateOneWithoutRobex_Version_Vertical_MetricInput>;
  robex_sorting_metric_config?: InputMaybe<Robex_Sorting_Metric_ConfigCreateOneWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Robex_Version_Vertical_MetricRobex_Version_Vertical_Metric_UniqueCompoundUniqueInput = {
  metric_uuid: Scalars['String']['input'];
  robex_version: Scalars['String']['input'];
  vertical_name: Scalars['String']['input'];
};

export type Robex_Version_Vertical_MetricScalarWhereInput = {
  AND?: InputMaybe<Array<Robex_Version_Vertical_MetricScalarWhereInput>>;
  NOT?: InputMaybe<Array<Robex_Version_Vertical_MetricScalarWhereInput>>;
  OR?: InputMaybe<Array<Robex_Version_Vertical_MetricScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  metric_uuid?: InputMaybe<StringNullableFilter>;
  robex_version?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
  vertical_name?: InputMaybe<StringNullableFilter>;
};

export type Robex_Version_Vertical_MetricUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Robex_Version_Vertical_MetricUpdateManyWithWhereWithoutCategories_Tier2Input = {
  data: Robex_Version_Vertical_MetricUpdateManyMutationInput;
  where: Robex_Version_Vertical_MetricScalarWhereInput;
};

export type Robex_Version_Vertical_MetricUpdateManyWithWhereWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  data: Robex_Version_Vertical_MetricUpdateManyMutationInput;
  where: Robex_Version_Vertical_MetricScalarWhereInput;
};

export type Robex_Version_Vertical_MetricUpdateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateWithoutCategories_Tier2Input>>;
  delete?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Robex_Version_Vertical_MetricScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  set?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  update?: InputMaybe<Array<Robex_Version_Vertical_MetricUpdateWithWhereUniqueWithoutCategories_Tier2Input>>;
  updateMany?: InputMaybe<Array<Robex_Version_Vertical_MetricUpdateManyWithWhereWithoutCategories_Tier2Input>>;
  upsert?: InputMaybe<Array<Robex_Version_Vertical_MetricUpsertWithWhereUniqueWithoutCategories_Tier2Input>>;
};

export type Robex_Version_Vertical_MetricUpdateManyWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  connect?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateOrConnectWithoutrobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>>;
  create?: InputMaybe<Array<Robex_Version_Vertical_MetricCreateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>>;
  delete?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Robex_Version_Vertical_MetricScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  set?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereUniqueInput>>;
  update?: InputMaybe<Array<Robex_Version_Vertical_MetricUpdateWithWhereUniqueWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>>;
  updateMany?: InputMaybe<Array<Robex_Version_Vertical_MetricUpdateManyWithWhereWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>>;
  upsert?: InputMaybe<Array<Robex_Version_Vertical_MetricUpsertWithWhereUniqueWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput>>;
};

export type Robex_Version_Vertical_MetricUpdateWithWhereUniqueWithoutCategories_Tier2Input = {
  data: Robex_Version_Vertical_MetricUpdateWithoutCategories_Tier2Input;
  where: Robex_Version_Vertical_MetricWhereUniqueInput;
};

export type Robex_Version_Vertical_MetricUpdateWithWhereUniqueWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  data: Robex_Version_Vertical_MetricUpdateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput;
  where: Robex_Version_Vertical_MetricWhereUniqueInput;
};

export type Robex_Version_Vertical_MetricUpdateWithoutCategories_Tier2Input = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_metric?: InputMaybe<Robex_MetricUpdateOneWithoutRobex_Version_Vertical_MetricInput>;
  robex_sorting_metric_config?: InputMaybe<Robex_Sorting_Metric_ConfigUpdateOneWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  robex_version_robex_versionTorobex_version_vertical_metric?: InputMaybe<Robex_VersionUpdateOneWithoutRobex_Version_Vertical_MetricInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Robex_Version_Vertical_MetricUpdateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneWithoutRobex_Version_Vertical_MetricInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_metric?: InputMaybe<Robex_MetricUpdateOneWithoutRobex_Version_Vertical_MetricInput>;
  robex_sorting_metric_config?: InputMaybe<Robex_Sorting_Metric_ConfigUpdateOneWithoutRobex_Version_Vertical_Metric_Robex_Sorting_Metric_ConfigTorobex_Version_Vertical_MetricInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Robex_Version_Vertical_MetricUpsertWithWhereUniqueWithoutCategories_Tier2Input = {
  create: Robex_Version_Vertical_MetricCreateWithoutCategories_Tier2Input;
  update: Robex_Version_Vertical_MetricUpdateWithoutCategories_Tier2Input;
  where: Robex_Version_Vertical_MetricWhereUniqueInput;
};

export type Robex_Version_Vertical_MetricUpsertWithWhereUniqueWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput = {
  create: Robex_Version_Vertical_MetricCreateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput;
  update: Robex_Version_Vertical_MetricUpdateWithoutRobex_Version_Robex_VersionTorobex_Version_Vertical_MetricInput;
  where: Robex_Version_Vertical_MetricWhereUniqueInput;
};

export type Robex_Version_Vertical_MetricWhereInput = {
  AND?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereInput>>;
  NOT?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereInput>>;
  OR?: InputMaybe<Array<Robex_Version_Vertical_MetricWhereInput>>;
  categories_tier2?: InputMaybe<Categories_Tier2WhereInput>;
  created?: InputMaybe<DateTimeNullableFilter>;
  metric_uuid?: InputMaybe<StringNullableFilter>;
  robex_metric?: InputMaybe<Robex_MetricWhereInput>;
  robex_sorting_metric_config?: InputMaybe<Robex_Sorting_Metric_ConfigWhereInput>;
  robex_version?: InputMaybe<StringNullableFilter>;
  robex_version_robex_versionTorobex_version_vertical_metric?: InputMaybe<Robex_VersionWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
  vertical_name?: InputMaybe<StringNullableFilter>;
};

export type Robex_Version_Vertical_MetricWhereUniqueInput = {
  robex_version_vertical_metric_unique?: InputMaybe<Robex_Version_Vertical_MetricRobex_Version_Vertical_Metric_UniqueCompoundUniqueInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Root_Tags = {
  __typename?: 'root_tags';
  categories_tier2_tag_groups: Array<Categories_Tier2_Tag_Groups>;
  created?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tags: Array<Tags>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type Root_TagsCategories_Tier2_Tag_GroupsArgs = {
  cursor?: InputMaybe<Categories_Tier2_Tag_GroupsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type Root_TagsTagsArgs = {
  cursor?: InputMaybe<TagsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Root_TagsCreateOneWithoutCategories_Tier2_Tag_GroupsInput = {
  connect?: InputMaybe<Root_TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Root_TagsCreateOrConnectWithoutcategories_Tier2_Tag_GroupsInput>;
  create?: InputMaybe<Root_TagsCreateWithoutCategories_Tier2_Tag_GroupsInput>;
};

export type Root_TagsCreateOneWithoutTagsInput = {
  connect?: InputMaybe<Root_TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Root_TagsCreateOrConnectWithouttagsInput>;
  create?: InputMaybe<Root_TagsCreateWithoutTagsInput>;
};

export type Root_TagsCreateOrConnectWithoutcategories_Tier2_Tag_GroupsInput = {
  create: Root_TagsCreateWithoutCategories_Tier2_Tag_GroupsInput;
  where: Root_TagsWhereUniqueInput;
};

export type Root_TagsCreateOrConnectWithouttagsInput = {
  create: Root_TagsCreateWithoutTagsInput;
  where: Root_TagsWhereUniqueInput;
};

export type Root_TagsCreateWithoutCategories_Tier2_Tag_GroupsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateManyWithoutRoot_TagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Root_TagsCreateWithoutTagsInput = {
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsCreateManyWithoutRoot_TagsInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Root_TagsUpdateOneRequiredWithoutCategories_Tier2_Tag_GroupsInput = {
  connect?: InputMaybe<Root_TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Root_TagsCreateOrConnectWithoutcategories_Tier2_Tag_GroupsInput>;
  create?: InputMaybe<Root_TagsCreateWithoutCategories_Tier2_Tag_GroupsInput>;
  update?: InputMaybe<Root_TagsUpdateWithoutCategories_Tier2_Tag_GroupsInput>;
  upsert?: InputMaybe<Root_TagsUpsertWithoutCategories_Tier2_Tag_GroupsInput>;
};

export type Root_TagsUpdateOneWithoutTagsInput = {
  connect?: InputMaybe<Root_TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Root_TagsCreateOrConnectWithouttagsInput>;
  create?: InputMaybe<Root_TagsCreateWithoutTagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Root_TagsUpdateWithoutTagsInput>;
  upsert?: InputMaybe<Root_TagsUpsertWithoutTagsInput>;
};

export type Root_TagsUpdateWithoutCategories_Tier2_Tag_GroupsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateManyWithoutRoot_TagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Root_TagsUpdateWithoutTagsInput = {
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsUpdateManyWithoutRoot_TagsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Root_TagsUpsertWithoutCategories_Tier2_Tag_GroupsInput = {
  create: Root_TagsCreateWithoutCategories_Tier2_Tag_GroupsInput;
  update: Root_TagsUpdateWithoutCategories_Tier2_Tag_GroupsInput;
};

export type Root_TagsUpsertWithoutTagsInput = {
  create: Root_TagsCreateWithoutTagsInput;
  update: Root_TagsUpdateWithoutTagsInput;
};

export type Root_TagsWhereInput = {
  AND?: InputMaybe<Array<Root_TagsWhereInput>>;
  NOT?: InputMaybe<Array<Root_TagsWhereInput>>;
  OR?: InputMaybe<Array<Root_TagsWhereInput>>;
  categories_tier2_tag_groups?: InputMaybe<Categories_Tier2_Tag_GroupsListRelationFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  key?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<TagsListRelationFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Root_TagsWhereUniqueInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type SaveEventRequestImageDescriptionsInput = {
  eventRequestId?: InputMaybe<Scalars['String']['input']>;
  eventRequestUuid?: InputMaybe<Scalars['String']['input']>;
  imageDescriptions: Scalars['Json']['input'];
};

export type Scheduled_Payments = {
  __typename?: 'scheduled_payments';
  amount?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  method?: Maybe<Enum_Scheduled_Payments_Method>;
  quote_id?: Maybe<Scalars['String']['output']>;
  scheduled_date?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Enum_Scheduled_Payments_Type>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Scheduled_PaymentsCreateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Scheduled_PaymentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Scheduled_PaymentsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Scheduled_PaymentsCreateWithoutQuotesInput>>;
};

export type Scheduled_PaymentsCreateOneWithoutSupplier_PaymentsInput = {
  connect?: InputMaybe<Scheduled_PaymentsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Scheduled_PaymentsCreateOrConnectWithoutsupplier_PaymentsInput>;
  create?: InputMaybe<Scheduled_PaymentsCreateWithoutSupplier_PaymentsInput>;
};

export type Scheduled_PaymentsCreateOrConnectWithoutquotesInput = {
  create: Scheduled_PaymentsCreateWithoutQuotesInput;
  where: Scheduled_PaymentsWhereUniqueInput;
};

export type Scheduled_PaymentsCreateOrConnectWithoutsupplier_PaymentsInput = {
  create: Scheduled_PaymentsCreateWithoutSupplier_PaymentsInput;
  where: Scheduled_PaymentsWhereUniqueInput;
};

export type Scheduled_PaymentsCreateWithoutQuotesInput = {
  amount: Scalars['Int']['input'];
  created: Scalars['DateTime']['input'];
  method: Enum_Scheduled_Payments_Method;
  scheduled_date: Scalars['DateTime']['input'];
  supplier_payments?: InputMaybe<Supplier_PaymentsCreateOneWithoutScheduled_PaymentsInput>;
  type: Enum_Scheduled_Payments_Type;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Scheduled_PaymentsCreateWithoutSupplier_PaymentsInput = {
  amount: Scalars['Int']['input'];
  created: Scalars['DateTime']['input'];
  method: Enum_Scheduled_Payments_Method;
  quotes: QuotesCreateOneWithoutScheduled_PaymentsInput;
  scheduled_date: Scalars['DateTime']['input'];
  type: Enum_Scheduled_Payments_Type;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Scheduled_PaymentsScalarWhereInput = {
  AND?: InputMaybe<Array<Scheduled_PaymentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Scheduled_PaymentsScalarWhereInput>>;
  OR?: InputMaybe<Array<Scheduled_PaymentsScalarWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  method?: InputMaybe<Enumenum_Scheduled_Payments_MethodFilter>;
  quote_id?: InputMaybe<StringFilter>;
  scheduled_date?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<Enumenum_Scheduled_Payments_TypeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Scheduled_PaymentsUpdateManyMutationInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  method?: InputMaybe<Enumenum_Scheduled_Payments_MethodFieldUpdateOperationsInput>;
  scheduled_date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Scheduled_Payments_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Scheduled_PaymentsUpdateManyWithWhereWithoutQuotesInput = {
  data: Scheduled_PaymentsUpdateManyMutationInput;
  where: Scheduled_PaymentsScalarWhereInput;
};

export type Scheduled_PaymentsUpdateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Scheduled_PaymentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Scheduled_PaymentsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Scheduled_PaymentsCreateWithoutQuotesInput>>;
  delete?: InputMaybe<Array<Scheduled_PaymentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Scheduled_PaymentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Scheduled_PaymentsWhereUniqueInput>>;
  set?: InputMaybe<Array<Scheduled_PaymentsWhereUniqueInput>>;
  update?: InputMaybe<Array<Scheduled_PaymentsUpdateWithWhereUniqueWithoutQuotesInput>>;
  updateMany?: InputMaybe<Array<Scheduled_PaymentsUpdateManyWithWhereWithoutQuotesInput>>;
  upsert?: InputMaybe<Array<Scheduled_PaymentsUpsertWithWhereUniqueWithoutQuotesInput>>;
};

export type Scheduled_PaymentsUpdateOneRequiredWithoutSupplier_PaymentsInput = {
  connect?: InputMaybe<Scheduled_PaymentsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Scheduled_PaymentsCreateOrConnectWithoutsupplier_PaymentsInput>;
  create?: InputMaybe<Scheduled_PaymentsCreateWithoutSupplier_PaymentsInput>;
  update?: InputMaybe<Scheduled_PaymentsUpdateWithoutSupplier_PaymentsInput>;
  upsert?: InputMaybe<Scheduled_PaymentsUpsertWithoutSupplier_PaymentsInput>;
};

export type Scheduled_PaymentsUpdateWithWhereUniqueWithoutQuotesInput = {
  data: Scheduled_PaymentsUpdateWithoutQuotesInput;
  where: Scheduled_PaymentsWhereUniqueInput;
};

export type Scheduled_PaymentsUpdateWithoutQuotesInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  method?: InputMaybe<Enumenum_Scheduled_Payments_MethodFieldUpdateOperationsInput>;
  scheduled_date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  supplier_payments?: InputMaybe<Supplier_PaymentsUpdateOneWithoutScheduled_PaymentsInput>;
  type?: InputMaybe<Enumenum_Scheduled_Payments_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Scheduled_PaymentsUpdateWithoutSupplier_PaymentsInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  method?: InputMaybe<Enumenum_Scheduled_Payments_MethodFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateOneRequiredWithoutScheduled_PaymentsInput>;
  scheduled_date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Scheduled_Payments_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Scheduled_PaymentsUpsertWithWhereUniqueWithoutQuotesInput = {
  create: Scheduled_PaymentsCreateWithoutQuotesInput;
  update: Scheduled_PaymentsUpdateWithoutQuotesInput;
  where: Scheduled_PaymentsWhereUniqueInput;
};

export type Scheduled_PaymentsUpsertWithoutSupplier_PaymentsInput = {
  create: Scheduled_PaymentsCreateWithoutSupplier_PaymentsInput;
  update: Scheduled_PaymentsUpdateWithoutSupplier_PaymentsInput;
};

export type Scheduled_PaymentsWhereInput = {
  AND?: InputMaybe<Array<Scheduled_PaymentsWhereInput>>;
  NOT?: InputMaybe<Array<Scheduled_PaymentsWhereInput>>;
  OR?: InputMaybe<Array<Scheduled_PaymentsWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  created?: InputMaybe<DateTimeFilter>;
  method?: InputMaybe<Enumenum_Scheduled_Payments_MethodFilter>;
  quote_id?: InputMaybe<StringFilter>;
  quotes?: InputMaybe<QuotesWhereInput>;
  scheduled_date?: InputMaybe<DateTimeFilter>;
  supplier_payments?: InputMaybe<Supplier_PaymentsWhereInput>;
  type?: InputMaybe<Enumenum_Scheduled_Payments_TypeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Scheduled_PaymentsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type SessionTrackingDetails = {
  gclid?: InputMaybe<Scalars['String']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  origin_page?: InputMaybe<Scalars['String']['input']>;
  previous_pages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  start_page?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type Settings = {
  __typename?: 'settings';
  option_name: Scalars['String']['output'];
  option_value?: Maybe<Scalars['String']['output']>;
};

export type SettingsWhereInput = {
  AND?: InputMaybe<Array<SettingsWhereInput>>;
  NOT?: InputMaybe<Array<SettingsWhereInput>>;
  OR?: InputMaybe<Array<SettingsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  option_name?: InputMaybe<StringFilter>;
  option_value?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type SettingsWhereUniqueInput = {
  option_name?: InputMaybe<Scalars['String']['input']>;
};

export type ShortLeadData = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  formName: Scalars['String']['input'];
  leadSource: Scalars['String']['input'];
  segment: Scalars['String']['input'];
  upcomingEventStatus?: InputMaybe<Scalars['String']['input']>;
  userEmail: Scalars['String']['input'];
  userFirstName: Scalars['String']['input'];
  userLastName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
};

export type Space_Groups = {
  __typename?: 'space_groups';
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  venue_spaces: Array<Venue_Spaces>;
};


export type Space_GroupsVenue_SpacesArgs = {
  cursor?: InputMaybe<Venue_SpacesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Space_GroupsCreateInput = {
  created: Scalars['DateTime']['input'];
  order: Scalars['Int']['input'];
  suppliers: SuppliersCreateOneWithoutSpace_GroupsInput;
  title: Scalars['String']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSpace_GroupsInput>;
};

export type Space_GroupsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Space_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Space_GroupsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Space_GroupsCreateWithoutSuppliersInput>>;
};

export type Space_GroupsCreateOneWithoutVenue_SpacesInput = {
  connect?: InputMaybe<Space_GroupsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Space_GroupsCreateOrConnectWithoutvenue_SpacesInput>;
  create?: InputMaybe<Space_GroupsCreateWithoutVenue_SpacesInput>;
};

export type Space_GroupsCreateOrConnectWithoutsuppliersInput = {
  create: Space_GroupsCreateWithoutSuppliersInput;
  where: Space_GroupsWhereUniqueInput;
};

export type Space_GroupsCreateOrConnectWithoutvenue_SpacesInput = {
  create: Space_GroupsCreateWithoutVenue_SpacesInput;
  where: Space_GroupsWhereUniqueInput;
};

export type Space_GroupsCreateWithoutSuppliersInput = {
  created: Scalars['DateTime']['input'];
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSpace_GroupsInput>;
};

export type Space_GroupsCreateWithoutVenue_SpacesInput = {
  created: Scalars['DateTime']['input'];
  order: Scalars['Int']['input'];
  suppliers: SuppliersCreateOneWithoutSpace_GroupsInput;
  title: Scalars['String']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Space_GroupsScalarWhereInput = {
  AND?: InputMaybe<Array<Space_GroupsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Space_GroupsScalarWhereInput>>;
  OR?: InputMaybe<Array<Space_GroupsScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  order?: InputMaybe<IntFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Space_GroupsUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSpace_GroupsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSpace_GroupsInput>;
};

export type Space_GroupsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Space_GroupsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Space_GroupsUpdateManyMutationInput;
  where: Space_GroupsScalarWhereInput;
};

export type Space_GroupsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Space_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Space_GroupsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Space_GroupsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Space_GroupsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Space_GroupsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Space_GroupsWhereUniqueInput>>;
  set?: InputMaybe<Array<Space_GroupsWhereUniqueInput>>;
  update?: InputMaybe<Array<Space_GroupsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Space_GroupsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Space_GroupsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Space_GroupsUpdateOneRequiredWithoutVenue_SpacesInput = {
  connect?: InputMaybe<Space_GroupsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Space_GroupsCreateOrConnectWithoutvenue_SpacesInput>;
  create?: InputMaybe<Space_GroupsCreateWithoutVenue_SpacesInput>;
  update?: InputMaybe<Space_GroupsUpdateWithoutVenue_SpacesInput>;
  upsert?: InputMaybe<Space_GroupsUpsertWithoutVenue_SpacesInput>;
};

export type Space_GroupsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Space_GroupsUpdateWithoutSuppliersInput;
  where: Space_GroupsWhereUniqueInput;
};

export type Space_GroupsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSpace_GroupsInput>;
};

export type Space_GroupsUpdateWithoutVenue_SpacesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSpace_GroupsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Space_GroupsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Space_GroupsCreateWithoutSuppliersInput;
  update: Space_GroupsUpdateWithoutSuppliersInput;
  where: Space_GroupsWhereUniqueInput;
};

export type Space_GroupsUpsertWithoutVenue_SpacesInput = {
  create: Space_GroupsCreateWithoutVenue_SpacesInput;
  update: Space_GroupsUpdateWithoutVenue_SpacesInput;
};

export type Space_GroupsWhereInput = {
  AND?: InputMaybe<Array<Space_GroupsWhereInput>>;
  NOT?: InputMaybe<Array<Space_GroupsWhereInput>>;
  OR?: InputMaybe<Array<Space_GroupsWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  order?: InputMaybe<IntFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  title?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
  venue_spaces?: InputMaybe<Venue_SpacesListRelationFilter>;
};

export type Space_GroupsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Space_Tags = {
  __typename?: 'space_tags';
  max_capacity?: Maybe<Scalars['Int']['output']>;
  space_id: Scalars['String']['output'];
  tags: Tags;
  uuid: Scalars['String']['output'];
};

export type Space_TagsCreateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Space_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Space_TagsCreateWithoutTagsInput>>;
};

export type Space_TagsCreateManyWithoutVenue_SpacesInput = {
  connect?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Space_TagsCreateOrConnectWithoutvenue_SpacesInput>>;
  create?: InputMaybe<Array<Space_TagsCreateWithoutVenue_SpacesInput>>;
};

export type Space_TagsCreateOrConnectWithouttagsInput = {
  create: Space_TagsCreateWithoutTagsInput;
  where: Space_TagsWhereUniqueInput;
};

export type Space_TagsCreateOrConnectWithoutvenue_SpacesInput = {
  create: Space_TagsCreateWithoutVenue_SpacesInput;
  where: Space_TagsWhereUniqueInput;
};

export type Space_TagsCreateWithoutTagsInput = {
  created: Scalars['DateTime']['input'];
  max_capacity?: InputMaybe<Scalars['Int']['input']>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
  venue_spaces: Venue_SpacesCreateOneWithoutSpace_TagsInput;
};

export type Space_TagsCreateWithoutVenue_SpacesInput = {
  created: Scalars['DateTime']['input'];
  max_capacity?: InputMaybe<Scalars['Int']['input']>;
  tags: TagsCreateOneWithoutSpace_TagsInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Space_TagsScalarWhereInput = {
  AND?: InputMaybe<Array<Space_TagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Space_TagsScalarWhereInput>>;
  OR?: InputMaybe<Array<Space_TagsScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  max_capacity?: InputMaybe<IntNullableFilter>;
  space_id?: InputMaybe<StringFilter>;
  tag_uuid?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Space_TagsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  max_capacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Space_TagsUpdateManyWithWhereWithoutTagsInput = {
  data: Space_TagsUpdateManyMutationInput;
  where: Space_TagsScalarWhereInput;
};

export type Space_TagsUpdateManyWithWhereWithoutVenue_SpacesInput = {
  data: Space_TagsUpdateManyMutationInput;
  where: Space_TagsScalarWhereInput;
};

export type Space_TagsUpdateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Space_TagsCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<Space_TagsCreateWithoutTagsInput>>;
  delete?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Space_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Space_TagsUpdateWithWhereUniqueWithoutTagsInput>>;
  updateMany?: InputMaybe<Array<Space_TagsUpdateManyWithWhereWithoutTagsInput>>;
  upsert?: InputMaybe<Array<Space_TagsUpsertWithWhereUniqueWithoutTagsInput>>;
};

export type Space_TagsUpdateManyWithoutVenue_SpacesInput = {
  connect?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Space_TagsCreateOrConnectWithoutvenue_SpacesInput>>;
  create?: InputMaybe<Array<Space_TagsCreateWithoutVenue_SpacesInput>>;
  delete?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Space_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Space_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Space_TagsUpdateWithWhereUniqueWithoutVenue_SpacesInput>>;
  updateMany?: InputMaybe<Array<Space_TagsUpdateManyWithWhereWithoutVenue_SpacesInput>>;
  upsert?: InputMaybe<Array<Space_TagsUpsertWithWhereUniqueWithoutVenue_SpacesInput>>;
};

export type Space_TagsUpdateWithWhereUniqueWithoutTagsInput = {
  data: Space_TagsUpdateWithoutTagsInput;
  where: Space_TagsWhereUniqueInput;
};

export type Space_TagsUpdateWithWhereUniqueWithoutVenue_SpacesInput = {
  data: Space_TagsUpdateWithoutVenue_SpacesInput;
  where: Space_TagsWhereUniqueInput;
};

export type Space_TagsUpdateWithoutTagsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  max_capacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateOneRequiredWithoutSpace_TagsInput>;
};

export type Space_TagsUpdateWithoutVenue_SpacesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  max_capacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneRequiredWithoutSpace_TagsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Space_TagsUpsertWithWhereUniqueWithoutTagsInput = {
  create: Space_TagsCreateWithoutTagsInput;
  update: Space_TagsUpdateWithoutTagsInput;
  where: Space_TagsWhereUniqueInput;
};

export type Space_TagsUpsertWithWhereUniqueWithoutVenue_SpacesInput = {
  create: Space_TagsCreateWithoutVenue_SpacesInput;
  update: Space_TagsUpdateWithoutVenue_SpacesInput;
  where: Space_TagsWhereUniqueInput;
};

export type Space_TagsWhereInput = {
  AND?: InputMaybe<Array<Space_TagsWhereInput>>;
  NOT?: InputMaybe<Array<Space_TagsWhereInput>>;
  OR?: InputMaybe<Array<Space_TagsWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  max_capacity?: InputMaybe<IntNullableFilter>;
  space_id?: InputMaybe<StringFilter>;
  tag_uuid?: InputMaybe<StringFilter>;
  tags?: InputMaybe<TagsWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
  venue_spaces?: InputMaybe<Venue_SpacesWhereInput>;
};

export type Space_TagsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierActivity = {
  __typename?: 'supplierActivity';
  calendar_id?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['DateTime']['output']>;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierCalendar = {
  __typename?: 'supplierCalendar';
  calendarDays?: Maybe<Array<Maybe<CalendarDay>>>;
  calendarId?: Maybe<Scalars['String']['output']>;
};

export type SupplierCalendarEvent = {
  __typename?: 'supplierCalendarEvent';
  calendar_id?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['DateTime']['output']>;
  quote_id?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierCalendarQuote = {
  __typename?: 'supplierCalendarQuote';
  custom_event_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_line_1?: Maybe<Scalars['String']['output']>;
  location_line_2?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  quote_id?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierDocType = {
  __typename?: 'supplierDocType';
  comments?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileStatus?: Maybe<DocumentFileStatusEnum>;
  fileType?: Maybe<DocumentFileTypeEnum>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  level?: Maybe<DocumentLevelEnum>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupplierDocsListType = {
  __typename?: 'supplierDocsListType';
  documents: Array<SupplierDocType>;
};

export type SupplierEvent = {
  __typename?: 'supplierEvent';
  approximate_location?: Maybe<Scalars['Boolean']['output']>;
  attribution_data_id?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Scalars['Json']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  custom_event_name?: Maybe<Scalars['String']['output']>;
  customer_referral?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  dateFlexibilityNotes?: Maybe<Scalars['String']['output']>;
  date_flexible?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  event_areas: Array<Event_Areas>;
  event_dates: Array<Event_Dates>;
  event_tags: Array<Event_Tags>;
  freshsales_id?: Maybe<Scalars['String']['output']>;
  freshsales_stage?: Maybe<Scalars['String']['output']>;
  high_demand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  lead_time?: Maybe<Scalars['Int']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_notes?: Maybe<Scalars['String']['output']>;
  partnership?: Maybe<Scalars['Boolean']['output']>;
  partnership_id?: Maybe<Scalars['String']['output']>;
  postcode_prefix?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  supplier_referral?: Maybe<Scalars['String']['output']>;
  suppliersEventRequest: Array<SuppliersEventRequest>;
  type?: Maybe<Scalars['String']['output']>;
  unread_quotes_email_sent?: Maybe<Scalars['Boolean']['output']>;
  upcoming_event_reminder_sent?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  urgency?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
  user_restricted: UserRestricted;
  uuid: Scalars['String']['output'];
};


export type SupplierEventEvent_AreasArgs = {
  cursor?: InputMaybe<Event_AreasWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SupplierEventEvent_TagsArgs = {
  cursor?: InputMaybe<Event_TagsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SupplierEventSuppliersEventRequestArgs = {
  cursor?: InputMaybe<Event_RequestsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Supplier_CalendarsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_CalendarsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_CalendarsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_CalendarsCreateWithoutSuppliersInput>>;
};

export type Supplier_CalendarsCreateOneWithoutSupplier_Calendars_EventsInput = {
  connect?: InputMaybe<Supplier_CalendarsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_CalendarsCreateOrConnectWithoutsupplier_Calendars_EventsInput>;
  create?: InputMaybe<Supplier_CalendarsCreateWithoutSupplier_Calendars_EventsInput>;
};

export type Supplier_CalendarsCreateOrConnectWithoutsupplier_Calendars_EventsInput = {
  create: Supplier_CalendarsCreateWithoutSupplier_Calendars_EventsInput;
  where: Supplier_CalendarsWhereUniqueInput;
};

export type Supplier_CalendarsCreateOrConnectWithoutsuppliersInput = {
  create: Supplier_CalendarsCreateWithoutSuppliersInput;
  where: Supplier_CalendarsWhereUniqueInput;
};

export type Supplier_CalendarsCreateWithoutSupplier_Calendars_EventsInput = {
  suppliers: SuppliersCreateOneWithoutSupplier_CalendarsInput;
  uuid: Scalars['String']['input'];
};

export type Supplier_CalendarsCreateWithoutSuppliersInput = {
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsCreateManyWithoutSupplier_CalendarsInput>;
  uuid: Scalars['String']['input'];
};

export type Supplier_CalendarsScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_CalendarsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_CalendarsScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_CalendarsScalarWhereInput>>;
  supplier_id?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_CalendarsUpdateManyMutationInput = {
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_CalendarsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Supplier_CalendarsUpdateManyMutationInput;
  where: Supplier_CalendarsScalarWhereInput;
};

export type Supplier_CalendarsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_CalendarsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_CalendarsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_CalendarsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Supplier_CalendarsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_CalendarsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_CalendarsWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_CalendarsWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_CalendarsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Supplier_CalendarsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Supplier_CalendarsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Supplier_CalendarsUpdateOneRequiredWithoutSupplier_Calendars_EventsInput = {
  connect?: InputMaybe<Supplier_CalendarsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_CalendarsCreateOrConnectWithoutsupplier_Calendars_EventsInput>;
  create?: InputMaybe<Supplier_CalendarsCreateWithoutSupplier_Calendars_EventsInput>;
  update?: InputMaybe<Supplier_CalendarsUpdateWithoutSupplier_Calendars_EventsInput>;
  upsert?: InputMaybe<Supplier_CalendarsUpsertWithoutSupplier_Calendars_EventsInput>;
};

export type Supplier_CalendarsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Supplier_CalendarsUpdateWithoutSuppliersInput;
  where: Supplier_CalendarsWhereUniqueInput;
};

export type Supplier_CalendarsUpdateWithoutSupplier_Calendars_EventsInput = {
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSupplier_CalendarsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_CalendarsUpdateWithoutSuppliersInput = {
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsUpdateManyWithoutSupplier_CalendarsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_CalendarsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Supplier_CalendarsCreateWithoutSuppliersInput;
  update: Supplier_CalendarsUpdateWithoutSuppliersInput;
  where: Supplier_CalendarsWhereUniqueInput;
};

export type Supplier_CalendarsUpsertWithoutSupplier_Calendars_EventsInput = {
  create: Supplier_CalendarsCreateWithoutSupplier_Calendars_EventsInput;
  update: Supplier_CalendarsUpdateWithoutSupplier_Calendars_EventsInput;
};

export type Supplier_CalendarsWhereInput = {
  AND?: InputMaybe<Array<Supplier_CalendarsWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_CalendarsWhereInput>>;
  OR?: InputMaybe<Array<Supplier_CalendarsWhereInput>>;
  supplier_calendars_events?: InputMaybe<Supplier_Calendars_EventsListRelationFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_CalendarsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Calendars_EventsCreateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Calendars_EventsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Supplier_Calendars_EventsCreateWithoutQuotesInput>>;
};

export type Supplier_Calendars_EventsCreateManyWithoutSupplier_CalendarsInput = {
  connect?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Calendars_EventsCreateOrConnectWithoutsupplier_CalendarsInput>>;
  create?: InputMaybe<Array<Supplier_Calendars_EventsCreateWithoutSupplier_CalendarsInput>>;
};

export type Supplier_Calendars_EventsCreateOrConnectWithoutquotesInput = {
  create: Supplier_Calendars_EventsCreateWithoutQuotesInput;
  where: Supplier_Calendars_EventsWhereUniqueInput;
};

export type Supplier_Calendars_EventsCreateOrConnectWithoutsupplier_CalendarsInput = {
  create: Supplier_Calendars_EventsCreateWithoutSupplier_CalendarsInput;
  where: Supplier_Calendars_EventsWhereUniqueInput;
};

export type Supplier_Calendars_EventsCreateWithoutQuotesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  supplier_calendars: Supplier_CalendarsCreateOneWithoutSupplier_Calendars_EventsInput;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Supplier_Calendars_Events_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Supplier_Calendars_EventsCreateWithoutSupplier_CalendarsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  quotes?: InputMaybe<QuotesCreateOneWithoutSupplier_Calendars_EventsInput>;
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Supplier_Calendars_Events_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Supplier_Calendars_EventsScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_Calendars_EventsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Calendars_EventsScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Calendars_EventsScalarWhereInput>>;
  calendar_id?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  end_time?: InputMaybe<DateTimeNullableFilter>;
  quote_id?: InputMaybe<StringNullableFilter>;
  start_time?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<Enumenum_Supplier_Calendars_Events_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_Calendars_EventsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Supplier_Calendars_Events_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Calendars_EventsUpdateManyWithWhereWithoutQuotesInput = {
  data: Supplier_Calendars_EventsUpdateManyMutationInput;
  where: Supplier_Calendars_EventsScalarWhereInput;
};

export type Supplier_Calendars_EventsUpdateManyWithWhereWithoutSupplier_CalendarsInput = {
  data: Supplier_Calendars_EventsUpdateManyMutationInput;
  where: Supplier_Calendars_EventsScalarWhereInput;
};

export type Supplier_Calendars_EventsUpdateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Calendars_EventsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Supplier_Calendars_EventsCreateWithoutQuotesInput>>;
  delete?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Calendars_EventsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Calendars_EventsUpdateWithWhereUniqueWithoutQuotesInput>>;
  updateMany?: InputMaybe<Array<Supplier_Calendars_EventsUpdateManyWithWhereWithoutQuotesInput>>;
  upsert?: InputMaybe<Array<Supplier_Calendars_EventsUpsertWithWhereUniqueWithoutQuotesInput>>;
};

export type Supplier_Calendars_EventsUpdateManyWithoutSupplier_CalendarsInput = {
  connect?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Calendars_EventsCreateOrConnectWithoutsupplier_CalendarsInput>>;
  create?: InputMaybe<Array<Supplier_Calendars_EventsCreateWithoutSupplier_CalendarsInput>>;
  delete?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Calendars_EventsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Calendars_EventsWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Calendars_EventsUpdateWithWhereUniqueWithoutSupplier_CalendarsInput>>;
  updateMany?: InputMaybe<Array<Supplier_Calendars_EventsUpdateManyWithWhereWithoutSupplier_CalendarsInput>>;
  upsert?: InputMaybe<Array<Supplier_Calendars_EventsUpsertWithWhereUniqueWithoutSupplier_CalendarsInput>>;
};

export type Supplier_Calendars_EventsUpdateWithWhereUniqueWithoutQuotesInput = {
  data: Supplier_Calendars_EventsUpdateWithoutQuotesInput;
  where: Supplier_Calendars_EventsWhereUniqueInput;
};

export type Supplier_Calendars_EventsUpdateWithWhereUniqueWithoutSupplier_CalendarsInput = {
  data: Supplier_Calendars_EventsUpdateWithoutSupplier_CalendarsInput;
  where: Supplier_Calendars_EventsWhereUniqueInput;
};

export type Supplier_Calendars_EventsUpdateWithoutQuotesInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateOneRequiredWithoutSupplier_Calendars_EventsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Supplier_Calendars_Events_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Calendars_EventsUpdateWithoutSupplier_CalendarsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  end_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateOneWithoutSupplier_Calendars_EventsInput>;
  start_time?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumenum_Supplier_Calendars_Events_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Calendars_EventsUpsertWithWhereUniqueWithoutQuotesInput = {
  create: Supplier_Calendars_EventsCreateWithoutQuotesInput;
  update: Supplier_Calendars_EventsUpdateWithoutQuotesInput;
  where: Supplier_Calendars_EventsWhereUniqueInput;
};

export type Supplier_Calendars_EventsUpsertWithWhereUniqueWithoutSupplier_CalendarsInput = {
  create: Supplier_Calendars_EventsCreateWithoutSupplier_CalendarsInput;
  update: Supplier_Calendars_EventsUpdateWithoutSupplier_CalendarsInput;
  where: Supplier_Calendars_EventsWhereUniqueInput;
};

export type Supplier_Calendars_EventsWhereInput = {
  AND?: InputMaybe<Array<Supplier_Calendars_EventsWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Calendars_EventsWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Calendars_EventsWhereInput>>;
  calendar_id?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  end_time?: InputMaybe<DateTimeNullableFilter>;
  quote_id?: InputMaybe<StringNullableFilter>;
  quotes?: InputMaybe<QuotesWhereInput>;
  start_time?: InputMaybe<DateTimeNullableFilter>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsWhereInput>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<Enumenum_Supplier_Calendars_Events_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_Calendars_EventsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Categories_Tier2 = {
  __typename?: 'supplier_categories_tier2';
  category?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['String']['output']>;
};

export type Supplier_Categories_Tier2CreateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Categories_Tier2CreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Supplier_Categories_Tier2CreateWithoutCategories_Tier2Input>>;
};

export type Supplier_Categories_Tier2CreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Categories_Tier2CreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_Categories_Tier2CreateWithoutSuppliersInput>>;
};

export type Supplier_Categories_Tier2CreateOrConnectWithoutcategories_Tier2Input = {
  create: Supplier_Categories_Tier2CreateWithoutCategories_Tier2Input;
  where: Supplier_Categories_Tier2WhereUniqueInput;
};

export type Supplier_Categories_Tier2CreateOrConnectWithoutsuppliersInput = {
  create: Supplier_Categories_Tier2CreateWithoutSuppliersInput;
  where: Supplier_Categories_Tier2WhereUniqueInput;
};

export type Supplier_Categories_Tier2CreateWithoutCategories_Tier2Input = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers: SuppliersCreateOneWithoutSupplier_Categories_Tier2Input;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Supplier_Categories_Tier2CreateWithoutSuppliersInput = {
  categories_tier2: Categories_Tier2CreateOneWithoutSupplier_Categories_Tier2Input;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Supplier_Categories_Tier2ScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_Categories_Tier2ScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Categories_Tier2ScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Categories_Tier2ScalarWhereInput>>;
  category?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Supplier_Categories_Tier2Supplier_IdCategoryCompoundUniqueInput = {
  category: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};

export type Supplier_Categories_Tier2UpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Supplier_Categories_Tier2UpdateManyWithWhereWithoutCategories_Tier2Input = {
  data: Supplier_Categories_Tier2UpdateManyMutationInput;
  where: Supplier_Categories_Tier2ScalarWhereInput;
};

export type Supplier_Categories_Tier2UpdateManyWithWhereWithoutSuppliersInput = {
  data: Supplier_Categories_Tier2UpdateManyMutationInput;
  where: Supplier_Categories_Tier2ScalarWhereInput;
};

export type Supplier_Categories_Tier2UpdateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Categories_Tier2CreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Supplier_Categories_Tier2CreateWithoutCategories_Tier2Input>>;
  delete?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Categories_Tier2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Categories_Tier2UpdateWithWhereUniqueWithoutCategories_Tier2Input>>;
  updateMany?: InputMaybe<Array<Supplier_Categories_Tier2UpdateManyWithWhereWithoutCategories_Tier2Input>>;
  upsert?: InputMaybe<Array<Supplier_Categories_Tier2UpsertWithWhereUniqueWithoutCategories_Tier2Input>>;
};

export type Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Categories_Tier2CreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_Categories_Tier2CreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Categories_Tier2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Categories_Tier2WhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Categories_Tier2UpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Supplier_Categories_Tier2UpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Supplier_Categories_Tier2UpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Supplier_Categories_Tier2UpdateWithWhereUniqueWithoutCategories_Tier2Input = {
  data: Supplier_Categories_Tier2UpdateWithoutCategories_Tier2Input;
  where: Supplier_Categories_Tier2WhereUniqueInput;
};

export type Supplier_Categories_Tier2UpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Supplier_Categories_Tier2UpdateWithoutSuppliersInput;
  where: Supplier_Categories_Tier2WhereUniqueInput;
};

export type Supplier_Categories_Tier2UpdateWithoutCategories_Tier2Input = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSupplier_Categories_Tier2Input>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Supplier_Categories_Tier2UpdateWithoutSuppliersInput = {
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneRequiredWithoutSupplier_Categories_Tier2Input>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Supplier_Categories_Tier2UpsertWithWhereUniqueWithoutCategories_Tier2Input = {
  create: Supplier_Categories_Tier2CreateWithoutCategories_Tier2Input;
  update: Supplier_Categories_Tier2UpdateWithoutCategories_Tier2Input;
  where: Supplier_Categories_Tier2WhereUniqueInput;
};

export type Supplier_Categories_Tier2UpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Supplier_Categories_Tier2CreateWithoutSuppliersInput;
  update: Supplier_Categories_Tier2UpdateWithoutSuppliersInput;
  where: Supplier_Categories_Tier2WhereUniqueInput;
};

export type Supplier_Categories_Tier2WhereInput = {
  AND?: InputMaybe<Array<Supplier_Categories_Tier2WhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Categories_Tier2WhereInput>>;
  OR?: InputMaybe<Array<Supplier_Categories_Tier2WhereInput>>;
  categories_tier2?: InputMaybe<Categories_Tier2WhereInput>;
  category?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Supplier_Categories_Tier2WhereUniqueInput = {
  supplier_id_category?: InputMaybe<Supplier_Categories_Tier2Supplier_IdCategoryCompoundUniqueInput>;
};

export type Supplier_Docs_Presigned_Url = {
  __typename?: 'supplier_docs_presigned_url';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum Supplier_Document_Type {
  Alcohol = 'ALCOHOL',
  EmployersLiability = 'EMPLOYERS_LIABILITY',
  FoodHygiene = 'FOOD_HYGIENE',
  PublicLiability = 'PUBLIC_LIABILITY',
  RiskAssessment = 'RISK_ASSESSMENT'
}

export type Supplier_Document_Type_Input = {
  type: Supplier_Document_Type;
};

export type Supplier_DocumentsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_DocumentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_DocumentsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_DocumentsCreateWithoutSuppliersInput>>;
};

export type Supplier_DocumentsCreateOrConnectWithoutsuppliersInput = {
  create: Supplier_DocumentsCreateWithoutSuppliersInput;
  where: Supplier_DocumentsWhereUniqueInput;
};

export type Supplier_DocumentsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  expiry_date?: InputMaybe<Scalars['DateTime']['input']>;
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  type: Enum_Supplier_Documents_Type;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Supplier_DocumentsScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_DocumentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_DocumentsScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_DocumentsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  expiry_date?: InputMaybe<DateTimeNullableFilter>;
  filename?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Supplier_Documents_TypeFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_DocumentsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expiry_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Supplier_Documents_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_DocumentsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Supplier_DocumentsUpdateManyMutationInput;
  where: Supplier_DocumentsScalarWhereInput;
};

export type Supplier_DocumentsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_DocumentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_DocumentsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_DocumentsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Supplier_DocumentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_DocumentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_DocumentsWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_DocumentsWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_DocumentsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Supplier_DocumentsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Supplier_DocumentsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Supplier_DocumentsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Supplier_DocumentsUpdateWithoutSuppliersInput;
  where: Supplier_DocumentsWhereUniqueInput;
};

export type Supplier_DocumentsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expiry_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Supplier_Documents_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_DocumentsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Supplier_DocumentsCreateWithoutSuppliersInput;
  update: Supplier_DocumentsUpdateWithoutSuppliersInput;
  where: Supplier_DocumentsWhereUniqueInput;
};

export type Supplier_DocumentsWhereInput = {
  AND?: InputMaybe<Array<Supplier_DocumentsWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_DocumentsWhereInput>>;
  OR?: InputMaybe<Array<Supplier_DocumentsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  expiry_date?: InputMaybe<DateTimeNullableFilter>;
  filename?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  type?: InputMaybe<Enumenum_Supplier_Documents_TypeFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_DocumentsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Event_Requests = {
  __typename?: 'supplier_event_requests';
  read_timestamp?: Maybe<Scalars['DateTime']['output']>;
  saved?: Maybe<Scalars['Boolean']['output']>;
};

export type Supplier_Event_RequestsCreateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Event_RequestsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Supplier_Event_RequestsCreateWithoutEvent_RequestsInput>>;
};

export type Supplier_Event_RequestsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Event_RequestsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_Event_RequestsCreateWithoutSuppliersInput>>;
};

export type Supplier_Event_RequestsCreateOrConnectWithoutevent_RequestsInput = {
  create: Supplier_Event_RequestsCreateWithoutEvent_RequestsInput;
  where: Supplier_Event_RequestsWhereUniqueInput;
};

export type Supplier_Event_RequestsCreateOrConnectWithoutsuppliersInput = {
  create: Supplier_Event_RequestsCreateWithoutSuppliersInput;
  where: Supplier_Event_RequestsWhereUniqueInput;
};

export type Supplier_Event_RequestsCreateWithoutEvent_RequestsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers: SuppliersCreateOneWithoutSupplier_Event_RequestsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Supplier_Event_RequestsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_requests: Event_RequestsCreateOneWithoutSupplier_Event_RequestsInput;
  read_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Supplier_Event_RequestsScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_Event_RequestsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Event_RequestsScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Event_RequestsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  read_timestamp?: InputMaybe<DateTimeNullableFilter>;
  saved?: InputMaybe<BoolNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Supplier_Event_RequestsSupplier_IdEvent_Request_IdCompoundUniqueInput = {
  event_request_id: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};

export type Supplier_Event_RequestsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  saved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Supplier_Event_RequestsUpdateManyWithWhereWithoutEvent_RequestsInput = {
  data: Supplier_Event_RequestsUpdateManyMutationInput;
  where: Supplier_Event_RequestsScalarWhereInput;
};

export type Supplier_Event_RequestsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Supplier_Event_RequestsUpdateManyMutationInput;
  where: Supplier_Event_RequestsScalarWhereInput;
};

export type Supplier_Event_RequestsUpdateManyWithoutEvent_RequestsInput = {
  connect?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Event_RequestsCreateOrConnectWithoutevent_RequestsInput>>;
  create?: InputMaybe<Array<Supplier_Event_RequestsCreateWithoutEvent_RequestsInput>>;
  delete?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Event_RequestsUpdateWithWhereUniqueWithoutEvent_RequestsInput>>;
  updateMany?: InputMaybe<Array<Supplier_Event_RequestsUpdateManyWithWhereWithoutEvent_RequestsInput>>;
  upsert?: InputMaybe<Array<Supplier_Event_RequestsUpsertWithWhereUniqueWithoutEvent_RequestsInput>>;
};

export type Supplier_Event_RequestsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Event_RequestsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_Event_RequestsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Event_RequestsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Event_RequestsWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Event_RequestsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Supplier_Event_RequestsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Supplier_Event_RequestsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Supplier_Event_RequestsUpdateWithWhereUniqueWithoutEvent_RequestsInput = {
  data: Supplier_Event_RequestsUpdateWithoutEvent_RequestsInput;
  where: Supplier_Event_RequestsWhereUniqueInput;
};

export type Supplier_Event_RequestsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Supplier_Event_RequestsUpdateWithoutSuppliersInput;
  where: Supplier_Event_RequestsWhereUniqueInput;
};

export type Supplier_Event_RequestsUpdateWithoutEvent_RequestsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  saved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSupplier_Event_RequestsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Supplier_Event_RequestsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_requests?: InputMaybe<Event_RequestsUpdateOneRequiredWithoutSupplier_Event_RequestsInput>;
  read_timestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  saved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Supplier_Event_RequestsUpsertWithWhereUniqueWithoutEvent_RequestsInput = {
  create: Supplier_Event_RequestsCreateWithoutEvent_RequestsInput;
  update: Supplier_Event_RequestsUpdateWithoutEvent_RequestsInput;
  where: Supplier_Event_RequestsWhereUniqueInput;
};

export type Supplier_Event_RequestsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Supplier_Event_RequestsCreateWithoutSuppliersInput;
  update: Supplier_Event_RequestsUpdateWithoutSuppliersInput;
  where: Supplier_Event_RequestsWhereUniqueInput;
};

export type Supplier_Event_RequestsWhereInput = {
  AND?: InputMaybe<Array<Supplier_Event_RequestsWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Event_RequestsWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Event_RequestsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_id?: InputMaybe<StringFilter>;
  event_requests?: InputMaybe<Event_RequestsWhereInput>;
  read_timestamp?: InputMaybe<DateTimeNullableFilter>;
  saved?: InputMaybe<BoolNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Supplier_Event_RequestsWhereUniqueInput = {
  supplier_id_event_request_id?: InputMaybe<Supplier_Event_RequestsSupplier_IdEvent_Request_IdCompoundUniqueInput>;
};

export type Supplier_Flexible_Pricing = {
  __typename?: 'supplier_flexible_pricing';
  day_of_week?: Maybe<Enum_Supplier_Flexible_Pricing_Day_Of_Week>;
  month?: Maybe<Enum_Supplier_Flexible_Pricing_Month>;
  price: Scalars['Int']['output'];
  price_adjustment: Enum_Supplier_Flexible_Pricing_Price_Adjustment;
  supplier_id: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type Supplier_Flexible_PricingCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_Flexible_PricingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Flexible_PricingCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_Flexible_PricingCreateWithoutSuppliersInput>>;
};

export type Supplier_Flexible_PricingCreateOrConnectWithoutsuppliersInput = {
  create: Supplier_Flexible_PricingCreateWithoutSuppliersInput;
  where: Supplier_Flexible_PricingWhereUniqueInput;
};

export type Supplier_Flexible_PricingCreateWithoutSuppliersInput = {
  created: Scalars['DateTime']['input'];
  day_of_week?: InputMaybe<Enum_Supplier_Flexible_Pricing_Day_Of_Week>;
  month?: InputMaybe<Enum_Supplier_Flexible_Pricing_Month>;
  price: Scalars['Int']['input'];
  price_adjustment: Enum_Supplier_Flexible_Pricing_Price_Adjustment;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_Flexible_PricingScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_Flexible_PricingScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Flexible_PricingScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Flexible_PricingScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  day_of_week?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_Day_Of_WeekNullableFilter>;
  month?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_MonthNullableFilter>;
  price?: InputMaybe<IntFilter>;
  price_adjustment?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_Price_AdjustmentFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_Flexible_PricingUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  day_of_week?: InputMaybe<NullableEnumenum_Supplier_Flexible_Pricing_Day_Of_WeekFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableEnumenum_Supplier_Flexible_Pricing_MonthFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  price_adjustment?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_Price_AdjustmentFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Flexible_PricingUpdateManyWithWhereWithoutSuppliersInput = {
  data: Supplier_Flexible_PricingUpdateManyMutationInput;
  where: Supplier_Flexible_PricingScalarWhereInput;
};

export type Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_Flexible_PricingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Flexible_PricingCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_Flexible_PricingCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Supplier_Flexible_PricingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Flexible_PricingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Flexible_PricingWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Flexible_PricingWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Flexible_PricingUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Supplier_Flexible_PricingUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Supplier_Flexible_PricingUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Supplier_Flexible_PricingUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Supplier_Flexible_PricingUpdateWithoutSuppliersInput;
  where: Supplier_Flexible_PricingWhereUniqueInput;
};

export type Supplier_Flexible_PricingUpdateWithoutSuppliersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  day_of_week?: InputMaybe<NullableEnumenum_Supplier_Flexible_Pricing_Day_Of_WeekFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableEnumenum_Supplier_Flexible_Pricing_MonthFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  price_adjustment?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_Price_AdjustmentFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Flexible_PricingUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Supplier_Flexible_PricingCreateWithoutSuppliersInput;
  update: Supplier_Flexible_PricingUpdateWithoutSuppliersInput;
  where: Supplier_Flexible_PricingWhereUniqueInput;
};

export type Supplier_Flexible_PricingWhereInput = {
  AND?: InputMaybe<Array<Supplier_Flexible_PricingWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Flexible_PricingWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Flexible_PricingWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  day_of_week?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_Day_Of_WeekNullableFilter>;
  month?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_MonthNullableFilter>;
  price?: InputMaybe<IntFilter>;
  price_adjustment?: InputMaybe<Enumenum_Supplier_Flexible_Pricing_Price_AdjustmentFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_Flexible_PricingWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Images = {
  __typename?: 'supplier_images';
  description?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  supplier_images_spaces: Array<Supplier_Images_Spaces>;
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};


export type Supplier_ImagesSupplier_Images_SpacesArgs = {
  cursor?: InputMaybe<Supplier_Images_SpacesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Supplier_ImagesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_ImagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_ImagesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_ImagesCreateWithoutSuppliersInput>>;
};

export type Supplier_ImagesCreateOneWithoutQuote_Line_Item_TemplatesInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutquote_Line_Item_TemplatesInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutQuote_Line_Item_TemplatesInput>;
};

export type Supplier_ImagesCreateOneWithoutQuote_Line_ItemsInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutquote_Line_ItemsInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutQuote_Line_ItemsInput>;
};

export type Supplier_ImagesCreateOneWithoutQuote_Template_Line_ItemsInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutquote_Template_Line_ItemsInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutQuote_Template_Line_ItemsInput>;
};

export type Supplier_ImagesCreateOneWithoutSupplier_Images_SpacesInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutsupplier_Images_SpacesInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutSupplier_Images_SpacesInput>;
};

export type Supplier_ImagesCreateOrConnectWithoutquote_Line_Item_TemplatesInput = {
  create: Supplier_ImagesCreateWithoutQuote_Line_Item_TemplatesInput;
  where: Supplier_ImagesWhereUniqueInput;
};

export type Supplier_ImagesCreateOrConnectWithoutquote_Line_ItemsInput = {
  create: Supplier_ImagesCreateWithoutQuote_Line_ItemsInput;
  where: Supplier_ImagesWhereUniqueInput;
};

export type Supplier_ImagesCreateOrConnectWithoutquote_Template_Line_ItemsInput = {
  create: Supplier_ImagesCreateWithoutQuote_Template_Line_ItemsInput;
  where: Supplier_ImagesWhereUniqueInput;
};

export type Supplier_ImagesCreateOrConnectWithoutsupplier_Images_SpacesInput = {
  create: Supplier_ImagesCreateWithoutSupplier_Images_SpacesInput;
  where: Supplier_ImagesWhereUniqueInput;
};

export type Supplier_ImagesCreateOrConnectWithoutsuppliersInput = {
  create: Supplier_ImagesCreateWithoutSuppliersInput;
  where: Supplier_ImagesWhereUniqueInput;
};

export type Supplier_ImagesCreateWithoutQuote_Line_Item_TemplatesInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutSupplier_ImagesInput>;
  suppliers: SuppliersCreateOneWithoutSupplier_Images_Supplier_ImagesTosuppliersInput;
  updated: Scalars['DateTime']['input'];
  url: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_ImagesCreateWithoutQuote_Line_ItemsInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutSupplier_ImagesInput>;
  suppliers: SuppliersCreateOneWithoutSupplier_Images_Supplier_ImagesTosuppliersInput;
  updated: Scalars['DateTime']['input'];
  url: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_ImagesCreateWithoutQuote_Template_Line_ItemsInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSupplier_ImagesInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutSupplier_ImagesInput>;
  suppliers: SuppliersCreateOneWithoutSupplier_Images_Supplier_ImagesTosuppliersInput;
  updated: Scalars['DateTime']['input'];
  url: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_ImagesCreateWithoutSupplier_Images_SpacesInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSupplier_ImagesInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  suppliers: SuppliersCreateOneWithoutSupplier_Images_Supplier_ImagesTosuppliersInput;
  updated: Scalars['DateTime']['input'];
  url: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_ImagesCreateWithoutSuppliersInput = {
  created: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSupplier_ImagesInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsCreateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutSupplier_ImagesInput>;
  updated: Scalars['DateTime']['input'];
  url: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_ImagesScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_ImagesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_ImagesScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_ImagesScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  filename?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_ImagesUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_ImagesUpdateManyWithWhereWithoutSuppliersInput = {
  data: Supplier_ImagesUpdateManyMutationInput;
  where: Supplier_ImagesScalarWhereInput;
};

export type Supplier_ImagesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Supplier_ImagesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_ImagesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Supplier_ImagesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Supplier_ImagesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_ImagesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_ImagesWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_ImagesWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_ImagesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Supplier_ImagesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Supplier_ImagesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Supplier_ImagesUpdateOneRequiredWithoutSupplier_Images_SpacesInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutsupplier_Images_SpacesInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutSupplier_Images_SpacesInput>;
  update?: InputMaybe<Supplier_ImagesUpdateWithoutSupplier_Images_SpacesInput>;
  upsert?: InputMaybe<Supplier_ImagesUpsertWithoutSupplier_Images_SpacesInput>;
};

export type Supplier_ImagesUpdateOneWithoutQuote_Line_Item_TemplatesInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutquote_Line_Item_TemplatesInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutQuote_Line_Item_TemplatesInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Supplier_ImagesUpdateWithoutQuote_Line_Item_TemplatesInput>;
  upsert?: InputMaybe<Supplier_ImagesUpsertWithoutQuote_Line_Item_TemplatesInput>;
};

export type Supplier_ImagesUpdateOneWithoutQuote_Line_ItemsInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutquote_Line_ItemsInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutQuote_Line_ItemsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Supplier_ImagesUpdateWithoutQuote_Line_ItemsInput>;
  upsert?: InputMaybe<Supplier_ImagesUpsertWithoutQuote_Line_ItemsInput>;
};

export type Supplier_ImagesUpdateOneWithoutQuote_Template_Line_ItemsInput = {
  connect?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_ImagesCreateOrConnectWithoutquote_Template_Line_ItemsInput>;
  create?: InputMaybe<Supplier_ImagesCreateWithoutQuote_Template_Line_ItemsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Supplier_ImagesUpdateWithoutQuote_Template_Line_ItemsInput>;
  upsert?: InputMaybe<Supplier_ImagesUpsertWithoutQuote_Template_Line_ItemsInput>;
};

export type Supplier_ImagesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Supplier_ImagesUpdateWithoutSuppliersInput;
  where: Supplier_ImagesWhereUniqueInput;
};

export type Supplier_ImagesUpdateWithoutQuote_Line_Item_TemplatesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutSupplier_ImagesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_ImagesUpdateWithoutQuote_Line_ItemsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutSupplier_ImagesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_ImagesUpdateWithoutQuote_Template_Line_ItemsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSupplier_ImagesInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutSupplier_ImagesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_ImagesUpdateWithoutSupplier_Images_SpacesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSupplier_ImagesInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_ImagesUpdateWithoutSuppliersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filename?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSupplier_ImagesInput>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsUpdateManyWithoutSupplier_ImagesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutSupplier_ImagesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_ImagesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Supplier_ImagesCreateWithoutSuppliersInput;
  update: Supplier_ImagesUpdateWithoutSuppliersInput;
  where: Supplier_ImagesWhereUniqueInput;
};

export type Supplier_ImagesUpsertWithoutQuote_Line_Item_TemplatesInput = {
  create: Supplier_ImagesCreateWithoutQuote_Line_Item_TemplatesInput;
  update: Supplier_ImagesUpdateWithoutQuote_Line_Item_TemplatesInput;
};

export type Supplier_ImagesUpsertWithoutQuote_Line_ItemsInput = {
  create: Supplier_ImagesCreateWithoutQuote_Line_ItemsInput;
  update: Supplier_ImagesUpdateWithoutQuote_Line_ItemsInput;
};

export type Supplier_ImagesUpsertWithoutQuote_Template_Line_ItemsInput = {
  create: Supplier_ImagesCreateWithoutQuote_Template_Line_ItemsInput;
  update: Supplier_ImagesUpdateWithoutQuote_Template_Line_ItemsInput;
};

export type Supplier_ImagesUpsertWithoutSupplier_Images_SpacesInput = {
  create: Supplier_ImagesCreateWithoutSupplier_Images_SpacesInput;
  update: Supplier_ImagesUpdateWithoutSupplier_Images_SpacesInput;
};

export type Supplier_ImagesWhereInput = {
  AND?: InputMaybe<Array<Supplier_ImagesWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_ImagesWhereInput>>;
  OR?: InputMaybe<Array<Supplier_ImagesWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  filename?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesListRelationFilter>;
  quote_line_items?: InputMaybe<Quote_Line_ItemsListRelationFilter>;
  quote_template_line_items?: InputMaybe<Quote_Template_Line_ItemsListRelationFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesListRelationFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_ImagesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Images_Spaces = {
  __typename?: 'supplier_images_spaces';
  supplier_images: Supplier_Images;
  uuid: Scalars['String']['output'];
};

export type Supplier_Images_SpacesCreateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Images_SpacesCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Supplier_Images_SpacesCreateWithoutSupplier_ImagesInput>>;
};

export type Supplier_Images_SpacesCreateManyWithoutVenue_SpacesInput = {
  connect?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Images_SpacesCreateOrConnectWithoutvenue_SpacesInput>>;
  create?: InputMaybe<Array<Supplier_Images_SpacesCreateWithoutVenue_SpacesInput>>;
};

export type Supplier_Images_SpacesCreateOrConnectWithoutsupplier_ImagesInput = {
  create: Supplier_Images_SpacesCreateWithoutSupplier_ImagesInput;
  where: Supplier_Images_SpacesWhereUniqueInput;
};

export type Supplier_Images_SpacesCreateOrConnectWithoutvenue_SpacesInput = {
  create: Supplier_Images_SpacesCreateWithoutVenue_SpacesInput;
  where: Supplier_Images_SpacesWhereUniqueInput;
};

export type Supplier_Images_SpacesCreateWithoutSupplier_ImagesInput = {
  created: Scalars['DateTime']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
  venue_spaces: Venue_SpacesCreateOneWithoutSupplier_Images_SpacesInput;
};

export type Supplier_Images_SpacesCreateWithoutVenue_SpacesInput = {
  created: Scalars['DateTime']['input'];
  supplier_images: Supplier_ImagesCreateOneWithoutSupplier_Images_SpacesInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_Images_SpacesScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_Images_SpacesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Images_SpacesScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Images_SpacesScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  image_id?: InputMaybe<StringFilter>;
  space_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_Images_SpacesUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Images_SpacesUpdateManyWithWhereWithoutSupplier_ImagesInput = {
  data: Supplier_Images_SpacesUpdateManyMutationInput;
  where: Supplier_Images_SpacesScalarWhereInput;
};

export type Supplier_Images_SpacesUpdateManyWithWhereWithoutVenue_SpacesInput = {
  data: Supplier_Images_SpacesUpdateManyMutationInput;
  where: Supplier_Images_SpacesScalarWhereInput;
};

export type Supplier_Images_SpacesUpdateManyWithoutSupplier_ImagesInput = {
  connect?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Images_SpacesCreateOrConnectWithoutsupplier_ImagesInput>>;
  create?: InputMaybe<Array<Supplier_Images_SpacesCreateWithoutSupplier_ImagesInput>>;
  delete?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Images_SpacesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Images_SpacesUpdateWithWhereUniqueWithoutSupplier_ImagesInput>>;
  updateMany?: InputMaybe<Array<Supplier_Images_SpacesUpdateManyWithWhereWithoutSupplier_ImagesInput>>;
  upsert?: InputMaybe<Array<Supplier_Images_SpacesUpsertWithWhereUniqueWithoutSupplier_ImagesInput>>;
};

export type Supplier_Images_SpacesUpdateManyWithoutVenue_SpacesInput = {
  connect?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_Images_SpacesCreateOrConnectWithoutvenue_SpacesInput>>;
  create?: InputMaybe<Array<Supplier_Images_SpacesCreateWithoutVenue_SpacesInput>>;
  delete?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_Images_SpacesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_Images_SpacesWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_Images_SpacesUpdateWithWhereUniqueWithoutVenue_SpacesInput>>;
  updateMany?: InputMaybe<Array<Supplier_Images_SpacesUpdateManyWithWhereWithoutVenue_SpacesInput>>;
  upsert?: InputMaybe<Array<Supplier_Images_SpacesUpsertWithWhereUniqueWithoutVenue_SpacesInput>>;
};

export type Supplier_Images_SpacesUpdateWithWhereUniqueWithoutSupplier_ImagesInput = {
  data: Supplier_Images_SpacesUpdateWithoutSupplier_ImagesInput;
  where: Supplier_Images_SpacesWhereUniqueInput;
};

export type Supplier_Images_SpacesUpdateWithWhereUniqueWithoutVenue_SpacesInput = {
  data: Supplier_Images_SpacesUpdateWithoutVenue_SpacesInput;
  where: Supplier_Images_SpacesWhereUniqueInput;
};

export type Supplier_Images_SpacesUpdateWithoutSupplier_ImagesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateOneRequiredWithoutSupplier_Images_SpacesInput>;
};

export type Supplier_Images_SpacesUpdateWithoutVenue_SpacesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  supplier_images?: InputMaybe<Supplier_ImagesUpdateOneRequiredWithoutSupplier_Images_SpacesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Images_SpacesUpsertWithWhereUniqueWithoutSupplier_ImagesInput = {
  create: Supplier_Images_SpacesCreateWithoutSupplier_ImagesInput;
  update: Supplier_Images_SpacesUpdateWithoutSupplier_ImagesInput;
  where: Supplier_Images_SpacesWhereUniqueInput;
};

export type Supplier_Images_SpacesUpsertWithWhereUniqueWithoutVenue_SpacesInput = {
  create: Supplier_Images_SpacesCreateWithoutVenue_SpacesInput;
  update: Supplier_Images_SpacesUpdateWithoutVenue_SpacesInput;
  where: Supplier_Images_SpacesWhereUniqueInput;
};

export type Supplier_Images_SpacesWhereInput = {
  AND?: InputMaybe<Array<Supplier_Images_SpacesWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Images_SpacesWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Images_SpacesWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  image_id?: InputMaybe<StringFilter>;
  space_id?: InputMaybe<StringFilter>;
  supplier_images?: InputMaybe<Supplier_ImagesWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
  venue_spaces?: InputMaybe<Venue_SpacesWhereInput>;
};

export type Supplier_Images_SpacesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Payment_DetailsCreateOneWithoutSuppliersInput = {
  connect?: InputMaybe<Supplier_Payment_DetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_Payment_DetailsCreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<Supplier_Payment_DetailsCreateWithoutSuppliersInput>;
};

export type Supplier_Payment_DetailsCreateOrConnectWithoutsuppliersInput = {
  create: Supplier_Payment_DetailsCreateWithoutSuppliersInput;
  where: Supplier_Payment_DetailsWhereUniqueInput;
};

export type Supplier_Payment_DetailsCreateWithoutSuppliersInput = {
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  sort_code: Scalars['String']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput = {
  connect?: InputMaybe<Supplier_Payment_DetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_Payment_DetailsCreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<Supplier_Payment_DetailsCreateWithoutSuppliersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Supplier_Payment_DetailsUpdateWithoutSuppliersInput>;
  upsert?: InputMaybe<Supplier_Payment_DetailsUpsertWithoutSuppliersInput>;
};

export type Supplier_Payment_DetailsUpdateWithoutSuppliersInput = {
  account_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  account_number?: InputMaybe<StringFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sort_code?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_Payment_DetailsUpsertWithoutSuppliersInput = {
  create: Supplier_Payment_DetailsCreateWithoutSuppliersInput;
  update: Supplier_Payment_DetailsUpdateWithoutSuppliersInput;
};

export type Supplier_Payment_DetailsWhereInput = {
  AND?: InputMaybe<Array<Supplier_Payment_DetailsWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_Payment_DetailsWhereInput>>;
  OR?: InputMaybe<Array<Supplier_Payment_DetailsWhereInput>>;
  account_name?: InputMaybe<StringFilter>;
  account_number?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  sort_code?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersListRelationFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_Payment_DetailsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Payments = {
  __typename?: 'supplier_payments';
  created?: Maybe<Scalars['DateTime']['output']>;
  external_payment_info_id?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Enum_Supplier_Payments_Method>;
  quote_id?: Maybe<Scalars['String']['output']>;
  scheduled_payment_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Enum_Supplier_Payments_Status>;
  type?: Maybe<Enum_Supplier_Payments_Type>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Supplier_PaymentsCreateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Supplier_PaymentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_PaymentsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Supplier_PaymentsCreateWithoutQuotesInput>>;
};

export type Supplier_PaymentsCreateOneWithoutScheduled_PaymentsInput = {
  connect?: InputMaybe<Supplier_PaymentsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_PaymentsCreateOrConnectWithoutscheduled_PaymentsInput>;
  create?: InputMaybe<Supplier_PaymentsCreateWithoutScheduled_PaymentsInput>;
};

export type Supplier_PaymentsCreateOrConnectWithoutquotesInput = {
  create: Supplier_PaymentsCreateWithoutQuotesInput;
  where: Supplier_PaymentsWhereUniqueInput;
};

export type Supplier_PaymentsCreateOrConnectWithoutscheduled_PaymentsInput = {
  create: Supplier_PaymentsCreateWithoutScheduled_PaymentsInput;
  where: Supplier_PaymentsWhereUniqueInput;
};

export type Supplier_PaymentsCreateWithoutQuotesInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  external_payment_info: External_Payment_InfoCreateOneWithoutSupplier_PaymentsInput;
  method: Enum_Supplier_Payments_Method;
  scheduled_payments: Scheduled_PaymentsCreateOneWithoutSupplier_PaymentsInput;
  status: Enum_Supplier_Payments_Status;
  type: Enum_Supplier_Payments_Type;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Supplier_PaymentsCreateWithoutScheduled_PaymentsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  external_payment_info: External_Payment_InfoCreateOneWithoutSupplier_PaymentsInput;
  method: Enum_Supplier_Payments_Method;
  quotes: QuotesCreateOneWithoutSupplier_PaymentsInput;
  status: Enum_Supplier_Payments_Status;
  type: Enum_Supplier_Payments_Type;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Supplier_PaymentsScalarWhereInput = {
  AND?: InputMaybe<Array<Supplier_PaymentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_PaymentsScalarWhereInput>>;
  OR?: InputMaybe<Array<Supplier_PaymentsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  external_payment_info_id?: InputMaybe<StringFilter>;
  method?: InputMaybe<Enumenum_Supplier_Payments_MethodFilter>;
  quote_id?: InputMaybe<StringFilter>;
  scheduled_payment_id?: InputMaybe<StringFilter>;
  status?: InputMaybe<Enumenum_Supplier_Payments_StatusFilter>;
  type?: InputMaybe<Enumenum_Supplier_Payments_TypeFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_PaymentsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  method?: InputMaybe<Enumenum_Supplier_Payments_MethodFieldUpdateOperationsInput>;
  status?: InputMaybe<Enumenum_Supplier_Payments_StatusFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Supplier_Payments_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_PaymentsUpdateManyWithWhereWithoutQuotesInput = {
  data: Supplier_PaymentsUpdateManyMutationInput;
  where: Supplier_PaymentsScalarWhereInput;
};

export type Supplier_PaymentsUpdateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Supplier_PaymentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Supplier_PaymentsCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Supplier_PaymentsCreateWithoutQuotesInput>>;
  delete?: InputMaybe<Array<Supplier_PaymentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Supplier_PaymentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Supplier_PaymentsWhereUniqueInput>>;
  set?: InputMaybe<Array<Supplier_PaymentsWhereUniqueInput>>;
  update?: InputMaybe<Array<Supplier_PaymentsUpdateWithWhereUniqueWithoutQuotesInput>>;
  updateMany?: InputMaybe<Array<Supplier_PaymentsUpdateManyWithWhereWithoutQuotesInput>>;
  upsert?: InputMaybe<Array<Supplier_PaymentsUpsertWithWhereUniqueWithoutQuotesInput>>;
};

export type Supplier_PaymentsUpdateOneWithoutScheduled_PaymentsInput = {
  connect?: InputMaybe<Supplier_PaymentsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_PaymentsCreateOrConnectWithoutscheduled_PaymentsInput>;
  create?: InputMaybe<Supplier_PaymentsCreateWithoutScheduled_PaymentsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Supplier_PaymentsUpdateWithoutScheduled_PaymentsInput>;
  upsert?: InputMaybe<Supplier_PaymentsUpsertWithoutScheduled_PaymentsInput>;
};

export type Supplier_PaymentsUpdateWithWhereUniqueWithoutQuotesInput = {
  data: Supplier_PaymentsUpdateWithoutQuotesInput;
  where: Supplier_PaymentsWhereUniqueInput;
};

export type Supplier_PaymentsUpdateWithoutQuotesInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  external_payment_info?: InputMaybe<External_Payment_InfoUpdateOneRequiredWithoutSupplier_PaymentsInput>;
  method?: InputMaybe<Enumenum_Supplier_Payments_MethodFieldUpdateOperationsInput>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsUpdateOneRequiredWithoutSupplier_PaymentsInput>;
  status?: InputMaybe<Enumenum_Supplier_Payments_StatusFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Supplier_Payments_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_PaymentsUpdateWithoutScheduled_PaymentsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  external_payment_info?: InputMaybe<External_Payment_InfoUpdateOneRequiredWithoutSupplier_PaymentsInput>;
  method?: InputMaybe<Enumenum_Supplier_Payments_MethodFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateOneRequiredWithoutSupplier_PaymentsInput>;
  status?: InputMaybe<Enumenum_Supplier_Payments_StatusFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Supplier_Payments_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Supplier_PaymentsUpsertWithWhereUniqueWithoutQuotesInput = {
  create: Supplier_PaymentsCreateWithoutQuotesInput;
  update: Supplier_PaymentsUpdateWithoutQuotesInput;
  where: Supplier_PaymentsWhereUniqueInput;
};

export type Supplier_PaymentsUpsertWithoutScheduled_PaymentsInput = {
  create: Supplier_PaymentsCreateWithoutScheduled_PaymentsInput;
  update: Supplier_PaymentsUpdateWithoutScheduled_PaymentsInput;
};

export type Supplier_PaymentsWhereInput = {
  AND?: InputMaybe<Array<Supplier_PaymentsWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_PaymentsWhereInput>>;
  OR?: InputMaybe<Array<Supplier_PaymentsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  external_payment_info?: InputMaybe<External_Payment_InfoWhereInput>;
  external_payment_info_id?: InputMaybe<StringFilter>;
  method?: InputMaybe<Enumenum_Supplier_Payments_MethodFilter>;
  quote_id?: InputMaybe<StringFilter>;
  quotes?: InputMaybe<QuotesWhereInput>;
  scheduled_payment_id?: InputMaybe<StringFilter>;
  scheduled_payments?: InputMaybe<Scheduled_PaymentsWhereInput>;
  status?: InputMaybe<Enumenum_Supplier_Payments_StatusFilter>;
  type?: InputMaybe<Enumenum_Supplier_Payments_TypeFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Supplier_PaymentsWhereUniqueInput = {
  external_payment_info_id?: InputMaybe<Scalars['String']['input']>;
  scheduled_payment_id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier_Referrals = {
  __typename?: 'supplier_referrals';
  booked?: Maybe<Referrals>;
  pending?: Maybe<Referrals>;
  referralLink?: Maybe<Scalars['String']['output']>;
  totalReferrals?: Maybe<Scalars['Int']['output']>;
};

export type Supplier_Statistic = {
  __typename?: 'supplier_statistic';
  difference?: Maybe<Scalars['Float']['output']>;
  metric?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type Supplier_Statistics = {
  __typename?: 'supplier_statistics';
  lastUpdated?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<Array<Maybe<Supplier_Statistic>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Supplier_StatsCreateOneWithoutSuppliersInput = {
  connect?: InputMaybe<Supplier_StatsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_StatsCreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<Supplier_StatsCreateWithoutSuppliersInput>;
};

export type Supplier_StatsCreateOrConnectWithoutsuppliersInput = {
  create: Supplier_StatsCreateWithoutSuppliersInput;
  where: Supplier_StatsWhereUniqueInput;
};

export type Supplier_StatsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  statistics?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<Enum_Supplier_Stats_Status>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Supplier_StatsUpdateOneWithoutSuppliersInput = {
  connect?: InputMaybe<Supplier_StatsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Supplier_StatsCreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<Supplier_StatsCreateWithoutSuppliersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Supplier_StatsUpdateWithoutSuppliersInput>;
  upsert?: InputMaybe<Supplier_StatsUpsertWithoutSuppliersInput>;
};

export type Supplier_StatsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  statistics?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableEnumenum_Supplier_Stats_StatusFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type Supplier_StatsUpsertWithoutSuppliersInput = {
  create: Supplier_StatsCreateWithoutSuppliersInput;
  update: Supplier_StatsUpdateWithoutSuppliersInput;
};

export type Supplier_StatsWhereInput = {
  AND?: InputMaybe<Array<Supplier_StatsWhereInput>>;
  NOT?: InputMaybe<Array<Supplier_StatsWhereInput>>;
  OR?: InputMaybe<Array<Supplier_StatsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  statistics?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<Enumenum_Supplier_Stats_StatusNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
};

export type Supplier_StatsWhereUniqueInput = {
  supplier_id?: InputMaybe<Scalars['String']['input']>;
};

export type Suppliers = {
  __typename?: 'suppliers';
  activity?: Maybe<Scalars['Int']['output']>;
  alcohol_permit?: Maybe<Scalars['Boolean']['output']>;
  algorithm_discoverable: Scalars['Boolean']['output'];
  available_hours_end?: Maybe<Scalars['String']['output']>;
  available_hours_start?: Maybe<Scalars['String']['output']>;
  average_rating?: Maybe<Scalars['Float']['output']>;
  base_price?: Maybe<Scalars['Float']['output']>;
  calendars?: Maybe<Array<Maybe<Calendar>>>;
  categories_tier2?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category_tier1?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  company_registration_number?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Scalars['Json']['output']>;
  declined_event_requests: Array<Declined_Event_Requests>;
  deposits_enabled?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<SupplierDocType>;
  employers_liability_certificate?: Maybe<Scalars['Json']['output']>;
  external_links?: Maybe<Scalars['Json']['output']>;
  foodHygieneLocalAuthorityName?: Maybe<Scalars['String']['output']>;
  foodHygieneRatingScore?: Maybe<Scalars['Int']['output']>;
  food_hygiene_certificate?: Maybe<Scalars['Json']['output']>;
  freshsales_stage?: Maybe<Scalars['String']['output']>;
  hygiene_rating?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Scalars['json']['output']>>>;
  isGasUser?: Maybe<Scalars['Boolean']['output']>;
  isMissingDocuments: Scalars['Boolean']['output'];
  kyb_status: Enum_Suppliers_Kyb_Status;
  localAuthorityName?: Maybe<Scalars['String']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_line_1?: Maybe<Scalars['String']['output']>;
  location_line_2?: Maybe<Scalars['String']['output']>;
  matterport_url?: Maybe<Scalars['String']['output']>;
  max_bookings_per_day: Scalars['Int']['output'];
  max_working_hours?: Maybe<Scalars['Int']['output']>;
  min_spend?: Maybe<Scalars['Float']['output']>;
  muta_accredited?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardingStatus?: Maybe<OnboardingStatus>;
  photoshoot_interested?: Maybe<Scalars['Boolean']['output']>;
  portions_per_hour?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  press_awards?: Maybe<Scalars['String']['output']>;
  price_per_mile?: Maybe<Scalars['Int']['output']>;
  primaryTag?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['Json']['output']>;
  public_events_count?: Maybe<Scalars['Int']['output']>;
  public_events_visible: Scalars['Boolean']['output'];
  public_liability_certificate?: Maybe<Scalars['Json']['output']>;
  quoteScore: Scalars['Float']['output'];
  quote_templates: Array<Quote_Templates>;
  radius?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Public_Supplier_Rating>;
  recentMatches: Array<Event_Request_Supplier_Notified>;
  recommendations: Array<Recommendations>;
  referrals?: Maybe<Supplier_Referrals>;
  registeredBusinessOwnerName?: Maybe<Scalars['String']['output']>;
  registered_city?: Maybe<Scalars['String']['output']>;
  registered_company_name?: Maybe<Scalars['String']['output']>;
  registered_location_line1?: Maybe<Scalars['String']['output']>;
  registered_location_line2?: Maybe<Scalars['String']['output']>;
  registered_name?: Maybe<Scalars['String']['output']>;
  registered_postcode?: Maybe<Scalars['String']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews: Array<Reviews>;
  risk_assessment_document?: Maybe<Scalars['Json']['output']>;
  risk_assessment_score?: Maybe<Scalars['String']['output']>;
  salesforceSuppliers?: Maybe<SalesforceSuppliers>;
  setup_details?: Maybe<Scalars['String']['output']>;
  setup_power?: Maybe<Scalars['String']['output']>;
  setup_water?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  space_groups: Array<Space_Groups>;
  state?: Maybe<Enum_Suppliers_State>;
  supplierLinks: Array<SupplierLinks>;
  supplierPermissions: Array<SupplierPermissions>;
  supplierPitchGroupTypes?: Maybe<Array<Maybe<SupplierPitchGroupType>>>;
  supplier_images_table: Array<Supplier_Images>;
  suppliers_groups: Array<Suppliers_Groups>;
  suppliers_users: Array<Suppliers_Users>;
  tagline?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tagsByRoot?: Maybe<Array<Maybe<Tags>>>;
  trusted: Scalars['Boolean']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
  vat_number?: Maybe<Scalars['String']['output']>;
  venue_services: Array<Venue_Services>;
  venue_spaces: Array<Venue_Spaces>;
  video_url?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};


export type SuppliersDeclined_Event_RequestsArgs = {
  cursor?: InputMaybe<Declined_Event_RequestsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeclinedEventRequestsWhereInput>;
};


export type SuppliersDocumentsArgs = {
  filter?: InputMaybe<SupplierDocsFilters>;
};


export type SuppliersQuote_TemplatesArgs = {
  cursor?: InputMaybe<Quote_TemplatesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersRecentMatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersRecommendationsArgs = {
  cursor?: InputMaybe<RecommendationsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersReviewsArgs = {
  cursor?: InputMaybe<ReviewsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewsWhereInput>;
};


export type SuppliersSpace_GroupsArgs = {
  cursor?: InputMaybe<Space_GroupsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersSupplier_Images_TableArgs = {
  cursor?: InputMaybe<Supplier_ImagesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersSuppliers_GroupsArgs = {
  cursor?: InputMaybe<Suppliers_GroupsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersSuppliers_UsersArgs = {
  cursor?: InputMaybe<Suppliers_UsersWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersTagsByRootArgs = {
  rootTag: Array<Scalars['String']['input']>;
};


export type SuppliersVenue_ServicesArgs = {
  cursor?: InputMaybe<Venue_ServicesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersVenue_SpacesArgs = {
  cursor?: InputMaybe<Venue_SpacesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SuppliersCreateInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateManyWithoutCategories_Tier1Input = {
  connect?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SuppliersCreateOrConnectWithoutcategories_Tier1Input>>;
  create?: InputMaybe<Array<SuppliersCreateWithoutCategories_Tier1Input>>;
};

export type SuppliersCreateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SuppliersCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<SuppliersCreateWithoutTagsInput>>;
};

export type SuppliersCreateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutbookings_Bookings_Supplier_IdTosuppliersInput>;
  create?: InputMaybe<SuppliersCreateWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
};

export type SuppliersCreateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutbookings_Bookings_Supplier_ReferralTosuppliersInput>;
  create?: InputMaybe<SuppliersCreateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
};

export type SuppliersCreateOneWithoutConversationsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutconversationsInput>;
  create?: InputMaybe<SuppliersCreateWithoutConversationsInput>;
};

export type SuppliersCreateOneWithoutDeclined_Event_RequestsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutdeclined_Event_RequestsInput>;
  create?: InputMaybe<SuppliersCreateWithoutDeclined_Event_RequestsInput>;
};

export type SuppliersCreateOneWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>;
  create?: InputMaybe<SuppliersCreateWithoutEvent_Request_Supplier_NotifiedInput>;
};

export type SuppliersCreateOneWithoutEventsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<SuppliersCreateWithoutEventsInput>;
};

export type SuppliersCreateOneWithoutHidden_Event_RequestsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithouthidden_Event_RequestsInput>;
  create?: InputMaybe<SuppliersCreateWithoutHidden_Event_RequestsInput>;
};

export type SuppliersCreateOneWithoutQuote_Line_Item_TemplatesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutquote_Line_Item_TemplatesInput>;
  create?: InputMaybe<SuppliersCreateWithoutQuote_Line_Item_TemplatesInput>;
};

export type SuppliersCreateOneWithoutQuote_TemplatesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutquote_TemplatesInput>;
  create?: InputMaybe<SuppliersCreateWithoutQuote_TemplatesInput>;
};

export type SuppliersCreateOneWithoutQuotesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutquotesInput>;
  create?: InputMaybe<SuppliersCreateWithoutQuotesInput>;
};

export type SuppliersCreateOneWithoutReviewsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutreviewsInput>;
  create?: InputMaybe<SuppliersCreateWithoutReviewsInput>;
};

export type SuppliersCreateOneWithoutSpace_GroupsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutspace_GroupsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSpace_GroupsInput>;
};

export type SuppliersCreateOneWithoutSupplier_CalendarsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_CalendarsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_CalendarsInput>;
};

export type SuppliersCreateOneWithoutSupplier_Categories_Tier2Input = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_Categories_Tier2Input>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_Categories_Tier2Input>;
};

export type SuppliersCreateOneWithoutSupplier_Event_RequestsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_Event_RequestsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_Event_RequestsInput>;
};

export type SuppliersCreateOneWithoutSupplier_Images_Supplier_ImagesTosuppliersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_Images_Supplier_ImagesTosuppliersInput>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
};

export type SuppliersCreateOneWithoutSuppliers_GroupsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_GroupsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_GroupsInput>;
};

export type SuppliersCreateOneWithoutSuppliers_ItemsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_ItemsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_ItemsInput>;
};

export type SuppliersCreateOneWithoutSuppliers_TagsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_TagsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_TagsInput>;
};

export type SuppliersCreateOneWithoutSuppliers_TypesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_TypesInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_TypesInput>;
};

export type SuppliersCreateOneWithoutSuppliers_UsersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_UsersInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_UsersInput>;
};

export type SuppliersCreateOneWithoutVenue_ServicesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutvenue_ServicesInput>;
  create?: InputMaybe<SuppliersCreateWithoutVenue_ServicesInput>;
};

export type SuppliersCreateOneWithoutVenue_SpacesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutvenue_SpacesInput>;
  create?: InputMaybe<SuppliersCreateWithoutVenue_SpacesInput>;
};

export type SuppliersCreateOrConnectWithoutbookings_Bookings_Supplier_IdTosuppliersInput = {
  create: SuppliersCreateWithoutBookings_Bookings_Supplier_IdTosuppliersInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutbookings_Bookings_Supplier_ReferralTosuppliersInput = {
  create: SuppliersCreateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutcategories_Tier1Input = {
  create: SuppliersCreateWithoutCategories_Tier1Input;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutconversationsInput = {
  create: SuppliersCreateWithoutConversationsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutdeclined_Event_RequestsInput = {
  create: SuppliersCreateWithoutDeclined_Event_RequestsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput = {
  create: SuppliersCreateWithoutEvent_Request_Supplier_NotifiedInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithouteventsInput = {
  create: SuppliersCreateWithoutEventsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithouthidden_Event_RequestsInput = {
  create: SuppliersCreateWithoutHidden_Event_RequestsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutquote_Line_Item_TemplatesInput = {
  create: SuppliersCreateWithoutQuote_Line_Item_TemplatesInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutquote_TemplatesInput = {
  create: SuppliersCreateWithoutQuote_TemplatesInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutquotesInput = {
  create: SuppliersCreateWithoutQuotesInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutreviewsInput = {
  create: SuppliersCreateWithoutReviewsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutspace_GroupsInput = {
  create: SuppliersCreateWithoutSpace_GroupsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsupplier_CalendarsInput = {
  create: SuppliersCreateWithoutSupplier_CalendarsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsupplier_Categories_Tier2Input = {
  create: SuppliersCreateWithoutSupplier_Categories_Tier2Input;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsupplier_Event_RequestsInput = {
  create: SuppliersCreateWithoutSupplier_Event_RequestsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsupplier_Images_Supplier_ImagesTosuppliersInput = {
  create: SuppliersCreateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsuppliers_GroupsInput = {
  create: SuppliersCreateWithoutSuppliers_GroupsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsuppliers_ItemsInput = {
  create: SuppliersCreateWithoutSuppliers_ItemsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsuppliers_TagsInput = {
  create: SuppliersCreateWithoutSuppliers_TagsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsuppliers_TypesInput = {
  create: SuppliersCreateWithoutSuppliers_TypesInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutsuppliers_UsersInput = {
  create: SuppliersCreateWithoutSuppliers_UsersInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithouttagsInput = {
  create: SuppliersCreateWithoutTagsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutvenue_ServicesInput = {
  create: SuppliersCreateWithoutVenue_ServicesInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateOrConnectWithoutvenue_SpacesInput = {
  create: SuppliersCreateWithoutVenue_SpacesInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersCreateWithoutBookings_Bookings_Supplier_IdTosuppliersInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutCategories_Tier1Input = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutConversationsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutDeclined_Event_RequestsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutEvent_Request_Supplier_NotifiedInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutEventsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutHidden_Event_RequestsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutQuote_Line_Item_TemplatesInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutQuote_TemplatesInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutQuotesInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutReviewsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSpace_GroupsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSupplier_CalendarsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSupplier_Categories_Tier2Input = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSupplier_Event_RequestsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSuppliers_GroupsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSuppliers_ItemsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSuppliers_TagsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSuppliers_TypesInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutSuppliers_UsersInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutTagsInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutVenue_ServicesInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_spaces?: InputMaybe<Venue_SpacesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateWithoutVenue_SpacesInput = {
  activated_date?: InputMaybe<Scalars['DateTime']['input']>;
  activity_state?: InputMaybe<Scalars['String']['input']>;
  alcohol_permit?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm_discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  available_hours_end?: InputMaybe<Scalars['String']['input']>;
  available_hours_start?: InputMaybe<Scalars['String']['input']>;
  average_rating?: InputMaybe<Scalars['Float']['input']>;
  base_price?: InputMaybe<Scalars['Float']['input']>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsCreateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1CreateOneWithoutSuppliersInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  company_registration_number?: InputMaybe<Scalars['String']['input']>;
  conversations?: InputMaybe<ConversationsCreateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsCreateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedCreateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsCreateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesCreateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_account_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_id?: InputMaybe<Scalars['String']['input']>;
  freshsales_stage?: InputMaybe<Scalars['String']['input']>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsCreateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<SuppliersCreateimagesInput>;
  izettle_staff_name?: InputMaybe<Scalars['String']['input']>;
  kyb_status?: InputMaybe<Enum_Suppliers_Kyb_Status>;
  kyb_verified_date?: InputMaybe<Scalars['DateTime']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_line_1?: InputMaybe<Scalars['String']['input']>;
  location_line_2?: InputMaybe<Scalars['String']['input']>;
  matterport_url?: InputMaybe<Scalars['String']['input']>;
  max_bookings_per_day?: InputMaybe<Scalars['Int']['input']>;
  max_working_hours?: InputMaybe<Scalars['Int']['input']>;
  min_spend?: InputMaybe<Scalars['Float']['input']>;
  muta_accredited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nps_survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  overall_message_response_rate?: InputMaybe<Scalars['Float']['input']>;
  photoshoot_interested?: InputMaybe<Scalars['Boolean']['input']>;
  portions_per_hour?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  press_awards?: InputMaybe<Scalars['String']['input']>;
  price_per_mile?: InputMaybe<Scalars['Int']['input']>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<Scalars['Int']['input']>;
  public_events_visible?: InputMaybe<Scalars['Boolean']['input']>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesCreateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesCreateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<Scalars['Float']['input']>;
  quotes?: InputMaybe<QuotesCreateManyWithoutSuppliersInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<RecommendationsCreateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<Scalars['String']['input']>;
  registered_company_name?: InputMaybe<Scalars['String']['input']>;
  registered_location_line1?: InputMaybe<Scalars['String']['input']>;
  registered_location_line2?: InputMaybe<Scalars['String']['input']>;
  registered_name?: InputMaybe<Scalars['String']['input']>;
  registered_postcode?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<ReviewsCreateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<Scalars['String']['input']>;
  robex_boost?: InputMaybe<Scalars['Int']['input']>;
  robex_boosted_until?: InputMaybe<Scalars['DateTime']['input']>;
  robex_response_rate?: InputMaybe<Scalars['Float']['input']>;
  setup_details?: InputMaybe<Scalars['String']['input']>;
  setup_power?: InputMaybe<Scalars['String']['input']>;
  setup_water?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  social?: InputMaybe<SuppliersCreatesocialInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  space_groups?: InputMaybe<Space_GroupsCreateManyWithoutSuppliersInput>;
  state?: InputMaybe<Enum_Suppliers_State>;
  stripe_connect_account?: InputMaybe<Scalars['String']['input']>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsCreateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2CreateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsCreateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsCreateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingCreateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesCreateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsCreateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsCreateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsCreateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsCreateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsCreateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesCreateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsCreateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
  vat_number?: InputMaybe<Scalars['String']['input']>;
  venue_services?: InputMaybe<Venue_ServicesCreateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput>;
};

export type SuppliersCreateimagesInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type SuppliersCreatesocialInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type SuppliersEventRequest = {
  __typename?: 'suppliersEventRequest';
  accepting_quotes?: Maybe<Scalars['Boolean']['output']>;
  additional_info?: Maybe<Additional_Info>;
  admin_note?: Maybe<Scalars['String']['output']>;
  all_quotes_email_sent?: Maybe<Scalars['Boolean']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  budget_flexible?: Maybe<Scalars['Boolean']['output']>;
  categories_tier2?: Maybe<Categories_Tier2>;
  category_tier2?: Maybe<Scalars['String']['output']>;
  close_date?: Maybe<Scalars['DateTime']['output']>;
  close_reason?: Maybe<Scalars['String']['output']>;
  close_source?: Maybe<Scalars['String']['output']>;
  close_stage?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  conversations: Array<Conversations>;
  created?: Maybe<Scalars['DateTime']['output']>;
  declined_event_requests: Array<Declined_Event_Requests>;
  description?: Maybe<Scalars['String']['output']>;
  directRequest?: Maybe<DirectRequest>;
  distance?: Maybe<Scalars['Float']['output']>;
  distanceSource?: Maybe<DistanceSource>;
  drivingDistanceEta?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['DateTime']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  event_request_supplier_notified: Array<Event_Request_Supplier_Notified>;
  event_request_tags: Array<Event_Request_Tags>;
  freshsales_id?: Maybe<Scalars['String']['output']>;
  freshsales_stage?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incomplete_request_email_sent?: Maybe<Scalars['Boolean']['output']>;
  item_quantity?: Maybe<Scalars['Int']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  msclkid?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  partialPostcode?: Maybe<Scalars['String']['output']>;
  partnership?: Maybe<Partnership>;
  potential_suppliers?: Maybe<Scalars['Int']['output']>;
  preferred_supplier_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preferred_suppliers: Array<Scalars['String']['output']>;
  priority_tag?: Maybe<Scalars['String']['output']>;
  quoteData?: Maybe<QuoteData>;
  quote_limited?: Maybe<Scalars['Boolean']['output']>;
  quote_limited_source?: Maybe<Enum_Event_Request_Quote_Limited_Source>;
  quotes: Array<Quotes>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  supplierEvent: SupplierEvent;
  supplier_event_requests?: Maybe<Supplier_Event_Requests>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};


export type SuppliersEventRequestConversationsArgs = {
  cursor?: InputMaybe<ConversationsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConversationsWhereInput>;
};


export type SuppliersEventRequestDeclined_Event_RequestsArgs = {
  cursor?: InputMaybe<Declined_Event_RequestsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SuppliersEventRequestDistanceArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};


export type SuppliersEventRequestDistanceSourceArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};


export type SuppliersEventRequestDrivingDistanceEtaArgs = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};


export type SuppliersEventRequestEvent_Request_Supplier_NotifiedArgs = {
  cursor?: InputMaybe<Event_Request_Supplier_NotifiedWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Event_Request_Supplier_NotifiedWhereInput>;
};


export type SuppliersEventRequestEvent_Request_TagsArgs = {
  cursor?: InputMaybe<Event_Request_TagsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Event_Request_TagsWhereInput>;
};


export type SuppliersEventRequestPartnershipArgs = {
  partnershipId?: InputMaybe<Scalars['String']['input']>;
};


export type SuppliersEventRequestQuotesArgs = {
  cursor?: InputMaybe<QuotesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuotesWhereInput>;
};

export type SuppliersScalarWhereInput = {
  AND?: InputMaybe<Array<SuppliersScalarWhereInput>>;
  NOT?: InputMaybe<Array<SuppliersScalarWhereInput>>;
  OR?: InputMaybe<Array<SuppliersScalarWhereInput>>;
  activated_date?: InputMaybe<DateTimeNullableFilter>;
  activity_state?: InputMaybe<StringNullableFilter>;
  alcohol_permit?: InputMaybe<BoolNullableFilter>;
  algorithm_discoverable?: InputMaybe<BoolFilter>;
  available_hours_end?: InputMaybe<StringNullableFilter>;
  available_hours_start?: InputMaybe<StringNullableFilter>;
  average_rating?: InputMaybe<FloatNullableFilter>;
  base_price?: InputMaybe<FloatNullableFilter>;
  category_tier1?: InputMaybe<StringNullableFilter>;
  commission?: InputMaybe<FloatNullableFilter>;
  company_registration_number?: InputMaybe<StringNullableFilter>;
  coordinates?: InputMaybe<JsonNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  deposits_enabled?: InputMaybe<BoolNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employers_liability_certificate?: InputMaybe<JsonNullableFilter>;
  external_links?: InputMaybe<JsonNullableFilter>;
  first_message_response_rate?: InputMaybe<FloatNullableFilter>;
  food_hygiene_certificate?: InputMaybe<JsonNullableFilter>;
  food_safety_agency_id?: InputMaybe<StringNullableFilter>;
  freshsales_account_id?: InputMaybe<StringNullableFilter>;
  freshsales_id?: InputMaybe<StringNullableFilter>;
  freshsales_stage?: InputMaybe<StringNullableFilter>;
  hygiene_rating?: InputMaybe<StringNullableFilter>;
  images?: InputMaybe<JsonNullableListFilter>;
  izettle_staff_name?: InputMaybe<StringNullableFilter>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFilter>;
  kyb_verified_date?: InputMaybe<DateTimeNullableFilter>;
  location_city?: InputMaybe<StringNullableFilter>;
  location_line_1?: InputMaybe<StringNullableFilter>;
  location_line_2?: InputMaybe<StringNullableFilter>;
  matterport_url?: InputMaybe<StringNullableFilter>;
  max_bookings_per_day?: InputMaybe<IntFilter>;
  max_working_hours?: InputMaybe<IntNullableFilter>;
  min_spend?: InputMaybe<FloatNullableFilter>;
  muta_accredited?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  nps_survey_sent_date?: InputMaybe<DateTimeNullableFilter>;
  overall_message_response_rate?: InputMaybe<FloatNullableFilter>;
  payment_details_id?: InputMaybe<StringNullableFilter>;
  photoshoot_interested?: InputMaybe<BoolNullableFilter>;
  portions_per_hour?: InputMaybe<IntNullableFilter>;
  postcode?: InputMaybe<StringNullableFilter>;
  press_awards?: InputMaybe<StringNullableFilter>;
  price_per_mile?: InputMaybe<IntNullableFilter>;
  primary_tag?: InputMaybe<StringNullableFilter>;
  profile_picture?: InputMaybe<JsonNullableFilter>;
  public_events_count?: InputMaybe<IntNullableFilter>;
  public_events_visible?: InputMaybe<BoolFilter>;
  public_liability_certificate?: InputMaybe<JsonNullableFilter>;
  quote_to_message_rate?: InputMaybe<FloatNullableFilter>;
  radius?: InputMaybe<FloatNullableFilter>;
  registered_city?: InputMaybe<StringNullableFilter>;
  registered_company_name?: InputMaybe<StringNullableFilter>;
  registered_location_line1?: InputMaybe<StringNullableFilter>;
  registered_location_line2?: InputMaybe<StringNullableFilter>;
  registered_name?: InputMaybe<StringNullableFilter>;
  registered_postcode?: InputMaybe<StringNullableFilter>;
  risk_assessment_document?: InputMaybe<JsonNullableFilter>;
  risk_assessment_score?: InputMaybe<StringNullableFilter>;
  robex_boost?: InputMaybe<IntNullableFilter>;
  robex_boosted_until?: InputMaybe<DateTimeNullableFilter>;
  robex_response_rate?: InputMaybe<FloatNullableFilter>;
  setup_details?: InputMaybe<StringNullableFilter>;
  setup_power?: InputMaybe<StringNullableFilter>;
  setup_water?: InputMaybe<BoolNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  social?: InputMaybe<JsonNullableListFilter>;
  source?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<Enumenum_Suppliers_StateNullableFilter>;
  stripe_connect_account?: InputMaybe<StringNullableFilter>;
  supplier_images?: InputMaybe<JsonNullableFilter>;
  tagline?: InputMaybe<StringNullableFilter>;
  trusted?: InputMaybe<BoolFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
  vat_number?: InputMaybe<StringNullableFilter>;
  video_url?: InputMaybe<StringNullableFilter>;
  visible?: InputMaybe<BoolFilter>;
};

export type SuppliersUpdateInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  foodHygieneRatingScore?: InputMaybe<Scalars['Int']['input']>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  isGasUser?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  localAuthorityName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registeredBusinessOwnerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplierPermissions?: InputMaybe<SupplierPermissionsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateManyMutationInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SuppliersUpdateManyWithWhereWithoutCategories_Tier1Input = {
  data: SuppliersUpdateManyMutationInput;
  where: SuppliersScalarWhereInput;
};

export type SuppliersUpdateManyWithWhereWithoutTagsInput = {
  data: SuppliersUpdateManyMutationInput;
  where: SuppliersScalarWhereInput;
};

export type SuppliersUpdateManyWithoutCategories_Tier1Input = {
  connect?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SuppliersCreateOrConnectWithoutcategories_Tier1Input>>;
  create?: InputMaybe<Array<SuppliersCreateWithoutCategories_Tier1Input>>;
  delete?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SuppliersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  set?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  update?: InputMaybe<Array<SuppliersUpdateWithWhereUniqueWithoutCategories_Tier1Input>>;
  updateMany?: InputMaybe<Array<SuppliersUpdateManyWithWhereWithoutCategories_Tier1Input>>;
  upsert?: InputMaybe<Array<SuppliersUpsertWithWhereUniqueWithoutCategories_Tier1Input>>;
};

export type SuppliersUpdateManyWithoutTagsInput = {
  connect?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SuppliersCreateOrConnectWithouttagsInput>>;
  create?: InputMaybe<Array<SuppliersCreateWithoutTagsInput>>;
  delete?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SuppliersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  set?: InputMaybe<Array<SuppliersWhereUniqueInput>>;
  update?: InputMaybe<Array<SuppliersUpdateWithWhereUniqueWithoutTagsInput>>;
  updateMany?: InputMaybe<Array<SuppliersUpdateManyWithWhereWithoutTagsInput>>;
  upsert?: InputMaybe<Array<SuppliersUpsertWithWhereUniqueWithoutTagsInput>>;
};

export type SuppliersUpdateOneRequiredWithoutDeclined_Event_RequestsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutdeclined_Event_RequestsInput>;
  create?: InputMaybe<SuppliersCreateWithoutDeclined_Event_RequestsInput>;
  update?: InputMaybe<SuppliersUpdateWithoutDeclined_Event_RequestsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutDeclined_Event_RequestsInput>;
};

export type SuppliersUpdateOneRequiredWithoutHidden_Event_RequestsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithouthidden_Event_RequestsInput>;
  create?: InputMaybe<SuppliersCreateWithoutHidden_Event_RequestsInput>;
  update?: InputMaybe<SuppliersUpdateWithoutHidden_Event_RequestsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutHidden_Event_RequestsInput>;
};

export type SuppliersUpdateOneRequiredWithoutReviewsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutreviewsInput>;
  create?: InputMaybe<SuppliersCreateWithoutReviewsInput>;
  update?: InputMaybe<SuppliersUpdateWithoutReviewsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutReviewsInput>;
};

export type SuppliersUpdateOneRequiredWithoutSpace_GroupsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutspace_GroupsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSpace_GroupsInput>;
  update?: InputMaybe<SuppliersUpdateWithoutSpace_GroupsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSpace_GroupsInput>;
};

export type SuppliersUpdateOneRequiredWithoutSupplier_CalendarsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_CalendarsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_CalendarsInput>;
  update?: InputMaybe<SuppliersUpdateWithoutSupplier_CalendarsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSupplier_CalendarsInput>;
};

export type SuppliersUpdateOneRequiredWithoutSupplier_Categories_Tier2Input = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_Categories_Tier2Input>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_Categories_Tier2Input>;
  update?: InputMaybe<SuppliersUpdateWithoutSupplier_Categories_Tier2Input>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSupplier_Categories_Tier2Input>;
};

export type SuppliersUpdateOneRequiredWithoutSupplier_Event_RequestsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_Event_RequestsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_Event_RequestsInput>;
  update?: InputMaybe<SuppliersUpdateWithoutSupplier_Event_RequestsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSupplier_Event_RequestsInput>;
};

export type SuppliersUpdateOneRequiredWithoutSupplier_Images_Supplier_ImagesTosuppliersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsupplier_Images_Supplier_ImagesTosuppliersInput>;
  create?: InputMaybe<SuppliersCreateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
  update?: InputMaybe<SuppliersUpdateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSupplier_Images_Supplier_ImagesTosuppliersInput>;
};

export type SuppliersUpdateOneRequiredWithoutSuppliers_GroupsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_GroupsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_GroupsInput>;
  update?: InputMaybe<SuppliersUpdateWithoutSuppliers_GroupsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSuppliers_GroupsInput>;
};

export type SuppliersUpdateOneRequiredWithoutSuppliers_UsersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_UsersInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_UsersInput>;
  update?: InputMaybe<SuppliersUpdateWithoutSuppliers_UsersInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSuppliers_UsersInput>;
};

export type SuppliersUpdateOneRequiredWithoutVenue_ServicesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutvenue_ServicesInput>;
  create?: InputMaybe<SuppliersCreateWithoutVenue_ServicesInput>;
  update?: InputMaybe<SuppliersUpdateWithoutVenue_ServicesInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutVenue_ServicesInput>;
};

export type SuppliersUpdateOneRequiredWithoutVenue_SpacesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutvenue_SpacesInput>;
  create?: InputMaybe<SuppliersCreateWithoutVenue_SpacesInput>;
  update?: InputMaybe<SuppliersUpdateWithoutVenue_SpacesInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutVenue_SpacesInput>;
};

export type SuppliersUpdateOneWithoutBookings_Bookings_Supplier_IdTosuppliersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutbookings_Bookings_Supplier_IdTosuppliersInput>;
  create?: InputMaybe<SuppliersCreateWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutBookings_Bookings_Supplier_IdTosuppliersInput>;
};

export type SuppliersUpdateOneWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutbookings_Bookings_Supplier_ReferralTosuppliersInput>;
  create?: InputMaybe<SuppliersCreateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput>;
};

export type SuppliersUpdateOneWithoutConversationsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutconversationsInput>;
  create?: InputMaybe<SuppliersCreateWithoutConversationsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutConversationsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutConversationsInput>;
};

export type SuppliersUpdateOneWithoutEvent_Request_Supplier_NotifiedInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutevent_Request_Supplier_NotifiedInput>;
  create?: InputMaybe<SuppliersCreateWithoutEvent_Request_Supplier_NotifiedInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutEvent_Request_Supplier_NotifiedInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutEvent_Request_Supplier_NotifiedInput>;
};

export type SuppliersUpdateOneWithoutEventsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<SuppliersCreateWithoutEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutEventsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutEventsInput>;
};

export type SuppliersUpdateOneWithoutQuote_Line_Item_TemplatesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutquote_Line_Item_TemplatesInput>;
  create?: InputMaybe<SuppliersCreateWithoutQuote_Line_Item_TemplatesInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutQuote_Line_Item_TemplatesInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutQuote_Line_Item_TemplatesInput>;
};

export type SuppliersUpdateOneWithoutQuote_TemplatesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutquote_TemplatesInput>;
  create?: InputMaybe<SuppliersCreateWithoutQuote_TemplatesInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutQuote_TemplatesInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutQuote_TemplatesInput>;
};

export type SuppliersUpdateOneWithoutQuotesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutquotesInput>;
  create?: InputMaybe<SuppliersCreateWithoutQuotesInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutQuotesInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutQuotesInput>;
};

export type SuppliersUpdateOneWithoutSuppliers_ItemsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_ItemsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_ItemsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutSuppliers_ItemsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSuppliers_ItemsInput>;
};

export type SuppliersUpdateOneWithoutSuppliers_TagsInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_TagsInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_TagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutSuppliers_TagsInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSuppliers_TagsInput>;
};

export type SuppliersUpdateOneWithoutSuppliers_TypesInput = {
  connect?: InputMaybe<SuppliersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SuppliersCreateOrConnectWithoutsuppliers_TypesInput>;
  create?: InputMaybe<SuppliersCreateWithoutSuppliers_TypesInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<SuppliersUpdateWithoutSuppliers_TypesInput>;
  upsert?: InputMaybe<SuppliersUpsertWithoutSuppliers_TypesInput>;
};

export type SuppliersUpdateWithWhereUniqueWithoutCategories_Tier1Input = {
  data: SuppliersUpdateWithoutCategories_Tier1Input;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersUpdateWithWhereUniqueWithoutTagsInput = {
  data: SuppliersUpdateWithoutTagsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersUpdateWithoutBookings_Bookings_Supplier_IdTosuppliersInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutCategories_Tier1Input = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutConversationsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutDeclined_Event_RequestsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutEvent_Request_Supplier_NotifiedInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutEventsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutHidden_Event_RequestsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutQuote_Line_Item_TemplatesInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutQuote_TemplatesInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutQuotesInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutReviewsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSpace_GroupsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSupplier_CalendarsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSupplier_Categories_Tier2Input = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSupplier_Event_RequestsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSuppliers_GroupsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSuppliers_ItemsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSuppliers_TagsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSuppliers_TypesInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutSuppliers_UsersInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutTagsInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutVenue_ServicesInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_spaces?: InputMaybe<Venue_SpacesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateWithoutVenue_SpacesInput = {
  activated_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  activity_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alcohol_permit?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  algorithm_discoverable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  available_hours_end?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  available_hours_start?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  average_rating?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  base_price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_IdTosuppliersInput>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsUpdateManyWithoutSuppliers_Bookings_Supplier_ReferralTosuppliersInput>;
  categories_tier1?: InputMaybe<Categories_Tier1UpdateOneWithoutSuppliersInput>;
  commission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  company_registration_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateManyWithoutSuppliersInput>;
  coordinates?: InputMaybe<Scalars['Json']['input']>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsUpdateManyWithoutSuppliersInput>;
  deposits_enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employers_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedUpdateManyWithoutSuppliersInput>;
  events?: InputMaybe<EventsUpdateManyWithoutSuppliersInput>;
  external_links?: InputMaybe<Scalars['Json']['input']>;
  favourites?: InputMaybe<FavouritesUpdateManyWithoutSuppliersInput>;
  first_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  food_hygiene_certificate?: InputMaybe<Scalars['Json']['input']>;
  food_safety_agency_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_account_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freshsales_stage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsUpdateManyWithoutSuppliersInput>;
  hygiene_rating?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  images?: InputMaybe<SuppliersUpdateimagesInput>;
  izettle_staff_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFieldUpdateOperationsInput>;
  kyb_verified_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location_line_2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matterport_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  max_bookings_per_day?: InputMaybe<IntFieldUpdateOperationsInput>;
  max_working_hours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  min_spend?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  muta_accredited?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nps_survey_sent_date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  overall_message_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  photoshoot_interested?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  portions_per_hour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  press_awards?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price_per_mile?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profile_picture?: InputMaybe<Scalars['Json']['input']>;
  public_events_count?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  public_events_visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  public_liability_certificate?: InputMaybe<Scalars['Json']['input']>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_templates?: InputMaybe<Quote_TemplatesUpdateManyWithoutSuppliersInput>;
  quote_to_message_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  quotes?: InputMaybe<QuotesUpdateManyWithoutSuppliersInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  recommendations?: InputMaybe<RecommendationsUpdateManyWithoutSuppliersInput>;
  registered_city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_company_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_location_line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registered_postcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<ReviewsUpdateManyWithoutSuppliersInput>;
  risk_assessment_document?: InputMaybe<Scalars['Json']['input']>;
  risk_assessment_score?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_boost?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  robex_boosted_until?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  robex_response_rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup_details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_power?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  setup_water?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social?: InputMaybe<SuppliersUpdatesocialInput>;
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateManyWithoutSuppliersInput>;
  state?: InputMaybe<NullableEnumenum_Suppliers_StateFieldUpdateOperationsInput>;
  stripe_connect_account?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsUpdateManyWithoutSuppliersInput>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2UpdateManyWithoutSuppliersInput>;
  supplier_documents?: InputMaybe<Supplier_DocumentsUpdateManyWithoutSuppliersInput>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsUpdateManyWithoutSuppliersInput>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingUpdateManyWithoutSuppliersInput>;
  supplier_images?: InputMaybe<Scalars['Json']['input']>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesUpdateManyWithoutSuppliersInput>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsUpdateOneWithoutSuppliersInput>;
  supplier_stats?: InputMaybe<Supplier_StatsUpdateOneWithoutSuppliersInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateManyWithoutSuppliersInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateManyWithoutSuppliersInput>;
  suppliers_tags?: InputMaybe<Suppliers_TagsUpdateManyWithoutSuppliersInput>;
  suppliers_types?: InputMaybe<Suppliers_TypesUpdateManyWithoutSuppliersInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutSuppliersInput>;
  tagline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagsUpdateOneWithoutSuppliersInput>;
  trusted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vat_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  venue_services?: InputMaybe<Venue_ServicesUpdateManyWithoutSuppliersInput>;
  video_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput>;
};

export type SuppliersUpdateimagesInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type SuppliersUpdatesocialInput = {
  set?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type SuppliersUpsertWithWhereUniqueWithoutCategories_Tier1Input = {
  create: SuppliersCreateWithoutCategories_Tier1Input;
  update: SuppliersUpdateWithoutCategories_Tier1Input;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersUpsertWithWhereUniqueWithoutTagsInput = {
  create: SuppliersCreateWithoutTagsInput;
  update: SuppliersUpdateWithoutTagsInput;
  where: SuppliersWhereUniqueInput;
};

export type SuppliersUpsertWithoutBookings_Bookings_Supplier_IdTosuppliersInput = {
  create: SuppliersCreateWithoutBookings_Bookings_Supplier_IdTosuppliersInput;
  update: SuppliersUpdateWithoutBookings_Bookings_Supplier_IdTosuppliersInput;
};

export type SuppliersUpsertWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput = {
  create: SuppliersCreateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput;
  update: SuppliersUpdateWithoutBookings_Bookings_Supplier_ReferralTosuppliersInput;
};

export type SuppliersUpsertWithoutConversationsInput = {
  create: SuppliersCreateWithoutConversationsInput;
  update: SuppliersUpdateWithoutConversationsInput;
};

export type SuppliersUpsertWithoutDeclined_Event_RequestsInput = {
  create: SuppliersCreateWithoutDeclined_Event_RequestsInput;
  update: SuppliersUpdateWithoutDeclined_Event_RequestsInput;
};

export type SuppliersUpsertWithoutEvent_Request_Supplier_NotifiedInput = {
  create: SuppliersCreateWithoutEvent_Request_Supplier_NotifiedInput;
  update: SuppliersUpdateWithoutEvent_Request_Supplier_NotifiedInput;
};

export type SuppliersUpsertWithoutEventsInput = {
  create: SuppliersCreateWithoutEventsInput;
  update: SuppliersUpdateWithoutEventsInput;
};

export type SuppliersUpsertWithoutHidden_Event_RequestsInput = {
  create: SuppliersCreateWithoutHidden_Event_RequestsInput;
  update: SuppliersUpdateWithoutHidden_Event_RequestsInput;
};

export type SuppliersUpsertWithoutQuote_Line_Item_TemplatesInput = {
  create: SuppliersCreateWithoutQuote_Line_Item_TemplatesInput;
  update: SuppliersUpdateWithoutQuote_Line_Item_TemplatesInput;
};

export type SuppliersUpsertWithoutQuote_TemplatesInput = {
  create: SuppliersCreateWithoutQuote_TemplatesInput;
  update: SuppliersUpdateWithoutQuote_TemplatesInput;
};

export type SuppliersUpsertWithoutQuotesInput = {
  create: SuppliersCreateWithoutQuotesInput;
  update: SuppliersUpdateWithoutQuotesInput;
};

export type SuppliersUpsertWithoutReviewsInput = {
  create: SuppliersCreateWithoutReviewsInput;
  update: SuppliersUpdateWithoutReviewsInput;
};

export type SuppliersUpsertWithoutSpace_GroupsInput = {
  create: SuppliersCreateWithoutSpace_GroupsInput;
  update: SuppliersUpdateWithoutSpace_GroupsInput;
};

export type SuppliersUpsertWithoutSupplier_CalendarsInput = {
  create: SuppliersCreateWithoutSupplier_CalendarsInput;
  update: SuppliersUpdateWithoutSupplier_CalendarsInput;
};

export type SuppliersUpsertWithoutSupplier_Categories_Tier2Input = {
  create: SuppliersCreateWithoutSupplier_Categories_Tier2Input;
  update: SuppliersUpdateWithoutSupplier_Categories_Tier2Input;
};

export type SuppliersUpsertWithoutSupplier_Event_RequestsInput = {
  create: SuppliersCreateWithoutSupplier_Event_RequestsInput;
  update: SuppliersUpdateWithoutSupplier_Event_RequestsInput;
};

export type SuppliersUpsertWithoutSupplier_Images_Supplier_ImagesTosuppliersInput = {
  create: SuppliersCreateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput;
  update: SuppliersUpdateWithoutSupplier_Images_Supplier_ImagesTosuppliersInput;
};

export type SuppliersUpsertWithoutSuppliers_GroupsInput = {
  create: SuppliersCreateWithoutSuppliers_GroupsInput;
  update: SuppliersUpdateWithoutSuppliers_GroupsInput;
};

export type SuppliersUpsertWithoutSuppliers_ItemsInput = {
  create: SuppliersCreateWithoutSuppliers_ItemsInput;
  update: SuppliersUpdateWithoutSuppliers_ItemsInput;
};

export type SuppliersUpsertWithoutSuppliers_TagsInput = {
  create: SuppliersCreateWithoutSuppliers_TagsInput;
  update: SuppliersUpdateWithoutSuppliers_TagsInput;
};

export type SuppliersUpsertWithoutSuppliers_TypesInput = {
  create: SuppliersCreateWithoutSuppliers_TypesInput;
  update: SuppliersUpdateWithoutSuppliers_TypesInput;
};

export type SuppliersUpsertWithoutSuppliers_UsersInput = {
  create: SuppliersCreateWithoutSuppliers_UsersInput;
  update: SuppliersUpdateWithoutSuppliers_UsersInput;
};

export type SuppliersUpsertWithoutVenue_ServicesInput = {
  create: SuppliersCreateWithoutVenue_ServicesInput;
  update: SuppliersUpdateWithoutVenue_ServicesInput;
};

export type SuppliersUpsertWithoutVenue_SpacesInput = {
  create: SuppliersCreateWithoutVenue_SpacesInput;
  update: SuppliersUpdateWithoutVenue_SpacesInput;
};

export type SuppliersWhereInput = {
  AND?: InputMaybe<Array<SuppliersWhereInput>>;
  NOT?: InputMaybe<Array<SuppliersWhereInput>>;
  OR?: InputMaybe<Array<SuppliersWhereInput>>;
  activated_date?: InputMaybe<DateTimeNullableFilter>;
  activity_state?: InputMaybe<StringNullableFilter>;
  alcohol_permit?: InputMaybe<BoolNullableFilter>;
  algorithm_discoverable?: InputMaybe<BoolFilter>;
  available_hours_end?: InputMaybe<StringNullableFilter>;
  available_hours_start?: InputMaybe<StringNullableFilter>;
  average_rating?: InputMaybe<FloatNullableFilter>;
  base_price?: InputMaybe<FloatNullableFilter>;
  bookings_bookings_supplier_idTosuppliers?: InputMaybe<BookingsListRelationFilter>;
  bookings_bookings_supplier_referralTosuppliers?: InputMaybe<BookingsListRelationFilter>;
  categories_tier1?: InputMaybe<Categories_Tier1WhereInput>;
  category_tier1?: InputMaybe<StringNullableFilter>;
  commission?: InputMaybe<FloatNullableFilter>;
  company_registration_number?: InputMaybe<StringNullableFilter>;
  conversations?: InputMaybe<ConversationsListRelationFilter>;
  coordinates?: InputMaybe<JsonNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  declined_event_requests?: InputMaybe<Declined_Event_RequestsListRelationFilter>;
  deposits_enabled?: InputMaybe<BoolNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employers_liability_certificate?: InputMaybe<JsonNullableFilter>;
  event_request_supplier_notified?: InputMaybe<Event_Request_Supplier_NotifiedListRelationFilter>;
  events?: InputMaybe<EventsListRelationFilter>;
  external_links?: InputMaybe<JsonNullableFilter>;
  favourites?: InputMaybe<FavouritesListRelationFilter>;
  first_message_response_rate?: InputMaybe<FloatNullableFilter>;
  food_hygiene_certificate?: InputMaybe<JsonNullableFilter>;
  food_safety_agency_id?: InputMaybe<StringNullableFilter>;
  freshsales_account_id?: InputMaybe<StringNullableFilter>;
  freshsales_id?: InputMaybe<StringNullableFilter>;
  freshsales_stage?: InputMaybe<StringNullableFilter>;
  hidden_event_requests?: InputMaybe<Hidden_Event_RequestsListRelationFilter>;
  hygiene_rating?: InputMaybe<StringNullableFilter>;
  images?: InputMaybe<JsonNullableListFilter>;
  izettle_staff_name?: InputMaybe<StringNullableFilter>;
  kyb_status?: InputMaybe<Enumenum_Suppliers_Kyb_StatusFilter>;
  kyb_verified_date?: InputMaybe<DateTimeNullableFilter>;
  location_city?: InputMaybe<StringNullableFilter>;
  location_line_1?: InputMaybe<StringNullableFilter>;
  location_line_2?: InputMaybe<StringNullableFilter>;
  matterport_url?: InputMaybe<StringNullableFilter>;
  max_bookings_per_day?: InputMaybe<IntFilter>;
  max_working_hours?: InputMaybe<IntNullableFilter>;
  min_spend?: InputMaybe<FloatNullableFilter>;
  muta_accredited?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  nps_survey_sent_date?: InputMaybe<DateTimeNullableFilter>;
  overall_message_response_rate?: InputMaybe<FloatNullableFilter>;
  payment_details_id?: InputMaybe<StringNullableFilter>;
  photoshoot_interested?: InputMaybe<BoolNullableFilter>;
  portions_per_hour?: InputMaybe<IntNullableFilter>;
  postcode?: InputMaybe<StringNullableFilter>;
  press_awards?: InputMaybe<StringNullableFilter>;
  price_per_mile?: InputMaybe<IntNullableFilter>;
  primary_tag?: InputMaybe<StringNullableFilter>;
  profile_picture?: InputMaybe<JsonNullableFilter>;
  public_events_count?: InputMaybe<IntNullableFilter>;
  public_events_visible?: InputMaybe<BoolFilter>;
  public_liability_certificate?: InputMaybe<JsonNullableFilter>;
  quote_line_item_templates?: InputMaybe<Quote_Line_Item_TemplatesListRelationFilter>;
  quote_templates?: InputMaybe<Quote_TemplatesListRelationFilter>;
  quote_to_message_rate?: InputMaybe<FloatNullableFilter>;
  quotes?: InputMaybe<QuotesListRelationFilter>;
  radius?: InputMaybe<FloatNullableFilter>;
  recommendations?: InputMaybe<RecommendationsListRelationFilter>;
  registered_city?: InputMaybe<StringNullableFilter>;
  registered_company_name?: InputMaybe<StringNullableFilter>;
  registered_location_line1?: InputMaybe<StringNullableFilter>;
  registered_location_line2?: InputMaybe<StringNullableFilter>;
  registered_name?: InputMaybe<StringNullableFilter>;
  registered_postcode?: InputMaybe<StringNullableFilter>;
  reviews?: InputMaybe<ReviewsListRelationFilter>;
  risk_assessment_document?: InputMaybe<JsonNullableFilter>;
  risk_assessment_score?: InputMaybe<StringNullableFilter>;
  robex_boost?: InputMaybe<IntNullableFilter>;
  robex_boosted_until?: InputMaybe<DateTimeNullableFilter>;
  robex_response_rate?: InputMaybe<FloatNullableFilter>;
  setup_details?: InputMaybe<StringNullableFilter>;
  setup_power?: InputMaybe<StringNullableFilter>;
  setup_water?: InputMaybe<BoolNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  social?: InputMaybe<JsonNullableListFilter>;
  source?: InputMaybe<StringNullableFilter>;
  space_groups?: InputMaybe<Space_GroupsListRelationFilter>;
  state?: InputMaybe<Enumenum_Suppliers_StateNullableFilter>;
  stripe_connect_account?: InputMaybe<StringNullableFilter>;
  supplier_calendars?: InputMaybe<Supplier_CalendarsListRelationFilter>;
  supplier_categories_tier2?: InputMaybe<Supplier_Categories_Tier2ListRelationFilter>;
  supplier_documents?: InputMaybe<Supplier_DocumentsListRelationFilter>;
  supplier_event_requests?: InputMaybe<Supplier_Event_RequestsListRelationFilter>;
  supplier_flexible_pricing?: InputMaybe<Supplier_Flexible_PricingListRelationFilter>;
  supplier_images?: InputMaybe<JsonNullableFilter>;
  supplier_images_supplier_imagesTosuppliers?: InputMaybe<Supplier_ImagesListRelationFilter>;
  supplier_payment_details?: InputMaybe<Supplier_Payment_DetailsWhereInput>;
  supplier_stats?: InputMaybe<Supplier_StatsWhereInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsListRelationFilter>;
  suppliers_items?: InputMaybe<Suppliers_ItemsListRelationFilter>;
  suppliers_tags?: InputMaybe<Suppliers_TagsListRelationFilter>;
  suppliers_types?: InputMaybe<Suppliers_TypesListRelationFilter>;
  suppliers_users?: InputMaybe<Suppliers_UsersListRelationFilter>;
  tagline?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<TagsWhereInput>;
  trusted?: InputMaybe<BoolFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
  vat_number?: InputMaybe<StringNullableFilter>;
  venue_services?: InputMaybe<Venue_ServicesListRelationFilter>;
  venue_spaces?: InputMaybe<Venue_SpacesListRelationFilter>;
  video_url?: InputMaybe<StringNullableFilter>;
  visible?: InputMaybe<BoolFilter>;
  workflow_automations_message_templates?: InputMaybe<Workflow_Automations_Message_TemplatesListRelationFilter>;
};

export type SuppliersWhereUniqueInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Suppliers_Groups = {
  __typename?: 'suppliers_groups';
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  suppliers_groups_items: Array<Suppliers_Groups_Items>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};


export type Suppliers_GroupsSuppliers_Groups_ItemsArgs = {
  cursor?: InputMaybe<Suppliers_Groups_ItemsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Suppliers_GroupsCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  old_menu_id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  suppliers: SuppliersCreateOneWithoutSuppliers_GroupsInput;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsCreateManyWithoutSuppliers_GroupsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_GroupsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_GroupsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_GroupsCreateWithoutSuppliersInput>>;
};

export type Suppliers_GroupsCreateOneWithoutSuppliers_Groups_ItemsInput = {
  connect?: InputMaybe<Suppliers_GroupsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Suppliers_GroupsCreateOrConnectWithoutsuppliers_Groups_ItemsInput>;
  create?: InputMaybe<Suppliers_GroupsCreateWithoutSuppliers_Groups_ItemsInput>;
};

export type Suppliers_GroupsCreateOrConnectWithoutsuppliersInput = {
  create: Suppliers_GroupsCreateWithoutSuppliersInput;
  where: Suppliers_GroupsWhereUniqueInput;
};

export type Suppliers_GroupsCreateOrConnectWithoutsuppliers_Groups_ItemsInput = {
  create: Suppliers_GroupsCreateWithoutSuppliers_Groups_ItemsInput;
  where: Suppliers_GroupsWhereUniqueInput;
};

export type Suppliers_GroupsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  old_menu_id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsCreateManyWithoutSuppliers_GroupsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_GroupsCreateWithoutSuppliers_Groups_ItemsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  old_menu_id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  suppliers: SuppliersCreateOneWithoutSuppliers_GroupsInput;
  title?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_GroupsScalarWhereInput = {
  AND?: InputMaybe<Array<Suppliers_GroupsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_GroupsScalarWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_GroupsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  old_menu_id?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_GroupsUpdateInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSuppliers_GroupsInput>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsUpdateManyWithoutSuppliers_GroupsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_GroupsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_GroupsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Suppliers_GroupsUpdateManyMutationInput;
  where: Suppliers_GroupsScalarWhereInput;
};

export type Suppliers_GroupsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_GroupsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_GroupsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_GroupsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Suppliers_GroupsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_GroupsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_GroupsWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_GroupsWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_GroupsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Suppliers_GroupsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Suppliers_GroupsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Suppliers_GroupsUpdateOneRequiredWithoutSuppliers_Groups_ItemsInput = {
  connect?: InputMaybe<Suppliers_GroupsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Suppliers_GroupsCreateOrConnectWithoutsuppliers_Groups_ItemsInput>;
  create?: InputMaybe<Suppliers_GroupsCreateWithoutSuppliers_Groups_ItemsInput>;
  update?: InputMaybe<Suppliers_GroupsUpdateWithoutSuppliers_Groups_ItemsInput>;
  upsert?: InputMaybe<Suppliers_GroupsUpsertWithoutSuppliers_Groups_ItemsInput>;
};

export type Suppliers_GroupsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Suppliers_GroupsUpdateWithoutSuppliersInput;
  where: Suppliers_GroupsWhereUniqueInput;
};

export type Suppliers_GroupsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsUpdateManyWithoutSuppliers_GroupsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_GroupsUpdateWithoutSuppliers_Groups_ItemsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSuppliers_GroupsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_GroupsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Suppliers_GroupsCreateWithoutSuppliersInput;
  update: Suppliers_GroupsUpdateWithoutSuppliersInput;
  where: Suppliers_GroupsWhereUniqueInput;
};

export type Suppliers_GroupsUpsertWithoutSuppliers_Groups_ItemsInput = {
  create: Suppliers_GroupsCreateWithoutSuppliers_Groups_ItemsInput;
  update: Suppliers_GroupsUpdateWithoutSuppliers_Groups_ItemsInput;
};

export type Suppliers_GroupsWhereInput = {
  AND?: InputMaybe<Array<Suppliers_GroupsWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_GroupsWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_GroupsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  old_menu_id?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsListRelationFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_GroupsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Suppliers_Groups_Items = {
  __typename?: 'suppliers_groups_items';
  order?: Maybe<Scalars['Int']['output']>;
  suppliers_items: Suppliers_Items;
  uuid: Scalars['String']['output'];
};

export type Suppliers_Groups_ItemsCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  suppliers_groups: Suppliers_GroupsCreateOneWithoutSuppliers_Groups_ItemsInput;
  suppliers_items: Suppliers_ItemsCreateOneWithoutSuppliers_Groups_ItemsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_Groups_ItemsCreateManyWithoutSuppliers_GroupsInput = {
  connect?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_Groups_ItemsCreateOrConnectWithoutsuppliers_GroupsInput>>;
  create?: InputMaybe<Array<Suppliers_Groups_ItemsCreateWithoutSuppliers_GroupsInput>>;
};

export type Suppliers_Groups_ItemsCreateManyWithoutSuppliers_ItemsInput = {
  connect?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_Groups_ItemsCreateOrConnectWithoutsuppliers_ItemsInput>>;
  create?: InputMaybe<Array<Suppliers_Groups_ItemsCreateWithoutSuppliers_ItemsInput>>;
};

export type Suppliers_Groups_ItemsCreateOrConnectWithoutsuppliers_GroupsInput = {
  create: Suppliers_Groups_ItemsCreateWithoutSuppliers_GroupsInput;
  where: Suppliers_Groups_ItemsWhereUniqueInput;
};

export type Suppliers_Groups_ItemsCreateOrConnectWithoutsuppliers_ItemsInput = {
  create: Suppliers_Groups_ItemsCreateWithoutSuppliers_ItemsInput;
  where: Suppliers_Groups_ItemsWhereUniqueInput;
};

export type Suppliers_Groups_ItemsCreateWithoutSuppliers_GroupsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  suppliers_items: Suppliers_ItemsCreateOneWithoutSuppliers_Groups_ItemsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_Groups_ItemsCreateWithoutSuppliers_ItemsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  suppliers_groups: Suppliers_GroupsCreateOneWithoutSuppliers_Groups_ItemsInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_Groups_ItemsScalarWhereInput = {
  AND?: InputMaybe<Array<Suppliers_Groups_ItemsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_Groups_ItemsScalarWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_Groups_ItemsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  group_id?: InputMaybe<StringFilter>;
  item_id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_Groups_ItemsUpdateInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateOneRequiredWithoutSuppliers_Groups_ItemsInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateOneRequiredWithoutSuppliers_Groups_ItemsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_Groups_ItemsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_Groups_ItemsUpdateManyWithWhereWithoutSuppliers_GroupsInput = {
  data: Suppliers_Groups_ItemsUpdateManyMutationInput;
  where: Suppliers_Groups_ItemsScalarWhereInput;
};

export type Suppliers_Groups_ItemsUpdateManyWithWhereWithoutSuppliers_ItemsInput = {
  data: Suppliers_Groups_ItemsUpdateManyMutationInput;
  where: Suppliers_Groups_ItemsScalarWhereInput;
};

export type Suppliers_Groups_ItemsUpdateManyWithoutSuppliers_GroupsInput = {
  connect?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_Groups_ItemsCreateOrConnectWithoutsuppliers_GroupsInput>>;
  create?: InputMaybe<Array<Suppliers_Groups_ItemsCreateWithoutSuppliers_GroupsInput>>;
  delete?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_Groups_ItemsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_Groups_ItemsUpdateWithWhereUniqueWithoutSuppliers_GroupsInput>>;
  updateMany?: InputMaybe<Array<Suppliers_Groups_ItemsUpdateManyWithWhereWithoutSuppliers_GroupsInput>>;
  upsert?: InputMaybe<Array<Suppliers_Groups_ItemsUpsertWithWhereUniqueWithoutSuppliers_GroupsInput>>;
};

export type Suppliers_Groups_ItemsUpdateManyWithoutSuppliers_ItemsInput = {
  connect?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_Groups_ItemsCreateOrConnectWithoutsuppliers_ItemsInput>>;
  create?: InputMaybe<Array<Suppliers_Groups_ItemsCreateWithoutSuppliers_ItemsInput>>;
  delete?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_Groups_ItemsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_Groups_ItemsWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_Groups_ItemsUpdateWithWhereUniqueWithoutSuppliers_ItemsInput>>;
  updateMany?: InputMaybe<Array<Suppliers_Groups_ItemsUpdateManyWithWhereWithoutSuppliers_ItemsInput>>;
  upsert?: InputMaybe<Array<Suppliers_Groups_ItemsUpsertWithWhereUniqueWithoutSuppliers_ItemsInput>>;
};

export type Suppliers_Groups_ItemsUpdateWithWhereUniqueWithoutSuppliers_GroupsInput = {
  data: Suppliers_Groups_ItemsUpdateWithoutSuppliers_GroupsInput;
  where: Suppliers_Groups_ItemsWhereUniqueInput;
};

export type Suppliers_Groups_ItemsUpdateWithWhereUniqueWithoutSuppliers_ItemsInput = {
  data: Suppliers_Groups_ItemsUpdateWithoutSuppliers_ItemsInput;
  where: Suppliers_Groups_ItemsWhereUniqueInput;
};

export type Suppliers_Groups_ItemsUpdateWithoutSuppliers_GroupsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsUpdateOneRequiredWithoutSuppliers_Groups_ItemsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_Groups_ItemsUpdateWithoutSuppliers_ItemsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsUpdateOneRequiredWithoutSuppliers_Groups_ItemsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_Groups_ItemsUpsertWithWhereUniqueWithoutSuppliers_GroupsInput = {
  create: Suppliers_Groups_ItemsCreateWithoutSuppliers_GroupsInput;
  update: Suppliers_Groups_ItemsUpdateWithoutSuppliers_GroupsInput;
  where: Suppliers_Groups_ItemsWhereUniqueInput;
};

export type Suppliers_Groups_ItemsUpsertWithWhereUniqueWithoutSuppliers_ItemsInput = {
  create: Suppliers_Groups_ItemsCreateWithoutSuppliers_ItemsInput;
  update: Suppliers_Groups_ItemsUpdateWithoutSuppliers_ItemsInput;
  where: Suppliers_Groups_ItemsWhereUniqueInput;
};

export type Suppliers_Groups_ItemsWhereInput = {
  AND?: InputMaybe<Array<Suppliers_Groups_ItemsWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_Groups_ItemsWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_Groups_ItemsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  group_id?: InputMaybe<StringFilter>;
  item_id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  suppliers_groups?: InputMaybe<Suppliers_GroupsWhereInput>;
  suppliers_items?: InputMaybe<Suppliers_ItemsWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_Groups_ItemsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Suppliers_Items = {
  __typename?: 'suppliers_items';
  description?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type Suppliers_ItemsCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_menu_item_id?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutSuppliers_ItemsInput>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsCreateManyWithoutSuppliers_ItemsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_ItemsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_ItemsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_ItemsCreateWithoutSuppliersInput>>;
};

export type Suppliers_ItemsCreateOneWithoutSuppliers_Groups_ItemsInput = {
  connect?: InputMaybe<Suppliers_ItemsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Suppliers_ItemsCreateOrConnectWithoutsuppliers_Groups_ItemsInput>;
  create?: InputMaybe<Suppliers_ItemsCreateWithoutSuppliers_Groups_ItemsInput>;
};

export type Suppliers_ItemsCreateOrConnectWithoutsuppliersInput = {
  create: Suppliers_ItemsCreateWithoutSuppliersInput;
  where: Suppliers_ItemsWhereUniqueInput;
};

export type Suppliers_ItemsCreateOrConnectWithoutsuppliers_Groups_ItemsInput = {
  create: Suppliers_ItemsCreateWithoutSuppliers_Groups_ItemsInput;
  where: Suppliers_ItemsWhereUniqueInput;
};

export type Suppliers_ItemsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_menu_item_id?: InputMaybe<Scalars['String']['input']>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsCreateManyWithoutSuppliers_ItemsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_ItemsCreateWithoutSuppliers_Groups_ItemsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_menu_item_id?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutSuppliers_ItemsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_ItemsScalarWhereInput = {
  AND?: InputMaybe<Array<Suppliers_ItemsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_ItemsScalarWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_ItemsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  old_menu_item_id?: InputMaybe<StringNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_ItemsUpdateInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_item_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutSuppliers_ItemsInput>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsUpdateManyWithoutSuppliers_ItemsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_ItemsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_item_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_ItemsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Suppliers_ItemsUpdateManyMutationInput;
  where: Suppliers_ItemsScalarWhereInput;
};

export type Suppliers_ItemsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_ItemsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_ItemsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_ItemsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Suppliers_ItemsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_ItemsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_ItemsWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_ItemsWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_ItemsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Suppliers_ItemsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Suppliers_ItemsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Suppliers_ItemsUpdateOneRequiredWithoutSuppliers_Groups_ItemsInput = {
  connect?: InputMaybe<Suppliers_ItemsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Suppliers_ItemsCreateOrConnectWithoutsuppliers_Groups_ItemsInput>;
  create?: InputMaybe<Suppliers_ItemsCreateWithoutSuppliers_Groups_ItemsInput>;
  update?: InputMaybe<Suppliers_ItemsUpdateWithoutSuppliers_Groups_ItemsInput>;
  upsert?: InputMaybe<Suppliers_ItemsUpsertWithoutSuppliers_Groups_ItemsInput>;
};

export type Suppliers_ItemsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Suppliers_ItemsUpdateWithoutSuppliersInput;
  where: Suppliers_ItemsWhereUniqueInput;
};

export type Suppliers_ItemsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_item_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsUpdateManyWithoutSuppliers_ItemsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_ItemsUpdateWithoutSuppliers_Groups_ItemsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isMigratedToLineItem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  old_menu_item_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutSuppliers_ItemsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_ItemsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Suppliers_ItemsCreateWithoutSuppliersInput;
  update: Suppliers_ItemsUpdateWithoutSuppliersInput;
  where: Suppliers_ItemsWhereUniqueInput;
};

export type Suppliers_ItemsUpsertWithoutSuppliers_Groups_ItemsInput = {
  create: Suppliers_ItemsCreateWithoutSuppliers_Groups_ItemsInput;
  update: Suppliers_ItemsUpdateWithoutSuppliers_Groups_ItemsInput;
};

export type Suppliers_ItemsWhereInput = {
  AND?: InputMaybe<Array<Suppliers_ItemsWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_ItemsWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_ItemsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  old_menu_item_id?: InputMaybe<StringNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  suppliers_groups_items?: InputMaybe<Suppliers_Groups_ItemsListRelationFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_ItemsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Suppliers_Tags = {
  __typename?: 'suppliers_tags';
  supplier_id?: Maybe<Scalars['String']['output']>;
  tag_uuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type Suppliers_TagsCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TagsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_TagsCreateWithoutSuppliersInput>>;
};

export type Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TagsCreateOrConnectWithouttags_Suppliers_Tags_Tag_IdTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>>;
};

export type Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TagsCreateOrConnectWithouttags_Suppliers_Tags_Tag_UuidTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>>;
};

export type Suppliers_TagsCreateOrConnectWithoutsuppliersInput = {
  create: Suppliers_TagsCreateWithoutSuppliersInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsCreateOrConnectWithouttags_Suppliers_Tags_Tag_IdTotagsInput = {
  create: Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsCreateOrConnectWithouttags_Suppliers_Tags_Tag_UuidTotagsInput = {
  create: Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  tags_suppliers_tags_tag_idTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  tags_suppliers_tags_tag_uuidTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutSuppliers_TagsInput>;
  tags_suppliers_tags_tag_uuidTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutSuppliers_TagsInput>;
  tags_suppliers_tags_tag_idTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_TagsScalarWhereInput = {
  AND?: InputMaybe<Array<Suppliers_TagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_TagsScalarWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_TagsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  tag_id?: InputMaybe<StringNullableFilter>;
  tag_uuid?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_TagsSuppliers_Tags_Unique_KeyCompoundUniqueInput = {
  supplier_id: Scalars['String']['input'];
  tag_uuid: Scalars['String']['input'];
};

export type Suppliers_TagsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TagsUpdateManyWithWhereWithoutSuppliersInput = {
  data: Suppliers_TagsUpdateManyMutationInput;
  where: Suppliers_TagsScalarWhereInput;
};

export type Suppliers_TagsUpdateManyWithWhereWithoutTags_Suppliers_Tags_Tag_IdTotagsInput = {
  data: Suppliers_TagsUpdateManyMutationInput;
  where: Suppliers_TagsScalarWhereInput;
};

export type Suppliers_TagsUpdateManyWithWhereWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput = {
  data: Suppliers_TagsUpdateManyMutationInput;
  where: Suppliers_TagsScalarWhereInput;
};

export type Suppliers_TagsUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TagsCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_TagsCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_TagsUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Suppliers_TagsUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Suppliers_TagsUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TagsCreateOrConnectWithouttags_Suppliers_Tags_Tag_IdTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>>;
  delete?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_TagsUpdateWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>>;
  updateMany?: InputMaybe<Array<Suppliers_TagsUpdateManyWithWhereWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>>;
  upsert?: InputMaybe<Array<Suppliers_TagsUpsertWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>>;
};

export type Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TagsCreateOrConnectWithouttags_Suppliers_Tags_Tag_UuidTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>>;
  delete?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_TagsUpdateWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>>;
  updateMany?: InputMaybe<Array<Suppliers_TagsUpdateManyWithWhereWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>>;
  upsert?: InputMaybe<Array<Suppliers_TagsUpsertWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>>;
};

export type Suppliers_TagsUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Suppliers_TagsUpdateWithoutSuppliersInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsUpdateWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_IdTotagsInput = {
  data: Suppliers_TagsUpdateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsUpdateWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput = {
  data: Suppliers_TagsUpdateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tags_suppliers_tags_tag_idTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  tags_suppliers_tags_tag_uuidTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TagsUpdateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutSuppliers_TagsInput>;
  tags_suppliers_tags_tag_uuidTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TagsUpdateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutSuppliers_TagsInput>;
  tags_suppliers_tags_tag_idTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TagsUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Suppliers_TagsCreateWithoutSuppliersInput;
  update: Suppliers_TagsUpdateWithoutSuppliersInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsUpsertWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_IdTotagsInput = {
  create: Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput;
  update: Suppliers_TagsUpdateWithoutTags_Suppliers_Tags_Tag_IdTotagsInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsUpsertWithWhereUniqueWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput = {
  create: Suppliers_TagsCreateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput;
  update: Suppliers_TagsUpdateWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput;
  where: Suppliers_TagsWhereUniqueInput;
};

export type Suppliers_TagsWhereInput = {
  AND?: InputMaybe<Array<Suppliers_TagsWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_TagsWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_TagsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  tag_id?: InputMaybe<StringNullableFilter>;
  tag_uuid?: InputMaybe<StringNullableFilter>;
  tags_suppliers_tags_tag_idTotags?: InputMaybe<TagsWhereInput>;
  tags_suppliers_tags_tag_uuidTotags?: InputMaybe<TagsWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_TagsWhereUniqueInput = {
  suppliers_tags_unique_key?: InputMaybe<Suppliers_TagsSuppliers_Tags_Unique_KeyCompoundUniqueInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Suppliers_TypesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TypesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_TypesCreateWithoutSuppliersInput>>;
};

export type Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TypesCreateOrConnectWithouttags_Suppliers_Types_Tag_IdTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_IdTotagsInput>>;
};

export type Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TypesCreateOrConnectWithouttags_Suppliers_Types_Tag_UuidTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>>;
};

export type Suppliers_TypesCreateOrConnectWithoutsuppliersInput = {
  create: Suppliers_TypesCreateWithoutSuppliersInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesCreateOrConnectWithouttags_Suppliers_Types_Tag_IdTotagsInput = {
  create: Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_IdTotagsInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesCreateOrConnectWithouttags_Suppliers_Types_Tag_UuidTotagsInput = {
  create: Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  tags_suppliers_types_tag_idTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  tags_suppliers_types_tag_uuidTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_IdTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutSuppliers_TypesInput>;
  tags_suppliers_types_tag_uuidTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers?: InputMaybe<SuppliersCreateOneWithoutSuppliers_TypesInput>;
  tags_suppliers_types_tag_idTotags?: InputMaybe<TagsCreateOneWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_TypesScalarWhereInput = {
  AND?: InputMaybe<Array<Suppliers_TypesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_TypesScalarWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_TypesScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  tag_id?: InputMaybe<StringNullableFilter>;
  tag_uuid?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_TypesUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TypesUpdateManyWithWhereWithoutSuppliersInput = {
  data: Suppliers_TypesUpdateManyMutationInput;
  where: Suppliers_TypesScalarWhereInput;
};

export type Suppliers_TypesUpdateManyWithWhereWithoutTags_Suppliers_Types_Tag_IdTotagsInput = {
  data: Suppliers_TypesUpdateManyMutationInput;
  where: Suppliers_TypesScalarWhereInput;
};

export type Suppliers_TypesUpdateManyWithWhereWithoutTags_Suppliers_Types_Tag_UuidTotagsInput = {
  data: Suppliers_TypesUpdateManyMutationInput;
  where: Suppliers_TypesScalarWhereInput;
};

export type Suppliers_TypesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TypesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_TypesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_TypesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_TypesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Suppliers_TypesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Suppliers_TypesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TypesCreateOrConnectWithouttags_Suppliers_Types_Tag_IdTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_IdTotagsInput>>;
  delete?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_TypesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_TypesUpdateWithWhereUniqueWithoutTags_Suppliers_Types_Tag_IdTotagsInput>>;
  updateMany?: InputMaybe<Array<Suppliers_TypesUpdateManyWithWhereWithoutTags_Suppliers_Types_Tag_IdTotagsInput>>;
  upsert?: InputMaybe<Array<Suppliers_TypesUpsertWithWhereUniqueWithoutTags_Suppliers_Types_Tag_IdTotagsInput>>;
};

export type Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput = {
  connect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_TypesCreateOrConnectWithouttags_Suppliers_Types_Tag_UuidTotagsInput>>;
  create?: InputMaybe<Array<Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>>;
  delete?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_TypesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_TypesWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_TypesUpdateWithWhereUniqueWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>>;
  updateMany?: InputMaybe<Array<Suppliers_TypesUpdateManyWithWhereWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>>;
  upsert?: InputMaybe<Array<Suppliers_TypesUpsertWithWhereUniqueWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>>;
};

export type Suppliers_TypesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Suppliers_TypesUpdateWithoutSuppliersInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesUpdateWithWhereUniqueWithoutTags_Suppliers_Types_Tag_IdTotagsInput = {
  data: Suppliers_TypesUpdateWithoutTags_Suppliers_Types_Tag_IdTotagsInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesUpdateWithWhereUniqueWithoutTags_Suppliers_Types_Tag_UuidTotagsInput = {
  data: Suppliers_TypesUpdateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tags_suppliers_types_tag_idTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  tags_suppliers_types_tag_uuidTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TypesUpdateWithoutTags_Suppliers_Types_Tag_IdTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutSuppliers_TypesInput>;
  tags_suppliers_types_tag_uuidTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TypesUpdateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneWithoutSuppliers_TypesInput>;
  tags_suppliers_types_tag_idTotags?: InputMaybe<TagsUpdateOneWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_TypesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Suppliers_TypesCreateWithoutSuppliersInput;
  update: Suppliers_TypesUpdateWithoutSuppliersInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesUpsertWithWhereUniqueWithoutTags_Suppliers_Types_Tag_IdTotagsInput = {
  create: Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_IdTotagsInput;
  update: Suppliers_TypesUpdateWithoutTags_Suppliers_Types_Tag_IdTotagsInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesUpsertWithWhereUniqueWithoutTags_Suppliers_Types_Tag_UuidTotagsInput = {
  create: Suppliers_TypesCreateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput;
  update: Suppliers_TypesUpdateWithoutTags_Suppliers_Types_Tag_UuidTotagsInput;
  where: Suppliers_TypesWhereUniqueInput;
};

export type Suppliers_TypesWhereInput = {
  AND?: InputMaybe<Array<Suppliers_TypesWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_TypesWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_TypesWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringNullableFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  tag_id?: InputMaybe<StringNullableFilter>;
  tag_uuid?: InputMaybe<StringNullableFilter>;
  tags_suppliers_types_tag_idTotags?: InputMaybe<TagsWhereInput>;
  tags_suppliers_types_tag_uuidTotags?: InputMaybe<TagsWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_TypesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Suppliers_Users = {
  __typename?: 'suppliers_users';
  supplier_id: Scalars['String']['output'];
  suppliers: Suppliers;
  user_id: Scalars['String']['output'];
  users: Users;
  uuid: Scalars['String']['output'];
};

export type Suppliers_UsersCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers: SuppliersCreateOneWithoutSuppliers_UsersInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users: UsersCreateOneWithoutSuppliers_UsersInput;
  uuid: Scalars['String']['input'];
};

export type Suppliers_UsersCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_UsersCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_UsersCreateWithoutSuppliersInput>>;
};

export type Suppliers_UsersCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Suppliers_UsersCreateWithoutUsersInput>>;
};

export type Suppliers_UsersCreateOrConnectWithoutsuppliersInput = {
  create: Suppliers_UsersCreateWithoutSuppliersInput;
  where: Suppliers_UsersWhereUniqueInput;
};

export type Suppliers_UsersCreateOrConnectWithoutusersInput = {
  create: Suppliers_UsersCreateWithoutUsersInput;
  where: Suppliers_UsersWhereUniqueInput;
};

export type Suppliers_UsersCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users: UsersCreateOneWithoutSuppliers_UsersInput;
  uuid: Scalars['String']['input'];
};

export type Suppliers_UsersCreateWithoutUsersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  suppliers: SuppliersCreateOneWithoutSuppliers_UsersInput;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Suppliers_UsersScalarWhereInput = {
  AND?: InputMaybe<Array<Suppliers_UsersScalarWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_UsersScalarWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_UsersScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_UsersUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_UsersUpdateManyWithWhereWithoutSuppliersInput = {
  data: Suppliers_UsersUpdateManyMutationInput;
  where: Suppliers_UsersScalarWhereInput;
};

export type Suppliers_UsersUpdateManyWithWhereWithoutUsersInput = {
  data: Suppliers_UsersUpdateManyMutationInput;
  where: Suppliers_UsersScalarWhereInput;
};

export type Suppliers_UsersUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_UsersCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Suppliers_UsersCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_UsersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_UsersUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Suppliers_UsersUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Suppliers_UsersUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Suppliers_UsersUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Suppliers_UsersCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Suppliers_UsersCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Suppliers_UsersScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  set?: InputMaybe<Array<Suppliers_UsersWhereUniqueInput>>;
  update?: InputMaybe<Array<Suppliers_UsersUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Suppliers_UsersUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Suppliers_UsersUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Suppliers_UsersUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Suppliers_UsersUpdateWithoutSuppliersInput;
  where: Suppliers_UsersWhereUniqueInput;
};

export type Suppliers_UsersUpdateWithWhereUniqueWithoutUsersInput = {
  data: Suppliers_UsersUpdateWithoutUsersInput;
  where: Suppliers_UsersWhereUniqueInput;
};

export type Suppliers_UsersUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutSuppliers_UsersInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_UsersUpdateWithoutUsersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutSuppliers_UsersInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Suppliers_UsersUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Suppliers_UsersCreateWithoutSuppliersInput;
  update: Suppliers_UsersUpdateWithoutSuppliersInput;
  where: Suppliers_UsersWhereUniqueInput;
};

export type Suppliers_UsersUpsertWithWhereUniqueWithoutUsersInput = {
  create: Suppliers_UsersCreateWithoutUsersInput;
  update: Suppliers_UsersUpdateWithoutUsersInput;
  where: Suppliers_UsersWhereUniqueInput;
};

export type Suppliers_UsersWhereInput = {
  AND?: InputMaybe<Array<Suppliers_UsersWhereInput>>;
  NOT?: InputMaybe<Array<Suppliers_UsersWhereInput>>;
  OR?: InputMaybe<Array<Suppliers_UsersWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Suppliers_UsersWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Tags = {
  __typename?: 'tags';
  active: Scalars['Boolean']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  rootTag?: Maybe<RootTag>;
  root_tag_id?: Maybe<Scalars['String']['output']>;
  root_tags?: Maybe<Root_Tags>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type TagsCreateInput = {
  active: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pid?: InputMaybe<Scalars['String']['input']>;
  root_tag_id: Scalars['String']['input'];
};

export type TagsCreateManyWithoutRoot_TagsInput = {
  connect?: InputMaybe<Array<TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TagsCreateOrConnectWithoutroot_TagsInput>>;
  create?: InputMaybe<Array<TagsCreateWithoutRoot_TagsInput>>;
};

export type TagsCreateOneWithoutEvent_Request_Priority_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_Request_Priority_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_Request_Priority_TagsInput>;
};

export type TagsCreateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
};

export type TagsCreateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
};

export type TagsCreateOneWithoutEvent_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_TagsInput>;
};

export type TagsCreateOneWithoutQuote_Template_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutquote_Template_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutQuote_Template_TagsInput>;
};

export type TagsCreateOneWithoutSpace_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutspace_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutSpace_TagsInput>;
};

export type TagsCreateOneWithoutSuppliersInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliersInput>;
};

export type TagsCreateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
};

export type TagsCreateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
};

export type TagsCreateOneWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
};

export type TagsCreateOneWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
};

export type TagsCreateOrConnectWithoutevent_Request_Priority_TagsInput = {
  create: TagsCreateWithoutEvent_Request_Priority_TagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutevent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput = {
  create: TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutevent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput = {
  create: TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutevent_TagsInput = {
  create: TagsCreateWithoutEvent_TagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutquote_Template_TagsInput = {
  create: TagsCreateWithoutQuote_Template_TagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutroot_TagsInput = {
  create: TagsCreateWithoutRoot_TagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutspace_TagsInput = {
  create: TagsCreateWithoutSpace_TagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutsuppliersInput = {
  create: TagsCreateWithoutSuppliersInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutsuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput = {
  create: TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutsuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput = {
  create: TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutsuppliers_Types_Suppliers_Types_Tag_IdTotagsInput = {
  create: TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateOrConnectWithoutsuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput = {
  create: TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsCreateWithoutEvent_Request_Priority_TagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutEvent_TagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutQuote_Template_TagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutRoot_TagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutSpace_TagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutSuppliersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsCreateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsCreateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsCreateManyWithoutTagsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsCreateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsCreateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersCreateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsCreateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesCreateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TagsOrderByInput = {
  created?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pid?: InputMaybe<SortOrder>;
  root_tag_id?: InputMaybe<SortOrder>;
  updated?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type TagsScalarWhereInput = {
  AND?: InputMaybe<Array<TagsScalarWhereInput>>;
  NOT?: InputMaybe<Array<TagsScalarWhereInput>>;
  OR?: InputMaybe<Array<TagsScalarWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  pid?: InputMaybe<StringNullableFilter>;
  root_tag_id?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringNullableFilter>;
};

export type TagsUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TagsUpdateManyMutationInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateManyWithWhereWithoutRoot_TagsInput = {
  data: TagsUpdateManyMutationInput;
  where: TagsScalarWhereInput;
};

export type TagsUpdateManyWithoutRoot_TagsInput = {
  connect?: InputMaybe<Array<TagsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TagsCreateOrConnectWithoutroot_TagsInput>>;
  create?: InputMaybe<Array<TagsCreateWithoutRoot_TagsInput>>;
  delete?: InputMaybe<Array<TagsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TagsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TagsWhereUniqueInput>>;
  set?: InputMaybe<Array<TagsWhereUniqueInput>>;
  update?: InputMaybe<Array<TagsUpdateWithWhereUniqueWithoutRoot_TagsInput>>;
  updateMany?: InputMaybe<Array<TagsUpdateManyWithWhereWithoutRoot_TagsInput>>;
  upsert?: InputMaybe<Array<TagsUpsertWithWhereUniqueWithoutRoot_TagsInput>>;
};

export type TagsUpdateOneRequiredWithoutEvent_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_TagsInput>;
  update?: InputMaybe<TagsUpdateWithoutEvent_TagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutEvent_TagsInput>;
};

export type TagsUpdateOneRequiredWithoutQuote_Template_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutquote_Template_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutQuote_Template_TagsInput>;
  update?: InputMaybe<TagsUpdateWithoutQuote_Template_TagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutQuote_Template_TagsInput>;
};

export type TagsUpdateOneRequiredWithoutSpace_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutspace_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutSpace_TagsInput>;
  update?: InputMaybe<TagsUpdateWithoutSpace_TagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutSpace_TagsInput>;
};

export type TagsUpdateOneWithoutEvent_Request_Priority_TagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_Request_Priority_TagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_Request_Priority_TagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutEvent_Request_Priority_TagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutEvent_Request_Priority_TagsInput>;
};

export type TagsUpdateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput>;
};

export type TagsUpdateOneWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutevent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput>;
};

export type TagsUpdateOneWithoutSuppliersInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliersInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutSuppliersInput>;
  upsert?: InputMaybe<TagsUpsertWithoutSuppliersInput>;
};

export type TagsUpdateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput>;
};

export type TagsUpdateOneWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput>;
};

export type TagsUpdateOneWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput>;
};

export type TagsUpdateOneWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput = {
  connect?: InputMaybe<TagsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TagsCreateOrConnectWithoutsuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  create?: InputMaybe<TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<TagsUpdateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
  upsert?: InputMaybe<TagsUpsertWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput>;
};

export type TagsUpdateWithWhereUniqueWithoutRoot_TagsInput = {
  data: TagsUpdateWithoutRoot_TagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsUpdateWithoutEvent_Request_Priority_TagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutEvent_TagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutQuote_Template_TagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutRoot_TagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutSpace_TagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutSuppliersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_UuidTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpdateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsUpdateManyWithoutTagsInput>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_IdTotagsInput>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsUpdateManyWithoutTags_Event_Request_Tags_Tag_UuidTotagsInput>;
  event_tags?: InputMaybe<Event_TagsUpdateManyWithoutTagsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsUpdateManyWithoutTagsInput>;
  root_tags?: InputMaybe<Root_TagsUpdateOneWithoutTagsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutTagsInput>;
  suppliers?: InputMaybe<SuppliersUpdateManyWithoutTagsInput>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_IdTotagsInput>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsUpdateManyWithoutTags_Suppliers_Tags_Tag_UuidTotagsInput>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesUpdateManyWithoutTags_Suppliers_Types_Tag_IdTotagsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TagsUpsertWithWhereUniqueWithoutRoot_TagsInput = {
  create: TagsCreateWithoutRoot_TagsInput;
  update: TagsUpdateWithoutRoot_TagsInput;
  where: TagsWhereUniqueInput;
};

export type TagsUpsertWithoutEvent_Request_Priority_TagsInput = {
  create: TagsCreateWithoutEvent_Request_Priority_TagsInput;
  update: TagsUpdateWithoutEvent_Request_Priority_TagsInput;
};

export type TagsUpsertWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput = {
  create: TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput;
  update: TagsUpdateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_IdTotagsInput;
};

export type TagsUpsertWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput = {
  create: TagsCreateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput;
  update: TagsUpdateWithoutEvent_Request_Tags_Event_Request_Tags_Tag_UuidTotagsInput;
};

export type TagsUpsertWithoutEvent_TagsInput = {
  create: TagsCreateWithoutEvent_TagsInput;
  update: TagsUpdateWithoutEvent_TagsInput;
};

export type TagsUpsertWithoutQuote_Template_TagsInput = {
  create: TagsCreateWithoutQuote_Template_TagsInput;
  update: TagsUpdateWithoutQuote_Template_TagsInput;
};

export type TagsUpsertWithoutSpace_TagsInput = {
  create: TagsCreateWithoutSpace_TagsInput;
  update: TagsUpdateWithoutSpace_TagsInput;
};

export type TagsUpsertWithoutSuppliersInput = {
  create: TagsCreateWithoutSuppliersInput;
  update: TagsUpdateWithoutSuppliersInput;
};

export type TagsUpsertWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput = {
  create: TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput;
  update: TagsUpdateWithoutSuppliers_Tags_Suppliers_Tags_Tag_IdTotagsInput;
};

export type TagsUpsertWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput = {
  create: TagsCreateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput;
  update: TagsUpdateWithoutSuppliers_Tags_Suppliers_Tags_Tag_UuidTotagsInput;
};

export type TagsUpsertWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput = {
  create: TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput;
  update: TagsUpdateWithoutSuppliers_Types_Suppliers_Types_Tag_IdTotagsInput;
};

export type TagsUpsertWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput = {
  create: TagsCreateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput;
  update: TagsUpdateWithoutSuppliers_Types_Suppliers_Types_Tag_UuidTotagsInput;
};

export type TagsWhereInput = {
  AND?: InputMaybe<Array<TagsWhereInput>>;
  NOT?: InputMaybe<Array<TagsWhereInput>>;
  OR?: InputMaybe<Array<TagsWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  event_request_priority_tags?: InputMaybe<Event_Request_Priority_TagsListRelationFilter>;
  event_request_tags_event_request_tags_tag_idTotags?: InputMaybe<Event_Request_TagsListRelationFilter>;
  event_request_tags_event_request_tags_tag_uuidTotags?: InputMaybe<Event_Request_TagsListRelationFilter>;
  event_tags?: InputMaybe<Event_TagsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  pid?: InputMaybe<StringNullableFilter>;
  quote_template_tags?: InputMaybe<Quote_Template_TagsListRelationFilter>;
  root_tag_id?: InputMaybe<StringNullableFilter>;
  root_tags?: InputMaybe<Root_TagsWhereInput>;
  space_tags?: InputMaybe<Space_TagsListRelationFilter>;
  suppliers?: InputMaybe<SuppliersListRelationFilter>;
  suppliers_tags_suppliers_tags_tag_idTotags?: InputMaybe<Suppliers_TagsListRelationFilter>;
  suppliers_tags_suppliers_tags_tag_uuidTotags?: InputMaybe<Suppliers_TagsListRelationFilter>;
  suppliers_types_suppliers_types_tag_idTotags?: InputMaybe<Suppliers_TypesListRelationFilter>;
  suppliers_types_suppliers_types_tag_uuidTotags?: InputMaybe<Suppliers_TypesListRelationFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringNullableFilter>;
};

export type TagsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Test_TreatmentsCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Test_TreatmentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Test_TreatmentsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Test_TreatmentsCreateWithoutUsersInput>>;
};

export type Test_TreatmentsCreateOrConnectWithoutusersInput = {
  create: Test_TreatmentsCreateWithoutUsersInput;
  where: Test_TreatmentsWhereUniqueInput;
};

export type Test_TreatmentsCreateWithoutUsersInput = {
  anonymous_id?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  splitio_test_name: Scalars['String']['input'];
  splitio_treatment_name: Scalars['String']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type Test_TreatmentsScalarWhereInput = {
  AND?: InputMaybe<Array<Test_TreatmentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Test_TreatmentsScalarWhereInput>>;
  OR?: InputMaybe<Array<Test_TreatmentsScalarWhereInput>>;
  anonymous_id?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  splitio_test_name?: InputMaybe<StringFilter>;
  splitio_treatment_name?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Test_TreatmentsUpdateManyMutationInput = {
  anonymous_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  splitio_test_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  splitio_treatment_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Test_TreatmentsUpdateManyWithWhereWithoutUsersInput = {
  data: Test_TreatmentsUpdateManyMutationInput;
  where: Test_TreatmentsScalarWhereInput;
};

export type Test_TreatmentsUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Test_TreatmentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Test_TreatmentsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Test_TreatmentsCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Test_TreatmentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Test_TreatmentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Test_TreatmentsWhereUniqueInput>>;
  set?: InputMaybe<Array<Test_TreatmentsWhereUniqueInput>>;
  update?: InputMaybe<Array<Test_TreatmentsUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Test_TreatmentsUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Test_TreatmentsUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Test_TreatmentsUpdateWithWhereUniqueWithoutUsersInput = {
  data: Test_TreatmentsUpdateWithoutUsersInput;
  where: Test_TreatmentsWhereUniqueInput;
};

export type Test_TreatmentsUpdateWithoutUsersInput = {
  anonymous_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  splitio_test_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  splitio_treatment_name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Test_TreatmentsUpsertWithWhereUniqueWithoutUsersInput = {
  create: Test_TreatmentsCreateWithoutUsersInput;
  update: Test_TreatmentsUpdateWithoutUsersInput;
  where: Test_TreatmentsWhereUniqueInput;
};

export type Test_TreatmentsWhereInput = {
  AND?: InputMaybe<Array<Test_TreatmentsWhereInput>>;
  NOT?: InputMaybe<Array<Test_TreatmentsWhereInput>>;
  OR?: InputMaybe<Array<Test_TreatmentsWhereInput>>;
  anonymous_id?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  splitio_test_name?: InputMaybe<StringFilter>;
  splitio_treatment_name?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringNullableFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Test_TreatmentsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Total_Count = {
  __typename?: 'total_count';
  count?: Maybe<Scalars['Int']['output']>;
};

export type Treatment = {
  __typename?: 'treatment';
  name?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Scalars['String']['output']>;
};

export type Update_Profile_Photo = {
  __typename?: 'update_profile_photo';
  image?: Maybe<File_Data>;
  percentageComplete?: Maybe<Scalars['Int']['output']>;
};

export type Update_Supplier_Images = {
  __typename?: 'update_supplier_images';
  images?: Maybe<Array<Maybe<File_Data>>>;
  percentageComplete?: Maybe<Scalars['Int']['output']>;
};

export type Update_Tags = {
  __typename?: 'update_tags';
  percentageComplete?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Update_Tier_Two = {
  __typename?: 'update_tier_two';
  percentageComplete?: Maybe<Scalars['Int']['output']>;
  tierTwoCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadPublicEventImageType = {
  __typename?: 'uploadPublicEventImageType';
  image?: Maybe<File_Data>;
  percentageComplete?: Maybe<Scalars['Int']['output']>;
};

export type User_External_IdsCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<User_External_IdsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<User_External_IdsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<User_External_IdsCreateWithoutUsersInput>>;
};

export type User_External_IdsCreateOrConnectWithoutusersInput = {
  create: User_External_IdsCreateWithoutUsersInput;
  where: User_External_IdsWhereUniqueInput;
};

export type User_External_IdsCreateWithoutUsersInput = {
  created: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  provider: Enum_User_External_Ids_Provider;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  updated: Scalars['DateTime']['input'];
  user_external_id: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type User_External_IdsScalarWhereInput = {
  AND?: InputMaybe<Array<User_External_IdsScalarWhereInput>>;
  NOT?: InputMaybe<Array<User_External_IdsScalarWhereInput>>;
  OR?: InputMaybe<Array<User_External_IdsScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  provider?: InputMaybe<Enumenum_User_External_Ids_ProviderFilter>;
  refresh_token?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_external_id?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type User_External_IdsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<Enumenum_User_External_Ids_ProviderFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user_external_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type User_External_IdsUpdateManyWithWhereWithoutUsersInput = {
  data: User_External_IdsUpdateManyMutationInput;
  where: User_External_IdsScalarWhereInput;
};

export type User_External_IdsUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<User_External_IdsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<User_External_IdsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<User_External_IdsCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<User_External_IdsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<User_External_IdsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<User_External_IdsWhereUniqueInput>>;
  set?: InputMaybe<Array<User_External_IdsWhereUniqueInput>>;
  update?: InputMaybe<Array<User_External_IdsUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<User_External_IdsUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<User_External_IdsUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type User_External_IdsUpdateWithWhereUniqueWithoutUsersInput = {
  data: User_External_IdsUpdateWithoutUsersInput;
  where: User_External_IdsWhereUniqueInput;
};

export type User_External_IdsUpdateWithoutUsersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<Enumenum_User_External_Ids_ProviderFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user_external_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type User_External_IdsUpsertWithWhereUniqueWithoutUsersInput = {
  create: User_External_IdsCreateWithoutUsersInput;
  update: User_External_IdsUpdateWithoutUsersInput;
  where: User_External_IdsWhereUniqueInput;
};

export type User_External_IdsWhereInput = {
  AND?: InputMaybe<Array<User_External_IdsWhereInput>>;
  NOT?: InputMaybe<Array<User_External_IdsWhereInput>>;
  OR?: InputMaybe<Array<User_External_IdsWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  provider?: InputMaybe<Enumenum_User_External_Ids_ProviderFilter>;
  refresh_token?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_external_id?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type User_External_IdsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type User_Preferences = {
  __typename?: 'user_preferences';
  created?: Maybe<Scalars['DateTime']['output']>;
  customer_message_from_supplier_email_frequency?: Maybe<Scalars['String']['output']>;
  customer_message_from_supplier_sms_frequency?: Maybe<Scalars['String']['output']>;
  customer_quote_notification_email_frequency?: Maybe<Scalars['String']['output']>;
  customer_quote_notification_sms_frequency?: Maybe<Scalars['String']['output']>;
  email_alerts_toggle?: Maybe<Scalars['Boolean']['output']>;
  showCustomerPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  sms_alerts_toggle?: Maybe<Scalars['Boolean']['output']>;
  supplier_message_from_customer_email_frequency?: Maybe<Scalars['String']['output']>;
  supplier_message_from_customer_sms_frequency?: Maybe<Scalars['String']['output']>;
  supplier_robex_notification_email_frequency?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type User_PreferencesCreateOneWithoutUsersInput = {
  connect?: InputMaybe<User_PreferencesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<User_PreferencesCreateOrConnectWithoutusersInput>;
  create?: InputMaybe<User_PreferencesCreateWithoutUsersInput>;
};

export type User_PreferencesCreateOrConnectWithoutusersInput = {
  create: User_PreferencesCreateWithoutUsersInput;
  where: User_PreferencesWhereUniqueInput;
};

export type User_PreferencesCreateWithoutUsersInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customer_message_from_supplier_email_frequency?: InputMaybe<Scalars['String']['input']>;
  customer_message_from_supplier_sms_frequency?: InputMaybe<Scalars['String']['input']>;
  customer_quote_notification_email_frequency?: InputMaybe<Scalars['String']['input']>;
  customer_quote_notification_sms_frequency?: InputMaybe<Scalars['String']['input']>;
  email_alerts_toggle?: InputMaybe<Scalars['Boolean']['input']>;
  showCustomerPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  sms_alerts_toggle?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_message_from_customer_email_frequency?: InputMaybe<Scalars['String']['input']>;
  supplier_message_from_customer_sms_frequency?: InputMaybe<Scalars['String']['input']>;
  supplier_robex_notification_email_frequency?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type User_PreferencesUpdateInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customer_message_from_supplier_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customer_message_from_supplier_sms_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customer_quote_notification_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customer_quote_notification_sms_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email_alerts_toggle?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  showCustomerPhoneNumber?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sms_alerts_toggle?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  supplier_message_from_customer_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_message_from_customer_sms_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_robex_notification_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users?: InputMaybe<UsersUpdateOneRequiredWithoutUser_PreferencesInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type User_PreferencesUpdateOneWithoutUsersInput = {
  connect?: InputMaybe<User_PreferencesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<User_PreferencesCreateOrConnectWithoutusersInput>;
  create?: InputMaybe<User_PreferencesCreateWithoutUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<User_PreferencesUpdateWithoutUsersInput>;
  upsert?: InputMaybe<User_PreferencesUpsertWithoutUsersInput>;
};

export type User_PreferencesUpdateWithoutUsersInput = {
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customer_message_from_supplier_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customer_message_from_supplier_sms_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customer_quote_notification_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customer_quote_notification_sms_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email_alerts_toggle?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  showCustomerPhoneNumber?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sms_alerts_toggle?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  supplier_message_from_customer_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_message_from_customer_sms_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplier_robex_notification_email_frequency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type User_PreferencesUpsertWithoutUsersInput = {
  create: User_PreferencesCreateWithoutUsersInput;
  update: User_PreferencesUpdateWithoutUsersInput;
};

export type User_PreferencesWhereInput = {
  AND?: InputMaybe<Array<User_PreferencesWhereInput>>;
  NOT?: InputMaybe<Array<User_PreferencesWhereInput>>;
  OR?: InputMaybe<Array<User_PreferencesWhereInput>>;
  created?: InputMaybe<DateTimeNullableFilter>;
  customer_message_from_supplier_email_frequency?: InputMaybe<StringNullableFilter>;
  customer_message_from_supplier_sms_frequency?: InputMaybe<StringNullableFilter>;
  customer_quote_notification_email_frequency?: InputMaybe<StringNullableFilter>;
  customer_quote_notification_sms_frequency?: InputMaybe<StringNullableFilter>;
  email_alerts_toggle?: InputMaybe<BoolNullableFilter>;
  sms_alerts_toggle?: InputMaybe<BoolNullableFilter>;
  supplier_message_from_customer_email_frequency?: InputMaybe<StringNullableFilter>;
  supplier_message_from_customer_sms_frequency?: InputMaybe<StringNullableFilter>;
  supplier_robex_notification_email_frequency?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type User_PreferencesWhereUniqueInput = {
  user_id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Users = {
  __typename?: 'users';
  accountClosedAt?: Maybe<Scalars['DateTime']['output']>;
  business_user?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  ethnic_origin?: Maybe<Scalars['String']['output']>;
  events: Array<Events>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  heardAboutUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isLgbtq?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  loginAccountTypes: Array<LoginAccountType>;
  phone?: Maybe<Scalars['String']['output']>;
  reset_token?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  smsNotifications?: Maybe<Scalars['Boolean']['output']>;
  suppliers_users: Array<Suppliers_Users>;
  tandc?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Enum_Users_Type>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  userOrganisations: Array<OrganisationUser>;
  user_preferences?: Maybe<User_Preferences>;
};


export type UsersEventsArgs = {
  cursor?: InputMaybe<EventsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersCreateOneWithoutBookingsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutbookingsInput>;
  create?: InputMaybe<UsersCreateWithoutBookingsInput>;
};

export type UsersCreateOneWithoutConversations_MessagesInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutconversations_MessagesInput>;
  create?: InputMaybe<UsersCreateWithoutConversations_MessagesInput>;
};

export type UsersCreateOneWithoutConversations_Read_ReceiptsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutconversations_Read_ReceiptsInput>;
  create?: InputMaybe<UsersCreateWithoutConversations_Read_ReceiptsInput>;
};

export type UsersCreateOneWithoutConversations_UsersInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutconversations_UsersInput>;
  create?: InputMaybe<UsersCreateWithoutConversations_UsersInput>;
};

export type UsersCreateOneWithoutEventsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<UsersCreateWithoutEventsInput>;
};

export type UsersCreateOneWithoutEvents_Events_Customer_ReferralTousersInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutevents_Events_Customer_ReferralTousersInput>;
  create?: InputMaybe<UsersCreateWithoutEvents_Events_Customer_ReferralTousersInput>;
};

export type UsersCreateOneWithoutRobex_NotificationsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutrobex_NotificationsInput>;
  create?: InputMaybe<UsersCreateWithoutRobex_NotificationsInput>;
};

export type UsersCreateOneWithoutSuppliers_UsersInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutsuppliers_UsersInput>;
  create?: InputMaybe<UsersCreateWithoutSuppliers_UsersInput>;
};

export type UsersCreateOneWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutvoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
  create?: InputMaybe<UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
};

export type UsersCreateOneWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutvoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
  create?: InputMaybe<UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
};

export type UsersCreateOrConnectWithoutbookingsInput = {
  create: UsersCreateWithoutBookingsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutconversations_MessagesInput = {
  create: UsersCreateWithoutConversations_MessagesInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutconversations_Read_ReceiptsInput = {
  create: UsersCreateWithoutConversations_Read_ReceiptsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutconversations_UsersInput = {
  create: UsersCreateWithoutConversations_UsersInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithouteventsInput = {
  create: UsersCreateWithoutEventsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutevents_Events_Customer_ReferralTousersInput = {
  create: UsersCreateWithoutEvents_Events_Customer_ReferralTousersInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutrobex_NotificationsInput = {
  create: UsersCreateWithoutRobex_NotificationsInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutsuppliers_UsersInput = {
  create: UsersCreateWithoutSuppliers_UsersInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutuser_PreferencesInput = {
  create: UsersCreateWithoutUser_PreferencesInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutvoice_Calls_UsersTovoice_Calls_Caller_IdInput = {
  create: UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateOrConnectWithoutvoice_Calls_UsersTovoice_Calls_Recipient_IdInput = {
  create: UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput;
  where: UsersWhereUniqueInput;
};

export type UsersCreateWithoutBookingsInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutConversations_MessagesInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutConversations_Read_ReceiptsInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutConversations_UsersInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutEventsInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutEvents_Events_Customer_ReferralTousersInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutRobex_NotificationsInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutSuppliers_UsersInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutUser_PreferencesInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput = {
  agency_users?: InputMaybe<Agency_UsersCreateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersCreateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsCreateManyWithoutUsersInput>;
  business_user?: InputMaybe<Scalars['Boolean']['input']>;
  conversations_messages?: InputMaybe<Conversations_MessagesCreateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsCreateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersCreateManyWithoutUsersInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ethnic_origin?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventsCreateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsCreateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hashedPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isLgbtq?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  reset_token?: InputMaybe<Scalars['String']['input']>;
  robex_notifications?: InputMaybe<Robex_NotificationsCreateManyWithoutUsersInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers_users?: InputMaybe<Suppliers_UsersCreateManyWithoutUsersInput>;
  tandc?: InputMaybe<Scalars['Boolean']['input']>;
  test_treatments?: InputMaybe<Test_TreatmentsCreateManyWithoutUsersInput>;
  type?: InputMaybe<Enum_Users_Type>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  user_external_ids?: InputMaybe<User_External_IdsCreateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesCreateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsCreateManyWithoutUsersInput>;
};

export type UsersUpdateInput = {
  accountClosedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  heardAboutUs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateOneRequiredWithoutConversations_MessagesInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutconversations_MessagesInput>;
  create?: InputMaybe<UsersCreateWithoutConversations_MessagesInput>;
  update?: InputMaybe<UsersUpdateWithoutConversations_MessagesInput>;
  upsert?: InputMaybe<UsersUpsertWithoutConversations_MessagesInput>;
};

export type UsersUpdateOneRequiredWithoutConversations_Read_ReceiptsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutconversations_Read_ReceiptsInput>;
  create?: InputMaybe<UsersCreateWithoutConversations_Read_ReceiptsInput>;
  update?: InputMaybe<UsersUpdateWithoutConversations_Read_ReceiptsInput>;
  upsert?: InputMaybe<UsersUpsertWithoutConversations_Read_ReceiptsInput>;
};

export type UsersUpdateOneRequiredWithoutConversations_UsersInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutconversations_UsersInput>;
  create?: InputMaybe<UsersCreateWithoutConversations_UsersInput>;
  update?: InputMaybe<UsersUpdateWithoutConversations_UsersInput>;
  upsert?: InputMaybe<UsersUpsertWithoutConversations_UsersInput>;
};

export type UsersUpdateOneRequiredWithoutEventsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithouteventsInput>;
  create?: InputMaybe<UsersCreateWithoutEventsInput>;
  update?: InputMaybe<UsersUpdateWithoutEventsInput>;
  upsert?: InputMaybe<UsersUpsertWithoutEventsInput>;
};

export type UsersUpdateOneRequiredWithoutRobex_NotificationsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutrobex_NotificationsInput>;
  create?: InputMaybe<UsersCreateWithoutRobex_NotificationsInput>;
  update?: InputMaybe<UsersUpdateWithoutRobex_NotificationsInput>;
  upsert?: InputMaybe<UsersUpsertWithoutRobex_NotificationsInput>;
};

export type UsersUpdateOneRequiredWithoutSuppliers_UsersInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutsuppliers_UsersInput>;
  create?: InputMaybe<UsersCreateWithoutSuppliers_UsersInput>;
  update?: InputMaybe<UsersUpdateWithoutSuppliers_UsersInput>;
  upsert?: InputMaybe<UsersUpsertWithoutSuppliers_UsersInput>;
};

export type UsersUpdateOneRequiredWithoutUser_PreferencesInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutuser_PreferencesInput>;
  create?: InputMaybe<UsersCreateWithoutUser_PreferencesInput>;
  update?: InputMaybe<UsersUpdateWithoutUser_PreferencesInput>;
  upsert?: InputMaybe<UsersUpsertWithoutUser_PreferencesInput>;
};

export type UsersUpdateOneRequiredWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutvoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
  create?: InputMaybe<UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
  update?: InputMaybe<UsersUpdateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
  upsert?: InputMaybe<UsersUpsertWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
};

export type UsersUpdateOneRequiredWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutvoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
  create?: InputMaybe<UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
  update?: InputMaybe<UsersUpdateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
  upsert?: InputMaybe<UsersUpsertWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
};

export type UsersUpdateOneWithoutBookingsInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutbookingsInput>;
  create?: InputMaybe<UsersCreateWithoutBookingsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<UsersUpdateWithoutBookingsInput>;
  upsert?: InputMaybe<UsersUpsertWithoutBookingsInput>;
};

export type UsersUpdateOneWithoutEvents_Events_Customer_ReferralTousersInput = {
  connect?: InputMaybe<UsersWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsersCreateOrConnectWithoutevents_Events_Customer_ReferralTousersInput>;
  create?: InputMaybe<UsersCreateWithoutEvents_Events_Customer_ReferralTousersInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<UsersUpdateWithoutEvents_Events_Customer_ReferralTousersInput>;
  upsert?: InputMaybe<UsersUpsertWithoutEvents_Events_Customer_ReferralTousersInput>;
};

export type UsersUpdateWithoutBookingsInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutConversations_MessagesInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutConversations_Read_ReceiptsInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutConversations_UsersInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutEventsInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutEvents_Events_Customer_ReferralTousersInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutRobex_NotificationsInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutSuppliers_UsersInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutUser_PreferencesInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpdateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput = {
  agency_users?: InputMaybe<Agency_UsersUpdateManyWithoutUsersInput>;
  anonymous_users?: InputMaybe<Anonymous_UsersUpdateManyWithoutUsersInput>;
  bookings?: InputMaybe<BookingsUpdateManyWithoutUsersInput>;
  business_user?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  conversations_messages?: InputMaybe<Conversations_MessagesUpdateManyWithoutUsersInput>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsUpdateManyWithoutUsersInput>;
  conversations_users?: InputMaybe<Conversations_UsersUpdateManyWithoutUsersInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  ethnic_origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  events?: InputMaybe<EventsUpdateManyWithoutUsersInput>;
  events_events_customer_referralTousers?: InputMaybe<EventsUpdateManyWithoutUsers_Events_Customer_ReferralTousersInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hashedPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLgbtq?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reset_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  robex_notifications?: InputMaybe<Robex_NotificationsUpdateManyWithoutUsersInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  salt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  segment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsNotifications?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  suppliers_users?: InputMaybe<Suppliers_UsersUpdateManyWithoutUsersInput>;
  tandc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  test_treatments?: InputMaybe<Test_TreatmentsUpdateManyWithoutUsersInput>;
  type?: InputMaybe<NullableEnumenum_Users_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user_external_ids?: InputMaybe<User_External_IdsUpdateManyWithoutUsersInput>;
  user_preferences?: InputMaybe<User_PreferencesUpdateOneWithoutUsersInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput>;
  xero_contacts?: InputMaybe<Xero_ContactsUpdateManyWithoutUsersInput>;
};

export type UsersUpsertWithoutBookingsInput = {
  create: UsersCreateWithoutBookingsInput;
  update: UsersUpdateWithoutBookingsInput;
};

export type UsersUpsertWithoutConversations_MessagesInput = {
  create: UsersCreateWithoutConversations_MessagesInput;
  update: UsersUpdateWithoutConversations_MessagesInput;
};

export type UsersUpsertWithoutConversations_Read_ReceiptsInput = {
  create: UsersCreateWithoutConversations_Read_ReceiptsInput;
  update: UsersUpdateWithoutConversations_Read_ReceiptsInput;
};

export type UsersUpsertWithoutConversations_UsersInput = {
  create: UsersCreateWithoutConversations_UsersInput;
  update: UsersUpdateWithoutConversations_UsersInput;
};

export type UsersUpsertWithoutEventsInput = {
  create: UsersCreateWithoutEventsInput;
  update: UsersUpdateWithoutEventsInput;
};

export type UsersUpsertWithoutEvents_Events_Customer_ReferralTousersInput = {
  create: UsersCreateWithoutEvents_Events_Customer_ReferralTousersInput;
  update: UsersUpdateWithoutEvents_Events_Customer_ReferralTousersInput;
};

export type UsersUpsertWithoutRobex_NotificationsInput = {
  create: UsersCreateWithoutRobex_NotificationsInput;
  update: UsersUpdateWithoutRobex_NotificationsInput;
};

export type UsersUpsertWithoutSuppliers_UsersInput = {
  create: UsersCreateWithoutSuppliers_UsersInput;
  update: UsersUpdateWithoutSuppliers_UsersInput;
};

export type UsersUpsertWithoutUser_PreferencesInput = {
  create: UsersCreateWithoutUser_PreferencesInput;
  update: UsersUpdateWithoutUser_PreferencesInput;
};

export type UsersUpsertWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput = {
  create: UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput;
  update: UsersUpdateWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput;
};

export type UsersUpsertWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput = {
  create: UsersCreateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput;
  update: UsersUpdateWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput;
};

export type UsersWhereInput = {
  AND?: InputMaybe<Array<UsersWhereInput>>;
  NOT?: InputMaybe<Array<UsersWhereInput>>;
  OR?: InputMaybe<Array<UsersWhereInput>>;
  accountClosedAt?: InputMaybe<DateTimeNullableFilter>;
  agency_users?: InputMaybe<Agency_UsersListRelationFilter>;
  anonymous_users?: InputMaybe<Anonymous_UsersListRelationFilter>;
  bookings?: InputMaybe<BookingsListRelationFilter>;
  business_user?: InputMaybe<BoolNullableFilter>;
  conversations_messages?: InputMaybe<Conversations_MessagesListRelationFilter>;
  conversations_read_receipts?: InputMaybe<Conversations_Read_ReceiptsListRelationFilter>;
  conversations_users?: InputMaybe<Conversations_UsersListRelationFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  ethnic_origin?: InputMaybe<StringNullableFilter>;
  events?: InputMaybe<EventsListRelationFilter>;
  events_events_customer_referralTousers?: InputMaybe<EventsListRelationFilter>;
  firstName?: InputMaybe<StringFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  hashedPassword?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isLgbtq?: InputMaybe<StringNullableFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastName?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  reset_token?: InputMaybe<StringNullableFilter>;
  robex_notifications?: InputMaybe<Robex_NotificationsListRelationFilter>;
  role?: InputMaybe<StringNullableFilter>;
  salt?: InputMaybe<StringNullableFilter>;
  segment?: InputMaybe<StringNullableFilter>;
  smsNotifications?: InputMaybe<BoolNullableFilter>;
  suppliers_users?: InputMaybe<Suppliers_UsersListRelationFilter>;
  tandc?: InputMaybe<BoolNullableFilter>;
  test_treatments?: InputMaybe<Test_TreatmentsListRelationFilter>;
  type?: InputMaybe<Enumenum_Users_TypeNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  user_external_ids?: InputMaybe<User_External_IdsListRelationFilter>;
  user_preferences?: InputMaybe<User_PreferencesWhereInput>;
  voice_calls_usersTovoice_calls_caller_id?: InputMaybe<Voice_CallsListRelationFilter>;
  voice_calls_usersTovoice_calls_recipient_id?: InputMaybe<Voice_CallsListRelationFilter>;
  xero_contacts?: InputMaybe<Xero_ContactsListRelationFilter>;
};

export type UsersWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type Venue_Services = {
  __typename?: 'venue_services';
  available: Scalars['Boolean']['output'];
  category_tier2: Scalars['String']['output'];
  in_house: Scalars['Boolean']['output'];
  supplier_id: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type Venue_ServicesCreateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_ServicesCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Venue_ServicesCreateWithoutCategories_Tier2Input>>;
};

export type Venue_ServicesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_ServicesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Venue_ServicesCreateWithoutSuppliersInput>>;
};

export type Venue_ServicesCreateOrConnectWithoutcategories_Tier2Input = {
  create: Venue_ServicesCreateWithoutCategories_Tier2Input;
  where: Venue_ServicesWhereUniqueInput;
};

export type Venue_ServicesCreateOrConnectWithoutsuppliersInput = {
  create: Venue_ServicesCreateWithoutSuppliersInput;
  where: Venue_ServicesWhereUniqueInput;
};

export type Venue_ServicesCreateWithoutCategories_Tier2Input = {
  available: Scalars['Boolean']['input'];
  created: Scalars['DateTime']['input'];
  in_house: Scalars['Boolean']['input'];
  suppliers: SuppliersCreateOneWithoutVenue_ServicesInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Venue_ServicesCreateWithoutSuppliersInput = {
  available: Scalars['Boolean']['input'];
  categories_tier2: Categories_Tier2CreateOneWithoutVenue_ServicesInput;
  created: Scalars['DateTime']['input'];
  in_house: Scalars['Boolean']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Venue_ServicesScalarWhereInput = {
  AND?: InputMaybe<Array<Venue_ServicesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Venue_ServicesScalarWhereInput>>;
  OR?: InputMaybe<Array<Venue_ServicesScalarWhereInput>>;
  available?: InputMaybe<BoolFilter>;
  category_tier2?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  in_house?: InputMaybe<BoolFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Venue_ServicesUpdateManyMutationInput = {
  available?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  in_house?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_ServicesUpdateManyWithWhereWithoutCategories_Tier2Input = {
  data: Venue_ServicesUpdateManyMutationInput;
  where: Venue_ServicesScalarWhereInput;
};

export type Venue_ServicesUpdateManyWithWhereWithoutSuppliersInput = {
  data: Venue_ServicesUpdateManyMutationInput;
  where: Venue_ServicesScalarWhereInput;
};

export type Venue_ServicesUpdateManyWithoutCategories_Tier2Input = {
  connect?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_ServicesCreateOrConnectWithoutcategories_Tier2Input>>;
  create?: InputMaybe<Array<Venue_ServicesCreateWithoutCategories_Tier2Input>>;
  delete?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Venue_ServicesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  set?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  update?: InputMaybe<Array<Venue_ServicesUpdateWithWhereUniqueWithoutCategories_Tier2Input>>;
  updateMany?: InputMaybe<Array<Venue_ServicesUpdateManyWithWhereWithoutCategories_Tier2Input>>;
  upsert?: InputMaybe<Array<Venue_ServicesUpsertWithWhereUniqueWithoutCategories_Tier2Input>>;
};

export type Venue_ServicesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_ServicesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Venue_ServicesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Venue_ServicesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  set?: InputMaybe<Array<Venue_ServicesWhereUniqueInput>>;
  update?: InputMaybe<Array<Venue_ServicesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Venue_ServicesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Venue_ServicesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Venue_ServicesUpdateWithWhereUniqueWithoutCategories_Tier2Input = {
  data: Venue_ServicesUpdateWithoutCategories_Tier2Input;
  where: Venue_ServicesWhereUniqueInput;
};

export type Venue_ServicesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Venue_ServicesUpdateWithoutSuppliersInput;
  where: Venue_ServicesWhereUniqueInput;
};

export type Venue_ServicesUpdateWithoutCategories_Tier2Input = {
  available?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  in_house?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutVenue_ServicesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_ServicesUpdateWithoutSuppliersInput = {
  available?: InputMaybe<BoolFieldUpdateOperationsInput>;
  categories_tier2?: InputMaybe<Categories_Tier2UpdateOneRequiredWithoutVenue_ServicesInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  in_house?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_ServicesUpsertWithWhereUniqueWithoutCategories_Tier2Input = {
  create: Venue_ServicesCreateWithoutCategories_Tier2Input;
  update: Venue_ServicesUpdateWithoutCategories_Tier2Input;
  where: Venue_ServicesWhereUniqueInput;
};

export type Venue_ServicesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Venue_ServicesCreateWithoutSuppliersInput;
  update: Venue_ServicesUpdateWithoutSuppliersInput;
  where: Venue_ServicesWhereUniqueInput;
};

export type Venue_ServicesWhereInput = {
  AND?: InputMaybe<Array<Venue_ServicesWhereInput>>;
  NOT?: InputMaybe<Array<Venue_ServicesWhereInput>>;
  OR?: InputMaybe<Array<Venue_ServicesWhereInput>>;
  available?: InputMaybe<BoolFilter>;
  categories_tier2?: InputMaybe<Categories_Tier2WhereInput>;
  category_tier2?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeFilter>;
  in_house?: InputMaybe<BoolFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Venue_ServicesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Venue_Spaces = {
  __typename?: 'venue_spaces';
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  group_id: Scalars['String']['output'];
  minSpendSubtotal?: Maybe<Scalars['Int']['output']>;
  min_spend_pennies: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  priceBreakdown?: Maybe<PriceBreakdown>;
  space_tags: Array<Space_Tags>;
  supplier_id: Scalars['String']['output'];
  supplier_images_spaces: Array<Supplier_Images_Spaces>;
  suppliers: Suppliers;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vatRateId?: Maybe<Scalars['String']['output']>;
};


export type Venue_SpacesSpace_TagsArgs = {
  cursor?: InputMaybe<Space_TagsWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type Venue_SpacesSupplier_Images_SpacesArgs = {
  cursor?: InputMaybe<Supplier_Images_SpacesWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type Venue_SpacesCreateInput = {
  created: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  minSpendSubtotal?: InputMaybe<Scalars['Int']['input']>;
  min_spend_pennies?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  space_groups: Space_GroupsCreateOneWithoutVenue_SpacesInput;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutVenue_SpacesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutVenue_SpacesInput>;
  suppliers: SuppliersCreateOneWithoutVenue_SpacesInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
  vatRate?: InputMaybe<VatRateConnectArgs>;
};

export type Venue_SpacesCreateManyWithoutSpace_GroupsInput = {
  connect?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_SpacesCreateOrConnectWithoutspace_GroupsInput>>;
  create?: InputMaybe<Array<Venue_SpacesCreateWithoutSpace_GroupsInput>>;
};

export type Venue_SpacesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_SpacesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Venue_SpacesCreateWithoutSuppliersInput>>;
};

export type Venue_SpacesCreateOneWithoutSpace_TagsInput = {
  connect?: InputMaybe<Venue_SpacesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Venue_SpacesCreateOrConnectWithoutspace_TagsInput>;
  create?: InputMaybe<Venue_SpacesCreateWithoutSpace_TagsInput>;
};

export type Venue_SpacesCreateOneWithoutSupplier_Images_SpacesInput = {
  connect?: InputMaybe<Venue_SpacesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Venue_SpacesCreateOrConnectWithoutsupplier_Images_SpacesInput>;
  create?: InputMaybe<Venue_SpacesCreateWithoutSupplier_Images_SpacesInput>;
};

export type Venue_SpacesCreateOrConnectWithoutspace_GroupsInput = {
  create: Venue_SpacesCreateWithoutSpace_GroupsInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesCreateOrConnectWithoutspace_TagsInput = {
  create: Venue_SpacesCreateWithoutSpace_TagsInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesCreateOrConnectWithoutsupplier_Images_SpacesInput = {
  create: Venue_SpacesCreateWithoutSupplier_Images_SpacesInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesCreateOrConnectWithoutsuppliersInput = {
  create: Venue_SpacesCreateWithoutSuppliersInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesCreateWithoutSpace_GroupsInput = {
  created: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  min_spend_pennies?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutVenue_SpacesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutVenue_SpacesInput>;
  suppliers: SuppliersCreateOneWithoutVenue_SpacesInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Venue_SpacesCreateWithoutSpace_TagsInput = {
  created: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  min_spend_pennies?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  space_groups: Space_GroupsCreateOneWithoutVenue_SpacesInput;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutVenue_SpacesInput>;
  suppliers: SuppliersCreateOneWithoutVenue_SpacesInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Venue_SpacesCreateWithoutSupplier_Images_SpacesInput = {
  created: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  min_spend_pennies?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  space_groups: Space_GroupsCreateOneWithoutVenue_SpacesInput;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutVenue_SpacesInput>;
  suppliers: SuppliersCreateOneWithoutVenue_SpacesInput;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Venue_SpacesCreateWithoutSuppliersInput = {
  created: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  min_spend_pennies?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  space_groups: Space_GroupsCreateOneWithoutVenue_SpacesInput;
  space_tags?: InputMaybe<Space_TagsCreateManyWithoutVenue_SpacesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesCreateManyWithoutVenue_SpacesInput>;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Venue_SpacesScalarWhereInput = {
  AND?: InputMaybe<Array<Venue_SpacesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Venue_SpacesScalarWhereInput>>;
  OR?: InputMaybe<Array<Venue_SpacesScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  group_id?: InputMaybe<StringFilter>;
  min_spend_pennies?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Venue_SpacesUpdateInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  minSpendSubtotal?: InputMaybe<SetInteger>;
  min_spend_pennies?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateOneRequiredWithoutVenue_SpacesInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutVenue_SpacesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutVenue_SpacesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutVenue_SpacesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  vatRate?: InputMaybe<VatRateConnectArgs>;
};

export type Venue_SpacesUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  min_spend_pennies?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_SpacesUpdateManyWithWhereWithoutSpace_GroupsInput = {
  data: Venue_SpacesUpdateManyMutationInput;
  where: Venue_SpacesScalarWhereInput;
};

export type Venue_SpacesUpdateManyWithWhereWithoutSuppliersInput = {
  data: Venue_SpacesUpdateManyMutationInput;
  where: Venue_SpacesScalarWhereInput;
};

export type Venue_SpacesUpdateManyWithoutSpace_GroupsInput = {
  connect?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_SpacesCreateOrConnectWithoutspace_GroupsInput>>;
  create?: InputMaybe<Array<Venue_SpacesCreateWithoutSpace_GroupsInput>>;
  delete?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Venue_SpacesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  set?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  update?: InputMaybe<Array<Venue_SpacesUpdateWithWhereUniqueWithoutSpace_GroupsInput>>;
  updateMany?: InputMaybe<Array<Venue_SpacesUpdateManyWithWhereWithoutSpace_GroupsInput>>;
  upsert?: InputMaybe<Array<Venue_SpacesUpsertWithWhereUniqueWithoutSpace_GroupsInput>>;
};

export type Venue_SpacesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Venue_SpacesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Venue_SpacesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Venue_SpacesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  set?: InputMaybe<Array<Venue_SpacesWhereUniqueInput>>;
  update?: InputMaybe<Array<Venue_SpacesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Venue_SpacesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Venue_SpacesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Venue_SpacesUpdateOneRequiredWithoutSpace_TagsInput = {
  connect?: InputMaybe<Venue_SpacesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Venue_SpacesCreateOrConnectWithoutspace_TagsInput>;
  create?: InputMaybe<Venue_SpacesCreateWithoutSpace_TagsInput>;
  update?: InputMaybe<Venue_SpacesUpdateWithoutSpace_TagsInput>;
  upsert?: InputMaybe<Venue_SpacesUpsertWithoutSpace_TagsInput>;
};

export type Venue_SpacesUpdateOneRequiredWithoutSupplier_Images_SpacesInput = {
  connect?: InputMaybe<Venue_SpacesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<Venue_SpacesCreateOrConnectWithoutsupplier_Images_SpacesInput>;
  create?: InputMaybe<Venue_SpacesCreateWithoutSupplier_Images_SpacesInput>;
  update?: InputMaybe<Venue_SpacesUpdateWithoutSupplier_Images_SpacesInput>;
  upsert?: InputMaybe<Venue_SpacesUpsertWithoutSupplier_Images_SpacesInput>;
};

export type Venue_SpacesUpdateWithWhereUniqueWithoutSpace_GroupsInput = {
  data: Venue_SpacesUpdateWithoutSpace_GroupsInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Venue_SpacesUpdateWithoutSuppliersInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesUpdateWithoutSpace_GroupsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  min_spend_pennies?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutVenue_SpacesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutVenue_SpacesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutVenue_SpacesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_SpacesUpdateWithoutSpace_TagsInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  min_spend_pennies?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateOneRequiredWithoutVenue_SpacesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutVenue_SpacesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutVenue_SpacesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_SpacesUpdateWithoutSupplier_Images_SpacesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  min_spend_pennies?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateOneRequiredWithoutVenue_SpacesInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutVenue_SpacesInput>;
  suppliers?: InputMaybe<SuppliersUpdateOneRequiredWithoutVenue_SpacesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_SpacesUpdateWithoutSuppliersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  min_spend_pennies?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  space_groups?: InputMaybe<Space_GroupsUpdateOneRequiredWithoutVenue_SpacesInput>;
  space_tags?: InputMaybe<Space_TagsUpdateManyWithoutVenue_SpacesInput>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesUpdateManyWithoutVenue_SpacesInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Venue_SpacesUpsertWithWhereUniqueWithoutSpace_GroupsInput = {
  create: Venue_SpacesCreateWithoutSpace_GroupsInput;
  update: Venue_SpacesUpdateWithoutSpace_GroupsInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Venue_SpacesCreateWithoutSuppliersInput;
  update: Venue_SpacesUpdateWithoutSuppliersInput;
  where: Venue_SpacesWhereUniqueInput;
};

export type Venue_SpacesUpsertWithoutSpace_TagsInput = {
  create: Venue_SpacesCreateWithoutSpace_TagsInput;
  update: Venue_SpacesUpdateWithoutSpace_TagsInput;
};

export type Venue_SpacesUpsertWithoutSupplier_Images_SpacesInput = {
  create: Venue_SpacesCreateWithoutSupplier_Images_SpacesInput;
  update: Venue_SpacesUpdateWithoutSupplier_Images_SpacesInput;
};

export type Venue_SpacesWhereInput = {
  AND?: InputMaybe<Array<Venue_SpacesWhereInput>>;
  NOT?: InputMaybe<Array<Venue_SpacesWhereInput>>;
  OR?: InputMaybe<Array<Venue_SpacesWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  group_id?: InputMaybe<StringFilter>;
  min_spend_pennies?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  space_groups?: InputMaybe<Space_GroupsWhereInput>;
  space_tags?: InputMaybe<Space_TagsListRelationFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  supplier_images_spaces?: InputMaybe<Supplier_Images_SpacesListRelationFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Venue_SpacesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Voice_CallsCreateManyWithoutConversationsInput = {
  connect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Voice_CallsCreateOrConnectWithoutconversationsInput>>;
  create?: InputMaybe<Array<Voice_CallsCreateWithoutConversationsInput>>;
};

export type Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput = {
  connect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Voice_CallsCreateOrConnectWithoutusers_UsersTovoice_Calls_Caller_IdInput>>;
  create?: InputMaybe<Array<Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Caller_IdInput>>;
};

export type Voice_CallsCreateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput = {
  connect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Voice_CallsCreateOrConnectWithoutusers_UsersTovoice_Calls_Recipient_IdInput>>;
  create?: InputMaybe<Array<Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>>;
};

export type Voice_CallsCreateOrConnectWithoutconversationsInput = {
  create: Voice_CallsCreateWithoutConversationsInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsCreateOrConnectWithoutusers_UsersTovoice_Calls_Caller_IdInput = {
  create: Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Caller_IdInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsCreateOrConnectWithoutusers_UsersTovoice_Calls_Recipient_IdInput = {
  create: Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsCreateWithoutConversationsInput = {
  caller_answered?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  primary_status?: InputMaybe<Enum_Voice_Calls_Primary_Status>;
  recipient_answered?: InputMaybe<Scalars['Boolean']['input']>;
  recipient_type: Enum_Voice_Calling_Recipient_Type;
  secondary_status?: InputMaybe<Enum_Voice_Calls_Secondary_Status>;
  twilio_call_sid?: InputMaybe<Scalars['String']['input']>;
  twilio_second_call_sid?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users_usersTovoice_calls_caller_id: UsersCreateOneWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput;
  users_usersTovoice_calls_recipient_id: UsersCreateOneWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput;
  uuid: Scalars['String']['input'];
};

export type Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Caller_IdInput = {
  caller_answered?: InputMaybe<Scalars['Boolean']['input']>;
  conversations: ConversationsCreateOneWithoutVoice_CallsInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  primary_status?: InputMaybe<Enum_Voice_Calls_Primary_Status>;
  recipient_answered?: InputMaybe<Scalars['Boolean']['input']>;
  recipient_type: Enum_Voice_Calling_Recipient_Type;
  secondary_status?: InputMaybe<Enum_Voice_Calls_Secondary_Status>;
  twilio_call_sid?: InputMaybe<Scalars['String']['input']>;
  twilio_second_call_sid?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users_usersTovoice_calls_recipient_id: UsersCreateOneWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput;
  uuid: Scalars['String']['input'];
};

export type Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput = {
  caller_answered?: InputMaybe<Scalars['Boolean']['input']>;
  conversations: ConversationsCreateOneWithoutVoice_CallsInput;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  primary_status?: InputMaybe<Enum_Voice_Calls_Primary_Status>;
  recipient_answered?: InputMaybe<Scalars['Boolean']['input']>;
  recipient_type: Enum_Voice_Calling_Recipient_Type;
  secondary_status?: InputMaybe<Enum_Voice_Calls_Secondary_Status>;
  twilio_call_sid?: InputMaybe<Scalars['String']['input']>;
  twilio_second_call_sid?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  users_usersTovoice_calls_caller_id: UsersCreateOneWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput;
  uuid: Scalars['String']['input'];
};

export type Voice_CallsScalarWhereInput = {
  AND?: InputMaybe<Array<Voice_CallsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Voice_CallsScalarWhereInput>>;
  OR?: InputMaybe<Array<Voice_CallsScalarWhereInput>>;
  caller_answered?: InputMaybe<BoolFilter>;
  caller_id?: InputMaybe<StringFilter>;
  conversation_id?: InputMaybe<StringFilter>;
  created?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  primary_status?: InputMaybe<Enumenum_Voice_Calls_Primary_StatusNullableFilter>;
  recipient_answered?: InputMaybe<BoolFilter>;
  recipient_id?: InputMaybe<StringFilter>;
  recipient_type?: InputMaybe<Enumenum_Voice_Calling_Recipient_TypeFilter>;
  secondary_status?: InputMaybe<Enumenum_Voice_Calls_Secondary_StatusNullableFilter>;
  twilio_call_sid?: InputMaybe<StringFilter>;
  twilio_second_call_sid?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Voice_CallsUpdateManyMutationInput = {
  caller_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  primary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Primary_StatusFieldUpdateOperationsInput>;
  recipient_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  recipient_type?: InputMaybe<Enumenum_Voice_Calling_Recipient_TypeFieldUpdateOperationsInput>;
  secondary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Secondary_StatusFieldUpdateOperationsInput>;
  twilio_call_sid?: InputMaybe<StringFieldUpdateOperationsInput>;
  twilio_second_call_sid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Voice_CallsUpdateManyWithWhereWithoutConversationsInput = {
  data: Voice_CallsUpdateManyMutationInput;
  where: Voice_CallsScalarWhereInput;
};

export type Voice_CallsUpdateManyWithWhereWithoutUsers_UsersTovoice_Calls_Caller_IdInput = {
  data: Voice_CallsUpdateManyMutationInput;
  where: Voice_CallsScalarWhereInput;
};

export type Voice_CallsUpdateManyWithWhereWithoutUsers_UsersTovoice_Calls_Recipient_IdInput = {
  data: Voice_CallsUpdateManyMutationInput;
  where: Voice_CallsScalarWhereInput;
};

export type Voice_CallsUpdateManyWithoutConversationsInput = {
  connect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Voice_CallsCreateOrConnectWithoutconversationsInput>>;
  create?: InputMaybe<Array<Voice_CallsCreateWithoutConversationsInput>>;
  delete?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Voice_CallsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  set?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  update?: InputMaybe<Array<Voice_CallsUpdateWithWhereUniqueWithoutConversationsInput>>;
  updateMany?: InputMaybe<Array<Voice_CallsUpdateManyWithWhereWithoutConversationsInput>>;
  upsert?: InputMaybe<Array<Voice_CallsUpsertWithWhereUniqueWithoutConversationsInput>>;
};

export type Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Caller_IdInput = {
  connect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Voice_CallsCreateOrConnectWithoutusers_UsersTovoice_Calls_Caller_IdInput>>;
  create?: InputMaybe<Array<Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Caller_IdInput>>;
  delete?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Voice_CallsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  set?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  update?: InputMaybe<Array<Voice_CallsUpdateWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Caller_IdInput>>;
  updateMany?: InputMaybe<Array<Voice_CallsUpdateManyWithWhereWithoutUsers_UsersTovoice_Calls_Caller_IdInput>>;
  upsert?: InputMaybe<Array<Voice_CallsUpsertWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Caller_IdInput>>;
};

export type Voice_CallsUpdateManyWithoutUsers_UsersTovoice_Calls_Recipient_IdInput = {
  connect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Voice_CallsCreateOrConnectWithoutusers_UsersTovoice_Calls_Recipient_IdInput>>;
  create?: InputMaybe<Array<Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>>;
  delete?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Voice_CallsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  set?: InputMaybe<Array<Voice_CallsWhereUniqueInput>>;
  update?: InputMaybe<Array<Voice_CallsUpdateWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>>;
  updateMany?: InputMaybe<Array<Voice_CallsUpdateManyWithWhereWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>>;
  upsert?: InputMaybe<Array<Voice_CallsUpsertWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Recipient_IdInput>>;
};

export type Voice_CallsUpdateWithWhereUniqueWithoutConversationsInput = {
  data: Voice_CallsUpdateWithoutConversationsInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsUpdateWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Caller_IdInput = {
  data: Voice_CallsUpdateWithoutUsers_UsersTovoice_Calls_Caller_IdInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsUpdateWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Recipient_IdInput = {
  data: Voice_CallsUpdateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsUpdateWithoutConversationsInput = {
  caller_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  primary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Primary_StatusFieldUpdateOperationsInput>;
  recipient_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  recipient_type?: InputMaybe<Enumenum_Voice_Calling_Recipient_TypeFieldUpdateOperationsInput>;
  secondary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Secondary_StatusFieldUpdateOperationsInput>;
  twilio_call_sid?: InputMaybe<StringFieldUpdateOperationsInput>;
  twilio_second_call_sid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users_usersTovoice_calls_caller_id?: InputMaybe<UsersUpdateOneRequiredWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
  users_usersTovoice_calls_recipient_id?: InputMaybe<UsersUpdateOneRequiredWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Voice_CallsUpdateWithoutUsers_UsersTovoice_Calls_Caller_IdInput = {
  caller_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateOneRequiredWithoutVoice_CallsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  primary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Primary_StatusFieldUpdateOperationsInput>;
  recipient_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  recipient_type?: InputMaybe<Enumenum_Voice_Calling_Recipient_TypeFieldUpdateOperationsInput>;
  secondary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Secondary_StatusFieldUpdateOperationsInput>;
  twilio_call_sid?: InputMaybe<StringFieldUpdateOperationsInput>;
  twilio_second_call_sid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users_usersTovoice_calls_recipient_id?: InputMaybe<UsersUpdateOneRequiredWithoutVoice_Calls_UsersTovoice_Calls_Recipient_IdInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Voice_CallsUpdateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput = {
  caller_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  conversations?: InputMaybe<ConversationsUpdateOneRequiredWithoutVoice_CallsInput>;
  created?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  primary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Primary_StatusFieldUpdateOperationsInput>;
  recipient_answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  recipient_type?: InputMaybe<Enumenum_Voice_Calling_Recipient_TypeFieldUpdateOperationsInput>;
  secondary_status?: InputMaybe<NullableEnumenum_Voice_Calls_Secondary_StatusFieldUpdateOperationsInput>;
  twilio_call_sid?: InputMaybe<StringFieldUpdateOperationsInput>;
  twilio_second_call_sid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  users_usersTovoice_calls_caller_id?: InputMaybe<UsersUpdateOneRequiredWithoutVoice_Calls_UsersTovoice_Calls_Caller_IdInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Voice_CallsUpsertWithWhereUniqueWithoutConversationsInput = {
  create: Voice_CallsCreateWithoutConversationsInput;
  update: Voice_CallsUpdateWithoutConversationsInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsUpsertWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Caller_IdInput = {
  create: Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Caller_IdInput;
  update: Voice_CallsUpdateWithoutUsers_UsersTovoice_Calls_Caller_IdInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsUpsertWithWhereUniqueWithoutUsers_UsersTovoice_Calls_Recipient_IdInput = {
  create: Voice_CallsCreateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput;
  update: Voice_CallsUpdateWithoutUsers_UsersTovoice_Calls_Recipient_IdInput;
  where: Voice_CallsWhereUniqueInput;
};

export type Voice_CallsWhereInput = {
  AND?: InputMaybe<Array<Voice_CallsWhereInput>>;
  NOT?: InputMaybe<Array<Voice_CallsWhereInput>>;
  OR?: InputMaybe<Array<Voice_CallsWhereInput>>;
  caller_answered?: InputMaybe<BoolFilter>;
  caller_id?: InputMaybe<StringFilter>;
  conversation_id?: InputMaybe<StringFilter>;
  conversations?: InputMaybe<ConversationsWhereInput>;
  created?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  primary_status?: InputMaybe<Enumenum_Voice_Calls_Primary_StatusNullableFilter>;
  recipient_answered?: InputMaybe<BoolFilter>;
  recipient_id?: InputMaybe<StringFilter>;
  recipient_type?: InputMaybe<Enumenum_Voice_Calling_Recipient_TypeFilter>;
  secondary_status?: InputMaybe<Enumenum_Voice_Calls_Secondary_StatusNullableFilter>;
  twilio_call_sid?: InputMaybe<StringFilter>;
  twilio_second_call_sid?: InputMaybe<StringNullableFilter>;
  updated?: InputMaybe<DateTimeNullableFilter>;
  users_usersTovoice_calls_caller_id?: InputMaybe<UsersWhereInput>;
  users_usersTovoice_calls_recipient_id?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Voice_CallsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Void = {
  __typename?: 'void';
  complete?: Maybe<Scalars['Boolean']['output']>;
};

export type Workflow_Automations_Message_Templates = {
  __typename?: 'workflow_automations_message_templates';
  automation_trigger: Enum_Workflow_Automations_Message_Templates_Automation_Trigger;
  created: Scalars['DateTime']['output'];
  is_active: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  supplier_id: Scalars['String']['output'];
  trigger_interval_seconds: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type Workflow_Automations_Message_TemplatesCreateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Workflow_Automations_Message_TemplatesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Workflow_Automations_Message_TemplatesCreateWithoutSuppliersInput>>;
};

export type Workflow_Automations_Message_TemplatesCreateOrConnectWithoutsuppliersInput = {
  create: Workflow_Automations_Message_TemplatesCreateWithoutSuppliersInput;
  where: Workflow_Automations_Message_TemplatesWhereUniqueInput;
};

export type Workflow_Automations_Message_TemplatesCreateWithoutSuppliersInput = {
  automation_trigger: Enum_Workflow_Automations_Message_Templates_Automation_Trigger;
  created: Scalars['DateTime']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trigger_interval_seconds: Scalars['Int']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Workflow_Automations_Message_TemplatesScalarWhereInput = {
  AND?: InputMaybe<Array<Workflow_Automations_Message_TemplatesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Workflow_Automations_Message_TemplatesScalarWhereInput>>;
  OR?: InputMaybe<Array<Workflow_Automations_Message_TemplatesScalarWhereInput>>;
  automation_trigger?: InputMaybe<Enumenum_Workflow_Automations_Message_Templates_Automation_TriggerFilter>;
  created?: InputMaybe<DateTimeFilter>;
  is_active?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  trigger_interval_seconds?: InputMaybe<IntFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Workflow_Automations_Message_TemplatesUpdateManyMutationInput = {
  automation_trigger?: InputMaybe<Enumenum_Workflow_Automations_Message_Templates_Automation_TriggerFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  is_active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  trigger_interval_seconds?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Workflow_Automations_Message_TemplatesUpdateManyWithWhereWithoutSuppliersInput = {
  data: Workflow_Automations_Message_TemplatesUpdateManyMutationInput;
  where: Workflow_Automations_Message_TemplatesScalarWhereInput;
};

export type Workflow_Automations_Message_TemplatesUpdateManyWithoutSuppliersInput = {
  connect?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Workflow_Automations_Message_TemplatesCreateOrConnectWithoutsuppliersInput>>;
  create?: InputMaybe<Array<Workflow_Automations_Message_TemplatesCreateWithoutSuppliersInput>>;
  delete?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Workflow_Automations_Message_TemplatesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereUniqueInput>>;
  set?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereUniqueInput>>;
  update?: InputMaybe<Array<Workflow_Automations_Message_TemplatesUpdateWithWhereUniqueWithoutSuppliersInput>>;
  updateMany?: InputMaybe<Array<Workflow_Automations_Message_TemplatesUpdateManyWithWhereWithoutSuppliersInput>>;
  upsert?: InputMaybe<Array<Workflow_Automations_Message_TemplatesUpsertWithWhereUniqueWithoutSuppliersInput>>;
};

export type Workflow_Automations_Message_TemplatesUpdateWithWhereUniqueWithoutSuppliersInput = {
  data: Workflow_Automations_Message_TemplatesUpdateWithoutSuppliersInput;
  where: Workflow_Automations_Message_TemplatesWhereUniqueInput;
};

export type Workflow_Automations_Message_TemplatesUpdateWithoutSuppliersInput = {
  automation_trigger?: InputMaybe<Enumenum_Workflow_Automations_Message_Templates_Automation_TriggerFieldUpdateOperationsInput>;
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  is_active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  trigger_interval_seconds?: InputMaybe<IntFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Workflow_Automations_Message_TemplatesUpsertWithWhereUniqueWithoutSuppliersInput = {
  create: Workflow_Automations_Message_TemplatesCreateWithoutSuppliersInput;
  update: Workflow_Automations_Message_TemplatesUpdateWithoutSuppliersInput;
  where: Workflow_Automations_Message_TemplatesWhereUniqueInput;
};

export type Workflow_Automations_Message_TemplatesWhereInput = {
  AND?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereInput>>;
  NOT?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereInput>>;
  OR?: InputMaybe<Array<Workflow_Automations_Message_TemplatesWhereInput>>;
  automation_trigger?: InputMaybe<Enumenum_Workflow_Automations_Message_Templates_Automation_TriggerFilter>;
  created?: InputMaybe<DateTimeFilter>;
  is_active?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  supplier_id?: InputMaybe<StringFilter>;
  suppliers?: InputMaybe<SuppliersWhereInput>;
  trigger_interval_seconds?: InputMaybe<IntFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Workflow_Automations_Message_TemplatesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Workflow_Automations_Message_TemplatesWorkflow_Automations_Message_Templates_Supplier_Id_NameCompoundUniqueInput = {
  name: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};

export type Xero_ContactsCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Xero_ContactsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Xero_ContactsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Xero_ContactsCreateWithoutUsersInput>>;
};

export type Xero_ContactsCreateOrConnectWithoutusersInput = {
  create: Xero_ContactsCreateWithoutUsersInput;
  where: Xero_ContactsWhereUniqueInput;
};

export type Xero_ContactsCreateWithoutUsersInput = {
  created: Scalars['DateTime']['input'];
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Xero_ContactsScalarWhereInput = {
  AND?: InputMaybe<Array<Xero_ContactsScalarWhereInput>>;
  NOT?: InputMaybe<Array<Xero_ContactsScalarWhereInput>>;
  OR?: InputMaybe<Array<Xero_ContactsScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_id?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Xero_ContactsUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Xero_ContactsUpdateManyWithWhereWithoutUsersInput = {
  data: Xero_ContactsUpdateManyMutationInput;
  where: Xero_ContactsScalarWhereInput;
};

export type Xero_ContactsUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<Xero_ContactsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Xero_ContactsCreateOrConnectWithoutusersInput>>;
  create?: InputMaybe<Array<Xero_ContactsCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<Xero_ContactsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Xero_ContactsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Xero_ContactsWhereUniqueInput>>;
  set?: InputMaybe<Array<Xero_ContactsWhereUniqueInput>>;
  update?: InputMaybe<Array<Xero_ContactsUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<Xero_ContactsUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<Xero_ContactsUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type Xero_ContactsUpdateWithWhereUniqueWithoutUsersInput = {
  data: Xero_ContactsUpdateWithoutUsersInput;
  where: Xero_ContactsWhereUniqueInput;
};

export type Xero_ContactsUpdateWithoutUsersInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Xero_ContactsUpsertWithWhereUniqueWithoutUsersInput = {
  create: Xero_ContactsCreateWithoutUsersInput;
  update: Xero_ContactsUpdateWithoutUsersInput;
  where: Xero_ContactsWhereUniqueInput;
};

export type Xero_ContactsWhereInput = {
  AND?: InputMaybe<Array<Xero_ContactsWhereInput>>;
  NOT?: InputMaybe<Array<Xero_ContactsWhereInput>>;
  OR?: InputMaybe<Array<Xero_ContactsWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  user_id?: InputMaybe<StringFilter>;
  users?: InputMaybe<UsersWhereInput>;
  uuid?: InputMaybe<StringFilter>;
};

export type Xero_ContactsWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Xero_InvoicesCreateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Xero_InvoicesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Xero_InvoicesCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Xero_InvoicesCreateWithoutQuotesInput>>;
};

export type Xero_InvoicesCreateOrConnectWithoutquotesInput = {
  create: Xero_InvoicesCreateWithoutQuotesInput;
  where: Xero_InvoicesWhereUniqueInput;
};

export type Xero_InvoicesCreateWithoutQuotesInput = {
  created: Scalars['DateTime']['input'];
  type: Enum_Xero_Invoices_Type;
  updated: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type Xero_InvoicesScalarWhereInput = {
  AND?: InputMaybe<Array<Xero_InvoicesScalarWhereInput>>;
  NOT?: InputMaybe<Array<Xero_InvoicesScalarWhereInput>>;
  OR?: InputMaybe<Array<Xero_InvoicesScalarWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  quote_id?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumenum_Xero_Invoices_TypeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Xero_InvoicesUpdateManyMutationInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Xero_Invoices_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Xero_InvoicesUpdateManyWithWhereWithoutQuotesInput = {
  data: Xero_InvoicesUpdateManyMutationInput;
  where: Xero_InvoicesScalarWhereInput;
};

export type Xero_InvoicesUpdateManyWithoutQuotesInput = {
  connect?: InputMaybe<Array<Xero_InvoicesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Xero_InvoicesCreateOrConnectWithoutquotesInput>>;
  create?: InputMaybe<Array<Xero_InvoicesCreateWithoutQuotesInput>>;
  delete?: InputMaybe<Array<Xero_InvoicesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Xero_InvoicesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Xero_InvoicesWhereUniqueInput>>;
  set?: InputMaybe<Array<Xero_InvoicesWhereUniqueInput>>;
  update?: InputMaybe<Array<Xero_InvoicesUpdateWithWhereUniqueWithoutQuotesInput>>;
  updateMany?: InputMaybe<Array<Xero_InvoicesUpdateManyWithWhereWithoutQuotesInput>>;
  upsert?: InputMaybe<Array<Xero_InvoicesUpsertWithWhereUniqueWithoutQuotesInput>>;
};

export type Xero_InvoicesUpdateWithWhereUniqueWithoutQuotesInput = {
  data: Xero_InvoicesUpdateWithoutQuotesInput;
  where: Xero_InvoicesWhereUniqueInput;
};

export type Xero_InvoicesUpdateWithoutQuotesInput = {
  created?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumenum_Xero_Invoices_TypeFieldUpdateOperationsInput>;
  updated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Xero_InvoicesUpsertWithWhereUniqueWithoutQuotesInput = {
  create: Xero_InvoicesCreateWithoutQuotesInput;
  update: Xero_InvoicesUpdateWithoutQuotesInput;
  where: Xero_InvoicesWhereUniqueInput;
};

export type Xero_InvoicesWhereInput = {
  AND?: InputMaybe<Array<Xero_InvoicesWhereInput>>;
  NOT?: InputMaybe<Array<Xero_InvoicesWhereInput>>;
  OR?: InputMaybe<Array<Xero_InvoicesWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  quote_id?: InputMaybe<StringFilter>;
  quotes?: InputMaybe<QuotesWhereInput>;
  type?: InputMaybe<Enumenum_Xero_Invoices_TypeFilter>;
  updated?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Xero_InvoicesWhereUniqueInput = {
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type LocalisedSupplierCountQueryVariables = Exact<{
  tier1: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
}>;


export type LocalisedSupplierCountQuery = { __typename?: 'Query', localisedSupplierCount: number };

export type PublicSupplierReviewsQueryVariables = Exact<{
  supplierUuid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicSupplierReviewsQuery = { __typename?: 'Query', publicSupplierReviews: { __typename?: 'PublicSupplierReviewsResult', reviews: Array<{ __typename?: 'PublicSupplierReview', uuid: string, ratings: { __typename?: 'PublicSupplierReviewRatings', overall: number }, fields: { __typename?: 'PublicSupplierReviewFields', publicComment?: string | null }, externalEvent?: { __typename?: 'PublicSupplierReviewExternalEvent', eventType: string, userFullName: string } | null, booking?: { __typename?: 'PublicSupplierReviewBooking', type?: string | null, customer?: { __typename?: 'PublicSupplierReviewCustomer', firstName: string, lastName: string } | null } | null }> } };

export type SimpleSupplierSearchQueryVariables = Exact<{
  filters: SimpleSupplierSearchFilters;
}>;


export type SimpleSupplierSearchQuery = { __typename?: 'Query', simpleSupplierSearch?: { __typename?: 'SimpleSupplierSearchResult', totalResults: number, suppliers: Array<{ __typename?: 'SimpleSupplier', uuid?: string | null, name?: string | null, slug?: string | null, state?: Enum_Suppliers_State | null, tagline?: string | null, categoryTier1?: string | null, average_rating?: number | null, base_price?: number | null, distance?: number | null, overall_message_response_rate?: number | null, updated?: any | null, dietary?: Array<{ __typename?: 'SupplierDietary', tagId?: string | null, pid?: string | null, name?: string | null } | null> | null, tier2?: Array<{ __typename?: 'public_supplier_tier2', name?: string | null, sysName?: string | null } | null> | null, external?: { __typename?: 'ExternalSupplierInfo', hygieneRating?: string | null, iZettleStaffName?: string | null, foodSafetyAgencyId?: string | null, numReviews?: number | null } | null, public?: { __typename?: 'PublicSupplier', description?: string | null, social?: Array<string | null> | null, video_url?: string | null, profilePicture?: { __typename?: 'SupplierImage', key?: string | null, url?: string | null } | null, images?: Array<{ __typename?: 'SupplierImage', key?: string | null, url?: string | null } | null> | null, logistics?: { __typename?: 'SupplierLogistics', registeredCity?: string | null } | null } | null }> } | null };


export const LocalisedSupplierCountDocument = gql`
    query LocalisedSupplierCount($tier1: String!, $lat: Float, $lon: Float) {
  localisedSupplierCount(tier1: $tier1, lat: $lat, lon: $lon)
}
    `;
export type LocalisedSupplierCountQueryResult = Apollo.QueryResult<LocalisedSupplierCountQuery, LocalisedSupplierCountQueryVariables>;
export const PublicSupplierReviewsDocument = gql`
    query PublicSupplierReviews($supplierUuid: String!, $page: Int, $limit: Int) {
  publicSupplierReviews(supplierUuid: $supplierUuid, page: $page, limit: $limit) {
    reviews {
      uuid
      ratings {
        overall
      }
      fields {
        publicComment
      }
      externalEvent {
        eventType
        userFullName
      }
      booking {
        type
        customer {
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export type PublicSupplierReviewsQueryResult = Apollo.QueryResult<PublicSupplierReviewsQuery, PublicSupplierReviewsQueryVariables>;
export const SimpleSupplierSearchDocument = gql`
    query SimpleSupplierSearch($filters: SimpleSupplierSearchFilters!) {
  simpleSupplierSearch(filters: $filters) {
    totalResults
    suppliers {
      uuid
      name
      slug
      state
      tagline
      categoryTier1
      average_rating
      base_price
      distance
      overall_message_response_rate
      updated
      dietary {
        tagId
        pid
        name
      }
      tier2 {
        name
        sysName
      }
      external {
        hygieneRating
        iZettleStaffName
        foodSafetyAgencyId
        numReviews
      }
      public {
        description
        social
        video_url
        profilePicture {
          key
          url
        }
        images {
          key
          url
        }
        logistics {
          registeredCity
        }
      }
    }
  }
}
    `;
export type SimpleSupplierSearchQueryResult = Apollo.QueryResult<SimpleSupplierSearchQuery, SimpleSupplierSearchQueryVariables>;